if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
  // Get from cart.js returns the cart in JSON
  if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

/*! modernizr.min.js */
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-backgroundblendmode-csstransforms-csstransforms3d-flexbox-placeholder-svg-touchevents-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
/*! magic-grid.min.js */
/* Magic Grid 3.2.4 by Emmanuel Olaojo at https://github.com/e-oj/Magic-Grid under MIT License */
function _instanceof(t, e) {
    return null != e && "undefined" != typeof Symbol && e[Symbol.hasInstance] ? e[Symbol.hasInstance](t) : t instanceof e
}
/*! markerclusterer.min.js */
/*!
MarkerClusterer for Google Maps v3 - version 1.0
Copyright 2010 Google Inc. All Rights Reserved.
Licensed under the Apache License, Version 2.0
https://github.com/googlemaps/js-marker-clusterer/blob/gh-pages/LICENSE
*/
function MarkerClusterer(t, e, n) {
    this.extend(MarkerClusterer, google.maps.OverlayView),
    this.map_ = t,
    this.markers_ = [],
    this.clusters_ = [],
    this.sizes = [53, 56, 66, 78, 90],
    this.styles_ = [],
    this.ready_ = !1;
    var r = n || {};
    this.gridSize_ = r.gridSize || 60,
    this.minClusterSize_ = r.minimumClusterSize || 2,
    this.maxZoom_ = r.maxZoom || null,
    this.styles_ = r.styles || [],
    this.imagePath_ = r.imagePath || this.MARKER_CLUSTER_IMAGE_PATH_,
    this.imageExtension_ = r.imageExtension || this.MARKER_CLUSTER_IMAGE_EXTENSION_,
    this.zoomOnClick_ = !0,
    null != r.zoomOnClick && (this.zoomOnClick_ = r.zoomOnClick),
    this.averageCenter_ = !1,
    null != r.averageCenter && (this.averageCenter_ = r.averageCenter),
    this.setupStyles_(),
    this.setMap(t),
    this.prevZoom_ = this.map_.getZoom();
    var i = this;
    google.maps.event.addListener(this.map_, "zoom_changed", function() {
        var t = i.map_.getZoom()
          , e = i.map_.minZoom || 0
          , n = Math.min(i.map_.maxZoom || 100, i.map_.mapTypes[i.map_.getMapTypeId()].maxZoom);
        t = Math.min(Math.max(t, e), n),
        i.prevZoom_ != t && (i.prevZoom_ = t,
        i.resetViewport())
    }),
    google.maps.event.addListener(this.map_, "idle", function() {
        i.redraw()
    }),
    e && (e.length || Object.keys(e).length) && this.addMarkers(e, !1)
}
function Cluster(t) {
    this.markerClusterer_ = t,
    this.map_ = t.getMap(),
    this.gridSize_ = t.getGridSize(),
    this.minClusterSize_ = t.getMinClusterSize(),
    this.averageCenter_ = t.isAverageCenter(),
    this.center_ = null,
    this.markers_ = [],
    this.bounds_ = null,
    this.clusterIcon_ = new ClusterIcon(this,t.getStyles(),t.getGridSize())
}
function ClusterIcon(t, e, n) {
    t.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView),
    this.styles_ = e,
    this.padding_ = n || 0,
    this.cluster_ = t,
    this.center_ = null,
    this.map_ = t.getMap(),
    this.div_ = null,
    this.sums_ = null,
    this.visible_ = !1,
    this.setMap(this.map_)
}
!function(t, e, n) {
    function r(t, e) {
        return typeof t === e
    }
    function i() {
        var t, e, n, i, o, a, s;
        for (var l in w)
            if (w.hasOwnProperty(l)) {
                if (t = [],
                e = w[l],
                e.name && (t.push(e.name.toLowerCase()),
                e.options && e.options.aliases && e.options.aliases.length))
                    for (n = 0; n < e.options.aliases.length; n++)
                        t.push(e.options.aliases[n].toLowerCase());
                for (i = r(e.fn, "function") ? e.fn() : e.fn,
                o = 0; o < t.length; o++)
                    a = t[o],
                    s = a.split("."),
                    1 === s.length ? C[s[0]] = i : (!C[s[0]] || C[s[0]]instanceof Boolean || (C[s[0]] = new Boolean(C[s[0]])),
                    C[s[0]][s[1]] = i),
                    b.push((i ? "" : "no-") + s.join("-"))
            }
    }
    function o(t) {
        var e = _.className
          , n = C._config.classPrefix || "";
        if (S && (e = e.baseVal),
        C._config.enableJSClass) {
            var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            e = e.replace(r, "$1" + n + "js$2")
        }
        C._config.enableClasses && (e += " " + n + t.join(" " + n),
        S ? _.className.baseVal = e : _.className = e)
    }
    function a() {
        return "function" != typeof e.createElement ? e.createElement(arguments[0]) : S ? e.createElementNS.call(e, "http://www.w3.org/2000/svg", arguments[0]) : e.createElement.apply(e, arguments)
    }
    function s(t, e) {
        return !!~("" + t).indexOf(e)
    }
    function l(t) {
        return t.replace(/([a-z])-([a-z])/g, function(t, e, n) {
            return e + n.toUpperCase()
        }).replace(/^-/, "")
    }
    function u() {
        var t = e.body;
        return t || (t = a(S ? "svg" : "body"),
        t.fake = !0),
        t
    }
    function c(t, n, r, i) {
        var o, s, l, c, d = "modernizr", p = a("div"), f = u();
        if (parseInt(r, 10))
            for (; r--; )
                l = a("div"),
                l.id = i ? i[r] : d + (r + 1),
                p.appendChild(l);
        return o = a("style"),
        o.type = "text/css",
        o.id = "s" + d,
        (f.fake ? f : p).appendChild(o),
        f.appendChild(p),
        o.styleSheet ? o.styleSheet.cssText = t : o.appendChild(e.createTextNode(t)),
        p.id = d,
        f.fake && (f.style.background = "",
        f.style.overflow = "hidden",
        c = _.style.overflow,
        _.style.overflow = "hidden",
        _.appendChild(f)),
        s = n(p, t),
        f.fake ? (f.parentNode.removeChild(f),
        _.style.overflow = c,
        _.offsetHeight) : p.parentNode.removeChild(p),
        !!s
    }
    function d(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }
    function p(t, e, n) {
        var i;
        for (var o in t)
            if (t[o]in e)
                return n === !1 ? t[o] : (i = e[t[o]],
                r(i, "function") ? d(i, n || e) : i);
        return !1
    }
    function f(t) {
        return t.replace(/([A-Z])/g, function(t, e) {
            return "-" + e.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }
    function h(e, n, r) {
        var i;
        if ("getComputedStyle"in t) {
            i = getComputedStyle.call(t, e, n);
            var o = t.console;
            if (null !== i)
                r && (i = i.getPropertyValue(r));
            else if (o) {
                var a = o.error ? "error" : "log";
                o[a].call(o, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
            }
        } else
            i = !n && e.currentStyle && e.currentStyle[r];
        return i
    }
    function m(e, r) {
        var i = e.length;
        if ("CSS"in t && "supports"in t.CSS) {
            for (; i--; )
                if (t.CSS.supports(f(e[i]), r))
                    return !0;
            return !1
        }
        if ("CSSSupportsRule"in t) {
            for (var o = []; i--; )
                o.push("(" + f(e[i]) + ":" + r + ")");
            return o = o.join(" or "),
            c("@supports (" + o + ") { #modernizr { position: absolute; } }", function(t) {
                return "absolute" == h(t, null, "position")
            })
        }
        return n
    }
    function g(t, e, i, o) {
        function u() {
            d && (delete j.style,
            delete j.modElem)
        }
        if (o = !r(o, "undefined") && o,
        !r(i, "undefined")) {
            var c = m(t, i);
            if (!r(c, "undefined"))
                return c
        }
        for (var d, p, f, h, g, v = ["modernizr", "tspan", "samp"]; !j.style && v.length; )
            d = !0,
            j.modElem = a(v.shift()),
            j.style = j.modElem.style;
        for (f = t.length,
        p = 0; f > p; p++)
            if (h = t[p],
            g = j.style[h],
            s(h, "-") && (h = l(h)),
            j.style[h] !== n) {
                if (o || r(i, "undefined"))
                    return u(),
                    "pfx" != e || h;
                try {
                    j.style[h] = i
                } catch (t) {}
                if (j.style[h] != g)
                    return u(),
                    "pfx" != e || h
            }
        return u(),
        !1
    }
    function v(t, e, n, i, o) {
        var a = t.charAt(0).toUpperCase() + t.slice(1)
          , s = (t + " " + O.join(a + " ") + a).split(" ");
        return r(e, "string") || r(e, "undefined") ? g(s, e, i, o) : (s = (t + " " + E.join(a + " ") + a).split(" "),
        p(s, e, n))
    }
    function y(t, e, r) {
        return v(t, n, n, e, r)
    }
    var b = []
      , w = []
      , x = {
        _version: "3.6.0",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(t, e) {
            var n = this;
            setTimeout(function() {
                e(n[t])
            }, 0)
        },
        addTest: function(t, e, n) {
            w.push({
                name: t,
                fn: e,
                options: n
            })
        },
        addAsyncTest: function(t) {
            w.push({
                name: null,
                fn: t
            })
        }
    }
      , C = function() {};
    C.prototype = x,
    C = new C,
    C.addTest("svg", !!e.createElementNS && !!e.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var k = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    x._prefixes = k;
    var _ = e.documentElement
      , S = "svg" === _.nodeName.toLowerCase()
      , T = "Moz O ms Webkit"
      , E = x._config.usePrefixes ? T.toLowerCase().split(" ") : [];
    x._domPrefixes = E;
    var A = "CSS"in t && "supports"in t.CSS
      , M = "supportsCSS"in t;
    C.addTest("supports", A || M),
    C.addTest("placeholder", "placeholder"in a("input") && "placeholder"in a("textarea"));
    var O = x._config.usePrefixes ? T.split(" ") : [];
    x._cssomPrefixes = O;
    var L = x.testStyles = c;
    C.addTest("touchevents", function() {
        var n;
        if ("ontouchstart"in t || t.DocumentTouch && e instanceof DocumentTouch)
            n = !0;
        else {
            var r = ["@media (", k.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            L(r, function(t) {
                n = 9 === t.offsetTop
            })
        }
        return n
    });
    var I = {
        elem: a("modernizr")
    };
    C._q.push(function() {
        delete I.elem
    });
    var j = {
        style: I.elem.style
    };
    C._q.unshift(function() {
        delete j.style
    }),
    x.testProp = function(t, e, r) {
        return g([t], n, e, r)
    }
    ,
    x.testAllProps = v,
    x.testAllProps = y,
    C.addTest("flexbox", y("flexBasis", "1px", !0)),
    C.addTest("csstransforms", function() {
        return -1 === navigator.userAgent.indexOf("Android 2.") && y("transform", "scale(1)", !0)
    }),
    C.addTest("csstransforms3d", function() {
        return !!y("perspective", "1px", !0)
    });
    var z = function(e) {
        var r, i = k.length, o = t.CSSRule;
        if ("undefined" == typeof o)
            return n;
        if (!e)
            return !1;
        if (e = e.replace(/^@/, ""),
        r = e.replace(/-/g, "_").toUpperCase() + "_RULE",
        r in o)
            return "@" + e;
        for (var a = 0; i > a; a++) {
            var s = k[a]
              , l = s.toUpperCase() + "_" + r;
            if (l in o)
                return "@-" + s.toLowerCase() + "-" + e
        }
        return !1
    };
    x.atRule = z;
    var N = x.prefixed = function(t, e, n) {
        return 0 === t.indexOf("@") ? z(t) : (-1 != t.indexOf("-") && (t = l(t)),
        e ? v(t, e, n) : v(t, "pfx"))
    }
    ;
    C.addTest("backgroundblendmode", N("backgroundBlendMode", "text")),
    i(),
    o(b),
    delete x.addTest,
    delete x.addAsyncTest;
    for (var P = 0; P < C._q.length; P++)
        C._q[P]();
    t.Modernizr = C
}(window, document),
/*! css-vars-ponyfill.min.js */
/*!
 * css-vars-ponyfill
 * v1.17.2
 * https://github.com/jhildenbiddle/css-vars-ponyfill
 * (c) 2018-2019 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self).cssVars = e()
}(this, function() {
    "use strict";
    function t() {
        return (t = Object.assign || function(t) {
            for (var e = 1; e < arguments.length; e++) {
                var n = arguments[e];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r])
            }
            return t
        }
        ).apply(this, arguments)
    }
    function e(t) {
        return function(t) {
            if (Array.isArray(t)) {
                for (var e = 0, n = new Array(t.length); e < t.length; e++)
                    n[e] = t[e];
                return n
            }
        }(t) || function(t) {
            if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))
                return Array.from(t)
        }(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance")
        }()
    }
    function n(t) {
        function e() {
            return !("<" === (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").trim().charAt(0))
        }
        function n(t, e) {
            o.onError(t, a[e], e)
        }
        function r(t, e) {
            var n = o.onSuccess(t, a[e], e);
            t = !1 === n ? "" : n || t,
            s[e] = t,
            -1 === s.indexOf(null) && o.onComplete(s)
        }
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
          , o = {
            mimeType: i.mimeType || null,
            onBeforeSend: i.onBeforeSend || Function.prototype,
            onSuccess: i.onSuccess || Function.prototype,
            onError: i.onError || Function.prototype,
            onComplete: i.onComplete || Function.prototype
        }
          , a = Array.isArray(t) ? t : [t]
          , s = Array.apply(null, Array(a.length)).map(function(t) {
            return null
        })
          , l = document.createElement("a");
        a.forEach(function(t, i) {
            if (l.setAttribute("href", t),
            l.href = String(l.href),
            Boolean(document.all && !window.atob) && l.host.split(":")[0] !== location.host.split(":")[0])
                if (l.protocol === location.protocol) {
                    var a = new XDomainRequest;
                    a.open("GET", t),
                    a.timeout = 0,
                    a.onprogress = Function.prototype,
                    a.ontimeout = Function.prototype,
                    a.onload = function() {
                        e(a.responseText) ? r(a.responseText, i) : n(a, i)
                    }
                    ,
                    a.onerror = function(t) {
                        n(a, i)
                    }
                    ,
                    setTimeout(function() {
                        a.send()
                    }, 0)
                } else
                    console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(t, ")")),
                    n(null, i);
            else {
                var s = new XMLHttpRequest;
                s.open("GET", t),
                o.mimeType && s.overrideMimeType && s.overrideMimeType(o.mimeType),
                o.onBeforeSend(s, t, i),
                s.onreadystatechange = function() {
                    4 === s.readyState && (200 === s.status && e(s.responseText) ? r(s.responseText, i) : n(s, i))
                }
                ,
                s.send()
            }
        })
    }
    function r(t) {
        function e() {
            if (-1 === u.indexOf(null)) {
                var t = u.join("");
                s.onComplete(t, u, l)
            }
        }
        function r(t, r, i, a) {
            var l = s.onSuccess(t, i, a);
            !function t(e, r, i, a) {
                var l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : []
                  , u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : []
                  , c = o(e, i, u);
                c.rules.length ? n(c.absoluteUrls, {
                    onBeforeSend: function(t, e, n) {
                        s.onBeforeSend(t, r, e)
                    },
                    onSuccess: function(t, e, n) {
                        var i = s.onSuccess(t, r, e)
                          , a = o(t = !1 === i ? "" : i || t, e, u);
                        return a.rules.forEach(function(e, n) {
                            t = t.replace(e, a.absoluteRules[n])
                        }),
                        t
                    },
                    onError: function(n, o, s) {
                        l.push({
                            xhr: n,
                            url: o
                        }),
                        u.push(c.rules[s]),
                        t(e, r, i, a, l, u)
                    },
                    onComplete: function(n) {
                        n.forEach(function(t, n) {
                            e = e.replace(c.rules[n], t)
                        }),
                        t(e, r, i, a, l, u)
                    }
                }) : a(e, l)
            }(t = void 0 !== l && !1 === Boolean(l) ? "" : l || t, i, a, function(t, n) {
                null === u[r] && (n.forEach(function(t) {
                    return s.onError(t.xhr, i, t.url)
                }),
                !s.filter || s.filter.test(t) ? u[r] = t : u[r] = "",
                e())
            })
        }
        function o(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : []
              , r = {};
            return r.rules = (t.replace(a.cssComments, "").match(a.cssImports) || []).filter(function(t) {
                return -1 === n.indexOf(t)
            }),
            r.urls = r.rules.map(function(t) {
                return t.replace(a.cssImports, "$1")
            }),
            r.absoluteUrls = r.urls.map(function(t) {
                return i(t, e)
            }),
            r.absoluteRules = r.rules.map(function(t, n) {
                var o = r.urls[n]
                  , a = i(r.absoluteUrls[n], e);
                return t.replace(o, a)
            }),
            r
        }
        var a = {
            cssComments: /\/\*[\s\S]+?\*\//g,
            cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g
        }
          , s = {
            rootElement: t.rootElement || document,
            include: t.include || 'style,link[rel="stylesheet"]',
            exclude: t.exclude || null,
            filter: t.filter || null,
            useCSSOM: t.useCSSOM || !1,
            onBeforeSend: t.onBeforeSend || Function.prototype,
            onSuccess: t.onSuccess || Function.prototype,
            onError: t.onError || Function.prototype,
            onComplete: t.onComplete || Function.prototype
        }
          , l = Array.apply(null, s.rootElement.querySelectorAll(s.include)).filter(function(t) {
            return e = t,
            n = s.exclude,
            !(e.matches || e.matchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector).call(e, n);
            var e, n
        })
          , u = Array.apply(null, Array(l.length)).map(function(t) {
            return null
        });
        l.length ? l.forEach(function(t, o) {
            var a = t.getAttribute("href")
              , l = t.getAttribute("rel")
              , c = "LINK" === t.nodeName && a && l && "stylesheet" === l.toLowerCase()
              , d = "STYLE" === t.nodeName;
            if (c)
                n(a, {
                    mimeType: "text/css",
                    onBeforeSend: function(e, n, r) {
                        s.onBeforeSend(e, t, n)
                    },
                    onSuccess: function(e, n, s) {
                        var l = i(a, location.href);
                        r(e, o, t, l)
                    },
                    onError: function(n, r, i) {
                        u[o] = "",
                        s.onError(n, t, r),
                        e()
                    }
                });
            else if (d) {
                var p = t.textContent;
                s.useCSSOM && (p = Array.apply(null, t.sheet.cssRules).map(function(t) {
                    return t.cssText
                }).join("")),
                r(p, o, t, location.href)
            } else
                u[o] = "",
                e()
        }) : s.onComplete("", [])
    }
    function i(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : location.href
          , n = document.implementation.createHTMLDocument("")
          , r = n.createElement("base")
          , i = n.createElement("a");
        return n.head.appendChild(r),
        n.body.appendChild(i),
        r.href = e,
        i.href = t,
        i.href
    }
    function o(t, e, n) {
        t instanceof RegExp && (t = a(t, n)),
        e instanceof RegExp && (e = a(e, n));
        var r = s(t, e, n);
        return r && {
            start: r[0],
            end: r[1],
            pre: n.slice(0, r[0]),
            body: n.slice(r[0] + t.length, r[1]),
            post: n.slice(r[1] + e.length)
        }
    }
    function a(t, e) {
        var n = e.match(t);
        return n ? n[0] : null
    }
    function s(t, e, n) {
        var r, i, o, a, s, l = n.indexOf(t), u = n.indexOf(e, l + 1), c = l;
        if (l >= 0 && u > 0) {
            for (r = [],
            o = n.length; c >= 0 && !s; )
                c == l ? (r.push(c),
                l = n.indexOf(t, c + 1)) : 1 == r.length ? s = [r.pop(), u] : ((i = r.pop()) < o && (o = i,
                a = u),
                u = n.indexOf(e, c + 1)),
                c = l < u && l >= 0 ? l : u;
            r.length && (s = [o, a])
        }
        return s
    }
    function l(e) {
        function n(t) {
            throw new Error("CSS parse error: ".concat(t))
        }
        function r(t) {
            var n = t.exec(e);
            if (n)
                return e = e.slice(n[0].length),
                n
        }
        function i() {
            return r(/^{\s*/)
        }
        function o() {
            return r(/^}/)
        }
        function a() {
            r(/^\s*/)
        }
        function s() {
            if (a(),
            "/" === e[0] && "*" === e[1]) {
                for (var t = 2; e[t] && ("*" !== e[t] || "/" !== e[t + 1]); )
                    t++;
                if (!e[t])
                    return n("end of comment is missing");
                var r = e.slice(2, t);
                return e = e.slice(t + 2),
                {
                    type: "comment",
                    comment: r
                }
            }
        }
        function l() {
            for (var t, e = []; t = s(); )
                e.push(t);
            return v.removeComments ? [] : e
        }
        function u() {
            for (a(); "}" === e[0]; )
                n("extra closing bracket");
            var t = r(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
            if (t)
                return t[0].trim().replace(/\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(t) {
                    return t.replace(/,/g, "‌")
                }).split(/\s*(?![^(]*\)),\s*/).map(function(t) {
                    return t.replace(/\u200C/g, ",")
                })
        }
        function c() {
            r(/^([;\s]*)+/);
            var t = /\/\*[^*]*\*+([^\/*][^*]*\*+)*\//g
              , e = r(/^(\*?[-#\/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
            if (e) {
                if (e = e[0].trim(),
                !r(/^:\s*/))
                    return n("property missing ':'");
                var i = r(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/)
                  , o = {
                    type: "declaration",
                    property: e.replace(t, ""),
                    value: i ? i[0].replace(t, "").trim() : ""
                };
                return r(/^[;\s]*/),
                o
            }
        }
        function d() {
            if (!i())
                return n("missing '{'");
            for (var t, e = l(); t = c(); )
                e.push(t),
                e = e.concat(l());
            return o() ? e : n("missing '}'")
        }
        function p() {
            a();
            for (var t, e = []; t = r(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/); )
                e.push(t[1]),
                r(/^,\s*/);
            if (e.length)
                return {
                    type: "keyframe",
                    values: e,
                    declarations: d()
                }
        }
        function f() {
            if (a(),
            "@" === e[0]) {
                var t = function() {
                    var t = r(/^@([-\w]+)?keyframes\s*/);
                    if (t) {
                        var e = t[1];
                        if (!(t = r(/^([-\w]+)\s*/)))
                            return n("@keyframes missing name");
                        var a, s = t[1];
                        if (!i())
                            return n("@keyframes missing '{'");
                        for (var u = l(); a = p(); )
                            u.push(a),
                            u = u.concat(l());
                        return o() ? {
                            type: "keyframes",
                            name: s,
                            vendor: e,
                            keyframes: u
                        } : n("@keyframes missing '}'")
                    }
                }() || function() {
                    var t = r(/^@supports *([^{]+)/);
                    if (t)
                        return {
                            type: "supports",
                            supports: t[1].trim(),
                            rules: g()
                        }
                }() || function() {
                    if (r(/^@host\s*/))
                        return {
                            type: "host",
                            rules: g()
                        }
                }() || function() {
                    var t = r(/^@media *([^{]+)/);
                    if (t)
                        return {
                            type: "media",
                            media: t[1].trim(),
                            rules: g()
                        }
                }() || function() {
                    var t = r(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
                    if (t)
                        return {
                            type: "custom-media",
                            name: t[1].trim(),
                            media: t[2].trim()
                        }
                }() || function() {
                    if (r(/^@page */))
                        return {
                            type: "page",
                            selectors: u() || [],
                            declarations: d()
                        }
                }() || function() {
                    var t = r(/^@([-\w]+)?document *([^{]+)/);
                    if (t)
                        return {
                            type: "document",
                            document: t[2].trim(),
                            vendor: t[1] ? t[1].trim() : null,
                            rules: g()
                        }
                }() || function() {
                    if (r(/^@font-face\s*/))
                        return {
                            type: "font-face",
                            declarations: d()
                        }
                }() || function() {
                    var t = r(/^@(import|charset|namespace)\s*([^;]+);/);
                    if (t)
                        return {
                            type: t[1],
                            name: t[2].trim()
                        }
                }();
                if (t && v.onlyVars) {
                    var s = !1;
                    return s = t.declarations ? t.declarations.some(function(t) {
                        return /var\(/.test(t.value)
                    }) : (t.keyframes || t.rules || []).some(function(t) {
                        return (t.declarations || []).some(function(t) {
                            return /var\(/.test(t.value)
                        })
                    }),
                    s ? t : {}
                }
                return t
            }
        }
        function h() {
            if (v.onlyVars) {
                var t = m("{", "}", e);
                if (t) {
                    var r = -1 !== t.pre.indexOf(":root") && /--\S*\s*:/.test(t.body)
                      , i = /var\(/.test(t.body);
                    if (!r && !i)
                        return e = e.slice(t.end + 1),
                        {}
                }
            }
            var o = u() || []
              , a = v.onlyVars ? d().filter(function(t) {
                var e = o.some(function(t) {
                    return -1 !== t.indexOf(":root")
                }) && /^--\S/.test(t.property)
                  , n = /var\(/.test(t.value);
                return e || n
            }) : d();
            return o.length || n("selector missing"),
            {
                type: "rule",
                selectors: o,
                declarations: a
            }
        }
        function g(t) {
            if (!t && !i())
                return n("missing '{'");
            for (var r, a = l(); e.length && (t || "}" !== e[0]) && (r = f() || h()); )
                r.type && a.push(r),
                a = a.concat(l());
            return t || o() ? a : n("missing '}'")
        }
        var v = t({}, {
            onlyVars: !1,
            removeComments: !1
        }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
        return {
            type: "stylesheet",
            stylesheet: {
                rules: g(!0),
                errors: []
            }
        }
    }
    function u(e) {
        var n, r, i = t({}, {
            fixNestedCalc: !0,
            onlyVars: !1,
            persist: !1,
            preserve: !1,
            variables: {},
            onWarning: function() {}
        }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}), o = i.persist ? y.dom : y.temp = JSON.parse(JSON.stringify(y.dom)), a = l(e, {
            onlyVars: i.onlyVars
        });
        if (a.stylesheet.rules.forEach(function(t) {
            var e = [];
            if ("rule" === t.type && 1 === t.selectors.length && ":root" === t.selectors[0] && (t.declarations.forEach(function(t, n) {
                var r = t.property
                  , i = t.value;
                r && 0 === r.indexOf(g) && (o[r] = i,
                e.push(n))
            }),
            !i.preserve))
                for (var n = e.length - 1; n >= 0; n--)
                    t.declarations.splice(e[n], 1)
        }),
        Object.keys(y.user).forEach(function(t) {
            o[t] = y.user[t]
        }),
        Object.keys(i.variables).length) {
            var s = {
                declarations: [],
                selectors: [":root"],
                type: "rule"
            };
            Object.keys(i.variables).forEach(function(t) {
                var e = "--".concat(t.replace(/^-+/, ""))
                  , n = i.variables[t];
                i.persist && (y.user[e] = n),
                o[e] !== n && (o[e] = n,
                s.declarations.push({
                    type: "declaration",
                    property: e,
                    value: n
                }))
            }),
            i.preserve && s.declarations.length && a.stylesheet.rules.push(s)
        }
        return function t(e, n) {
            e.rules.forEach(function(r) {
                r.rules ? t(r, n) : r.keyframes ? r.keyframes.forEach(function(t) {
                    "keyframe" === t.type && n(t.declarations, r)
                }) : r.declarations && n(r.declarations, e)
            })
        }(a.stylesheet, function(t, e) {
            for (var n, r, a, s = 0; s < t.length; s++)
                a = (n = t[s]).value,
                "declaration" === n.type && a && -1 !== a.indexOf(v + "(") && (r = c(a, o, i)) !== n.value && (i.preserve ? (t.splice(s, 0, {
                    type: n.type,
                    property: n.property,
                    value: r
                }),
                s++) : n.value = r)
        }),
        i.fixNestedCalc && (n = a.stylesheet.rules,
        r = /(-[a-z]+-)?calc\(/,
        n.forEach(function(t) {
            t.declarations && t.declarations.forEach(function(t) {
                for (var e = t.value, n = ""; r.test(e); ) {
                    var i = m("calc(", ")", e || "");
                    for (e = e.slice(i.end); r.test(i.body); ) {
                        var o = m(r, ")", i.body);
                        i.body = "".concat(o.pre, "(").concat(o.body, ")").concat(o.post)
                    }
                    n += "".concat(i.pre, "calc(").concat(i.body),
                    n += r.test(e) ? "" : ")".concat(i.post)
                }
                t.value = n || t.value
            })
        })),
        function(t) {
            function e(t) {
                for (var e = "", o = 0; o < t.length; o++) {
                    var a = t[o];
                    r && r(a);
                    var s = i[a.type](a);
                    s && (e += s,
                    s.length && a.selectors && (e += n))
                }
                return e
            }
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
              , r = arguments.length > 2 ? arguments[2] : void 0
              , i = {
                charset: function(t) {
                    return "@charset " + t.name + ";"
                },
                comment: function(t) {
                    return 0 === t.comment.indexOf("__CSSVARSPONYFILL") ? "/*" + t.comment + "*/" : ""
                },
                "custom-media": function(t) {
                    return "@custom-media " + t.name + " " + t.media + ";"
                },
                declaration: function(t) {
                    return t.property + ":" + t.value + ";"
                },
                document: function(t) {
                    return "@" + (t.vendor || "") + "document " + t.document + "{" + e(t.rules) + "}"
                },
                "font-face": function(t) {
                    return "@font-face{" + e(t.declarations) + "}"
                },
                host: function(t) {
                    return "@host{" + e(t.rules) + "}"
                },
                import: function(t) {
                    return "@import " + t.name + ";"
                },
                keyframe: function(t) {
                    return t.values.join(",") + "{" + e(t.declarations) + "}"
                },
                keyframes: function(t) {
                    return "@" + (t.vendor || "") + "keyframes " + t.name + "{" + e(t.keyframes) + "}"
                },
                media: function(t) {
                    return "@media " + t.media + "{" + e(t.rules) + "}"
                },
                namespace: function(t) {
                    return "@namespace " + t.name + ";"
                },
                page: function(t) {
                    return "@page " + (t.selectors.length ? t.selectors.join(", ") : "") + "{" + e(t.declarations) + "}"
                },
                rule: function(t) {
                    var n = t.declarations;
                    if (n.length)
                        return t.selectors.join(",") + "{" + e(n) + "}"
                },
                supports: function(t) {
                    return "@supports " + t.supports + "{" + e(t.rules) + "}"
                }
            };
            return e(t.stylesheet.rules)
        }(a)
    }
    function c(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}
          , r = arguments.length > 3 ? arguments[3] : void 0;
        if (-1 === t.indexOf("var("))
            return t;
        var i = m("(", ")", t);
        return i ? "var" === i.pre.slice(-3) ? 0 === i.body.trim().length ? (n.onWarning("var() must contain a non-whitespace string"),
        t) : i.pre.slice(0, -3) + function(t) {
            var i = t.split(",")[0].replace(/[\s\n\t]/g, "")
              , o = (t.match(/(?:\s*,\s*){1}(.*)?/) || [])[1]
              , a = e.hasOwnProperty(i) ? String(e[i]) : void 0
              , s = a || (o ? String(o) : void 0)
              , l = r || t;
            return a || n.onWarning('variable "'.concat(i, '" is undefined')),
            s && "undefined" !== s && s.length > 0 ? c(s, e, n, l) : "var(".concat(l, ")")
        }(i.body) + c(i.post, e, n) : i.pre + "(".concat(c(i.body, e, n), ")") + c(i.post, e, n) : (-1 !== t.indexOf("var(") && n.onWarning('missing closing ")" in the value "'.concat(t, '"')),
        t)
    }
    function d() {
        function n(t, e, n, r) {
            a.silent || console.error("".concat(C).concat(t, "\n"), e),
            a.onError(t, e, n, r)
        }
        function i(t) {
            a.silent || console.warn("".concat(C).concat(t)),
            a.onWarning(t)
        }
        var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
          , a = t({}, k, o)
          , s = b;
        if (a.exclude = "#".concat(s) + (a.exclude ? ",".concat(a.exclude) : ""),
        a._benchmark = a._benchmark ? a._benchmark : h(),
        w)
            if (!1 === a.watch && S && S.disconnect(),
            a.watch)
                !function(t, e) {
                    if (window.MutationObserver) {
                        var n = function(t) {
                            return "LINK" === t.tagName && -1 !== (t.getAttribute("rel") || "").indexOf("stylesheet")
                        }
                          , r = function(t) {
                            return "STYLE" === t.tagName && (!e || t.id !== e)
                        };
                        S && S.disconnect(),
                        t.watch = k.watch,
                        (S = new MutationObserver(function(e) {
                            var i = e.some(function(t) {
                                var e = !1;
                                if ("attributes" === t.type)
                                    e = n(t.target) || r(t.target);
                                else if ("childList" === t.type) {
                                    var i = Array.apply(null, t.addedNodes)
                                      , o = Array.apply(null, t.removedNodes);
                                    e = [].concat(i, o).some(function(t) {
                                        var e = n(t) && !t.disabled
                                          , i = r(t) && _.cssVars.test(t.textContent);
                                        return e || i
                                    })
                                }
                                return e
                            });
                            i && p(t)
                        }
                        )).observe(document.documentElement, {
                            attributes: !0,
                            attributeFilter: ["disabled", "href"],
                            childList: !0,
                            subtree: !0
                        })
                    }
                }(a, s),
                p(a);
            else if ("loading" !== document.readyState) {
                var l = a.shadowDOM || a.rootElement.shadowRoot || a.rootElement.host;
                if (x && a.onlyLegacy) {
                    if (a.updateDOM) {
                        var c = a.rootElement.host || (a.rootElement === document ? document.documentElement : a.rootElement);
                        Object.keys(a.variables).forEach(function(t) {
                            var e = "--".concat(t.replace(/^-+/, ""))
                              , n = a.variables[t];
                            c.style.setProperty(e, n)
                        })
                    }
                } else
                    r(l && !E ? {
                        rootElement: k.rootElement,
                        include: k.include,
                        exclude: a.exclude,
                        onSuccess: function(t, e, n) {
                            return (t.match(_.cssRootRules) || []).join("") || !1
                        },
                        onComplete: function(t, e, n) {
                            u(t, {
                                persist: !0
                            }),
                            E = !0,
                            d(a)
                        }
                    } : {
                        rootElement: a.rootElement,
                        include: a.include,
                        exclude: a.exclude,
                        filter: a.onlyVars ? _.cssVars : null,
                        onBeforeSend: a.onBeforeSend,
                        onSuccess: function(t, e, n) {
                            var r = a.onSuccess(t, e, n);
                            return t = void 0 !== r && !1 === Boolean(r) ? "" : r || t,
                            e.setAttribute("data-cssvars", ""),
                            a.updateURLs && (t.replace(_.cssComments, "").match(_.cssUrls) || []).forEach(function(e) {
                                var r = e.replace(_.cssUrls, "$1")
                                  , i = f(r, n);
                                t = t.replace(e, e.replace(r, i))
                            }),
                            t
                        },
                        onError: function(t, e, r) {
                            var i = t.responseURL || f(r, location.href)
                              , o = t.statusText ? "(".concat(t.statusText, ")") : "Unspecified Error" + (0 === t.status ? " (possibly CORS related)" : "");
                            n("CSS XHR Error: ".concat(i, " ").concat(t.status, " ").concat(o), e, t, i)
                        },
                        onComplete: function(r, o, l) {
                            var c, p = JSON.stringify({
                                include: a.include,
                                exclude: a.exclude,
                                variables: a.variables,
                                fixNestedCalc: a.fixNestedCalc,
                                onlyVars: a.onlyVars,
                                preserve: a.preserve,
                                silent: a.silent,
                                updateURLs: a.updateURLs
                            }), f = a.rootElement.querySelector("#".concat(s)) || document.createElement("style"), m = f.__cssVars || {}, g = m.cssText === r && m.settings === p;
                            if (g)
                                r = f.textContent,
                                a.silent || console.info("".concat(C, "No changes"), f);
                            else {
                                f.__cssVars = {
                                    cssText: r,
                                    settings: p
                                },
                                r = o.map(function(t, e) {
                                    return _.cssVars.test(t) ? t : "/*__CSSVARSPONYFILL-".concat(e, "__*/")
                                }).join("");
                                try {
                                    r = u(r, {
                                        fixNestedCalc: a.fixNestedCalc,
                                        onlyVars: a.onlyVars,
                                        persist: a.updateDOM,
                                        preserve: a.preserve,
                                        variables: a.variables,
                                        onWarning: i
                                    }),
                                    c = _.cssKeyframes.test(r),
                                    r = r.replace(/\/\*__CSSVARSPONYFILL-(\d+)__\*\//g, function(t, e) {
                                        return o[e]
                                    })
                                } catch (t) {
                                    var v = !1;
                                    o.forEach(function(t, e) {
                                        try {
                                            t = u(t, a)
                                        } catch (t) {
                                            var r = l[e - 0];
                                            v = !0,
                                            n(t.message, r)
                                        }
                                    }),
                                    v || n(t.message || t)
                                }
                            }
                            if (a.shadowDOM)
                                for (var b, w = [a.rootElement].concat(e(a.rootElement.querySelectorAll("*"))), x = 0; b = w[x]; ++x)
                                    b.shadowRoot && b.shadowRoot.querySelector("style") && d(t({}, a, {
                                        rootElement: b.shadowRoot,
                                        variables: y.dom
                                    }));
                            if (!g && l && l.length) {
                                var k = a.rootElement.querySelectorAll("link[data-cssvars],style[data-cssvars]") || a.rootElement.querySelectorAll('link[rel+="stylesheet"],style')
                                  , S = k ? k[k.length - 1] : null;
                                S ? S.parentNode.insertBefore(f, S.nextSibling) : (a.rootElement.head || a.rootElement.body || a.rootElement).appendChild(f),
                                a.updateDOM && (f.setAttribute("id", s),
                                f.textContent = r,
                                c && function(t) {
                                    var e = ["animation-name", "-moz-animation-name", "-webkit-animation-name"].filter(function(t) {
                                        return getComputedStyle(document.body)[t]
                                    })[0];
                                    if (e) {
                                        for (var n = t.getElementsByTagName("*"), r = [], i = 0, o = n.length; i < o; i++) {
                                            var a = n[i]
                                              , s = getComputedStyle(a)[e];
                                            "none" !== s && (a.style[e] += "__CSSVARSPONYFILL-KEYFRAMES__",
                                            r.push(a))
                                        }
                                        document.body.offsetHeight;
                                        for (var l = 0, u = r.length; l < u; l++) {
                                            var c = r[l].style;
                                            c[e] = c[e].replace("__CSSVARSPONYFILL-KEYFRAMES__", "")
                                        }
                                    }
                                }(a.rootElement)),
                                a.onComplete(r, f, JSON.parse(JSON.stringify(a.updateDOM ? y.dom : y.temp)), h() - a._benchmark)
                            }
                        }
                    })
            } else
                document.addEventListener("DOMContentLoaded", function t(e) {
                    d(o),
                    document.removeEventListener("DOMContentLoaded", t)
                })
    }
    function p(t) {
        clearTimeout(T),
        T = setTimeout(function() {
            t._benchmark = null,
            d(t)
        }, 100)
    }
    function f(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : location.href
          , n = document.implementation.createHTMLDocument("")
          , r = n.createElement("base")
          , i = n.createElement("a");
        return n.head.appendChild(r),
        n.body.appendChild(i),
        r.href = e,
        i.href = t,
        i.href
    }
    function h() {
        return w && (window.performance || {}).now ? window.performance.now() : (new Date).getTime()
    }
    var m = o;
    o.range = s;
    var g = "--"
      , v = "var"
      , y = {
        dom: {},
        temp: {},
        user: {}
    }
      , b = "css-vars-ponyfill"
      , w = "undefined" != typeof window
      , x = w && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)")
      , C = "cssVars(): "
      , k = {
        rootElement: w ? document : null,
        shadowDOM: !1,
        include: "style,link[rel=stylesheet]",
        exclude: "",
        variables: {},
        fixNestedCalc: !0,
        onlyLegacy: !0,
        onlyVars: !1,
        preserve: !1,
        silent: !1,
        updateDOM: !0,
        updateURLs: !0,
        watch: null,
        onBeforeSend: function() {},
        onSuccess: function() {},
        onWarning: function() {},
        onError: function() {},
        onComplete: function() {}
    }
      , _ = {
        cssComments: /\/\*[\s\S]+?\*\//g,
        cssKeyframes: /@(?:-\w*-)?keyframes/,
        cssRootRules: /(?::root\s*{\s*[^}]*})/g,
        cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
        cssVars: /(?:(?::root\s*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
    }
      , S = null
      , T = null
      , E = !1;
    return d
}),
/*! jquery-3.4.1.min.js */
/*! jQuery v3.4.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(t, e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function(t) {
        if (!t.document)
            throw new Error("jQuery requires a window with a document");
        return e(t)
    }
    : e(t)
}("undefined" != typeof window ? window : this, function(t, e) {
    "use strict";
    function n(t, e, n) {
        var r, i, o = (n = n || Q).createElement("script");
        if (o.text = t,
        e)
            for (r in pt)
                (i = e[r] || e.getAttribute && e.getAttribute(r)) && o.setAttribute(r, i);
        n.head.appendChild(o).parentNode.removeChild(o)
    }
    function r(t) {
        return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? it[ot.call(t)] || "object" : typeof t
    }
    function i(t) {
        var e = !!t && "length"in t && t.length
          , n = r(t);
        return !ct(t) && !dt(t) && ("array" === n || 0 === e || "number" == typeof e && 0 < e && e - 1 in t)
    }
    function o(t, e) {
        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
    }
    function a(t, e, n) {
        return ct(e) ? ht.grep(t, function(t, r) {
            return !!e.call(t, r, t) !== n
        }) : e.nodeType ? ht.grep(t, function(t) {
            return t === e !== n
        }) : "string" != typeof e ? ht.grep(t, function(t) {
            return -1 < rt.call(e, t) !== n
        }) : ht.filter(e, t, n)
    }
    function s(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType; )
            ;
        return t
    }
    function l(t) {
        return t
    }
    function u(t) {
        throw t
    }
    function c(t, e, n, r) {
        var i;
        try {
            t && ct(i = t.promise) ? i.call(t).done(e).fail(n) : t && ct(i = t.then) ? i.call(t, e, n) : e.apply(void 0, [t].slice(r))
        } catch (t) {
            n.apply(void 0, [t])
        }
    }
    function d() {
        Q.removeEventListener("DOMContentLoaded", d),
        t.removeEventListener("load", d),
        ht.ready()
    }
    function p(t, e) {
        return e.toUpperCase()
    }
    function f(t) {
        return t.replace(Mt, "ms-").replace(Ot, p)
    }
    function h() {
        this.expando = ht.expando + h.uid++
    }
    function m(t, e, n) {
        var r, i;
        if (void 0 === n && 1 === t.nodeType)
            if (r = "data-" + e.replace(Nt, "-$&").toLowerCase(),
            "string" == typeof (n = t.getAttribute(r))) {
                try {
                    n = "true" === (i = n) || "false" !== i && ("null" === i ? null : i === +i + "" ? +i : zt.test(i) ? JSON.parse(i) : i)
                } catch (t) {}
                jt.set(t, e, n)
            } else
                n = void 0;
        return n
    }
    function g(t, e, n, r) {
        var i, o, a = 20, s = r ? function() {
            return r.cur()
        }
        : function() {
            return ht.css(t, e, "")
        }
        , l = s(), u = n && n[3] || (ht.cssNumber[e] ? "" : "px"), c = t.nodeType && (ht.cssNumber[e] || "px" !== u && +l) && Dt.exec(ht.css(t, e));
        if (c && c[3] !== u) {
            for (l /= 2,
            u = u || c[3],
            c = +l || 1; a--; )
                ht.style(t, e, c + u),
                (1 - o) * (1 - (o = s() / l || .5)) <= 0 && (a = 0),
                c /= o;
            c *= 2,
            ht.style(t, e, c + u),
            n = n || []
        }
        return n && (c = +c || +l || 0,
        i = n[1] ? c + (n[1] + 1) * n[2] : +n[2],
        r && (r.unit = u,
        r.start = c,
        r.end = i)),
        i
    }
    function v(t, e) {
        for (var n, r, i, o, a, s, l, u = [], c = 0, d = t.length; c < d; c++)
            (r = t[c]).style && (n = r.style.display,
            e ? ("none" === n && (u[c] = It.get(r, "display") || null,
            u[c] || (r.style.display = "")),
            "" === r.style.display && Bt(r) && (u[c] = (l = a = o = void 0,
            a = (i = r).ownerDocument,
            s = i.nodeName,
            (l = Wt[s]) || (o = a.body.appendChild(a.createElement(s)),
            l = ht.css(o, "display"),
            o.parentNode.removeChild(o),
            "none" === l && (l = "block"),
            Wt[s] = l)))) : "none" !== n && (u[c] = "none",
            It.set(r, "display", n)));
        for (c = 0; c < d; c++)
            null != u[c] && (t[c].style.display = u[c]);
        return t
    }
    function y(t, e) {
        var n;
        return n = "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e || "*") : "undefined" != typeof t.querySelectorAll ? t.querySelectorAll(e || "*") : [],
        void 0 === e || e && o(t, e) ? ht.merge([t], n) : n
    }
    function b(t, e) {
        for (var n = 0, r = t.length; n < r; n++)
            It.set(t[n], "globalEval", !e || It.get(e[n], "globalEval"))
    }
    function w(t, e, n, i, o) {
        for (var a, s, l, u, c, d, p = e.createDocumentFragment(), f = [], h = 0, m = t.length; h < m; h++)
            if ((a = t[h]) || 0 === a)
                if ("object" === r(a))
                    ht.merge(f, a.nodeType ? [a] : a);
                else if (Gt.test(a)) {
                    for (s = s || p.appendChild(e.createElement("div")),
                    l = (Vt.exec(a) || ["", ""])[1].toLowerCase(),
                    u = Yt[l] || Yt._default,
                    s.innerHTML = u[1] + ht.htmlPrefilter(a) + u[2],
                    d = u[0]; d--; )
                        s = s.lastChild;
                    ht.merge(f, s.childNodes),
                    (s = p.firstChild).textContent = ""
                } else
                    f.push(e.createTextNode(a));
        for (p.textContent = "",
        h = 0; a = f[h++]; )
            if (i && -1 < ht.inArray(a, i))
                o && o.push(a);
            else if (c = Ft(a),
            s = y(p.appendChild(a), "script"),
            c && b(s),
            n)
                for (d = 0; a = s[d++]; )
                    Xt.test(a.type || "") && n.push(a);
        return p
    }
    function x() {
        return !0
    }
    function C() {
        return !1
    }
    function k(t, e) {
        return t === function() {
            try {
                return Q.activeElement
            } catch (t) {}
        }() == ("focus" === e)
    }
    function _(t, e, n, r, i, o) {
        var a, s;
        if ("object" == typeof e) {
            for (s in "string" != typeof n && (r = r || n,
            n = void 0),
            e)
                _(t, s, n, r, e[s], o);
            return t
        }
        if (null == r && null == i ? (i = n,
        r = n = void 0) : null == i && ("string" == typeof n ? (i = r,
        r = void 0) : (i = r,
        r = n,
        n = void 0)),
        !1 === i)
            i = C;
        else if (!i)
            return t;
        return 1 === o && (a = i,
        (i = function(t) {
            return ht().off(t),
            a.apply(this, arguments)
        }
        ).guid = a.guid || (a.guid = ht.guid++)),
        t.each(function() {
            ht.event.add(this, e, i, r, n)
        })
    }
    function S(t, e, n) {
        n ? (It.set(t, e, !1),
        ht.event.add(t, e, {
            namespace: !1,
            handler: function(t) {
                var r, i, o = It.get(this, e);
                if (1 & t.isTrigger && this[e]) {
                    if (o.length)
                        (ht.event.special[e] || {}).delegateType && t.stopPropagation();
                    else if (o = tt.call(arguments),
                    It.set(this, e, o),
                    r = n(this, e),
                    this[e](),
                    o !== (i = It.get(this, e)) || r ? It.set(this, e, !1) : i = {},
                    o !== i)
                        return t.stopImmediatePropagation(),
                        t.preventDefault(),
                        i.value
                } else
                    o.length && (It.set(this, e, {
                        value: ht.event.trigger(ht.extend(o[0], ht.Event.prototype), o.slice(1), this)
                    }),
                    t.stopImmediatePropagation())
            }
        })) : void 0 === It.get(t, e) && ht.event.add(t, e, x)
    }
    function T(t, e) {
        return o(t, "table") && o(11 !== e.nodeType ? e : e.firstChild, "tr") && ht(t).children("tbody")[0] || t
    }
    function E(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type,
        t
    }
    function A(t) {
        return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"),
        t
    }
    function M(t, e) {
        var n, r, i, o, a, s, l, u;
        if (1 === e.nodeType) {
            if (It.hasData(t) && (o = It.access(t),
            a = It.set(e, o),
            u = o.events))
                for (i in delete a.handle,
                a.events = {},
                u)
                    for (n = 0,
                    r = u[i].length; n < r; n++)
                        ht.event.add(e, i, u[i][n]);
            jt.hasData(t) && (s = jt.access(t),
            l = ht.extend({}, s),
            jt.set(e, l))
        }
    }
    function O(t, e, r, i) {
        e = et.apply([], e);
        var o, a, s, l, u, c, d = 0, p = t.length, f = p - 1, h = e[0], m = ct(h);
        if (m || 1 < p && "string" == typeof h && !ut.checkClone && re.test(h))
            return t.each(function(n) {
                var o = t.eq(n);
                m && (e[0] = h.call(this, n, o.html())),
                O(o, e, r, i)
            });
        if (p && (a = (o = w(e, t[0].ownerDocument, !1, t, i)).firstChild,
        1 === o.childNodes.length && (o = a),
        a || i)) {
            for (l = (s = ht.map(y(o, "script"), E)).length; d < p; d++)
                u = o,
                d !== f && (u = ht.clone(u, !0, !0),
                l && ht.merge(s, y(u, "script"))),
                r.call(t[d], u, d);
            if (l)
                for (c = s[s.length - 1].ownerDocument,
                ht.map(s, A),
                d = 0; d < l; d++)
                    u = s[d],
                    Xt.test(u.type || "") && !It.access(u, "globalEval") && ht.contains(c, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? ht._evalUrl && !u.noModule && ht._evalUrl(u.src, {
                        nonce: u.nonce || u.getAttribute("nonce")
                    }) : n(u.textContent.replace(ie, ""), u, c))
        }
        return t
    }
    function L(t, e, n) {
        for (var r, i = e ? ht.filter(e, t) : t, o = 0; null != (r = i[o]); o++)
            n || 1 !== r.nodeType || ht.cleanData(y(r)),
            r.parentNode && (n && Ft(r) && b(y(r, "script")),
            r.parentNode.removeChild(r));
        return t
    }
    function I(t, e, n) {
        var r, i, o, a, s = t.style;
        return (n = n || ae(t)) && ("" !== (a = n.getPropertyValue(e) || n[e]) || Ft(t) || (a = ht.style(t, e)),
        !ut.pixelBoxStyles() && oe.test(a) && se.test(e) && (r = s.width,
        i = s.minWidth,
        o = s.maxWidth,
        s.minWidth = s.maxWidth = s.width = a,
        a = n.width,
        s.width = r,
        s.minWidth = i,
        s.maxWidth = o)),
        void 0 !== a ? a + "" : a
    }
    function j(t, e) {
        return {
            get: function() {
                return t() ? void delete this.get : (this.get = e).apply(this, arguments)
            }
        }
    }
    function z(t) {
        var e = ht.cssProps[t] || ce[t];
        return e || (t in ue ? t : ce[t] = function(t) {
            for (var e = t[0].toUpperCase() + t.slice(1), n = le.length; n--; )
                if ((t = le[n] + e)in ue)
                    return t
        }(t) || t)
    }
    function N(t, e, n) {
        var r = Dt.exec(e);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : e
    }
    function P(t, e, n, r, i, o) {
        var a = "width" === e ? 1 : 0
          , s = 0
          , l = 0;
        if (n === (r ? "border" : "content"))
            return 0;
        for (; a < 4; a += 2)
            "margin" === n && (l += ht.css(t, n + $t[a], !0, i)),
            r ? ("content" === n && (l -= ht.css(t, "padding" + $t[a], !0, i)),
            "margin" !== n && (l -= ht.css(t, "border" + $t[a] + "Width", !0, i))) : (l += ht.css(t, "padding" + $t[a], !0, i),
            "padding" !== n ? l += ht.css(t, "border" + $t[a] + "Width", !0, i) : s += ht.css(t, "border" + $t[a] + "Width", !0, i));
        return !r && 0 <= o && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - o - l - s - .5)) || 0),
        l
    }
    function D(t, e, n) {
        var r = ae(t)
          , i = (!ut.boxSizingReliable() || n) && "border-box" === ht.css(t, "boxSizing", !1, r)
          , o = i
          , a = I(t, e, r)
          , s = "offset" + e[0].toUpperCase() + e.slice(1);
        if (oe.test(a)) {
            if (!n)
                return a;
            a = "auto"
        }
        return (!ut.boxSizingReliable() && i || "auto" === a || !parseFloat(a) && "inline" === ht.css(t, "display", !1, r)) && t.getClientRects().length && (i = "border-box" === ht.css(t, "boxSizing", !1, r),
        (o = s in t) && (a = t[s])),
        (a = parseFloat(a) || 0) + P(t, e, n || (i ? "border" : "content"), o, r, a) + "px"
    }
    function $(t, e, n, r, i) {
        return new $.prototype.init(t,e,n,r,i)
    }
    function R() {
        ge && (!1 === Q.hidden && t.requestAnimationFrame ? t.requestAnimationFrame(R) : t.setTimeout(R, ht.fx.interval),
        ht.fx.tick())
    }
    function F() {
        return t.setTimeout(function() {
            me = void 0
        }),
        me = Date.now()
    }
    function H(t, e) {
        var n, r = 0, i = {
            height: t
        };
        for (e = e ? 1 : 0; r < 4; r += 2 - e)
            i["margin" + (n = $t[r])] = i["padding" + n] = t;
        return e && (i.opacity = i.width = t),
        i
    }
    function B(t, e, n) {
        for (var r, i = (q.tweeners[e] || []).concat(q.tweeners["*"]), o = 0, a = i.length; o < a; o++)
            if (r = i[o].call(n, e, t))
                return r
    }
    function q(t, e, n) {
        var r, i, o = 0, a = q.prefilters.length, s = ht.Deferred().always(function() {
            delete l.elem
        }), l = function() {
            if (i)
                return !1;
            for (var e = me || F(), n = Math.max(0, u.startTime + u.duration - e), r = 1 - (n / u.duration || 0), o = 0, a = u.tweens.length; o < a; o++)
                u.tweens[o].run(r);
            return s.notifyWith(t, [u, r, n]),
            r < 1 && a ? n : (a || s.notifyWith(t, [u, 1, 0]),
            s.resolveWith(t, [u]),
            !1)
        }, u = s.promise({
            elem: t,
            props: ht.extend({}, e),
            opts: ht.extend(!0, {
                specialEasing: {},
                easing: ht.easing._default
            }, n),
            originalProperties: e,
            originalOptions: n,
            startTime: me || F(),
            duration: n.duration,
            tweens: [],
            createTween: function(e, n) {
                var r = ht.Tween(t, u.opts, e, n, u.opts.specialEasing[e] || u.opts.easing);
                return u.tweens.push(r),
                r
            },
            stop: function(e) {
                var n = 0
                  , r = e ? u.tweens.length : 0;
                if (i)
                    return this;
                for (i = !0; n < r; n++)
                    u.tweens[n].run(1);
                return e ? (s.notifyWith(t, [u, 1, 0]),
                s.resolveWith(t, [u, e])) : s.rejectWith(t, [u, e]),
                this
            }
        }), c = u.props;
        for ((!function(t, e) {
            var n, r, i, o, a;
            for (n in t)
                if (i = e[r = f(n)],
                o = t[n],
                Array.isArray(o) && (i = o[1],
                o = t[n] = o[0]),
                n !== r && (t[r] = o,
                delete t[n]),
                (a = ht.cssHooks[r]) && "expand"in a)
                    for (n in o = a.expand(o),
                    delete t[r],
                    o)
                        n in t || (t[n] = o[n],
                        e[n] = i);
                else
                    e[r] = i
        }(c, u.opts.specialEasing)); o < a; o++)
            if (r = q.prefilters[o].call(u, t, c, u.opts))
                return ct(r.stop) && (ht._queueHooks(u.elem, u.opts.queue).stop = r.stop.bind(r)),
                r;
        return ht.map(c, B, u),
        ct(u.opts.start) && u.opts.start.call(t, u),
        u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
        ht.fx.timer(ht.extend(l, {
            elem: t,
            anim: u,
            queue: u.opts.queue
        })),
        u
    }
    function W(t) {
        return (t.match(St) || []).join(" ")
    }
    function U(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }
    function V(t) {
        return Array.isArray(t) ? t : "string" == typeof t && t.match(St) || []
    }
    function X(t, e, n, i) {
        var o;
        if (Array.isArray(e))
            ht.each(e, function(e, r) {
                n || Le.test(t) ? i(t, r) : X(t + "[" + ("object" == typeof r && null != r ? e : "") + "]", r, n, i)
            });
        else if (n || "object" !== r(e))
            i(t, e);
        else
            for (o in e)
                X(t + "[" + o + "]", e[o], n, i)
    }
    function Y(t) {
        return function(e, n) {
            "string" != typeof e && (n = e,
            e = "*");
            var r, i = 0, o = e.toLowerCase().match(St) || [];
            if (ct(n))
                for (; r = o[i++]; )
                    "+" === r[0] ? (r = r.slice(1) || "*",
                    (t[r] = t[r] || []).unshift(n)) : (t[r] = t[r] || []).push(n)
        }
    }
    function Z(t, e, n, r) {
        function i(s) {
            var l;
            return o[s] = !0,
            ht.each(t[s] || [], function(t, s) {
                var u = s(e, n, r);
                return "string" != typeof u || a || o[u] ? a ? !(l = u) : void 0 : (e.dataTypes.unshift(u),
                i(u),
                !1)
            }),
            l
        }
        var o = {}
          , a = t === Be;
        return i(e.dataTypes[0]) || !o["*"] && i("*")
    }
    function K(t, e) {
        var n, r, i = ht.ajaxSettings.flatOptions || {};
        for (n in e)
            void 0 !== e[n] && ((i[n] ? t : r || (r = {}))[n] = e[n]);
        return r && ht.extend(!0, t, r),
        t
    }
    var G = []
      , Q = t.document
      , J = Object.getPrototypeOf
      , tt = G.slice
      , et = G.concat
      , nt = G.push
      , rt = G.indexOf
      , it = {}
      , ot = it.toString
      , at = it.hasOwnProperty
      , st = at.toString
      , lt = st.call(Object)
      , ut = {}
      , ct = function(t) {
        return "function" == typeof t && "number" != typeof t.nodeType
    }
      , dt = function(t) {
        return null != t && t === t.window
    }
      , pt = {
        type: !0,
        src: !0,
        nonce: !0,
        noModule: !0
    }
      , ft = "3.4.1"
      , ht = function(t, e) {
        return new ht.fn.init(t,e)
    }
      , mt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    ht.fn = ht.prototype = {
        jquery: ft,
        constructor: ht,
        length: 0,
        toArray: function() {
            return tt.call(this)
        },
        get: function(t) {
            return null == t ? tt.call(this) : t < 0 ? this[t + this.length] : this[t]
        },
        pushStack: function(t) {
            var e = ht.merge(this.constructor(), t);
            return e.prevObject = this,
            e
        },
        each: function(t) {
            return ht.each(this, t)
        },
        map: function(t) {
            return this.pushStack(ht.map(this, function(e, n) {
                return t.call(e, n, e)
            }))
        },
        slice: function() {
            return this.pushStack(tt.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(t) {
            var e = this.length
              , n = +t + (t < 0 ? e : 0);
            return this.pushStack(0 <= n && n < e ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: nt,
        sort: G.sort,
        splice: G.splice
    },
    ht.extend = ht.fn.extend = function() {
        var t, e, n, r, i, o, a = arguments[0] || {}, s = 1, l = arguments.length, u = !1;
        for ("boolean" == typeof a && (u = a,
        a = arguments[s] || {},
        s++),
        "object" == typeof a || ct(a) || (a = {}),
        s === l && (a = this,
        s--); s < l; s++)
            if (null != (t = arguments[s]))
                for (e in t)
                    r = t[e],
                    "__proto__" !== e && a !== r && (u && r && (ht.isPlainObject(r) || (i = Array.isArray(r))) ? (n = a[e],
                    o = i && !Array.isArray(n) ? [] : i || ht.isPlainObject(n) ? n : {},
                    i = !1,
                    a[e] = ht.extend(u, o, r)) : void 0 !== r && (a[e] = r));
        return a
    }
    ,
    ht.extend({
        expando: "jQuery" + (ft + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw new Error(t)
        },
        noop: function() {},
        isPlainObject: function(t) {
            var e, n;
            return !(!t || "[object Object]" !== ot.call(t) || (e = J(t)) && ("function" != typeof (n = at.call(e, "constructor") && e.constructor) || st.call(n) !== lt))
        },
        isEmptyObject: function(t) {
            var e;
            for (e in t)
                return !1;
            return !0
        },
        globalEval: function(t, e) {
            n(t, {
                nonce: e && e.nonce
            })
        },
        each: function(t, e) {
            var n, r = 0;
            if (i(t))
                for (n = t.length; r < n && !1 !== e.call(t[r], r, t[r]); r++)
                    ;
            else
                for (r in t)
                    if (!1 === e.call(t[r], r, t[r]))
                        break;
            return t
        },
        trim: function(t) {
            return null == t ? "" : (t + "").replace(mt, "")
        },
        makeArray: function(t, e) {
            var n = e || [];
            return null != t && (i(Object(t)) ? ht.merge(n, "string" == typeof t ? [t] : t) : nt.call(n, t)),
            n
        },
        inArray: function(t, e, n) {
            return null == e ? -1 : rt.call(e, t, n)
        },
        merge: function(t, e) {
            for (var n = +e.length, r = 0, i = t.length; r < n; r++)
                t[i++] = e[r];
            return t.length = i,
            t
        },
        grep: function(t, e, n) {
            for (var r = [], i = 0, o = t.length, a = !n; i < o; i++)
                !e(t[i], i) !== a && r.push(t[i]);
            return r
        },
        map: function(t, e, n) {
            var r, o, a = 0, s = [];
            if (i(t))
                for (r = t.length; a < r; a++)
                    null != (o = e(t[a], a, n)) && s.push(o);
            else
                for (a in t)
                    null != (o = e(t[a], a, n)) && s.push(o);
            return et.apply([], s)
        },
        guid: 1,
        support: ut
    }),
    "function" == typeof Symbol && (ht.fn[Symbol.iterator] = G[Symbol.iterator]),
    ht.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
        it["[object " + e + "]"] = e.toLowerCase()
    });
    var gt = function(t) {
        function e(t, e, n, r) {
            var i, o, a, s, l, u, c, p = e && e.ownerDocument, h = e ? e.nodeType : 9;
            if (n = n || [],
            "string" != typeof t || !t || 1 !== h && 9 !== h && 11 !== h)
                return n;
            if (!r && ((e ? e.ownerDocument || e : R) !== L && O(e),
            e = e || L,
            j)) {
                if (11 !== h && (l = vt.exec(t)))
                    if (i = l[1]) {
                        if (9 === h) {
                            if (!(a = e.getElementById(i)))
                                return n;
                            if (a.id === i)
                                return n.push(a),
                                n
                        } else if (p && (a = p.getElementById(i)) && D(e, a) && a.id === i)
                            return n.push(a),
                            n
                    } else {
                        if (l[2])
                            return G.apply(n, e.getElementsByTagName(t)),
                            n;
                        if ((i = l[3]) && w.getElementsByClassName && e.getElementsByClassName)
                            return G.apply(n, e.getElementsByClassName(i)),
                            n
                    }
                if (w.qsa && !U[t + " "] && (!z || !z.test(t)) && (1 !== h || "object" !== e.nodeName.toLowerCase())) {
                    if (c = t,
                    p = e,
                    1 === h && ut.test(t)) {
                        for ((s = e.getAttribute("id")) ? s = s.replace(xt, Ct) : e.setAttribute("id", s = $),
                        o = (u = _(t)).length; o--; )
                            u[o] = "#" + s + " " + f(u[o]);
                        c = u.join(","),
                        p = yt.test(t) && d(e.parentNode) || e
                    }
                    try {
                        return G.apply(n, p.querySelectorAll(c)),
                        n
                    } catch (e) {
                        U(t, !0)
                    } finally {
                        s === $ && e.removeAttribute("id")
                    }
                }
            }
            return T(t.replace(at, "$1"), e, n, r)
        }
        function n() {
            var t = [];
            return function e(n, r) {
                return t.push(n + " ") > x.cacheLength && delete e[t.shift()],
                e[n + " "] = r
            }
        }
        function r(t) {
            return t[$] = !0,
            t
        }
        function i(t) {
            var e = L.createElement("fieldset");
            try {
                return !!t(e)
            } catch (t) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e),
                e = null
            }
        }
        function o(t, e) {
            for (var n = t.split("|"), r = n.length; r--; )
                x.attrHandle[n[r]] = e
        }
        function a(t, e) {
            var n = e && t
              , r = n && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
            if (r)
                return r;
            if (n)
                for (; n = n.nextSibling; )
                    if (n === e)
                        return -1;
            return t ? 1 : -1
        }
        function s(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }
        function l(t) {
            return function(e) {
                var n = e.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && e.type === t
            }
        }
        function u(t) {
            return function(e) {
                return "form"in e ? e.parentNode && !1 === e.disabled ? "label"in e ? "label"in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && _t(e) === t : e.disabled === t : "label"in e && e.disabled === t
            }
        }
        function c(t) {
            return r(function(e) {
                return e = +e,
                r(function(n, r) {
                    for (var i, o = t([], n.length, e), a = o.length; a--; )
                        n[i = o[a]] && (n[i] = !(r[i] = n[i]))
                })
            })
        }
        function d(t) {
            return t && "undefined" != typeof t.getElementsByTagName && t
        }
        function p() {}
        function f(t) {
            for (var e = 0, n = t.length, r = ""; e < n; e++)
                r += t[e].value;
            return r
        }
        function h(t, e, n) {
            var r = e.dir
              , i = e.next
              , o = i || r
              , a = n && "parentNode" === o
              , s = H++;
            return e.first ? function(e, n, i) {
                for (; e = e[r]; )
                    if (1 === e.nodeType || a)
                        return t(e, n, i);
                return !1
            }
            : function(e, n, l) {
                var u, c, d, p = [F, s];
                if (l) {
                    for (; e = e[r]; )
                        if ((1 === e.nodeType || a) && t(e, n, l))
                            return !0
                } else
                    for (; e = e[r]; )
                        if (1 === e.nodeType || a)
                            if (c = (d = e[$] || (e[$] = {}))[e.uniqueID] || (d[e.uniqueID] = {}),
                            i && i === e.nodeName.toLowerCase())
                                e = e[r] || e;
                            else {
                                if ((u = c[o]) && u[0] === F && u[1] === s)
                                    return p[2] = u[2];
                                if ((c[o] = p)[2] = t(e, n, l))
                                    return !0
                            }
                return !1
            }
        }
        function m(t) {
            return 1 < t.length ? function(e, n, r) {
                for (var i = t.length; i--; )
                    if (!t[i](e, n, r))
                        return !1;
                return !0
            }
            : t[0]
        }
        function g(t, e, n, r, i) {
            for (var o, a = [], s = 0, l = t.length, u = null != e; s < l; s++)
                (o = t[s]) && (n && !n(o, r, i) || (a.push(o),
                u && e.push(s)));
            return a
        }
        function v(t, n, i, o, a, s) {
            return o && !o[$] && (o = v(o)),
            a && !a[$] && (a = v(a, s)),
            r(function(r, s, l, u) {
                var c, d, p, f = [], h = [], m = s.length, v = r || function(t, n, r) {
                    for (var i = 0, o = n.length; i < o; i++)
                        e(t, n[i], r);
                    return r
                }(n || "*", l.nodeType ? [l] : l, []), y = !t || !r && n ? v : g(v, f, t, l, u), b = i ? a || (r ? t : m || o) ? [] : s : y;
                if (i && i(y, b, l, u),
                o)
                    for (c = g(b, h),
                    o(c, [], l, u),
                    d = c.length; d--; )
                        (p = c[d]) && (b[h[d]] = !(y[h[d]] = p));
                if (r) {
                    if (a || t) {
                        if (a) {
                            for (c = [],
                            d = b.length; d--; )
                                (p = b[d]) && c.push(y[d] = p);
                            a(null, b = [], c, u)
                        }
                        for (d = b.length; d--; )
                            (p = b[d]) && -1 < (c = a ? J(r, p) : f[d]) && (r[c] = !(s[c] = p))
                    }
                } else
                    b = g(b === s ? b.splice(m, b.length) : b),
                    a ? a(null, s, b, u) : G.apply(s, b)
            })
        }
        function y(t) {
            for (var e, n, r, i = t.length, o = x.relative[t[0].type], a = o || x.relative[" "], s = o ? 1 : 0, l = h(function(t) {
                return t === e
            }, a, !0), u = h(function(t) {
                return -1 < J(e, t)
            }, a, !0), c = [function(t, n, r) {
                var i = !o && (r || n !== E) || ((e = n).nodeType ? l(t, n, r) : u(t, n, r));
                return e = null,
                i
            }
            ]; s < i; s++)
                if (n = x.relative[t[s].type])
                    c = [h(m(c), n)];
                else {
                    if ((n = x.filter[t[s].type].apply(null, t[s].matches))[$]) {
                        for (r = ++s; r < i && !x.relative[t[r].type]; r++)
                            ;
                        return v(1 < s && m(c), 1 < s && f(t.slice(0, s - 1).concat({
                            value: " " === t[s - 2].type ? "*" : ""
                        })).replace(at, "$1"), n, s < r && y(t.slice(s, r)), r < i && y(t = t.slice(r)), r < i && f(t))
                    }
                    c.push(n)
                }
            return m(c)
        }
        var b, w, x, C, k, _, S, T, E, A, M, O, L, I, j, z, N, P, D, $ = "sizzle" + 1 * new Date, R = t.document, F = 0, H = 0, B = n(), q = n(), W = n(), U = n(), V = function(t, e) {
            return t === e && (M = !0),
            0
        }, X = {}.hasOwnProperty, Y = [], Z = Y.pop, K = Y.push, G = Y.push, Q = Y.slice, J = function(t, e) {
            for (var n = 0, r = t.length; n < r; n++)
                if (t[n] === e)
                    return n;
            return -1
        }, tt = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", et = "[\\x20\\t\\r\\n\\f]", nt = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", rt = "\\[" + et + "*(" + nt + ")(?:" + et + "*([*^$|!~]?=)" + et + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + nt + "))|)" + et + "*\\]", it = ":(" + nt + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + rt + ")*)|.*)\\)|)", ot = new RegExp(et + "+","g"), at = new RegExp("^" + et + "+|((?:^|[^\\\\])(?:\\\\.)*)" + et + "+$","g"), st = new RegExp("^" + et + "*," + et + "*"), lt = new RegExp("^" + et + "*([>+~]|" + et + ")" + et + "*"), ut = new RegExp(et + "|>"), ct = new RegExp(it), dt = new RegExp("^" + nt + "$"), pt = {
            ID: new RegExp("^#(" + nt + ")"),
            CLASS: new RegExp("^\\.(" + nt + ")"),
            TAG: new RegExp("^(" + nt + "|[*])"),
            ATTR: new RegExp("^" + rt),
            PSEUDO: new RegExp("^" + it),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + et + "*(even|odd|(([+-]|)(\\d*)n|)" + et + "*(?:([+-]|)" + et + "*(\\d+)|))" + et + "*\\)|)","i"),
            bool: new RegExp("^(?:" + tt + ")$","i"),
            needsContext: new RegExp("^" + et + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + et + "*((?:-\\d)?\\d*)" + et + "*\\)|)(?=[^-]|$)","i")
        }, ft = /HTML$/i, ht = /^(?:input|select|textarea|button)$/i, mt = /^h\d$/i, gt = /^[^{]+\{\s*\[native \w/, vt = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, yt = /[+~]/, bt = new RegExp("\\\\([\\da-f]{1,6}" + et + "?|(" + et + ")|.)","ig"), wt = function(t, e, n) {
            var r = "0x" + e - 65536;
            return r != r || n ? e : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320)
        }, xt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, Ct = function(t, e) {
            return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
        }, kt = function() {
            O()
        }, _t = h(function(t) {
            return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase()
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            G.apply(Y = Q.call(R.childNodes), R.childNodes),
            Y[R.childNodes.length].nodeType
        } catch (t) {
            G = {
                apply: Y.length ? function(t, e) {
                    K.apply(t, Q.call(e))
                }
                : function(t, e) {
                    for (var n = t.length, r = 0; t[n++] = e[r++]; )
                        ;
                    t.length = n - 1
                }
            }
        }
        for (b in w = e.support = {},
        k = e.isXML = function(t) {
            var e = t.namespaceURI
              , n = (t.ownerDocument || t).documentElement;
            return !ft.test(e || n && n.nodeName || "HTML")
        }
        ,
        O = e.setDocument = function(t) {
            var e, n, r = t ? t.ownerDocument || t : R;
            return r !== L && 9 === r.nodeType && r.documentElement && (I = (L = r).documentElement,
            j = !k(L),
            R !== L && (n = L.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", kt, !1) : n.attachEvent && n.attachEvent("onunload", kt)),
            w.attributes = i(function(t) {
                return t.className = "i",
                !t.getAttribute("className")
            }),
            w.getElementsByTagName = i(function(t) {
                return t.appendChild(L.createComment("")),
                !t.getElementsByTagName("*").length
            }),
            w.getElementsByClassName = gt.test(L.getElementsByClassName),
            w.getById = i(function(t) {
                return I.appendChild(t).id = $,
                !L.getElementsByName || !L.getElementsByName($).length
            }),
            w.getById ? (x.filter.ID = function(t) {
                var e = t.replace(bt, wt);
                return function(t) {
                    return t.getAttribute("id") === e
                }
            }
            ,
            x.find.ID = function(t, e) {
                if ("undefined" != typeof e.getElementById && j) {
                    var n = e.getElementById(t);
                    return n ? [n] : []
                }
            }
            ) : (x.filter.ID = function(t) {
                var e = t.replace(bt, wt);
                return function(t) {
                    var n = "undefined" != typeof t.getAttributeNode && t.getAttributeNode("id");
                    return n && n.value === e
                }
            }
            ,
            x.find.ID = function(t, e) {
                if ("undefined" != typeof e.getElementById && j) {
                    var n, r, i, o = e.getElementById(t);
                    if (o) {
                        if ((n = o.getAttributeNode("id")) && n.value === t)
                            return [o];
                        for (i = e.getElementsByName(t),
                        r = 0; o = i[r++]; )
                            if ((n = o.getAttributeNode("id")) && n.value === t)
                                return [o]
                    }
                    return []
                }
            }
            ),
            x.find.TAG = w.getElementsByTagName ? function(t, e) {
                return "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t) : w.qsa ? e.querySelectorAll(t) : void 0
            }
            : function(t, e) {
                var n, r = [], i = 0, o = e.getElementsByTagName(t);
                if ("*" === t) {
                    for (; n = o[i++]; )
                        1 === n.nodeType && r.push(n);
                    return r
                }
                return o
            }
            ,
            x.find.CLASS = w.getElementsByClassName && function(t, e) {
                if ("undefined" != typeof e.getElementsByClassName && j)
                    return e.getElementsByClassName(t)
            }
            ,
            N = [],
            z = [],
            (w.qsa = gt.test(L.querySelectorAll)) && (i(function(t) {
                I.appendChild(t).innerHTML = "<a id='" + $ + "'></a><select id='" + $ + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                t.querySelectorAll("[msallowcapture^='']").length && z.push("[*^$]=" + et + "*(?:''|\"\")"),
                t.querySelectorAll("[selected]").length || z.push("\\[" + et + "*(?:value|" + tt + ")"),
                t.querySelectorAll("[id~=" + $ + "-]").length || z.push("~="),
                t.querySelectorAll(":checked").length || z.push(":checked"),
                t.querySelectorAll("a#" + $ + "+*").length || z.push(".#.+[+~]")
            }),
            i(function(t) {
                t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var e = L.createElement("input");
                e.setAttribute("type", "hidden"),
                t.appendChild(e).setAttribute("name", "D"),
                t.querySelectorAll("[name=d]").length && z.push("name" + et + "*[*^$|!~]?="),
                2 !== t.querySelectorAll(":enabled").length && z.push(":enabled", ":disabled"),
                I.appendChild(t).disabled = !0,
                2 !== t.querySelectorAll(":disabled").length && z.push(":enabled", ":disabled"),
                t.querySelectorAll("*,:x"),
                z.push(",.*:")
            })),
            (w.matchesSelector = gt.test(P = I.matches || I.webkitMatchesSelector || I.mozMatchesSelector || I.oMatchesSelector || I.msMatchesSelector)) && i(function(t) {
                w.disconnectedMatch = P.call(t, "*"),
                P.call(t, "[s!='']:x"),
                N.push("!=", it)
            }),
            z = z.length && new RegExp(z.join("|")),
            N = N.length && new RegExp(N.join("|")),
            e = gt.test(I.compareDocumentPosition),
            D = e || gt.test(I.contains) ? function(t, e) {
                var n = 9 === t.nodeType ? t.documentElement : t
                  , r = e && e.parentNode;
                return t === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(r)))
            }
            : function(t, e) {
                if (e)
                    for (; e = e.parentNode; )
                        if (e === t)
                            return !0;
                return !1
            }
            ,
            V = e ? function(t, e) {
                if (t === e)
                    return M = !0,
                    0;
                var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                return n || (1 & (n = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !w.sortDetached && e.compareDocumentPosition(t) === n ? t === L || t.ownerDocument === R && D(R, t) ? -1 : e === L || e.ownerDocument === R && D(R, e) ? 1 : A ? J(A, t) - J(A, e) : 0 : 4 & n ? -1 : 1)
            }
            : function(t, e) {
                if (t === e)
                    return M = !0,
                    0;
                var n, r = 0, i = t.parentNode, o = e.parentNode, s = [t], l = [e];
                if (!i || !o)
                    return t === L ? -1 : e === L ? 1 : i ? -1 : o ? 1 : A ? J(A, t) - J(A, e) : 0;
                if (i === o)
                    return a(t, e);
                for (n = t; n = n.parentNode; )
                    s.unshift(n);
                for (n = e; n = n.parentNode; )
                    l.unshift(n);
                for (; s[r] === l[r]; )
                    r++;
                return r ? a(s[r], l[r]) : s[r] === R ? -1 : l[r] === R ? 1 : 0
            }
            ),
            L
        }
        ,
        e.matches = function(t, n) {
            return e(t, null, null, n)
        }
        ,
        e.matchesSelector = function(t, n) {
            if ((t.ownerDocument || t) !== L && O(t),
            w.matchesSelector && j && !U[n + " "] && (!N || !N.test(n)) && (!z || !z.test(n)))
                try {
                    var r = P.call(t, n);
                    if (r || w.disconnectedMatch || t.document && 11 !== t.document.nodeType)
                        return r
                } catch (t) {
                    U(n, !0)
                }
            return 0 < e(n, L, null, [t]).length
        }
        ,
        e.contains = function(t, e) {
            return (t.ownerDocument || t) !== L && O(t),
            D(t, e)
        }
        ,
        e.attr = function(t, e) {
            (t.ownerDocument || t) !== L && O(t);
            var n = x.attrHandle[e.toLowerCase()]
              , r = n && X.call(x.attrHandle, e.toLowerCase()) ? n(t, e, !j) : void 0;
            return void 0 !== r ? r : w.attributes || !j ? t.getAttribute(e) : (r = t.getAttributeNode(e)) && r.specified ? r.value : null
        }
        ,
        e.escape = function(t) {
            return (t + "").replace(xt, Ct)
        }
        ,
        e.error = function(t) {
            throw new Error("Syntax error, unrecognized expression: " + t)
        }
        ,
        e.uniqueSort = function(t) {
            var e, n = [], r = 0, i = 0;
            if (M = !w.detectDuplicates,
            A = !w.sortStable && t.slice(0),
            t.sort(V),
            M) {
                for (; e = t[i++]; )
                    e === t[i] && (r = n.push(i));
                for (; r--; )
                    t.splice(n[r], 1)
            }
            return A = null,
            t
        }
        ,
        C = e.getText = function(t) {
            var e, n = "", r = 0, i = t.nodeType;
            if (i) {
                if (1 === i || 9 === i || 11 === i) {
                    if ("string" == typeof t.textContent)
                        return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling)
                        n += C(t)
                } else if (3 === i || 4 === i)
                    return t.nodeValue
            } else
                for (; e = t[r++]; )
                    n += C(e);
            return n
        }
        ,
        (x = e.selectors = {
            cacheLength: 50,
            createPseudo: r,
            match: pt,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(t) {
                    return t[1] = t[1].replace(bt, wt),
                    t[3] = (t[3] || t[4] || t[5] || "").replace(bt, wt),
                    "~=" === t[2] && (t[3] = " " + t[3] + " "),
                    t.slice(0, 4)
                },
                CHILD: function(t) {
                    return t[1] = t[1].toLowerCase(),
                    "nth" === t[1].slice(0, 3) ? (t[3] || e.error(t[0]),
                    t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])),
                    t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && e.error(t[0]),
                    t
                },
                PSEUDO: function(t) {
                    var e, n = !t[6] && t[2];
                    return pt.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && ct.test(n) && (e = _(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e),
                    t[2] = n.slice(0, e)),
                    t.slice(0, 3))
                }
            },
            filter: {
                TAG: function(t) {
                    var e = t.replace(bt, wt).toLowerCase();
                    return "*" === t ? function() {
                        return !0
                    }
                    : function(t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e
                    }
                },
                CLASS: function(t) {
                    var e = B[t + " "];
                    return e || (e = new RegExp("(^|" + et + ")" + t + "(" + et + "|$)")) && B(t, function(t) {
                        return e.test("string" == typeof t.className && t.className || "undefined" != typeof t.getAttribute && t.getAttribute("class") || "")
                    })
                },
                ATTR: function(t, n, r) {
                    return function(i) {
                        var o = e.attr(i, t);
                        return null == o ? "!=" === n : !n || (o += "",
                        "=" === n ? o === r : "!=" === n ? o !== r : "^=" === n ? r && 0 === o.indexOf(r) : "*=" === n ? r && -1 < o.indexOf(r) : "$=" === n ? r && o.slice(-r.length) === r : "~=" === n ? -1 < (" " + o.replace(ot, " ") + " ").indexOf(r) : "|=" === n && (o === r || o.slice(0, r.length + 1) === r + "-"))
                    }
                },
                CHILD: function(t, e, n, r, i) {
                    var o = "nth" !== t.slice(0, 3)
                      , a = "last" !== t.slice(-4)
                      , s = "of-type" === e;
                    return 1 === r && 0 === i ? function(t) {
                        return !!t.parentNode
                    }
                    : function(e, n, l) {
                        var u, c, d, p, f, h, m = o !== a ? "nextSibling" : "previousSibling", g = e.parentNode, v = s && e.nodeName.toLowerCase(), y = !l && !s, b = !1;
                        if (g) {
                            if (o) {
                                for (; m; ) {
                                    for (p = e; p = p[m]; )
                                        if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType)
                                            return !1;
                                    h = m = "only" === t && !h && "nextSibling"
                                }
                                return !0
                            }
                            if (h = [a ? g.firstChild : g.lastChild],
                            a && y) {
                                for (b = (f = (u = (c = (d = (p = g)[$] || (p[$] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === F && u[1]) && u[2],
                                p = f && g.childNodes[f]; p = ++f && p && p[m] || (b = f = 0) || h.pop(); )
                                    if (1 === p.nodeType && ++b && p === e) {
                                        c[t] = [F, f, b];
                                        break
                                    }
                            } else if (y && (b = f = (u = (c = (d = (p = e)[$] || (p[$] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === F && u[1]),
                            !1 === b)
                                for (; (p = ++f && p && p[m] || (b = f = 0) || h.pop()) && ((s ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++b || (y && ((c = (d = p[$] || (p[$] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] = [F, b]),
                                p !== e)); )
                                    ;
                            return (b -= i) === r || b % r == 0 && 0 <= b / r
                        }
                    }
                },
                PSEUDO: function(t, n) {
                    var i, o = x.pseudos[t] || x.setFilters[t.toLowerCase()] || e.error("unsupported pseudo: " + t);
                    return o[$] ? o(n) : 1 < o.length ? (i = [t, t, "", n],
                    x.setFilters.hasOwnProperty(t.toLowerCase()) ? r(function(t, e) {
                        for (var r, i = o(t, n), a = i.length; a--; )
                            t[r = J(t, i[a])] = !(e[r] = i[a])
                    }) : function(t) {
                        return o(t, 0, i)
                    }
                    ) : o
                }
            },
            pseudos: {
                not: r(function(t) {
                    var e = []
                      , n = []
                      , i = S(t.replace(at, "$1"));
                    return i[$] ? r(function(t, e, n, r) {
                        for (var o, a = i(t, null, r, []), s = t.length; s--; )
                            (o = a[s]) && (t[s] = !(e[s] = o))
                    }) : function(t, r, o) {
                        return e[0] = t,
                        i(e, null, o, n),
                        e[0] = null,
                        !n.pop()
                    }
                }),
                has: r(function(t) {
                    return function(n) {
                        return 0 < e(t, n).length
                    }
                }),
                contains: r(function(t) {
                    return t = t.replace(bt, wt),
                    function(e) {
                        return -1 < (e.textContent || C(e)).indexOf(t)
                    }
                }),
                lang: r(function(t) {
                    return dt.test(t || "") || e.error("unsupported lang: " + t),
                    t = t.replace(bt, wt).toLowerCase(),
                    function(e) {
                        var n;
                        do
                            if (n = j ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                                return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-");
                        while ((e = e.parentNode) && 1 === e.nodeType);return !1
                    }
                }),
                target: function(e) {
                    var n = t.location && t.location.hash;
                    return n && n.slice(1) === e.id
                },
                root: function(t) {
                    return t === I
                },
                focus: function(t) {
                    return t === L.activeElement && (!L.hasFocus || L.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                },
                enabled: u(!1),
                disabled: u(!0),
                checked: function(t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && !!t.checked || "option" === e && !!t.selected
                },
                selected: function(t) {
                    return t.parentNode && t.parentNode.selectedIndex,
                    !0 === t.selected
                },
                empty: function(t) {
                    for (t = t.firstChild; t; t = t.nextSibling)
                        if (t.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(t) {
                    return !x.pseudos.empty(t)
                },
                header: function(t) {
                    return mt.test(t.nodeName)
                },
                input: function(t) {
                    return ht.test(t.nodeName)
                },
                button: function(t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && "button" === t.type || "button" === e
                },
                text: function(t) {
                    var e;
                    return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                },
                first: c(function() {
                    return [0]
                }),
                last: c(function(t, e) {
                    return [e - 1]
                }),
                eq: c(function(t, e, n) {
                    return [n < 0 ? n + e : n]
                }),
                even: c(function(t, e) {
                    for (var n = 0; n < e; n += 2)
                        t.push(n);
                    return t
                }),
                odd: c(function(t, e) {
                    for (var n = 1; n < e; n += 2)
                        t.push(n);
                    return t
                }),
                lt: c(function(t, e, n) {
                    for (var r = n < 0 ? n + e : e < n ? e : n; 0 <= --r; )
                        t.push(r);
                    return t
                }),
                gt: c(function(t, e, n) {
                    for (var r = n < 0 ? n + e : n; ++r < e; )
                        t.push(r);
                    return t
                })
            }
        }).pseudos.nth = x.pseudos.eq,
        {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            x.pseudos[b] = s(b);
        for (b in {
            submit: !0,
            reset: !0
        })
            x.pseudos[b] = l(b);
        return p.prototype = x.filters = x.pseudos,
        x.setFilters = new p,
        _ = e.tokenize = function(t, n) {
            var r, i, o, a, s, l, u, c = q[t + " "];
            if (c)
                return n ? 0 : c.slice(0);
            for (s = t,
            l = [],
            u = x.preFilter; s; ) {
                for (a in r && !(i = st.exec(s)) || (i && (s = s.slice(i[0].length) || s),
                l.push(o = [])),
                r = !1,
                (i = lt.exec(s)) && (r = i.shift(),
                o.push({
                    value: r,
                    type: i[0].replace(at, " ")
                }),
                s = s.slice(r.length)),
                x.filter)
                    !(i = pt[a].exec(s)) || u[a] && !(i = u[a](i)) || (r = i.shift(),
                    o.push({
                        value: r,
                        type: a,
                        matches: i
                    }),
                    s = s.slice(r.length));
                if (!r)
                    break
            }
            return n ? s.length : s ? e.error(t) : q(t, l).slice(0)
        }
        ,
        S = e.compile = function(t, n) {
            var i, o, a, s, l, u, c = [], d = [], p = W[t + " "];
            if (!p) {
                for (n || (n = _(t)),
                i = n.length; i--; )
                    (p = y(n[i]))[$] ? c.push(p) : d.push(p);
                (p = W(t, (o = d,
                s = 0 < (a = c).length,
                l = 0 < o.length,
                u = function(t, n, r, i, u) {
                    var c, d, p, f = 0, h = "0", m = t && [], v = [], y = E, b = t || l && x.find.TAG("*", u), w = F += null == y ? 1 : Math.random() || .1, C = b.length;
                    for (u && (E = n === L || n || u); h !== C && null != (c = b[h]); h++) {
                        if (l && c) {
                            for (d = 0,
                            n || c.ownerDocument === L || (O(c),
                            r = !j); p = o[d++]; )
                                if (p(c, n || L, r)) {
                                    i.push(c);
                                    break
                                }
                            u && (F = w)
                        }
                        s && ((c = !p && c) && f--,
                        t && m.push(c))
                    }
                    if (f += h,
                    s && h !== f) {
                        for (d = 0; p = a[d++]; )
                            p(m, v, n, r);
                        if (t) {
                            if (0 < f)
                                for (; h--; )
                                    m[h] || v[h] || (v[h] = Z.call(i));
                            v = g(v)
                        }
                        G.apply(i, v),
                        u && !t && 0 < v.length && 1 < f + a.length && e.uniqueSort(i)
                    }
                    return u && (F = w,
                    E = y),
                    m
                }
                ,
                s ? r(u) : u))).selector = t
            }
            return p
        }
        ,
        T = e.select = function(t, e, n, r) {
            var i, o, a, s, l, u = "function" == typeof t && t, c = !r && _(t = u.selector || t);
            if (n = n || [],
            1 === c.length) {
                if (2 < (o = c[0] = c[0].slice(0)).length && "ID" === (a = o[0]).type && 9 === e.nodeType && j && x.relative[o[1].type]) {
                    if (!(e = (x.find.ID(a.matches[0].replace(bt, wt), e) || [])[0]))
                        return n;
                    u && (e = e.parentNode),
                    t = t.slice(o.shift().value.length)
                }
                for (i = pt.needsContext.test(t) ? 0 : o.length; i-- && (a = o[i],
                !x.relative[s = a.type]); )
                    if ((l = x.find[s]) && (r = l(a.matches[0].replace(bt, wt), yt.test(o[0].type) && d(e.parentNode) || e))) {
                        if (o.splice(i, 1),
                        !(t = r.length && f(o)))
                            return G.apply(n, r),
                            n;
                        break
                    }
            }
            return (u || S(t, c))(r, e, !j, n, !e || yt.test(t) && d(e.parentNode) || e),
            n
        }
        ,
        w.sortStable = $.split("").sort(V).join("") === $,
        w.detectDuplicates = !!M,
        O(),
        w.sortDetached = i(function(t) {
            return 1 & t.compareDocumentPosition(L.createElement("fieldset"))
        }),
        i(function(t) {
            return t.innerHTML = "<a href='#'></a>",
            "#" === t.firstChild.getAttribute("href")
        }) || o("type|href|height|width", function(t, e, n) {
            if (!n)
                return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }),
        w.attributes && i(function(t) {
            return t.innerHTML = "<input/>",
            t.firstChild.setAttribute("value", ""),
            "" === t.firstChild.getAttribute("value")
        }) || o("value", function(t, e, n) {
            if (!n && "input" === t.nodeName.toLowerCase())
                return t.defaultValue
        }),
        i(function(t) {
            return null == t.getAttribute("disabled")
        }) || o(tt, function(t, e, n) {
            var r;
            if (!n)
                return !0 === t[e] ? e.toLowerCase() : (r = t.getAttributeNode(e)) && r.specified ? r.value : null
        }),
        e
    }(t);
    ht.find = gt,
    ht.expr = gt.selectors,
    ht.expr[":"] = ht.expr.pseudos,
    ht.uniqueSort = ht.unique = gt.uniqueSort,
    ht.text = gt.getText,
    ht.isXMLDoc = gt.isXML,
    ht.contains = gt.contains,
    ht.escapeSelector = gt.escape;
    var vt = function(t, e, n) {
        for (var r = [], i = void 0 !== n; (t = t[e]) && 9 !== t.nodeType; )
            if (1 === t.nodeType) {
                if (i && ht(t).is(n))
                    break;
                r.push(t)
            }
        return r
    }
      , yt = function(t, e) {
        for (var n = []; t; t = t.nextSibling)
            1 === t.nodeType && t !== e && n.push(t);
        return n
    }
      , bt = ht.expr.match.needsContext
      , wt = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    ht.filter = function(t, e, n) {
        var r = e[0];
        return n && (t = ":not(" + t + ")"),
        1 === e.length && 1 === r.nodeType ? ht.find.matchesSelector(r, t) ? [r] : [] : ht.find.matches(t, ht.grep(e, function(t) {
            return 1 === t.nodeType
        }))
    }
    ,
    ht.fn.extend({
        find: function(t) {
            var e, n, r = this.length, i = this;
            if ("string" != typeof t)
                return this.pushStack(ht(t).filter(function() {
                    for (e = 0; e < r; e++)
                        if (ht.contains(i[e], this))
                            return !0
                }));
            for (n = this.pushStack([]),
            e = 0; e < r; e++)
                ht.find(t, i[e], n);
            return 1 < r ? ht.uniqueSort(n) : n
        },
        filter: function(t) {
            return this.pushStack(a(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(a(this, t || [], !0))
        },
        is: function(t) {
            return !!a(this, "string" == typeof t && bt.test(t) ? ht(t) : t || [], !1).length
        }
    });
    var xt, Ct = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (ht.fn.init = function(t, e, n) {
        var r, i;
        if (!t)
            return this;
        if (n = n || xt,
        "string" == typeof t) {
            if (!(r = "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length ? [null, t, null] : Ct.exec(t)) || !r[1] && e)
                return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
            if (r[1]) {
                if (e = e instanceof ht ? e[0] : e,
                ht.merge(this, ht.parseHTML(r[1], e && e.nodeType ? e.ownerDocument || e : Q, !0)),
                wt.test(r[1]) && ht.isPlainObject(e))
                    for (r in e)
                        ct(this[r]) ? this[r](e[r]) : this.attr(r, e[r]);
                return this
            }
            return (i = Q.getElementById(r[2])) && (this[0] = i,
            this.length = 1),
            this
        }
        return t.nodeType ? (this[0] = t,
        this.length = 1,
        this) : ct(t) ? void 0 !== n.ready ? n.ready(t) : t(ht) : ht.makeArray(t, this)
    }
    ).prototype = ht.fn,
    xt = ht(Q);
    var kt = /^(?:parents|prev(?:Until|All))/
      , _t = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    ht.fn.extend({
        has: function(t) {
            var e = ht(t, this)
              , n = e.length;
            return this.filter(function() {
                for (var t = 0; t < n; t++)
                    if (ht.contains(this, e[t]))
                        return !0
            })
        },
        closest: function(t, e) {
            var n, r = 0, i = this.length, o = [], a = "string" != typeof t && ht(t);
            if (!bt.test(t))
                for (; r < i; r++)
                    for (n = this[r]; n && n !== e; n = n.parentNode)
                        if (n.nodeType < 11 && (a ? -1 < a.index(n) : 1 === n.nodeType && ht.find.matchesSelector(n, t))) {
                            o.push(n);
                            break
                        }
            return this.pushStack(1 < o.length ? ht.uniqueSort(o) : o)
        },
        index: function(t) {
            return t ? "string" == typeof t ? rt.call(ht(t), this[0]) : rt.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, e) {
            return this.pushStack(ht.uniqueSort(ht.merge(this.get(), ht(t, e))))
        },
        addBack: function(t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }),
    ht.each({
        parent: function(t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null
        },
        parents: function(t) {
            return vt(t, "parentNode")
        },
        parentsUntil: function(t, e, n) {
            return vt(t, "parentNode", n)
        },
        next: function(t) {
            return s(t, "nextSibling")
        },
        prev: function(t) {
            return s(t, "previousSibling")
        },
        nextAll: function(t) {
            return vt(t, "nextSibling")
        },
        prevAll: function(t) {
            return vt(t, "previousSibling")
        },
        nextUntil: function(t, e, n) {
            return vt(t, "nextSibling", n)
        },
        prevUntil: function(t, e, n) {
            return vt(t, "previousSibling", n)
        },
        siblings: function(t) {
            return yt((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return yt(t.firstChild)
        },
        contents: function(t) {
            return "undefined" != typeof t.contentDocument ? t.contentDocument : (o(t, "template") && (t = t.content || t),
            ht.merge([], t.childNodes))
        }
    }, function(t, e) {
        ht.fn[t] = function(n, r) {
            var i = ht.map(this, e, n);
            return "Until" !== t.slice(-5) && (r = n),
            r && "string" == typeof r && (i = ht.filter(r, i)),
            1 < this.length && (_t[t] || ht.uniqueSort(i),
            kt.test(t) && i.reverse()),
            this.pushStack(i)
        }
    });
    var St = /[^\x20\t\r\n\f]+/g;
    ht.Callbacks = function(t) {
        var e, n;
        t = "string" == typeof t ? (e = t,
        n = {},
        ht.each(e.match(St) || [], function(t, e) {
            n[e] = !0
        }),
        n) : ht.extend({}, t);
        var i, o, a, s, l = [], u = [], c = -1, d = function() {
            for (s = s || t.once,
            a = i = !0; u.length; c = -1)
                for (o = u.shift(); ++c < l.length; )
                    !1 === l[c].apply(o[0], o[1]) && t.stopOnFalse && (c = l.length,
                    o = !1);
            t.memory || (o = !1),
            i = !1,
            s && (l = o ? [] : "")
        }, p = {
            add: function() {
                return l && (o && !i && (c = l.length - 1,
                u.push(o)),
                function e(n) {
                    ht.each(n, function(n, i) {
                        ct(i) ? t.unique && p.has(i) || l.push(i) : i && i.length && "string" !== r(i) && e(i)
                    })
                }(arguments),
                o && !i && d()),
                this
            },
            remove: function() {
                return ht.each(arguments, function(t, e) {
                    for (var n; -1 < (n = ht.inArray(e, l, n)); )
                        l.splice(n, 1),
                        n <= c && c--
                }),
                this
            },
            has: function(t) {
                return t ? -1 < ht.inArray(t, l) : 0 < l.length
            },
            empty: function() {
                return l && (l = []),
                this
            },
            disable: function() {
                return s = u = [],
                l = o = "",
                this
            },
            disabled: function() {
                return !l
            },
            lock: function() {
                return s = u = [],
                o || i || (l = o = ""),
                this
            },
            locked: function() {
                return !!s
            },
            fireWith: function(t, e) {
                return s || (e = [t, (e = e || []).slice ? e.slice() : e],
                u.push(e),
                i || d()),
                this
            },
            fire: function() {
                return p.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!a
            }
        };
        return p
    }
    ,
    ht.extend({
        Deferred: function(e) {
            var n = [["notify", "progress", ht.Callbacks("memory"), ht.Callbacks("memory"), 2], ["resolve", "done", ht.Callbacks("once memory"), ht.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", ht.Callbacks("once memory"), ht.Callbacks("once memory"), 1, "rejected"]]
              , r = "pending"
              , i = {
                state: function() {
                    return r
                },
                always: function() {
                    return o.done(arguments).fail(arguments),
                    this
                },
                catch: function(t) {
                    return i.then(null, t)
                },
                pipe: function() {
                    var t = arguments;
                    return ht.Deferred(function(e) {
                        ht.each(n, function(n, r) {
                            var i = ct(t[r[4]]) && t[r[4]];
                            o[r[1]](function() {
                                var t = i && i.apply(this, arguments);
                                t && ct(t.promise) ? t.promise().progress(e.notify).done(e.resolve).fail(e.reject) : e[r[0] + "With"](this, i ? [t] : arguments)
                            })
                        }),
                        t = null
                    }).promise()
                },
                then: function(e, r, i) {
                    function o(e, n, r, i) {
                        return function() {
                            var s = this
                              , c = arguments
                              , d = function() {
                                var t, d;
                                if (!(e < a)) {
                                    if ((t = r.apply(s, c)) === n.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    d = t && ("object" == typeof t || "function" == typeof t) && t.then,
                                    ct(d) ? i ? d.call(t, o(a, n, l, i), o(a, n, u, i)) : (a++,
                                    d.call(t, o(a, n, l, i), o(a, n, u, i), o(a, n, l, n.notifyWith))) : (r !== l && (s = void 0,
                                    c = [t]),
                                    (i || n.resolveWith)(s, c))
                                }
                            }
                              , p = i ? d : function() {
                                try {
                                    d()
                                } catch (t) {
                                    ht.Deferred.exceptionHook && ht.Deferred.exceptionHook(t, p.stackTrace),
                                    a <= e + 1 && (r !== u && (s = void 0,
                                    c = [t]),
                                    n.rejectWith(s, c))
                                }
                            }
                            ;
                            e ? p() : (ht.Deferred.getStackHook && (p.stackTrace = ht.Deferred.getStackHook()),
                            t.setTimeout(p))
                        }
                    }
                    var a = 0;
                    return ht.Deferred(function(t) {
                        n[0][3].add(o(0, t, ct(i) ? i : l, t.notifyWith)),
                        n[1][3].add(o(0, t, ct(e) ? e : l)),
                        n[2][3].add(o(0, t, ct(r) ? r : u))
                    }).promise()
                },
                promise: function(t) {
                    return null != t ? ht.extend(t, i) : i
                }
            }
              , o = {};
            return ht.each(n, function(t, e) {
                var a = e[2]
                  , s = e[5];
                i[e[1]] = a.add,
                s && a.add(function() {
                    r = s
                }, n[3 - t][2].disable, n[3 - t][3].disable, n[0][2].lock, n[0][3].lock),
                a.add(e[3].fire),
                o[e[0]] = function() {
                    return o[e[0] + "With"](this === o ? void 0 : this, arguments),
                    this
                }
                ,
                o[e[0] + "With"] = a.fireWith
            }),
            i.promise(o),
            e && e.call(o, o),
            o
        },
        when: function(t) {
            var e = arguments.length
              , n = e
              , r = Array(n)
              , i = tt.call(arguments)
              , o = ht.Deferred()
              , a = function(t) {
                return function(n) {
                    r[t] = this,
                    i[t] = 1 < arguments.length ? tt.call(arguments) : n,
                    --e || o.resolveWith(r, i)
                }
            };
            if (e <= 1 && (c(t, o.done(a(n)).resolve, o.reject, !e),
            "pending" === o.state() || ct(i[n] && i[n].then)))
                return o.then();
            for (; n--; )
                c(i[n], a(n), o.reject);
            return o.promise()
        }
    });
    var Tt = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    ht.Deferred.exceptionHook = function(e, n) {
        t.console && t.console.warn && e && Tt.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, n)
    }
    ,
    ht.readyException = function(e) {
        t.setTimeout(function() {
            throw e
        })
    }
    ;
    var Et = ht.Deferred();
    ht.fn.ready = function(t) {
        return Et.then(t).catch(function(t) {
            ht.readyException(t)
        }),
        this
    }
    ,
    ht.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(t) {
            (!0 === t ? --ht.readyWait : ht.isReady) || (ht.isReady = !0) !== t && 0 < --ht.readyWait || Et.resolveWith(Q, [ht])
        }
    }),
    ht.ready.then = Et.then,
    "complete" === Q.readyState || "loading" !== Q.readyState && !Q.documentElement.doScroll ? t.setTimeout(ht.ready) : (Q.addEventListener("DOMContentLoaded", d),
    t.addEventListener("load", d));
    var At = function(t, e, n, i, o, a, s) {
        var l = 0
          , u = t.length
          , c = null == n;
        if ("object" === r(n))
            for (l in o = !0,
            n)
                At(t, e, l, n[l], !0, a, s);
        else if (void 0 !== i && (o = !0,
        ct(i) || (s = !0),
        c && (s ? (e.call(t, i),
        e = null) : (c = e,
        e = function(t, e, n) {
            return c.call(ht(t), n)
        }
        )),
        e))
            for (; l < u; l++)
                e(t[l], n, s ? i : i.call(t[l], l, e(t[l], n)));
        return o ? t : c ? e.call(t) : u ? e(t[0], n) : a
    }
      , Mt = /^-ms-/
      , Ot = /-([a-z])/g
      , Lt = function(t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
    };
    h.uid = 1,
    h.prototype = {
        cache: function(t) {
            var e = t[this.expando];
            return e || (e = {},
            Lt(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))),
            e
        },
        set: function(t, e, n) {
            var r, i = this.cache(t);
            if ("string" == typeof e)
                i[f(e)] = n;
            else
                for (r in e)
                    i[f(r)] = e[r];
            return i
        },
        get: function(t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][f(e)]
        },
        access: function(t, e, n) {
            return void 0 === e || e && "string" == typeof e && void 0 === n ? this.get(t, e) : (this.set(t, e, n),
            void 0 !== n ? n : e)
        },
        remove: function(t, e) {
            var n, r = t[this.expando];
            if (void 0 !== r) {
                if (void 0 !== e) {
                    n = (e = Array.isArray(e) ? e.map(f) : (e = f(e))in r ? [e] : e.match(St) || []).length;
                    for (; n--; )
                        delete r[e[n]]
                }
                (void 0 === e || ht.isEmptyObject(r)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var e = t[this.expando];
            return void 0 !== e && !ht.isEmptyObject(e)
        }
    };
    var It = new h
      , jt = new h
      , zt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , Nt = /[A-Z]/g;
    ht.extend({
        hasData: function(t) {
            return jt.hasData(t) || It.hasData(t)
        },
        data: function(t, e, n) {
            return jt.access(t, e, n)
        },
        removeData: function(t, e) {
            jt.remove(t, e)
        },
        _data: function(t, e, n) {
            return It.access(t, e, n)
        },
        _removeData: function(t, e) {
            It.remove(t, e)
        }
    }),
    ht.fn.extend({
        data: function(t, e) {
            var n, r, i, o = this[0], a = o && o.attributes;
            if (void 0 === t) {
                if (this.length && (i = jt.get(o),
                1 === o.nodeType && !It.get(o, "hasDataAttrs"))) {
                    for (n = a.length; n--; )
                        a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = f(r.slice(5)),
                        m(o, r, i[r]));
                    It.set(o, "hasDataAttrs", !0)
                }
                return i
            }
            return "object" == typeof t ? this.each(function() {
                jt.set(this, t)
            }) : At(this, function(e) {
                var n;
                return o && void 0 === e ? void 0 !== (n = jt.get(o, t)) ? n : void 0 !== (n = m(o, t)) ? n : void 0 : void this.each(function() {
                    jt.set(this, t, e)
                })
            }, null, e, 1 < arguments.length, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                jt.remove(this, t)
            })
        }
    }),
    ht.extend({
        queue: function(t, e, n) {
            var r;
            if (t)
                return e = (e || "fx") + "queue",
                r = It.get(t, e),
                n && (!r || Array.isArray(n) ? r = It.access(t, e, ht.makeArray(n)) : r.push(n)),
                r || []
        },
        dequeue: function(t, e) {
            e = e || "fx";
            var n = ht.queue(t, e)
              , r = n.length
              , i = n.shift()
              , o = ht._queueHooks(t, e);
            "inprogress" === i && (i = n.shift(),
            r--),
            i && ("fx" === e && n.unshift("inprogress"),
            delete o.stop,
            i.call(t, function() {
                ht.dequeue(t, e)
            }, o)),
            !r && o && o.empty.fire()
        },
        _queueHooks: function(t, e) {
            var n = e + "queueHooks";
            return It.get(t, n) || It.access(t, n, {
                empty: ht.Callbacks("once memory").add(function() {
                    It.remove(t, [e + "queue", n])
                })
            })
        }
    }),
    ht.fn.extend({
        queue: function(t, e) {
            var n = 2;
            return "string" != typeof t && (e = t,
            t = "fx",
            n--),
            arguments.length < n ? ht.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                var n = ht.queue(this, t, e);
                ht._queueHooks(this, t),
                "fx" === t && "inprogress" !== n[0] && ht.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                ht.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, e) {
            var n, r = 1, i = ht.Deferred(), o = this, a = this.length, s = function() {
                --r || i.resolveWith(o, [o])
            };
            for ("string" != typeof t && (e = t,
            t = void 0),
            t = t || "fx"; a--; )
                (n = It.get(o[a], t + "queueHooks")) && n.empty && (r++,
                n.empty.add(s));
            return s(),
            i.promise(e)
        }
    });
    var Pt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , Dt = new RegExp("^(?:([+-])=|)(" + Pt + ")([a-z%]*)$","i")
      , $t = ["Top", "Right", "Bottom", "Left"]
      , Rt = Q.documentElement
      , Ft = function(t) {
        return ht.contains(t.ownerDocument, t)
    }
      , Ht = {
        composed: !0
    };
    Rt.getRootNode && (Ft = function(t) {
        return ht.contains(t.ownerDocument, t) || t.getRootNode(Ht) === t.ownerDocument
    }
    );
    var Bt = function(t, e) {
        return "none" === (t = e || t).style.display || "" === t.style.display && Ft(t) && "none" === ht.css(t, "display")
    }
      , qt = function(t, e, n, r) {
        var i, o, a = {};
        for (o in e)
            a[o] = t.style[o],
            t.style[o] = e[o];
        for (o in i = n.apply(t, r || []),
        e)
            t.style[o] = a[o];
        return i
    }
      , Wt = {};
    ht.fn.extend({
        show: function() {
            return v(this, !0)
        },
        hide: function() {
            return v(this)
        },
        toggle: function(t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                Bt(this) ? ht(this).show() : ht(this).hide()
            })
        }
    });
    var Ut = /^(?:checkbox|radio)$/i
      , Vt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i
      , Xt = /^$|^module$|\/(?:java|ecma)script/i
      , Yt = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    Yt.optgroup = Yt.option,
    Yt.tbody = Yt.tfoot = Yt.colgroup = Yt.caption = Yt.thead,
    Yt.th = Yt.td;
    var Zt, Kt, Gt = /<|&#?\w+;/;
    Zt = Q.createDocumentFragment().appendChild(Q.createElement("div")),
    (Kt = Q.createElement("input")).setAttribute("type", "radio"),
    Kt.setAttribute("checked", "checked"),
    Kt.setAttribute("name", "t"),
    Zt.appendChild(Kt),
    ut.checkClone = Zt.cloneNode(!0).cloneNode(!0).lastChild.checked,
    Zt.innerHTML = "<textarea>x</textarea>",
    ut.noCloneChecked = !!Zt.cloneNode(!0).lastChild.defaultValue;
    var Qt = /^key/
      , Jt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , te = /^([^.]*)(?:\.(.+)|)/;
    ht.event = {
        global: {},
        add: function(t, e, n, r, i) {
            var o, a, s, l, u, c, d, p, f, h, m, g = It.get(t);
            if (g)
                for (n.handler && (n = (o = n).handler,
                i = o.selector),
                i && ht.find.matchesSelector(Rt, i),
                n.guid || (n.guid = ht.guid++),
                (l = g.events) || (l = g.events = {}),
                (a = g.handle) || (a = g.handle = function(e) {
                    return "undefined" != typeof ht && ht.event.triggered !== e.type ? ht.event.dispatch.apply(t, arguments) : void 0
                }
                ),
                u = (e = (e || "").match(St) || [""]).length; u--; )
                    f = m = (s = te.exec(e[u]) || [])[1],
                    h = (s[2] || "").split(".").sort(),
                    f && (d = ht.event.special[f] || {},
                    f = (i ? d.delegateType : d.bindType) || f,
                    d = ht.event.special[f] || {},
                    c = ht.extend({
                        type: f,
                        origType: m,
                        data: r,
                        handler: n,
                        guid: n.guid,
                        selector: i,
                        needsContext: i && ht.expr.match.needsContext.test(i),
                        namespace: h.join(".")
                    }, o),
                    (p = l[f]) || ((p = l[f] = []).delegateCount = 0,
                    d.setup && !1 !== d.setup.call(t, r, h, a) || t.addEventListener && t.addEventListener(f, a)),
                    d.add && (d.add.call(t, c),
                    c.handler.guid || (c.handler.guid = n.guid)),
                    i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                    ht.event.global[f] = !0)
        },
        remove: function(t, e, n, r, i) {
            var o, a, s, l, u, c, d, p, f, h, m, g = It.hasData(t) && It.get(t);
            if (g && (l = g.events)) {
                for (u = (e = (e || "").match(St) || [""]).length; u--; )
                    if (f = m = (s = te.exec(e[u]) || [])[1],
                    h = (s[2] || "").split(".").sort(),
                    f) {
                        for (d = ht.event.special[f] || {},
                        p = l[f = (r ? d.delegateType : d.bindType) || f] || [],
                        s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        a = o = p.length; o--; )
                            c = p[o],
                            !i && m !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1),
                            c.selector && p.delegateCount--,
                            d.remove && d.remove.call(t, c));
                        a && !p.length && (d.teardown && !1 !== d.teardown.call(t, h, g.handle) || ht.removeEvent(t, f, g.handle),
                        delete l[f])
                    } else
                        for (f in l)
                            ht.event.remove(t, f + e[u], n, r, !0);
                ht.isEmptyObject(l) && It.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            var e, n, r, i, o, a, s = ht.event.fix(t), l = new Array(arguments.length), u = (It.get(this, "events") || {})[s.type] || [], c = ht.event.special[s.type] || {};
            for (l[0] = s,
            e = 1; e < arguments.length; e++)
                l[e] = arguments[e];
            if (s.delegateTarget = this,
            !c.preDispatch || !1 !== c.preDispatch.call(this, s)) {
                for (a = ht.event.handlers.call(this, s, u),
                e = 0; (i = a[e++]) && !s.isPropagationStopped(); )
                    for (s.currentTarget = i.elem,
                    n = 0; (o = i.handlers[n++]) && !s.isImmediatePropagationStopped(); )
                        s.rnamespace && !1 !== o.namespace && !s.rnamespace.test(o.namespace) || (s.handleObj = o,
                        s.data = o.data,
                        void 0 !== (r = ((ht.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, l)) && !1 === (s.result = r) && (s.preventDefault(),
                        s.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, s),
                s.result
            }
        },
        handlers: function(t, e) {
            var n, r, i, o, a, s = [], l = e.delegateCount, u = t.target;
            if (l && u.nodeType && !("click" === t.type && 1 <= t.button))
                for (; u !== this; u = u.parentNode || this)
                    if (1 === u.nodeType && ("click" !== t.type || !0 !== u.disabled)) {
                        for (o = [],
                        a = {},
                        n = 0; n < l; n++)
                            void 0 === a[i = (r = e[n]).selector + " "] && (a[i] = r.needsContext ? -1 < ht(i, this).index(u) : ht.find(i, this, null, [u]).length),
                            a[i] && o.push(r);
                        o.length && s.push({
                            elem: u,
                            handlers: o
                        })
                    }
            return u = this,
            l < e.length && s.push({
                elem: u,
                handlers: e.slice(l)
            }),
            s
        },
        addProp: function(t, e) {
            Object.defineProperty(ht.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: ct(e) ? function() {
                    if (this.originalEvent)
                        return e(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[t]
                }
                ,
                set: function(e) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: e
                    })
                }
            })
        },
        fix: function(t) {
            return t[ht.expando] ? t : new ht.Event(t)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(t) {
                    var e = this || t;
                    return Ut.test(e.type) && e.click && o(e, "input") && S(e, "click", x),
                    !1
                },
                trigger: function(t) {
                    var e = this || t;
                    return Ut.test(e.type) && e.click && o(e, "input") && S(e, "click"),
                    !0
                },
                _default: function(t) {
                    var e = t.target;
                    return Ut.test(e.type) && e.click && o(e, "input") && It.get(e, "click") || o(e, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    },
    ht.removeEvent = function(t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n)
    }
    ,
    ht.Event = function(t, e) {
        return this instanceof ht.Event ? (t && t.type ? (this.originalEvent = t,
        this.type = t.type,
        this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? x : C,
        this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target,
        this.currentTarget = t.currentTarget,
        this.relatedTarget = t.relatedTarget) : this.type = t,
        e && ht.extend(this, e),
        this.timeStamp = t && t.timeStamp || Date.now(),
        this[ht.expando] = !0,
        void 0) : new ht.Event(t,e)
    }
    ,
    ht.Event.prototype = {
        constructor: ht.Event,
        isDefaultPrevented: C,
        isPropagationStopped: C,
        isImmediatePropagationStopped: C,
        isSimulated: !1,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = x,
            t && !this.isSimulated && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = x,
            t && !this.isSimulated && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = x,
            t && !this.isSimulated && t.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    ht.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(t) {
            var e = t.button;
            return null == t.which && Qt.test(t.type) ? null != t.charCode ? t.charCode : t.keyCode : !t.which && void 0 !== e && Jt.test(t.type) ? 1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0 : t.which
        }
    }, ht.event.addProp),
    ht.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        ht.event.special[t] = {
            setup: function() {
                return S(this, t, k),
                !1
            },
            trigger: function() {
                return S(this, t),
                !0
            },
            delegateType: e
        }
    }),
    ht.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(t, e) {
        ht.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function(t) {
                var n, r = t.relatedTarget, i = t.handleObj;
                return r && (r === this || ht.contains(this, r)) || (t.type = i.origType,
                n = i.handler.apply(this, arguments),
                t.type = e),
                n
            }
        }
    }),
    ht.fn.extend({
        on: function(t, e, n, r) {
            return _(this, t, e, n, r)
        },
        one: function(t, e, n, r) {
            return _(this, t, e, n, r, 1)
        },
        off: function(t, e, n) {
            var r, i;
            if (t && t.preventDefault && t.handleObj)
                return r = t.handleObj,
                ht(t.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler),
                this;
            if ("object" == typeof t) {
                for (i in t)
                    this.off(i, e, t[i]);
                return this
            }
            return !1 !== e && "function" != typeof e || (n = e,
            e = void 0),
            !1 === n && (n = C),
            this.each(function() {
                ht.event.remove(this, t, n, e)
            })
        }
    });
    var ee = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi
      , ne = /<script|<style|<link/i
      , re = /checked\s*(?:[^=]|=\s*.checked.)/i
      , ie = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    ht.extend({
        htmlPrefilter: function(t) {
            return t.replace(ee, "<$1></$2>")
        },
        clone: function(t, e, n) {
            var r, i, o, a, s, l, u, c = t.cloneNode(!0), d = Ft(t);
            if (!(ut.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || ht.isXMLDoc(t)))
                for (a = y(c),
                r = 0,
                i = (o = y(t)).length; r < i; r++)
                    s = o[r],
                    l = a[r],
                    "input" === (u = l.nodeName.toLowerCase()) && Ut.test(s.type) ? l.checked = s.checked : "input" !== u && "textarea" !== u || (l.defaultValue = s.defaultValue);
            if (e)
                if (n)
                    for (o = o || y(t),
                    a = a || y(c),
                    r = 0,
                    i = o.length; r < i; r++)
                        M(o[r], a[r]);
                else
                    M(t, c);
            return 0 < (a = y(c, "script")).length && b(a, !d && y(t, "script")),
            c
        },
        cleanData: function(t) {
            for (var e, n, r, i = ht.event.special, o = 0; void 0 !== (n = t[o]); o++)
                if (Lt(n)) {
                    if (e = n[It.expando]) {
                        if (e.events)
                            for (r in e.events)
                                i[r] ? ht.event.remove(n, r) : ht.removeEvent(n, r, e.handle);
                        n[It.expando] = void 0
                    }
                    n[jt.expando] && (n[jt.expando] = void 0)
                }
        }
    }),
    ht.fn.extend({
        detach: function(t) {
            return L(this, t, !0)
        },
        remove: function(t) {
            return L(this, t)
        },
        text: function(t) {
            return At(this, function(t) {
                return void 0 === t ? ht.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return O(this, arguments, function(t) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || T(this, t).appendChild(t)
            })
        },
        prepend: function() {
            return O(this, arguments, function(t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = T(this, t);
                    e.insertBefore(t, e.firstChild)
                }
            })
        },
        before: function() {
            return O(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return O(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, e = 0; null != (t = this[e]); e++)
                1 === t.nodeType && (ht.cleanData(y(t, !1)),
                t.textContent = "");
            return this
        },
        clone: function(t, e) {
            return t = null != t && t,
            e = null == e ? t : e,
            this.map(function() {
                return ht.clone(this, t, e)
            })
        },
        html: function(t) {
            return At(this, function(t) {
                var e = this[0] || {}
                  , n = 0
                  , r = this.length;
                if (void 0 === t && 1 === e.nodeType)
                    return e.innerHTML;
                if ("string" == typeof t && !ne.test(t) && !Yt[(Vt.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = ht.htmlPrefilter(t);
                    try {
                        for (; n < r; n++)
                            1 === (e = this[n] || {}).nodeType && (ht.cleanData(y(e, !1)),
                            e.innerHTML = t);
                        e = 0
                    } catch (t) {}
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return O(this, arguments, function(e) {
                var n = this.parentNode;
                ht.inArray(this, t) < 0 && (ht.cleanData(y(this)),
                n && n.replaceChild(e, this))
            }, t)
        }
    }),
    ht.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(t, e) {
        ht.fn[t] = function(t) {
            for (var n, r = [], i = ht(t), o = i.length - 1, a = 0; a <= o; a++)
                n = a === o ? this : this.clone(!0),
                ht(i[a])[e](n),
                nt.apply(r, n.get());
            return this.pushStack(r)
        }
    });
    var oe = new RegExp("^(" + Pt + ")(?!px)[a-z%]+$","i")
      , ae = function(e) {
        var n = e.ownerDocument.defaultView;
        return n && n.opener || (n = t),
        n.getComputedStyle(e)
    }
      , se = new RegExp($t.join("|"),"i");
    !function() {
        function e() {
            if (u) {
                l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                Rt.appendChild(l).appendChild(u);
                var e = t.getComputedStyle(u);
                r = "1%" !== e.top,
                s = 12 === n(e.marginLeft),
                u.style.right = "60%",
                a = 36 === n(e.right),
                i = 36 === n(e.width),
                u.style.position = "absolute",
                o = 12 === n(u.offsetWidth / 3),
                Rt.removeChild(l),
                u = null
            }
        }
        function n(t) {
            return Math.round(parseFloat(t))
        }
        var r, i, o, a, s, l = Q.createElement("div"), u = Q.createElement("div");
        u.style && (u.style.backgroundClip = "content-box",
        u.cloneNode(!0).style.backgroundClip = "",
        ut.clearCloneStyle = "content-box" === u.style.backgroundClip,
        ht.extend(ut, {
            boxSizingReliable: function() {
                return e(),
                i
            },
            pixelBoxStyles: function() {
                return e(),
                a
            },
            pixelPosition: function() {
                return e(),
                r
            },
            reliableMarginLeft: function() {
                return e(),
                s
            },
            scrollboxSize: function() {
                return e(),
                o
            }
        }))
    }();
    var le = ["Webkit", "Moz", "ms"]
      , ue = Q.createElement("div").style
      , ce = {}
      , de = /^(none|table(?!-c[ea]).+)/
      , pe = /^--/
      , fe = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , he = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    ht.extend({
        cssHooks: {
            opacity: {
                get: function(t, e) {
                    if (e) {
                        var n = I(t, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(t, e, n, r) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var i, o, a, s = f(e), l = pe.test(e), u = t.style;
                if (l || (e = z(s)),
                a = ht.cssHooks[e] || ht.cssHooks[s],
                void 0 === n)
                    return a && "get"in a && void 0 !== (i = a.get(t, !1, r)) ? i : u[e];
                "string" == (o = typeof n) && (i = Dt.exec(n)) && i[1] && (n = g(t, e, i),
                o = "number"),
                null != n && n == n && ("number" !== o || l || (n += i && i[3] || (ht.cssNumber[s] ? "" : "px")),
                ut.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (u[e] = "inherit"),
                a && "set"in a && void 0 === (n = a.set(t, n, r)) || (l ? u.setProperty(e, n) : u[e] = n))
            }
        },
        css: function(t, e, n, r) {
            var i, o, a, s = f(e);
            return pe.test(e) || (e = z(s)),
            (a = ht.cssHooks[e] || ht.cssHooks[s]) && "get"in a && (i = a.get(t, !0, n)),
            void 0 === i && (i = I(t, e, r)),
            "normal" === i && e in he && (i = he[e]),
            "" === n || n ? (o = parseFloat(i),
            !0 === n || isFinite(o) ? o || 0 : i) : i
        }
    }),
    ht.each(["height", "width"], function(t, e) {
        ht.cssHooks[e] = {
            get: function(t, n, r) {
                if (n)
                    return !de.test(ht.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? D(t, e, r) : qt(t, fe, function() {
                        return D(t, e, r)
                    })
            },
            set: function(t, n, r) {
                var i, o = ae(t), a = !ut.scrollboxSize() && "absolute" === o.position, s = (a || r) && "border-box" === ht.css(t, "boxSizing", !1, o), l = r ? P(t, e, r, s, o) : 0;
                return s && a && (l -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(o[e]) - P(t, e, "border", !1, o) - .5)),
                l && (i = Dt.exec(n)) && "px" !== (i[3] || "px") && (t.style[e] = n,
                n = ht.css(t, e)),
                N(0, n, l)
            }
        }
    }),
    ht.cssHooks.marginLeft = j(ut.reliableMarginLeft, function(t, e) {
        if (e)
            return (parseFloat(I(t, "marginLeft")) || t.getBoundingClientRect().left - qt(t, {
                marginLeft: 0
            }, function() {
                return t.getBoundingClientRect().left
            })) + "px"
    }),
    ht.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(t, e) {
        ht.cssHooks[t + e] = {
            expand: function(n) {
                for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++)
                    i[t + $t[r] + e] = o[r] || o[r - 2] || o[0];
                return i
            }
        },
        "margin" !== t && (ht.cssHooks[t + e].set = N)
    }),
    ht.fn.extend({
        css: function(t, e) {
            return At(this, function(t, e, n) {
                var r, i, o = {}, a = 0;
                if (Array.isArray(e)) {
                    for (r = ae(t),
                    i = e.length; a < i; a++)
                        o[e[a]] = ht.css(t, e[a], !1, r);
                    return o
                }
                return void 0 !== n ? ht.style(t, e, n) : ht.css(t, e)
            }, t, e, 1 < arguments.length)
        }
    }),
    ((ht.Tween = $).prototype = {
        constructor: $,
        init: function(t, e, n, r, i, o) {
            this.elem = t,
            this.prop = n,
            this.easing = i || ht.easing._default,
            this.options = e,
            this.start = this.now = this.cur(),
            this.end = r,
            this.unit = o || (ht.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var t = $.propHooks[this.prop];
            return t && t.get ? t.get(this) : $.propHooks._default.get(this)
        },
        run: function(t) {
            var e, n = $.propHooks[this.prop];
            return this.options.duration ? this.pos = e = ht.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t,
            this.now = (this.end - this.start) * e + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : $.propHooks._default.set(this),
            this
        }
    }).init.prototype = $.prototype,
    ($.propHooks = {
        _default: {
            get: function(t) {
                var e;
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = ht.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
            },
            set: function(t) {
                ht.fx.step[t.prop] ? ht.fx.step[t.prop](t) : 1 !== t.elem.nodeType || !ht.cssHooks[t.prop] && null == t.elem.style[z(t.prop)] ? t.elem[t.prop] = t.now : ht.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    }).scrollTop = $.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    },
    ht.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    },
    ht.fx = $.prototype.init,
    ht.fx.step = {};
    var me, ge, ve, ye, be = /^(?:toggle|show|hide)$/, we = /queueHooks$/;
    ht.Animation = ht.extend(q, {
        tweeners: {
            "*": [function(t, e) {
                var n = this.createTween(t, e);
                return g(n.elem, t, Dt.exec(e), n),
                n
            }
            ]
        },
        tweener: function(t, e) {
            ct(t) ? (e = t,
            t = ["*"]) : t = t.match(St);
            for (var n, r = 0, i = t.length; r < i; r++)
                n = t[r],
                q.tweeners[n] = q.tweeners[n] || [],
                q.tweeners[n].unshift(e)
        },
        prefilters: [function(t, e, n) {
            var r, i, o, a, s, l, u, c, d = "width"in e || "height"in e, p = this, f = {}, h = t.style, m = t.nodeType && Bt(t), g = It.get(t, "fxshow");
            for (r in n.queue || (null == (a = ht._queueHooks(t, "fx")).unqueued && (a.unqueued = 0,
            s = a.empty.fire,
            a.empty.fire = function() {
                a.unqueued || s()
            }
            ),
            a.unqueued++,
            p.always(function() {
                p.always(function() {
                    a.unqueued--,
                    ht.queue(t, "fx").length || a.empty.fire()
                })
            })),
            e)
                if (i = e[r],
                be.test(i)) {
                    if (delete e[r],
                    o = o || "toggle" === i,
                    i === (m ? "hide" : "show")) {
                        if ("show" !== i || !g || void 0 === g[r])
                            continue;
                        m = !0
                    }
                    f[r] = g && g[r] || ht.style(t, r)
                }
            if ((l = !ht.isEmptyObject(e)) || !ht.isEmptyObject(f))
                for (r in d && 1 === t.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY],
                null == (u = g && g.display) && (u = It.get(t, "display")),
                "none" === (c = ht.css(t, "display")) && (u ? c = u : (v([t], !0),
                u = t.style.display || u,
                c = ht.css(t, "display"),
                v([t]))),
                ("inline" === c || "inline-block" === c && null != u) && "none" === ht.css(t, "float") && (l || (p.done(function() {
                    h.display = u
                }),
                null == u && (c = h.display,
                u = "none" === c ? "" : c)),
                h.display = "inline-block")),
                n.overflow && (h.overflow = "hidden",
                p.always(function() {
                    h.overflow = n.overflow[0],
                    h.overflowX = n.overflow[1],
                    h.overflowY = n.overflow[2]
                })),
                l = !1,
                f)
                    l || (g ? "hidden"in g && (m = g.hidden) : g = It.access(t, "fxshow", {
                        display: u
                    }),
                    o && (g.hidden = !m),
                    m && v([t], !0),
                    p.done(function() {
                        for (r in m || v([t]),
                        It.remove(t, "fxshow"),
                        f)
                            ht.style(t, r, f[r])
                    })),
                    l = B(m ? g[r] : 0, r, p),
                    r in g || (g[r] = l.start,
                    m && (l.end = l.start,
                    l.start = 0))
        }
        ],
        prefilter: function(t, e) {
            e ? q.prefilters.unshift(t) : q.prefilters.push(t)
        }
    }),
    ht.speed = function(t, e, n) {
        var r = t && "object" == typeof t ? ht.extend({}, t) : {
            complete: n || !n && e || ct(t) && t,
            duration: t,
            easing: n && e || e && !ct(e) && e
        };
        return ht.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in ht.fx.speeds ? r.duration = ht.fx.speeds[r.duration] : r.duration = ht.fx.speeds._default),
        null != r.queue && !0 !== r.queue || (r.queue = "fx"),
        r.old = r.complete,
        r.complete = function() {
            ct(r.old) && r.old.call(this),
            r.queue && ht.dequeue(this, r.queue)
        }
        ,
        r
    }
    ,
    ht.fn.extend({
        fadeTo: function(t, e, n, r) {
            return this.filter(Bt).css("opacity", 0).show().end().animate({
                opacity: e
            }, t, n, r)
        },
        animate: function(t, e, n, r) {
            var i = ht.isEmptyObject(t)
              , o = ht.speed(e, n, r)
              , a = function() {
                var e = q(this, ht.extend({}, t), o);
                (i || It.get(this, "finish")) && e.stop(!0)
            };
            return a.finish = a,
            i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        },
        stop: function(t, e, n) {
            var r = function(t) {
                var e = t.stop;
                delete t.stop,
                e(n)
            };
            return "string" != typeof t && (n = e,
            e = t,
            t = void 0),
            e && !1 !== t && this.queue(t || "fx", []),
            this.each(function() {
                var e = !0
                  , i = null != t && t + "queueHooks"
                  , o = ht.timers
                  , a = It.get(this);
                if (i)
                    a[i] && a[i].stop && r(a[i]);
                else
                    for (i in a)
                        a[i] && a[i].stop && we.test(i) && r(a[i]);
                for (i = o.length; i--; )
                    o[i].elem !== this || null != t && o[i].queue !== t || (o[i].anim.stop(n),
                    e = !1,
                    o.splice(i, 1));
                !e && n || ht.dequeue(this, t)
            })
        },
        finish: function(t) {
            return !1 !== t && (t = t || "fx"),
            this.each(function() {
                var e, n = It.get(this), r = n[t + "queue"], i = n[t + "queueHooks"], o = ht.timers, a = r ? r.length : 0;
                for (n.finish = !0,
                ht.queue(this, t, []),
                i && i.stop && i.stop.call(this, !0),
                e = o.length; e--; )
                    o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0),
                    o.splice(e, 1));
                for (e = 0; e < a; e++)
                    r[e] && r[e].finish && r[e].finish.call(this);
                delete n.finish
            })
        }
    }),
    ht.each(["toggle", "show", "hide"], function(t, e) {
        var n = ht.fn[e];
        ht.fn[e] = function(t, r, i) {
            return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(H(e, !0), t, r, i)
        }
    }),
    ht.each({
        slideDown: H("show"),
        slideUp: H("hide"),
        slideToggle: H("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(t, e) {
        ht.fn[t] = function(t, n, r) {
            return this.animate(e, t, n, r)
        }
    }),
    ht.timers = [],
    ht.fx.tick = function() {
        var t, e = 0, n = ht.timers;
        for (me = Date.now(); e < n.length; e++)
            (t = n[e])() || n[e] !== t || n.splice(e--, 1);
        n.length || ht.fx.stop(),
        me = void 0
    }
    ,
    ht.fx.timer = function(t) {
        ht.timers.push(t),
        ht.fx.start()
    }
    ,
    ht.fx.interval = 13,
    ht.fx.start = function() {
        ge || (ge = !0,
        R())
    }
    ,
    ht.fx.stop = function() {
        ge = null
    }
    ,
    ht.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    ht.fn.delay = function(e, n) {
        return e = ht.fx && ht.fx.speeds[e] || e,
        n = n || "fx",
        this.queue(n, function(n, r) {
            var i = t.setTimeout(n, e);
            r.stop = function() {
                t.clearTimeout(i)
            }
        })
    }
    ,
    ve = Q.createElement("input"),
    ye = Q.createElement("select").appendChild(Q.createElement("option")),
    ve.type = "checkbox",
    ut.checkOn = "" !== ve.value,
    ut.optSelected = ye.selected,
    (ve = Q.createElement("input")).value = "t",
    ve.type = "radio",
    ut.radioValue = "t" === ve.value;
    var xe, Ce = ht.expr.attrHandle;
    ht.fn.extend({
        attr: function(t, e) {
            return At(this, ht.attr, t, e, 1 < arguments.length)
        },
        removeAttr: function(t) {
            return this.each(function() {
                ht.removeAttr(this, t)
            })
        }
    }),
    ht.extend({
        attr: function(t, e, n) {
            var r, i, o = t.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return "undefined" == typeof t.getAttribute ? ht.prop(t, e, n) : (1 === o && ht.isXMLDoc(t) || (i = ht.attrHooks[e.toLowerCase()] || (ht.expr.match.bool.test(e) ? xe : void 0)),
                void 0 !== n ? null === n ? void ht.removeAttr(t, e) : i && "set"in i && void 0 !== (r = i.set(t, n, e)) ? r : (t.setAttribute(e, n + ""),
                n) : i && "get"in i && null !== (r = i.get(t, e)) ? r : null == (r = ht.find.attr(t, e)) ? void 0 : r)
        },
        attrHooks: {
            type: {
                set: function(t, e) {
                    if (!ut.radioValue && "radio" === e && o(t, "input")) {
                        var n = t.value;
                        return t.setAttribute("type", e),
                        n && (t.value = n),
                        e
                    }
                }
            }
        },
        removeAttr: function(t, e) {
            var n, r = 0, i = e && e.match(St);
            if (i && 1 === t.nodeType)
                for (; n = i[r++]; )
                    t.removeAttribute(n)
        }
    }),
    xe = {
        set: function(t, e, n) {
            return !1 === e ? ht.removeAttr(t, n) : t.setAttribute(n, n),
            n
        }
    },
    ht.each(ht.expr.match.bool.source.match(/\w+/g), function(t, e) {
        var n = Ce[e] || ht.find.attr;
        Ce[e] = function(t, e, r) {
            var i, o, a = e.toLowerCase();
            return r || (o = Ce[a],
            Ce[a] = i,
            i = null != n(t, e, r) ? a : null,
            Ce[a] = o),
            i
        }
    });
    var ke = /^(?:input|select|textarea|button)$/i
      , _e = /^(?:a|area)$/i;
    ht.fn.extend({
        prop: function(t, e) {
            return At(this, ht.prop, t, e, 1 < arguments.length)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[ht.propFix[t] || t]
            })
        }
    }),
    ht.extend({
        prop: function(t, e, n) {
            var r, i, o = t.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return 1 === o && ht.isXMLDoc(t) || (e = ht.propFix[e] || e,
                i = ht.propHooks[e]),
                void 0 !== n ? i && "set"in i && void 0 !== (r = i.set(t, n, e)) ? r : t[e] = n : i && "get"in i && null !== (r = i.get(t, e)) ? r : t[e]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var e = ht.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : ke.test(t.nodeName) || _e.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    ut.optSelected || (ht.propHooks.selected = {
        get: function(t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex,
            null
        },
        set: function(t) {
            var e = t.parentNode;
            e && (e.selectedIndex,
            e.parentNode && e.parentNode.selectedIndex)
        }
    }),
    ht.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        ht.propFix[this.toLowerCase()] = this
    }),
    ht.fn.extend({
        addClass: function(t) {
            var e, n, r, i, o, a, s, l = 0;
            if (ct(t))
                return this.each(function(e) {
                    ht(this).addClass(t.call(this, e, U(this)))
                });
            if ((e = V(t)).length)
                for (; n = this[l++]; )
                    if (i = U(n),
                    r = 1 === n.nodeType && " " + W(i) + " ") {
                        for (a = 0; o = e[a++]; )
                            r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                        i !== (s = W(r)) && n.setAttribute("class", s)
                    }
            return this
        },
        removeClass: function(t) {
            var e, n, r, i, o, a, s, l = 0;
            if (ct(t))
                return this.each(function(e) {
                    ht(this).removeClass(t.call(this, e, U(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ((e = V(t)).length)
                for (; n = this[l++]; )
                    if (i = U(n),
                    r = 1 === n.nodeType && " " + W(i) + " ") {
                        for (a = 0; o = e[a++]; )
                            for (; -1 < r.indexOf(" " + o + " "); )
                                r = r.replace(" " + o + " ", " ");
                        i !== (s = W(r)) && n.setAttribute("class", s)
                    }
            return this
        },
        toggleClass: function(t, e) {
            var n = typeof t
              , r = "string" === n || Array.isArray(t);
            return "boolean" == typeof e && r ? e ? this.addClass(t) : this.removeClass(t) : ct(t) ? this.each(function(n) {
                ht(this).toggleClass(t.call(this, n, U(this), e), e)
            }) : this.each(function() {
                var e, i, o, a;
                if (r)
                    for (i = 0,
                    o = ht(this),
                    a = V(t); e = a[i++]; )
                        o.hasClass(e) ? o.removeClass(e) : o.addClass(e);
                else
                    void 0 !== t && "boolean" !== n || ((e = U(this)) && It.set(this, "__className__", e),
                    this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : It.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var e, n, r = 0;
            for (e = " " + t + " "; n = this[r++]; )
                if (1 === n.nodeType && -1 < (" " + W(U(n)) + " ").indexOf(e))
                    return !0;
            return !1
        }
    });
    var Se = /\r/g;
    ht.fn.extend({
        val: function(t) {
            var e, n, r, i = this[0];
            return arguments.length ? (r = ct(t),
            this.each(function(n) {
                var i;
                1 === this.nodeType && (null == (i = r ? t.call(this, n, ht(this).val()) : t) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = ht.map(i, function(t) {
                    return null == t ? "" : t + ""
                })),
                (e = ht.valHooks[this.type] || ht.valHooks[this.nodeName.toLowerCase()]) && "set"in e && void 0 !== e.set(this, i, "value") || (this.value = i))
            })) : i ? (e = ht.valHooks[i.type] || ht.valHooks[i.nodeName.toLowerCase()]) && "get"in e && void 0 !== (n = e.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(Se, "") : null == n ? "" : n : void 0
        }
    }),
    ht.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var e = ht.find.attr(t, "value");
                    return null != e ? e : W(ht.text(t))
                }
            },
            select: {
                get: function(t) {
                    var e, n, r, i = t.options, a = t.selectedIndex, s = "select-one" === t.type, l = s ? null : [], u = s ? a + 1 : i.length;
                    for (r = a < 0 ? u : s ? a : 0; r < u; r++)
                        if (((n = i[r]).selected || r === a) && !n.disabled && (!n.parentNode.disabled || !o(n.parentNode, "optgroup"))) {
                            if (e = ht(n).val(),
                            s)
                                return e;
                            l.push(e)
                        }
                    return l
                },
                set: function(t, e) {
                    for (var n, r, i = t.options, o = ht.makeArray(e), a = i.length; a--; )
                        ((r = i[a]).selected = -1 < ht.inArray(ht.valHooks.option.get(r), o)) && (n = !0);
                    return n || (t.selectedIndex = -1),
                    o
                }
            }
        }
    }),
    ht.each(["radio", "checkbox"], function() {
        ht.valHooks[this] = {
            set: function(t, e) {
                if (Array.isArray(e))
                    return t.checked = -1 < ht.inArray(ht(t).val(), e)
            }
        },
        ut.checkOn || (ht.valHooks[this].get = function(t) {
            return null === t.getAttribute("value") ? "on" : t.value
        }
        )
    }),
    ut.focusin = "onfocusin"in t;
    var Te = /^(?:focusinfocus|focusoutblur)$/
      , Ee = function(t) {
        t.stopPropagation()
    };
    ht.extend(ht.event, {
        trigger: function(e, n, r, i) {
            var o, a, s, l, u, c, d, p, f = [r || Q], h = at.call(e, "type") ? e.type : e, m = at.call(e, "namespace") ? e.namespace.split(".") : [];
            if (a = p = s = r = r || Q,
            3 !== r.nodeType && 8 !== r.nodeType && !Te.test(h + ht.event.triggered) && (-1 < h.indexOf(".") && (h = (m = h.split(".")).shift(),
            m.sort()),
            u = h.indexOf(":") < 0 && "on" + h,
            (e = e[ht.expando] ? e : new ht.Event(h,"object" == typeof e && e)).isTrigger = i ? 2 : 3,
            e.namespace = m.join("."),
            e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            e.result = void 0,
            e.target || (e.target = r),
            n = null == n ? [e] : ht.makeArray(n, [e]),
            d = ht.event.special[h] || {},
            i || !d.trigger || !1 !== d.trigger.apply(r, n))) {
                if (!i && !d.noBubble && !dt(r)) {
                    for (l = d.delegateType || h,
                    Te.test(l + h) || (a = a.parentNode); a; a = a.parentNode)
                        f.push(a),
                        s = a;
                    s === (r.ownerDocument || Q) && f.push(s.defaultView || s.parentWindow || t)
                }
                for (o = 0; (a = f[o++]) && !e.isPropagationStopped(); )
                    p = a,
                    e.type = 1 < o ? l : d.bindType || h,
                    (c = (It.get(a, "events") || {})[e.type] && It.get(a, "handle")) && c.apply(a, n),
                    (c = u && a[u]) && c.apply && Lt(a) && (e.result = c.apply(a, n),
                    !1 === e.result && e.preventDefault());
                return e.type = h,
                i || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(f.pop(), n) || !Lt(r) || u && ct(r[h]) && !dt(r) && ((s = r[u]) && (r[u] = null),
                ht.event.triggered = h,
                e.isPropagationStopped() && p.addEventListener(h, Ee),
                r[h](),
                e.isPropagationStopped() && p.removeEventListener(h, Ee),
                ht.event.triggered = void 0,
                s && (r[u] = s)),
                e.result
            }
        },
        simulate: function(t, e, n) {
            var r = ht.extend(new ht.Event, n, {
                type: t,
                isSimulated: !0
            });
            ht.event.trigger(r, null, e)
        }
    }),
    ht.fn.extend({
        trigger: function(t, e) {
            return this.each(function() {
                ht.event.trigger(t, e, this)
            })
        },
        triggerHandler: function(t, e) {
            var n = this[0];
            if (n)
                return ht.event.trigger(t, e, n, !0)
        }
    }),
    ut.focusin || ht.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        var n = function(t) {
            ht.event.simulate(e, t.target, ht.event.fix(t))
        };
        ht.event.special[e] = {
            setup: function() {
                var r = this.ownerDocument || this
                  , i = It.access(r, e);
                i || r.addEventListener(t, n, !0),
                It.access(r, e, (i || 0) + 1)
            },
            teardown: function() {
                var r = this.ownerDocument || this
                  , i = It.access(r, e) - 1;
                i ? It.access(r, e, i) : (r.removeEventListener(t, n, !0),
                It.remove(r, e))
            }
        }
    });
    var Ae = t.location
      , Me = Date.now()
      , Oe = /\?/;
    ht.parseXML = function(e) {
        var n;
        if (!e || "string" != typeof e)
            return null;
        try {
            n = (new t.DOMParser).parseFromString(e, "text/xml")
        } catch (t) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || ht.error("Invalid XML: " + e),
        n
    }
    ;
    var Le = /\[\]$/
      , Ie = /\r?\n/g
      , je = /^(?:submit|button|image|reset|file)$/i
      , ze = /^(?:input|select|textarea|keygen)/i;
    ht.param = function(t, e) {
        var n, r = [], i = function(t, e) {
            var n = ct(e) ? e() : e;
            r[r.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == n ? "" : n)
        };
        if (null == t)
            return "";
        if (Array.isArray(t) || t.jquery && !ht.isPlainObject(t))
            ht.each(t, function() {
                i(this.name, this.value)
            });
        else
            for (n in t)
                X(n, t[n], e, i);
        return r.join("&")
    }
    ,
    ht.fn.extend({
        serialize: function() {
            return ht.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = ht.prop(this, "elements");
                return t ? ht.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !ht(this).is(":disabled") && ze.test(this.nodeName) && !je.test(t) && (this.checked || !Ut.test(t))
            }).map(function(t, e) {
                var n = ht(this).val();
                return null == n ? null : Array.isArray(n) ? ht.map(n, function(t) {
                    return {
                        name: e.name,
                        value: t.replace(Ie, "\r\n")
                    }
                }) : {
                    name: e.name,
                    value: n.replace(Ie, "\r\n")
                }
            }).get()
        }
    });
    var Ne = /%20/g
      , Pe = /#.*$/
      , De = /([?&])_=[^&]*/
      , $e = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , Re = /^(?:GET|HEAD)$/
      , Fe = /^\/\//
      , He = {}
      , Be = {}
      , qe = "*/".concat("*")
      , We = Q.createElement("a");
    We.href = Ae.href,
    ht.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Ae.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ae.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": qe,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": ht.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, e) {
            return e ? K(K(t, ht.ajaxSettings), e) : K(ht.ajaxSettings, t)
        },
        ajaxPrefilter: Y(He),
        ajaxTransport: Y(Be),
        ajax: function(e, n) {
            function r(e, n, r, s) {
                var u, p, f, w, x, C = n;
                c || (c = !0,
                l && t.clearTimeout(l),
                i = void 0,
                a = s || "",
                k.readyState = 0 < e ? 4 : 0,
                u = 200 <= e && e < 300 || 304 === e,
                r && (w = function(t, e, n) {
                    for (var r, i, o, a, s = t.contents, l = t.dataTypes; "*" === l[0]; )
                        l.shift(),
                        void 0 === r && (r = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (r)
                        for (i in s)
                            if (s[i] && s[i].test(r)) {
                                l.unshift(i);
                                break
                            }
                    if (l[0]in n)
                        o = l[0];
                    else {
                        for (i in n) {
                            if (!l[0] || t.converters[i + " " + l[0]]) {
                                o = i;
                                break
                            }
                            a || (a = i)
                        }
                        o = o || a
                    }
                    if (o)
                        return o !== l[0] && l.unshift(o),
                        n[o]
                }(h, k, r)),
                w = function(t, e, n, r) {
                    var i, o, a, s, l, u = {}, c = t.dataTypes.slice();
                    if (c[1])
                        for (a in t.converters)
                            u[a.toLowerCase()] = t.converters[a];
                    for (o = c.shift(); o; )
                        if (t.responseFields[o] && (n[t.responseFields[o]] = e),
                        !l && r && t.dataFilter && (e = t.dataFilter(e, t.dataType)),
                        l = o,
                        o = c.shift())
                            if ("*" === o)
                                o = l;
                            else if ("*" !== l && l !== o) {
                                if (!(a = u[l + " " + o] || u["* " + o]))
                                    for (i in u)
                                        if ((s = i.split(" "))[1] === o && (a = u[l + " " + s[0]] || u["* " + s[0]])) {
                                            !0 === a ? a = u[i] : !0 !== u[i] && (o = s[0],
                                            c.unshift(s[1]));
                                            break
                                        }
                                if (!0 !== a)
                                    if (a && t.throws)
                                        e = a(e);
                                    else
                                        try {
                                            e = a(e)
                                        } catch (t) {
                                            return {
                                                state: "parsererror",
                                                error: a ? t : "No conversion from " + l + " to " + o
                                            }
                                        }
                            }
                    return {
                        state: "success",
                        data: e
                    }
                }(h, w, k, u),
                u ? (h.ifModified && ((x = k.getResponseHeader("Last-Modified")) && (ht.lastModified[o] = x),
                (x = k.getResponseHeader("etag")) && (ht.etag[o] = x)),
                204 === e || "HEAD" === h.type ? C = "nocontent" : 304 === e ? C = "notmodified" : (C = w.state,
                p = w.data,
                u = !(f = w.error))) : (f = C,
                !e && C || (C = "error",
                e < 0 && (e = 0))),
                k.status = e,
                k.statusText = (n || C) + "",
                u ? v.resolveWith(m, [p, C, k]) : v.rejectWith(m, [k, C, f]),
                k.statusCode(b),
                b = void 0,
                d && g.trigger(u ? "ajaxSuccess" : "ajaxError", [k, h, u ? p : f]),
                y.fireWith(m, [k, C]),
                d && (g.trigger("ajaxComplete", [k, h]),
                --ht.active || ht.event.trigger("ajaxStop")))
            }
            "object" == typeof e && (n = e,
            e = void 0),
            n = n || {};
            var i, o, a, s, l, u, c, d, p, f, h = ht.ajaxSetup({}, n), m = h.context || h, g = h.context && (m.nodeType || m.jquery) ? ht(m) : ht.event, v = ht.Deferred(), y = ht.Callbacks("once memory"), b = h.statusCode || {}, w = {}, x = {}, C = "canceled", k = {
                readyState: 0,
                getResponseHeader: function(t) {
                    var e;
                    if (c) {
                        if (!s)
                            for (s = {}; e = $e.exec(a); )
                                s[e[1].toLowerCase() + " "] = (s[e[1].toLowerCase() + " "] || []).concat(e[2]);
                        e = s[t.toLowerCase() + " "]
                    }
                    return null == e ? null : e.join(", ")
                },
                getAllResponseHeaders: function() {
                    return c ? a : null
                },
                setRequestHeader: function(t, e) {
                    return null == c && (t = x[t.toLowerCase()] = x[t.toLowerCase()] || t,
                    w[t] = e),
                    this
                },
                overrideMimeType: function(t) {
                    return null == c && (h.mimeType = t),
                    this
                },
                statusCode: function(t) {
                    var e;
                    if (t)
                        if (c)
                            k.always(t[k.status]);
                        else
                            for (e in t)
                                b[e] = [b[e], t[e]];
                    return this
                },
                abort: function(t) {
                    var e = t || C;
                    return i && i.abort(e),
                    r(0, e),
                    this
                }
            };
            if (v.promise(k),
            h.url = ((e || h.url || Ae.href) + "").replace(Fe, Ae.protocol + "//"),
            h.type = n.method || n.type || h.method || h.type,
            h.dataTypes = (h.dataType || "*").toLowerCase().match(St) || [""],
            null == h.crossDomain) {
                u = Q.createElement("a");
                try {
                    u.href = h.url,
                    u.href = u.href,
                    h.crossDomain = We.protocol + "//" + We.host != u.protocol + "//" + u.host
                } catch (t) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = ht.param(h.data, h.traditional)),
            Z(He, h, n, k),
            c)
                return k;
            for (p in (d = ht.event && h.global) && 0 == ht.active++ && ht.event.trigger("ajaxStart"),
            h.type = h.type.toUpperCase(),
            h.hasContent = !Re.test(h.type),
            o = h.url.replace(Pe, ""),
            h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Ne, "+")) : (f = h.url.slice(o.length),
            h.data && (h.processData || "string" == typeof h.data) && (o += (Oe.test(o) ? "&" : "?") + h.data,
            delete h.data),
            !1 === h.cache && (o = o.replace(De, "$1"),
            f = (Oe.test(o) ? "&" : "?") + "_=" + Me++ + f),
            h.url = o + f),
            h.ifModified && (ht.lastModified[o] && k.setRequestHeader("If-Modified-Since", ht.lastModified[o]),
            ht.etag[o] && k.setRequestHeader("If-None-Match", ht.etag[o])),
            (h.data && h.hasContent && !1 !== h.contentType || n.contentType) && k.setRequestHeader("Content-Type", h.contentType),
            k.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + qe + "; q=0.01" : "") : h.accepts["*"]),
            h.headers)
                k.setRequestHeader(p, h.headers[p]);
            if (h.beforeSend && (!1 === h.beforeSend.call(m, k, h) || c))
                return k.abort();
            if (C = "abort",
            y.add(h.complete),
            k.done(h.success),
            k.fail(h.error),
            i = Z(Be, h, n, k)) {
                if (k.readyState = 1,
                d && g.trigger("ajaxSend", [k, h]),
                c)
                    return k;
                h.async && 0 < h.timeout && (l = t.setTimeout(function() {
                    k.abort("timeout")
                }, h.timeout));
                try {
                    c = !1,
                    i.send(w, r)
                } catch (t) {
                    if (c)
                        throw t;
                    r(-1, t)
                }
            } else
                r(-1, "No Transport");
            return k
        },
        getJSON: function(t, e, n) {
            return ht.get(t, e, n, "json")
        },
        getScript: function(t, e) {
            return ht.get(t, void 0, e, "script")
        }
    }),
    ht.each(["get", "post"], function(t, e) {
        ht[e] = function(t, n, r, i) {
            return ct(n) && (i = i || r,
            r = n,
            n = void 0),
            ht.ajax(ht.extend({
                url: t,
                type: e,
                dataType: i,
                data: n,
                success: r
            }, ht.isPlainObject(t) && t))
        }
    }),
    ht._evalUrl = function(t, e) {
        return ht.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(t) {
                ht.globalEval(t, e)
            }
        })
    }
    ,
    ht.fn.extend({
        wrapAll: function(t) {
            var e;
            return this[0] && (ct(t) && (t = t.call(this[0])),
            e = ht(t, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && e.insertBefore(this[0]),
            e.map(function() {
                for (var t = this; t.firstElementChild; )
                    t = t.firstElementChild;
                return t
            }).append(this)),
            this
        },
        wrapInner: function(t) {
            return ct(t) ? this.each(function(e) {
                ht(this).wrapInner(t.call(this, e))
            }) : this.each(function() {
                var e = ht(this)
                  , n = e.contents();
                n.length ? n.wrapAll(t) : e.append(t)
            })
        },
        wrap: function(t) {
            var e = ct(t);
            return this.each(function(n) {
                ht(this).wrapAll(e ? t.call(this, n) : t)
            })
        },
        unwrap: function(t) {
            return this.parent(t).not("body").each(function() {
                ht(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    ht.expr.pseudos.hidden = function(t) {
        return !ht.expr.pseudos.visible(t)
    }
    ,
    ht.expr.pseudos.visible = function(t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
    }
    ,
    ht.ajaxSettings.xhr = function() {
        try {
            return new t.XMLHttpRequest
        } catch (t) {}
    }
    ;
    var Ue = {
        0: 200,
        1223: 204
    }
      , Ve = ht.ajaxSettings.xhr();
    ut.cors = !!Ve && "withCredentials"in Ve,
    ut.ajax = Ve = !!Ve,
    ht.ajaxTransport(function(e) {
        var n, r;
        if (ut.cors || Ve && !e.crossDomain)
            return {
                send: function(i, o) {
                    var a, s = e.xhr();
                    if (s.open(e.type, e.url, e.async, e.username, e.password),
                    e.xhrFields)
                        for (a in e.xhrFields)
                            s[a] = e.xhrFields[a];
                    for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType),
                    e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"),
                    i)
                        s.setRequestHeader(a, i[a]);
                    n = function(t) {
                        return function() {
                            n && (n = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null,
                            "abort" === t ? s.abort() : "error" === t ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Ue[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                                binary: s.response
                            } : {
                                text: s.responseText
                            }, s.getAllResponseHeaders()))
                        }
                    }
                    ,
                    s.onload = n(),
                    r = s.onerror = s.ontimeout = n("error"),
                    void 0 !== s.onabort ? s.onabort = r : s.onreadystatechange = function() {
                        4 === s.readyState && t.setTimeout(function() {
                            n && r()
                        })
                    }
                    ,
                    n = n("abort");
                    try {
                        s.send(e.hasContent && e.data || null)
                    } catch (t) {
                        if (n)
                            throw t
                    }
                },
                abort: function() {
                    n && n()
                }
            }
    }),
    ht.ajaxPrefilter(function(t) {
        t.crossDomain && (t.contents.script = !1)
    }),
    ht.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return ht.globalEval(t),
                t
            }
        }
    }),
    ht.ajaxPrefilter("script", function(t) {
        void 0 === t.cache && (t.cache = !1),
        t.crossDomain && (t.type = "GET")
    }),
    ht.ajaxTransport("script", function(t) {
        var e, n;
        if (t.crossDomain || t.scriptAttrs)
            return {
                send: function(r, i) {
                    e = ht("<script>").attr(t.scriptAttrs || {}).prop({
                        charset: t.scriptCharset,
                        src: t.url
                    }).on("load error", n = function(t) {
                        e.remove(),
                        n = null,
                        t && i("error" === t.type ? 404 : 200, t.type)
                    }
                    ),
                    Q.head.appendChild(e[0])
                },
                abort: function() {
                    n && n()
                }
            }
    });
    var Xe, Ye = [], Ze = /(=)\?(?=&|$)|\?\?/;
    ht.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = Ye.pop() || ht.expando + "_" + Me++;
            return this[t] = !0,
            t
        }
    }),
    ht.ajaxPrefilter("json jsonp", function(e, n, r) {
        var i, o, a, s = !1 !== e.jsonp && (Ze.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ze.test(e.data) && "data");
        if (s || "jsonp" === e.dataTypes[0])
            return i = e.jsonpCallback = ct(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
            s ? e[s] = e[s].replace(Ze, "$1" + i) : !1 !== e.jsonp && (e.url += (Oe.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
            e.converters["script json"] = function() {
                return a || ht.error(i + " was not called"),
                a[0]
            }
            ,
            e.dataTypes[0] = "json",
            o = t[i],
            t[i] = function() {
                a = arguments
            }
            ,
            r.always(function() {
                void 0 === o ? ht(t).removeProp(i) : t[i] = o,
                e[i] && (e.jsonpCallback = n.jsonpCallback,
                Ye.push(i)),
                a && ct(o) && o(a[0]),
                a = o = void 0
            }),
            "script"
    }),
    ut.createHTMLDocument = ((Xe = Q.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>",
    2 === Xe.childNodes.length),
    ht.parseHTML = function(t, e, n) {
        return "string" != typeof t ? [] : ("boolean" == typeof e && (n = e,
        e = !1),
        e || (ut.createHTMLDocument ? ((r = (e = Q.implementation.createHTMLDocument("")).createElement("base")).href = Q.location.href,
        e.head.appendChild(r)) : e = Q),
        o = !n && [],
        (i = wt.exec(t)) ? [e.createElement(i[1])] : (i = w([t], e, o),
        o && o.length && ht(o).remove(),
        ht.merge([], i.childNodes)));
        var r, i, o
    }
    ,
    ht.fn.load = function(t, e, n) {
        var r, i, o, a = this, s = t.indexOf(" ");
        return -1 < s && (r = W(t.slice(s)),
        t = t.slice(0, s)),
        ct(e) ? (n = e,
        e = void 0) : e && "object" == typeof e && (i = "POST"),
        0 < a.length && ht.ajax({
            url: t,
            type: i || "GET",
            dataType: "html",
            data: e
        }).done(function(t) {
            o = arguments,
            a.html(r ? ht("<div>").append(ht.parseHTML(t)).find(r) : t)
        }).always(n && function(t, e) {
            a.each(function() {
                n.apply(this, o || [t.responseText, e, t])
            })
        }
        ),
        this
    }
    ,
    ht.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
        ht.fn[e] = function(t) {
            return this.on(e, t)
        }
    }),
    ht.expr.pseudos.animated = function(t) {
        return ht.grep(ht.timers, function(e) {
            return t === e.elem
        }).length
    }
    ,
    ht.offset = {
        setOffset: function(t, e, n) {
            var r, i, o, a, s, l, u = ht.css(t, "position"), c = ht(t), d = {};
            "static" === u && (t.style.position = "relative"),
            s = c.offset(),
            o = ht.css(t, "top"),
            l = ht.css(t, "left"),
            ("absolute" === u || "fixed" === u) && -1 < (o + l).indexOf("auto") ? (a = (r = c.position()).top,
            i = r.left) : (a = parseFloat(o) || 0,
            i = parseFloat(l) || 0),
            ct(e) && (e = e.call(t, n, ht.extend({}, s))),
            null != e.top && (d.top = e.top - s.top + a),
            null != e.left && (d.left = e.left - s.left + i),
            "using"in e ? e.using.call(t, d) : c.css(d)
        }
    },
    ht.fn.extend({
        offset: function(t) {
            if (arguments.length)
                return void 0 === t ? this : this.each(function(e) {
                    ht.offset.setOffset(this, t, e)
                });
            var e, n, r = this[0];
            return r ? r.getClientRects().length ? (e = r.getBoundingClientRect(),
            n = r.ownerDocument.defaultView,
            {
                top: e.top + n.pageYOffset,
                left: e.left + n.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var t, e, n, r = this[0], i = {
                    top: 0,
                    left: 0
                };
                if ("fixed" === ht.css(r, "position"))
                    e = r.getBoundingClientRect();
                else {
                    for (e = this.offset(),
                    n = r.ownerDocument,
                    t = r.offsetParent || n.documentElement; t && (t === n.body || t === n.documentElement) && "static" === ht.css(t, "position"); )
                        t = t.parentNode;
                    t && t !== r && 1 === t.nodeType && ((i = ht(t).offset()).top += ht.css(t, "borderTopWidth", !0),
                    i.left += ht.css(t, "borderLeftWidth", !0))
                }
                return {
                    top: e.top - i.top - ht.css(r, "marginTop", !0),
                    left: e.left - i.left - ht.css(r, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && "static" === ht.css(t, "position"); )
                    t = t.offsetParent;
                return t || Rt
            })
        }
    }),
    ht.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, e) {
        var n = "pageYOffset" === e;
        ht.fn[t] = function(r) {
            return At(this, function(t, r, i) {
                var o;
                return dt(t) ? o = t : 9 === t.nodeType && (o = t.defaultView),
                void 0 === i ? o ? o[e] : t[r] : void (o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : t[r] = i)
            }, t, r, arguments.length)
        }
    }),
    ht.each(["top", "left"], function(t, e) {
        ht.cssHooks[e] = j(ut.pixelPosition, function(t, n) {
            if (n)
                return n = I(t, e),
                oe.test(n) ? ht(t).position()[e] + "px" : n
        })
    }),
    ht.each({
        Height: "height",
        Width: "width"
    }, function(t, e) {
        ht.each({
            padding: "inner" + t,
            content: e,
            "": "outer" + t
        }, function(n, r) {
            ht.fn[r] = function(i, o) {
                var a = arguments.length && (n || "boolean" != typeof i)
                  , s = n || (!0 === i || !0 === o ? "margin" : "border");
                return At(this, function(e, n, i) {
                    var o;
                    return dt(e) ? 0 === r.indexOf("outer") ? e["inner" + t] : e.document.documentElement["client" + t] : 9 === e.nodeType ? (o = e.documentElement,
                    Math.max(e.body["scroll" + t], o["scroll" + t], e.body["offset" + t], o["offset" + t], o["client" + t])) : void 0 === i ? ht.css(e, n, s) : ht.style(e, n, i, s)
                }, e, a ? i : void 0, a)
            }
        })
    }),
    ht.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(t, e) {
        ht.fn[e] = function(t, n) {
            return 0 < arguments.length ? this.on(e, null, t, n) : this.trigger(e)
        }
    }),
    ht.fn.extend({
        hover: function(t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }),
    ht.fn.extend({
        bind: function(t, e, n) {
            return this.on(t, null, e, n)
        },
        unbind: function(t, e) {
            return this.off(t, null, e)
        },
        delegate: function(t, e, n, r) {
            return this.on(e, t, n, r)
        },
        undelegate: function(t, e, n) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
        }
    }),
    ht.proxy = function(t, e) {
        var n, r, i;
        if ("string" == typeof e && (n = t[e],
        e = t,
        t = n),
        ct(t))
            return r = tt.call(arguments, 2),
            (i = function() {
                return t.apply(e || this, r.concat(tt.call(arguments)))
            }
            ).guid = t.guid = t.guid || ht.guid++,
            i
    }
    ,
    ht.holdReady = function(t) {
        t ? ht.readyWait++ : ht.ready(!0)
    }
    ,
    ht.isArray = Array.isArray,
    ht.parseJSON = JSON.parse,
    ht.nodeName = o,
    ht.isFunction = ct,
    ht.isWindow = dt,
    ht.camelCase = f,
    ht.type = r,
    ht.now = Date.now,
    ht.isNumeric = function(t) {
        var e = ht.type(t);
        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
    }
    ,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return ht
    });
    var Ke = t.jQuery
      , Ge = t.$;
    return ht.noConflict = function(e) {
        return t.$ === ht && (t.$ = Ge),
        e && t.jQuery === ht && (t.jQuery = Ke),
        ht
    }
    ,
    e || (t.jQuery = t.$ = ht),
    ht
}),
function() {
    function t(t, e, n) {
        switch (n.length) {
        case 0:
            return t.call(e);
        case 1:
            return t.call(e, n[0]);
        case 2:
            return t.call(e, n[0], n[1]);
        case 3:
            return t.call(e, n[0], n[1], n[2])
        }
        return t.apply(e, n)
    }
    function e(t, e, n, r) {
        for (var i = -1, o = null == t ? 0 : t.length; ++i < o; ) {
            var a = t[i];
            e(r, a, n(a), t)
        }
        return r
    }
    function n(t, e) {
        for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t); )
            ;
        return t
    }
    function r(t, e) {
        for (var n = null == t ? 0 : t.length; n-- && !1 !== e(t[n], n, t); )
            ;
        return t
    }
    function i(t, e) {
        for (var n = -1, r = null == t ? 0 : t.length; ++n < r; )
            if (!e(t[n], n, t))
                return !1;
        return !0
    }
    function o(t, e) {
        for (var n = -1, r = null == t ? 0 : t.length, i = 0, o = []; ++n < r; ) {
            var a = t[n];
            e(a, n, t) && (o[i++] = a)
        }
        return o
    }
    function a(t, e) {
        return !(null == t || !t.length) && -1 < m(t, e, 0)
    }
    function s(t, e, n) {
        for (var r = -1, i = null == t ? 0 : t.length; ++r < i; )
            if (n(e, t[r]))
                return !0;
        return !1
    }
    function l(t, e) {
        for (var n = -1, r = null == t ? 0 : t.length, i = Array(r); ++n < r; )
            i[n] = e(t[n], n, t);
        return i
    }
    function u(t, e) {
        for (var n = -1, r = e.length, i = t.length; ++n < r; )
            t[i + n] = e[n];
        return t
    }
    function c(t, e, n, r) {
        var i = -1
          , o = null == t ? 0 : t.length;
        for (r && o && (n = t[++i]); ++i < o; )
            n = e(n, t[i], i, t);
        return n
    }
    function d(t, e, n, r) {
        var i = null == t ? 0 : t.length;
        for (r && i && (n = t[--i]); i--; )
            n = e(n, t[i], i, t);
        return n
    }
    function p(t, e) {
        for (var n = -1, r = null == t ? 0 : t.length; ++n < r; )
            if (e(t[n], n, t))
                return !0;
        return !1
    }
    function f(t, e, n) {
        var r;
        return n(t, function(t, n, i) {
            if (e(t, n, i))
                return r = n,
                !1
        }),
        r
    }
    function h(t, e, n, r) {
        var i = t.length;
        for (n += r ? 1 : -1; r ? n-- : ++n < i; )
            if (e(t[n], n, t))
                return n;
        return -1
    }
    function m(t, e, n) {
        if (e === e)
            t: {
                --n;
                for (var r = t.length; ++n < r; )
                    if (t[n] === e) {
                        t = n;
                        break t
                    }
                t = -1
            }
        else
            t = h(t, v, n);
        return t
    }
    function g(t, e, n, r) {
        --n;
        for (var i = t.length; ++n < i; )
            if (r(t[n], e))
                return n;
        return -1
    }
    function v(t) {
        return t !== t
    }
    function y(t, e) {
        var n = null == t ? 0 : t.length;
        return n ? k(t, e) / n : H
    }
    function b(t) {
        return function(e) {
            return null == e ? R : e[t]
        }
    }
    function w(t) {
        return function(e) {
            return null == t ? R : t[e]
        }
    }
    function x(t, e, n, r, i) {
        return i(t, function(t, i, o) {
            n = r ? (r = !1,
            t) : e(n, t, i, o)
        }),
        n
    }
    function C(t, e) {
        var n = t.length;
        for (t.sort(e); n--; )
            t[n] = t[n].c;
        return t
    }
    function k(t, e) {
        for (var n, r = -1, i = t.length; ++r < i; ) {
            var o = e(t[r]);
            o !== R && (n = n === R ? o : n + o)
        }
        return n
    }
    function _(t, e) {
        for (var n = -1, r = Array(t); ++n < t; )
            r[n] = e(n);
        return r
    }
    function S(t, e) {
        return l(e, function(e) {
            return [e, t[e]]
        })
    }
    function T(t) {
        return function(e) {
            return t(e)
        }
    }
    function E(t, e) {
        return l(e, function(e) {
            return t[e]
        })
    }
    function A(t, e) {
        return t.has(e)
    }
    function M(t, e) {
        for (var n = -1, r = t.length; ++n < r && -1 < m(e, t[n], 0); )
            ;
        return n
    }
    function O(t, e) {
        for (var n = t.length; n-- && -1 < m(e, t[n], 0); )
            ;
        return n
    }
    function L(t) {
        return "\\" + zt[t]
    }
    function I(t) {
        var e = -1
          , n = Array(t.size);
        return t.forEach(function(t, r) {
            n[++e] = [r, t]
        }),
        n
    }
    function j(t, e) {
        return function(n) {
            return t(e(n))
        }
    }
    function z(t, e) {
        for (var n = -1, r = t.length, i = 0, o = []; ++n < r; ) {
            var a = t[n];
            a !== e && "__lodash_placeholder__" !== a || (t[n] = "__lodash_placeholder__",
            o[i++] = n)
        }
        return o
    }
    function N(t) {
        var e = -1
          , n = Array(t.size);
        return t.forEach(function(t) {
            n[++e] = t
        }),
        n
    }
    function P(t) {
        var e = -1
          , n = Array(t.size);
        return t.forEach(function(t) {
            n[++e] = [t, t]
        }),
        n
    }
    function D(t) {
        if (Mt.test(t)) {
            for (var e = Et.lastIndex = 0; Et.test(t); )
                ++e;
            t = e
        } else
            t = Gt(t);
        return t
    }
    function $(t) {
        return Mt.test(t) ? t.match(Et) || [] : t.split("")
    }
    var R, F = 1 / 0, H = NaN, B = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]], q = /\b__p\+='';/g, W = /\b(__p\+=)''\+/g, U = /(__e\(.*?\)|\b__t\))\+'';/g, V = /&(?:amp|lt|gt|quot|#39);/g, X = /[&<>"']/g, Y = RegExp(V.source), Z = RegExp(X.source), K = /<%-([\s\S]+?)%>/g, G = /<%([\s\S]+?)%>/g, Q = /<%=([\s\S]+?)%>/g, J = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, tt = /^\w*$/, et = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, nt = /[\\^$.*+?()[\]{}|]/g, rt = RegExp(nt.source), it = /^\s+|\s+$/g, ot = /^\s+/, at = /\s+$/, st = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, lt = /\{\n\/\* \[wrapped with (.+)\] \*/, ut = /,? & /, ct = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, dt = /\\(\\)?/g, pt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ft = /\w*$/, ht = /^[-+]0x[0-9a-f]+$/i, mt = /^0b[01]+$/i, gt = /^\[object .+?Constructor\]$/, vt = /^0o[0-7]+$/i, yt = /^(?:0|[1-9]\d*)$/, bt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, wt = /($^)/, xt = /['\n\r\u2028\u2029\\]/g, Ct = "[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*", kt = "(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])" + Ct, _t = "(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])", St = RegExp("['’]", "g"), Tt = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g"), Et = RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|" + _t + Ct, "g"), At = RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+", kt].join("|"), "g"), Mt = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"), Ot = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Lt = "Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "), It = {};
    It["[object Float32Array]"] = It["[object Float64Array]"] = It["[object Int8Array]"] = It["[object Int16Array]"] = It["[object Int32Array]"] = It["[object Uint8Array]"] = It["[object Uint8ClampedArray]"] = It["[object Uint16Array]"] = It["[object Uint32Array]"] = !0,
    It["[object Arguments]"] = It["[object Array]"] = It["[object ArrayBuffer]"] = It["[object Boolean]"] = It["[object DataView]"] = It["[object Date]"] = It["[object Error]"] = It["[object Function]"] = It["[object Map]"] = It["[object Number]"] = It["[object Object]"] = It["[object RegExp]"] = It["[object Set]"] = It["[object String]"] = It["[object WeakMap]"] = !1;
    var jt = {};
    jt["[object Arguments]"] = jt["[object Array]"] = jt["[object ArrayBuffer]"] = jt["[object DataView]"] = jt["[object Boolean]"] = jt["[object Date]"] = jt["[object Float32Array]"] = jt["[object Float64Array]"] = jt["[object Int8Array]"] = jt["[object Int16Array]"] = jt["[object Int32Array]"] = jt["[object Map]"] = jt["[object Number]"] = jt["[object Object]"] = jt["[object RegExp]"] = jt["[object Set]"] = jt["[object String]"] = jt["[object Symbol]"] = jt["[object Uint8Array]"] = jt["[object Uint8ClampedArray]"] = jt["[object Uint16Array]"] = jt["[object Uint32Array]"] = !0,
    jt["[object Error]"] = jt["[object Function]"] = jt["[object WeakMap]"] = !1;
    var zt = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    }
      , Nt = parseFloat
      , Pt = parseInt
      , Dt = "object" == typeof global && global && global.Object === Object && global
      , $t = "object" == typeof self && self && self.Object === Object && self
      , Rt = Dt || $t || Function("return this")()
      , Ft = "object" == typeof exports && exports && !exports.nodeType && exports
      , Ht = Ft && "object" == typeof module && module && !module.nodeType && module
      , Bt = Ht && Ht.exports === Ft
      , qt = Bt && Dt.process
      , Wt = function() {
        try {
            var t = Ht && Ht.require && Ht.require("util").types;
            return t ? t : qt && qt.binding && qt.binding("util")
        } catch (t) {}
    }()
      , Ut = Wt && Wt.isArrayBuffer
      , Vt = Wt && Wt.isDate
      , Xt = Wt && Wt.isMap
      , Yt = Wt && Wt.isRegExp
      , Zt = Wt && Wt.isSet
      , Kt = Wt && Wt.isTypedArray
      , Gt = b("length")
      , Qt = w({
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    })
      , Jt = w({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    })
      , te = w({
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    })
      , ee = function w(Ct) {
        function kt(t) {
            if (yi(t) && !as(t) && !(t instanceof zt)) {
                if (t instanceof Et)
                    return t;
                if (ao.call(t, "__wrapped__"))
                    return Hr(t)
            }
            return new Et(t)
        }
        function _t() {}
        function Et(t, e) {
            this.__wrapped__ = t,
            this.__actions__ = [],
            this.__chain__ = !!e,
            this.__index__ = 0,
            this.__values__ = R
        }
        function zt(t) {
            this.__wrapped__ = t,
            this.__actions__ = [],
            this.__dir__ = 1,
            this.__filtered__ = !1,
            this.__iteratees__ = [],
            this.__takeCount__ = 4294967295,
            this.__views__ = []
        }
        function Dt(t) {
            var e = -1
              , n = null == t ? 0 : t.length;
            for (this.clear(); ++e < n; ) {
                var r = t[e];
                this.set(r[0], r[1])
            }
        }
        function $t(t) {
            var e = -1
              , n = null == t ? 0 : t.length;
            for (this.clear(); ++e < n; ) {
                var r = t[e];
                this.set(r[0], r[1])
            }
        }
        function Ft(t) {
            var e = -1
              , n = null == t ? 0 : t.length;
            for (this.clear(); ++e < n; ) {
                var r = t[e];
                this.set(r[0], r[1])
            }
        }
        function Ht(t) {
            var e = -1
              , n = null == t ? 0 : t.length;
            for (this.__data__ = new Ft; ++e < n; )
                this.add(t[e])
        }
        function qt(t) {
            this.size = (this.__data__ = new $t(t)).size
        }
        function Wt(t, e) {
            var n, r = as(t), i = !r && os(t), o = !r && !i && ls(t), a = !r && !i && !o && fs(t), i = (r = r || i || o || a) ? _(t.length, to) : [], s = i.length;
            for (n in t)
                !e && !ao.call(t, n) || r && ("length" == n || o && ("offset" == n || "parent" == n) || a && ("buffer" == n || "byteLength" == n || "byteOffset" == n) || Er(n, s)) || i.push(n);
            return i
        }
        function Gt(t) {
            var e = t.length;
            return e ? t[on(0, e - 1)] : R
        }
        function ne(t, e) {
            return Dr(Nn(t), pe(e, 0, t.length))
        }
        function re(t) {
            return Dr(Nn(t))
        }
        function ie(t, e, n) {
            (n === R || ci(t[e], n)) && (n !== R || e in t) || ce(t, e, n)
        }
        function oe(t, e, n) {
            var r = t[e];
            ao.call(t, e) && ci(r, n) && (n !== R || e in t) || ce(t, e, n)
        }
        function ae(t, e) {
            for (var n = t.length; n--; )
                if (ci(t[n][0], e))
                    return n;
            return -1
        }
        function se(t, e, n, r) {
            return oa(t, function(t, i, o) {
                e(r, t, n(t), o)
            }),
            r
        }
        function le(t, e) {
            return t && Pn(e, Ii(e), t)
        }
        function ue(t, e) {
            return t && Pn(e, ji(e), t)
        }
        function ce(t, e, n) {
            "__proto__" == e && So ? So(t, e, {
                configurable: !0,
                enumerable: !0,
                value: n,
                writable: !0
            }) : t[e] = n
        }
        function de(t, e) {
            for (var n = -1, r = e.length, i = Xi(r), o = null == t; ++n < r; )
                i[n] = o ? R : Oi(t, e[n]);
            return i
        }
        function pe(t, e, n) {
            return t === t && (n !== R && (t = t <= n ? t : n),
            e !== R && (t = t >= e ? t : e)),
            t
        }
        function fe(t, e, r, i, o, a) {
            var s, l = 1 & e, u = 2 & e, c = 4 & e;
            if (r && (s = o ? r(t, i, o, a) : r(t)),
            s !== R)
                return s;
            if (!vi(t))
                return t;
            if (i = as(t)) {
                if (s = kr(t),
                !l)
                    return Nn(t, s)
            } else {
                var d = ga(t)
                  , p = "[object Function]" == d || "[object GeneratorFunction]" == d;
                if (ls(t))
                    return Mn(t, l);
                if ("[object Object]" == d || "[object Arguments]" == d || p && !o) {
                    if (s = u || p ? {} : _r(t),
                    !l)
                        return u ? $n(t, ue(s, t)) : Dn(t, le(s, t))
                } else {
                    if (!jt[d])
                        return o ? t : {};
                    s = Sr(t, d, l)
                }
            }
            if (a || (a = new qt),
            o = a.get(t))
                return o;
            if (a.set(t, s),
            ps(t))
                return t.forEach(function(n) {
                    s.add(fe(n, e, r, n, t, a))
                }),
                s;
            if (cs(t))
                return t.forEach(function(n, i) {
                    s.set(i, fe(n, e, r, i, t, a))
                }),
                s;
            var u = c ? u ? mr : hr : u ? ji : Ii
              , f = i ? R : u(t);
            return n(f || t, function(n, i) {
                f && (i = n,
                n = t[i]),
                oe(s, i, fe(n, e, r, i, t, a))
            }),
            s
        }
        function he(t) {
            var e = Ii(t);
            return function(n) {
                return me(n, t, e)
            }
        }
        function me(t, e, n) {
            var r = n.length;
            if (null == t)
                return !r;
            for (t = Qi(t); r--; ) {
                var i = n[r]
                  , o = e[i]
                  , a = t[i];
                if (a === R && !(i in t) || !o(a))
                    return !1
            }
            return !0
        }
        function ge(t, e, n) {
            if ("function" != typeof t)
                throw new eo("Expected a function");
            return ba(function() {
                t.apply(R, n)
            }, e)
        }
        function ve(t, e, n, r) {
            var i = -1
              , o = a
              , u = !0
              , c = t.length
              , d = []
              , p = e.length;
            if (!c)
                return d;
            n && (e = l(e, T(n))),
            r ? (o = s,
            u = !1) : 200 <= e.length && (o = A,
            u = !1,
            e = new Ht(e));
            t: for (; ++i < c; ) {
                var f = t[i]
                  , h = null == n ? f : n(f)
                  , f = r || 0 !== f ? f : 0;
                if (u && h === h) {
                    for (var m = p; m--; )
                        if (e[m] === h)
                            continue t;
                    d.push(f)
                } else
                    o(e, h, r) || d.push(f)
            }
            return d
        }
        function ye(t, e) {
            var n = !0;
            return oa(t, function(t, r, i) {
                return n = !!e(t, r, i)
            }),
            n
        }
        function be(t, e, n) {
            for (var r = -1, i = t.length; ++r < i; ) {
                var o = t[r]
                  , a = e(o);
                if (null != a && (s === R ? a === a && !Ci(a) : n(a, s)))
                    var s = a
                      , l = o
            }
            return l
        }
        function we(t, e) {
            var n = [];
            return oa(t, function(t, r, i) {
                e(t, r, i) && n.push(t)
            }),
            n
        }
        function xe(t, e, n, r, i) {
            var o = -1
              , a = t.length;
            for (n || (n = Tr),
            i || (i = []); ++o < a; ) {
                var s = t[o];
                0 < e && n(s) ? 1 < e ? xe(s, e - 1, n, r, i) : u(i, s) : r || (i[i.length] = s)
            }
            return i
        }
        function Ce(t, e) {
            return t && sa(t, e, Ii)
        }
        function ke(t, e) {
            return t && la(t, e, Ii)
        }
        function _e(t, e) {
            return o(e, function(e) {
                return hi(t[e])
            })
        }
        function Se(t, e) {
            e = En(e, t);
            for (var n = 0, r = e.length; null != t && n < r; )
                t = t[$r(e[n++])];
            return n && n == r ? t : R
        }
        function Te(t, e, n) {
            return e = e(t),
            as(t) ? e : u(e, n(t))
        }
        function Ee(t) {
            if (null == t)
                return t === R ? "[object Undefined]" : "[object Null]";
            if (_o && _o in Qi(t)) {
                var e = ao.call(t, _o)
                  , n = t[_o];
                try {
                    t[_o] = R;
                    var r = !0
                } catch (t) {}
                var i = uo.call(t);
                r && (e ? t[_o] = n : delete t[_o]),
                t = i
            } else
                t = uo.call(t);
            return t
        }
        function Ae(t, e) {
            return t > e
        }
        function Me(t, e) {
            return null != t && ao.call(t, e)
        }
        function Oe(t, e) {
            return null != t && e in Qi(t)
        }
        function Le(t, e, n) {
            for (var r = n ? s : a, i = t[0].length, o = t.length, u = o, c = Xi(o), d = 1 / 0, p = []; u--; ) {
                var f = t[u];
                u && e && (f = l(f, T(e))),
                d = Do(f.length, d),
                c[u] = !n && (e || 120 <= i && 120 <= f.length) ? new Ht(u && f) : R
            }
            var f = t[0]
              , h = -1
              , m = c[0];
            t: for (; ++h < i && p.length < d; ) {
                var g = f[h]
                  , v = e ? e(g) : g
                  , g = n || 0 !== g ? g : 0;
                if (m ? !A(m, v) : !r(p, v, n)) {
                    for (u = o; --u; ) {
                        var y = c[u];
                        if (y ? !A(y, v) : !r(t[u], v, n))
                            continue t
                    }
                    m && m.push(v),
                    p.push(g)
                }
            }
            return p
        }
        function Ie(t, e, n, r) {
            return Ce(t, function(t, i, o) {
                e(r, n(t), i, o)
            }),
            r
        }
        function je(e, n, r) {
            return n = En(n, e),
            e = 2 > n.length ? e : Se(e, pn(n, 0, -1)),
            n = null == e ? e : e[$r(Vr(n))],
            null == n ? R : t(n, e, r)
        }
        function ze(t) {
            return yi(t) && "[object Arguments]" == Ee(t)
        }
        function Ne(t) {
            return yi(t) && "[object ArrayBuffer]" == Ee(t)
        }
        function Pe(t) {
            return yi(t) && "[object Date]" == Ee(t)
        }
        function De(t, e, n, r, i) {
            if (t === e)
                return !0;
            if (null == t || null == e || !yi(t) && !yi(e))
                return t !== t && e !== e;
            t: {
                var o = as(t)
                  , a = as(e)
                  , s = o ? "[object Array]" : ga(t)
                  , l = a ? "[object Array]" : ga(e)
                  , s = "[object Arguments]" == s ? "[object Object]" : s
                  , l = "[object Arguments]" == l ? "[object Object]" : l
                  , u = "[object Object]" == s
                  , a = "[object Object]" == l;
                if ((l = s == l) && ls(t)) {
                    if (!ls(e)) {
                        e = !1;
                        break t
                    }
                    o = !0,
                    u = !1
                }
                if (l && !u)
                    i || (i = new qt),
                    e = o || fs(t) ? dr(t, e, n, r, De, i) : pr(t, e, s, n, r, De, i);
                else {
                    if (!(1 & n) && (o = u && ao.call(t, "__wrapped__"),
                    s = a && ao.call(e, "__wrapped__"),
                    o || s)) {
                        t = o ? t.value() : t,
                        e = s ? e.value() : e,
                        i || (i = new qt),
                        e = De(t, e, n, r, i);
                        break t
                    }
                    if (l)
                        e: if (i || (i = new qt),
                        o = 1 & n,
                        s = hr(t),
                        a = s.length,
                        l = hr(e).length,
                        a == l || o) {
                            for (u = a; u--; ) {
                                var c = s[u];
                                if (!(o ? c in e : ao.call(e, c))) {
                                    e = !1;
                                    break e
                                }
                            }
                            if ((l = i.get(t)) && i.get(e))
                                e = l == e;
                            else {
                                l = !0,
                                i.set(t, e),
                                i.set(e, t);
                                for (var d = o; ++u < a; ) {
                                    var c = s[u]
                                      , p = t[c]
                                      , f = e[c];
                                    if (r)
                                        var h = o ? r(f, p, c, e, t, i) : r(p, f, c, t, e, i);
                                    if (h === R ? p !== f && !De(p, f, n, r, i) : !h) {
                                        l = !1;
                                        break
                                    }
                                    d || (d = "constructor" == c)
                                }
                                l && !d && (n = t.constructor,
                                r = e.constructor,
                                n != r && "constructor"in t && "constructor"in e && !("function" == typeof n && n instanceof n && "function" == typeof r && r instanceof r) && (l = !1)),
                                i.delete(t),
                                i.delete(e),
                                e = l
                            }
                        } else
                            e = !1;
                    else
                        e = !1
                }
            }
            return e
        }
        function $e(t) {
            return yi(t) && "[object Map]" == ga(t)
        }
        function Re(t, e, n, r) {
            var i = n.length
              , o = i
              , a = !r;
            if (null == t)
                return !o;
            for (t = Qi(t); i--; ) {
                var s = n[i];
                if (a && s[2] ? s[1] !== t[s[0]] : !(s[0]in t))
                    return !1
            }
            for (; ++i < o; ) {
                var s = n[i]
                  , l = s[0]
                  , u = t[l]
                  , c = s[1];
                if (a && s[2]) {
                    if (u === R && !(l in t))
                        return !1
                } else {
                    if (s = new qt,
                    r)
                        var d = r(u, c, l, t, e, s);
                    if (d === R ? !De(c, u, 3, r, s) : !d)
                        return !1
                }
            }
            return !0
        }
        function Fe(t) {
            return !(!vi(t) || lo && lo in t) && (hi(t) ? fo : gt).test(Rr(t))
        }
        function He(t) {
            return yi(t) && "[object RegExp]" == Ee(t)
        }
        function Be(t) {
            return yi(t) && "[object Set]" == ga(t)
        }
        function qe(t) {
            return yi(t) && gi(t.length) && !!It[Ee(t)]
        }
        function We(t) {
            return "function" == typeof t ? t : null == t ? Fi : "object" == typeof t ? as(t) ? Ze(t[0], t[1]) : Ye(t) : Wi(t)
        }
        function Ue(t) {
            if (!Lr(t))
                return No(t);
            var e, n = [];
            for (e in Qi(t))
                ao.call(t, e) && "constructor" != e && n.push(e);
            return n
        }
        function Ve(t, e) {
            return t < e
        }
        function Xe(t, e) {
            var n = -1
              , r = di(t) ? Xi(t.length) : [];
            return oa(t, function(t, i, o) {
                r[++n] = e(t, i, o)
            }),
            r
        }
        function Ye(t) {
            var e = wr(t);
            return 1 == e.length && e[0][2] ? Ir(e[0][0], e[0][1]) : function(n) {
                return n === t || Re(n, t, e)
            }
        }
        function Ze(t, e) {
            return Mr(t) && e === e && !vi(e) ? Ir($r(t), e) : function(n) {
                var r = Oi(n, t);
                return r === R && r === e ? Li(n, t) : De(e, r, 3)
            }
        }
        function Ke(t, e, n, r, i) {
            t !== e && sa(e, function(o, a) {
                if (vi(o)) {
                    i || (i = new qt);
                    var s = i
                      , l = zr(t, a)
                      , u = zr(e, a)
                      , c = s.get(u);
                    if (!c) {
                        var c = r ? r(l, u, a + "", t, e, s) : R
                          , d = c === R;
                        if (d) {
                            var p = as(u)
                              , f = !p && ls(u)
                              , h = !p && !f && fs(u)
                              , c = u;
                            p || f || h ? as(l) ? c = l : pi(l) ? c = Nn(l) : f ? (d = !1,
                            c = Mn(u, !0)) : h ? (d = !1,
                            c = Ln(u, !0)) : c = [] : wi(u) || os(u) ? (c = l,
                            os(l) ? c = Ai(l) : vi(l) && !hi(l) || (c = _r(u))) : d = !1
                        }
                        d && (s.set(u, c),
                        Ke(c, u, n, r, s),
                        s.delete(u))
                    }
                    ie(t, a, c)
                } else
                    s = r ? r(zr(t, a), o, a + "", t, e, i) : R,
                    s === R && (s = o),
                    ie(t, a, s)
            }, ji)
        }
        function Ge(t, e) {
            var n = t.length;
            if (n)
                return e += 0 > e ? n : 0,
                Er(e, n) ? t[e] : R
        }
        function Qe(t, e, n) {
            var r = -1;
            return e = l(e.length ? e : [Fi], T(yr())),
            t = Xe(t, function(t, n, i) {
                return {
                    a: l(e, function(e) {
                        return e(t)
                    }),
                    b: ++r,
                    c: t
                }
            }),
            C(t, function(t, e) {
                var r;
                t: {
                    r = -1;
                    for (var i = t.a, o = e.a, a = i.length, s = n.length; ++r < a; ) {
                        var l = In(i[r], o[r]);
                        if (l) {
                            if (r >= s) {
                                r = l;
                                break t
                            }
                            r = l * ("desc" == n[r] ? -1 : 1);
                            break t
                        }
                    }
                    r = t.b - e.b
                }
                return r
            })
        }
        function Je(t, e) {
            return tn(t, e, function(e, n) {
                return Li(t, n)
            })
        }
        function tn(t, e, n) {
            for (var r = -1, i = e.length, o = {}; ++r < i; ) {
                var a = e[r]
                  , s = Se(t, a);
                n(s, a) && cn(o, En(a, t), s)
            }
            return o
        }
        function en(t) {
            return function(e) {
                return Se(e, t)
            }
        }
        function nn(t, e, n, r) {
            var i = r ? g : m
              , o = -1
              , a = e.length
              , s = t;
            for (t === e && (e = Nn(e)),
            n && (s = l(t, T(n))); ++o < a; )
                for (var u = 0, c = e[o], c = n ? n(c) : c; -1 < (u = i(s, c, u, r)); )
                    s !== t && xo.call(s, u, 1),
                    xo.call(t, u, 1);
            return t
        }
        function rn(t, e) {
            for (var n = t ? e.length : 0, r = n - 1; n--; ) {
                var i = e[n];
                if (n == r || i !== o) {
                    var o = i;
                    Er(i) ? xo.call(t, i, 1) : wn(t, i)
                }
            }
            return t
        }
        function on(t, e) {
            return t + Oo(Fo() * (e - t + 1))
        }
        function an(t, e) {
            var n = "";
            if (!t || 1 > e || 9007199254740991 < e)
                return n;
            do
                e % 2 && (n += t),
                (e = Oo(e / 2)) && (t += t);
            while (e);return n
        }
        function sn(t, e) {
            return wa(jr(t, e, Fi), t + "")
        }
        function ln(t) {
            return Gt(Ni(t))
        }
        function un(t, e) {
            var n = Ni(t);
            return Dr(n, pe(e, 0, n.length))
        }
        function cn(t, e, n, r) {
            if (!vi(t))
                return t;
            e = En(e, t);
            for (var i = -1, o = e.length, a = o - 1, s = t; null != s && ++i < o; ) {
                var l = $r(e[i])
                  , u = n;
                if (i != a) {
                    var c = s[l]
                      , u = r ? r(c, l, s) : R;
                    u === R && (u = vi(c) ? c : Er(e[i + 1]) ? [] : {})
                }
                oe(s, l, u),
                s = s[l]
            }
            return t
        }
        function dn(t) {
            return Dr(Ni(t))
        }
        function pn(t, e, n) {
            var r = -1
              , i = t.length;
            for (0 > e && (e = -e > i ? 0 : i + e),
            n = n > i ? i : n,
            0 > n && (n += i),
            i = e > n ? 0 : n - e >>> 0,
            e >>>= 0,
            n = Xi(i); ++r < i; )
                n[r] = t[r + e];
            return n
        }
        function fn(t, e) {
            var n;
            return oa(t, function(t, r, i) {
                return n = e(t, r, i),
                !n
            }),
            !!n
        }
        function hn(t, e, n) {
            var r = 0
              , i = null == t ? r : t.length;
            if ("number" == typeof e && e === e && 2147483647 >= i) {
                for (; r < i; ) {
                    var o = r + i >>> 1
                      , a = t[o];
                    null !== a && !Ci(a) && (n ? a <= e : a < e) ? r = o + 1 : i = o
                }
                return i
            }
            return mn(t, e, Fi, n)
        }
        function mn(t, e, n, r) {
            e = n(e);
            for (var i = 0, o = null == t ? 0 : t.length, a = e !== e, s = null === e, l = Ci(e), u = e === R; i < o; ) {
                var c = Oo((i + o) / 2)
                  , d = n(t[c])
                  , p = d !== R
                  , f = null === d
                  , h = d === d
                  , m = Ci(d);
                (a ? r || h : u ? h && (r || p) : s ? h && p && (r || !f) : l ? h && p && !f && (r || !m) : f || m ? 0 : r ? d <= e : d < e) ? i = c + 1 : o = c
            }
            return Do(o, 4294967294)
        }
        function gn(t, e) {
            for (var n = -1, r = t.length, i = 0, o = []; ++n < r; ) {
                var a = t[n]
                  , s = e ? e(a) : a;
                if (!n || !ci(s, l)) {
                    var l = s;
                    o[i++] = 0 === a ? 0 : a
                }
            }
            return o
        }
        function vn(t) {
            return "number" == typeof t ? t : Ci(t) ? H : +t
        }
        function yn(t) {
            if ("string" == typeof t)
                return t;
            if (as(t))
                return l(t, yn) + "";
            if (Ci(t))
                return ra ? ra.call(t) : "";
            var e = t + "";
            return "0" == e && 1 / t == -F ? "-0" : e
        }
        function bn(t, e, n) {
            var r = -1
              , i = a
              , o = t.length
              , l = !0
              , u = []
              , c = u;
            if (n)
                l = !1,
                i = s;
            else if (200 <= o) {
                if (i = e ? null : pa(t))
                    return N(i);
                l = !1,
                i = A,
                c = new Ht
            } else
                c = e ? [] : u;
            t: for (; ++r < o; ) {
                var d = t[r]
                  , p = e ? e(d) : d
                  , d = n || 0 !== d ? d : 0;
                if (l && p === p) {
                    for (var f = c.length; f--; )
                        if (c[f] === p)
                            continue t;
                    e && c.push(p),
                    u.push(d)
                } else
                    i(c, p, n) || (c !== u && c.push(p),
                    u.push(d))
            }
            return u
        }
        function wn(t, e) {
            return e = En(e, t),
            t = 2 > e.length ? t : Se(t, pn(e, 0, -1)),
            null == t || delete t[$r(Vr(e))]
        }
        function xn(t, e, n, r) {
            for (var i = t.length, o = r ? i : -1; (r ? o-- : ++o < i) && e(t[o], o, t); )
                ;
            return n ? pn(t, r ? 0 : o, r ? o + 1 : i) : pn(t, r ? o + 1 : 0, r ? i : o)
        }
        function Cn(t, e) {
            var n = t;
            return n instanceof zt && (n = n.value()),
            c(e, function(t, e) {
                return e.func.apply(e.thisArg, u([t], e.args))
            }, n)
        }
        function kn(t, e, n) {
            var r = t.length;
            if (2 > r)
                return r ? bn(t[0]) : [];
            for (var i = -1, o = Xi(r); ++i < r; )
                for (var a = t[i], s = -1; ++s < r; )
                    s != i && (o[i] = ve(o[i] || a, t[s], e, n));
            return bn(xe(o, 1), e, n)
        }
        function _n(t, e, n) {
            for (var r = -1, i = t.length, o = e.length, a = {}; ++r < i; )
                n(a, t[r], r < o ? e[r] : R);
            return a
        }
        function Sn(t) {
            return pi(t) ? t : []
        }
        function Tn(t) {
            return "function" == typeof t ? t : Fi
        }
        function En(t, e) {
            return as(t) ? t : Mr(t, e) ? [t] : xa(Mi(t))
        }
        function An(t, e, n) {
            var r = t.length;
            return n = n === R ? r : n,
            !e && n >= r ? t : pn(t, e, n)
        }
        function Mn(t, e) {
            if (e)
                return t.slice();
            var n = t.length
              , n = vo ? vo(n) : new t.constructor(n);
            return t.copy(n),
            n
        }
        function On(t) {
            var e = new t.constructor(t.byteLength);
            return new go(e).set(new go(t)),
            e
        }
        function Ln(t, e) {
            return new t.constructor(e ? On(t.buffer) : t.buffer,t.byteOffset,t.length)
        }
        function In(t, e) {
            if (t !== e) {
                var n = t !== R
                  , r = null === t
                  , i = t === t
                  , o = Ci(t)
                  , a = e !== R
                  , s = null === e
                  , l = e === e
                  , u = Ci(e);
                if (!s && !u && !o && t > e || o && a && l && !s && !u || r && a && l || !n && l || !i)
                    return 1;
                if (!r && !o && !u && t < e || u && n && i && !r && !o || s && n && i || !a && i || !l)
                    return -1
            }
            return 0
        }
        function jn(t, e, n, r) {
            var i = -1
              , o = t.length
              , a = n.length
              , s = -1
              , l = e.length
              , u = Po(o - a, 0)
              , c = Xi(l + u);
            for (r = !r; ++s < l; )
                c[s] = e[s];
            for (; ++i < a; )
                (r || i < o) && (c[n[i]] = t[i]);
            for (; u--; )
                c[s++] = t[i++];
            return c
        }
        function zn(t, e, n, r) {
            var i = -1
              , o = t.length
              , a = -1
              , s = n.length
              , l = -1
              , u = e.length
              , c = Po(o - s, 0)
              , d = Xi(c + u);
            for (r = !r; ++i < c; )
                d[i] = t[i];
            for (c = i; ++l < u; )
                d[c + l] = e[l];
            for (; ++a < s; )
                (r || i < o) && (d[c + n[a]] = t[i++]);
            return d
        }
        function Nn(t, e) {
            var n = -1
              , r = t.length;
            for (e || (e = Xi(r)); ++n < r; )
                e[n] = t[n];
            return e
        }
        function Pn(t, e, n, r) {
            var i = !n;
            n || (n = {});
            for (var o = -1, a = e.length; ++o < a; ) {
                var s = e[o]
                  , l = r ? r(n[s], t[s], s, n, t) : R;
                l === R && (l = t[s]),
                i ? ce(n, s, l) : oe(n, s, l)
            }
            return n
        }
        function Dn(t, e) {
            return Pn(t, ha(t), e)
        }
        function $n(t, e) {
            return Pn(t, ma(t), e)
        }
        function Rn(t, n) {
            return function(r, i) {
                var o = as(r) ? e : se
                  , a = n ? n() : {};
                return o(r, t, yr(i, 2), a)
            }
        }
        function Fn(t) {
            return sn(function(e, n) {
                var r = -1
                  , i = n.length
                  , o = 1 < i ? n[i - 1] : R
                  , a = 2 < i ? n[2] : R
                  , o = 3 < t.length && "function" == typeof o ? (i--,
                o) : R;
                for (a && Ar(n[0], n[1], a) && (o = 3 > i ? R : o,
                i = 1),
                e = Qi(e); ++r < i; )
                    (a = n[r]) && t(e, a, r, o);
                return e
            })
        }
        function Hn(t, e) {
            return function(n, r) {
                if (null == n)
                    return n;
                if (!di(n))
                    return t(n, r);
                for (var i = n.length, o = e ? i : -1, a = Qi(n); (e ? o-- : ++o < i) && !1 !== r(a[o], o, a); )
                    ;
                return n
            }
        }
        function Bn(t) {
            return function(e, n, r) {
                var i = -1
                  , o = Qi(e);
                r = r(e);
                for (var a = r.length; a--; ) {
                    var s = r[t ? a : ++i];
                    if (!1 === n(o[s], s, o))
                        break
                }
                return e
            }
        }
        function qn(t, e, n) {
            function r() {
                return (this && this !== Rt && this instanceof r ? o : t).apply(i ? n : this, arguments)
            }
            var i = 1 & e
              , o = Vn(t);
            return r
        }
        function Wn(t) {
            return function(e) {
                e = Mi(e);
                var n = Mt.test(e) ? $(e) : R
                  , r = n ? n[0] : e.charAt(0);
                return e = n ? An(n, 1).join("") : e.slice(1),
                r[t]() + e
            }
        }
        function Un(t) {
            return function(e) {
                return c($i(Di(e).replace(St, "")), t, "")
            }
        }
        function Vn(t) {
            return function() {
                var e = arguments;
                switch (e.length) {
                case 0:
                    return new t;
                case 1:
                    return new t(e[0]);
                case 2:
                    return new t(e[0],e[1]);
                case 3:
                    return new t(e[0],e[1],e[2]);
                case 4:
                    return new t(e[0],e[1],e[2],e[3]);
                case 5:
                    return new t(e[0],e[1],e[2],e[3],e[4]);
                case 6:
                    return new t(e[0],e[1],e[2],e[3],e[4],e[5]);
                case 7:
                    return new t(e[0],e[1],e[2],e[3],e[4],e[5],e[6])
                }
                var n = ia(t.prototype)
                  , e = t.apply(n, e);
                return vi(e) ? e : n
            }
        }
        function Xn(e, n, r) {
            function i() {
                for (var a = arguments.length, s = Xi(a), l = a, u = vr(i); l--; )
                    s[l] = arguments[l];
                return l = 3 > a && s[0] !== u && s[a - 1] !== u ? [] : z(s, u),
                a -= l.length,
                a < r ? ir(e, n, Kn, i.placeholder, R, s, l, R, R, r - a) : t(this && this !== Rt && this instanceof i ? o : e, this, s)
            }
            var o = Vn(e);
            return i
        }
        function Yn(t) {
            return function(e, n, r) {
                var i = Qi(e);
                if (!di(e)) {
                    var o = yr(n, 3);
                    e = Ii(e),
                    n = function(t) {
                        return o(i[t], t, i)
                    }
                }
                return n = t(e, n, r),
                -1 < n ? i[o ? e[n] : n] : R
            }
        }
        function Zn(t) {
            return fr(function(e) {
                var n = e.length
                  , r = n
                  , i = Et.prototype.thru;
                for (t && e.reverse(); r--; ) {
                    var o = e[r];
                    if ("function" != typeof o)
                        throw new eo("Expected a function");
                    if (i && !a && "wrapper" == gr(o))
                        var a = new Et([],(!0))
                }
                for (r = a ? r : n; ++r < n; )
                    var o = e[r]
                      , i = gr(o)
                      , s = "wrapper" == i ? fa(o) : R
                      , a = s && Or(s[0]) && 424 == s[1] && !s[4].length && 1 == s[9] ? a[gr(s[0])].apply(a, s[3]) : 1 == o.length && Or(o) ? a[i]() : a.thru(o);
                return function() {
                    var t = arguments
                      , r = t[0];
                    if (a && 1 == t.length && as(r))
                        return a.plant(r).value();
                    for (var i = 0, t = n ? e[i].apply(this, t) : r; ++i < n; )
                        t = e[i].call(this, t);
                    return t
                }
            })
        }
        function Kn(t, e, n, r, i, o, a, s, l, u) {
            function c() {
                for (var v = arguments.length, y = Xi(v), b = v; b--; )
                    y[b] = arguments[b];
                if (h) {
                    var w, x = vr(c), b = y.length;
                    for (w = 0; b--; )
                        y[b] === x && ++w
                }
                if (r && (y = jn(y, r, i, h)),
                o && (y = zn(y, o, a, h)),
                v -= w,
                h && v < u)
                    return x = z(y, x),
                    ir(t, e, Kn, c.placeholder, n, y, x, s, l, u - v);
                if (x = p ? n : this,
                b = f ? x[t] : t,
                v = y.length,
                s) {
                    w = y.length;
                    for (var C = Do(s.length, w), k = Nn(y); C--; ) {
                        var _ = s[C];
                        y[C] = Er(_, w) ? k[_] : R
                    }
                } else
                    m && 1 < v && y.reverse();
                return d && l < v && (y.length = l),
                this && this !== Rt && this instanceof c && (b = g || Vn(b)),
                b.apply(x, y)
            }
            var d = 128 & e
              , p = 1 & e
              , f = 2 & e
              , h = 24 & e
              , m = 512 & e
              , g = f ? R : Vn(t);
            return c
        }
        function Gn(t, e) {
            return function(n, r) {
                return Ie(n, t, e(r), {})
            }
        }
        function Qn(t, e) {
            return function(n, r) {
                var i;
                if (n === R && r === R)
                    return e;
                if (n !== R && (i = n),
                r !== R) {
                    if (i === R)
                        return r;
                    "string" == typeof n || "string" == typeof r ? (n = yn(n),
                    r = yn(r)) : (n = vn(n),
                    r = vn(r)),
                    i = t(n, r)
                }
                return i
            }
        }
        function Jn(e) {
            return fr(function(n) {
                return n = l(n, T(yr())),
                sn(function(r) {
                    var i = this;
                    return e(n, function(e) {
                        return t(e, i, r)
                    })
                })
            })
        }
        function tr(t, e) {
            e = e === R ? " " : yn(e);
            var n = e.length;
            return 2 > n ? n ? an(e, t) : e : (n = an(e, Mo(t / D(e))),
            Mt.test(e) ? An($(n), 0, t).join("") : n.slice(0, t))
        }
        function er(e, n, r, i) {
            function o() {
                for (var n = -1, l = arguments.length, u = -1, c = i.length, d = Xi(c + l), p = this && this !== Rt && this instanceof o ? s : e; ++u < c; )
                    d[u] = i[u];
                for (; l--; )
                    d[u++] = arguments[++n];
                return t(p, a ? r : this, d)
            }
            var a = 1 & n
              , s = Vn(e);
            return o
        }
        function nr(t) {
            return function(e, n, r) {
                r && "number" != typeof r && Ar(e, n, r) && (n = r = R),
                e = _i(e),
                n === R ? (n = e,
                e = 0) : n = _i(n),
                r = r === R ? e < n ? 1 : -1 : _i(r);
                var i = -1;
                n = Po(Mo((n - e) / (r || 1)), 0);
                for (var o = Xi(n); n--; )
                    o[t ? n : ++i] = e,
                    e += r;
                return o
            }
        }
        function rr(t) {
            return function(e, n) {
                return "string" == typeof e && "string" == typeof n || (e = Ei(e),
                n = Ei(n)),
                t(e, n)
            }
        }
        function ir(t, e, n, r, i, o, a, s, l, u) {
            var c = 8 & e
              , d = c ? a : R;
            a = c ? R : a;
            var p = c ? o : R;
            return o = c ? R : o,
            e = (e | (c ? 32 : 64)) & ~(c ? 64 : 32),
            4 & e || (e &= -4),
            i = [t, e, i, p, d, o, a, s, l, u],
            n = n.apply(R, i),
            Or(t) && ya(n, i),
            n.placeholder = r,
            Nr(n, t, e)
        }
        function or(t) {
            var e = Gi[t];
            return function(t, n) {
                if (t = Ei(t),
                n = null == n ? 0 : Do(Si(n), 292)) {
                    var r = (Mi(t) + "e").split("e")
                      , r = e(r[0] + "e" + (+r[1] + n))
                      , r = (Mi(r) + "e").split("e");
                    return +(r[0] + "e" + (+r[1] - n))
                }
                return e(t)
            }
        }
        function ar(t) {
            return function(e) {
                var n = ga(e);
                return "[object Map]" == n ? I(e) : "[object Set]" == n ? P(e) : S(e, t(e))
            }
        }
        function sr(t, e, n, r, i, o, a, s) {
            var l = 2 & e;
            if (!l && "function" != typeof t)
                throw new eo("Expected a function");
            var u = r ? r.length : 0;
            if (u || (e &= -97,
            r = i = R),
            a = a === R ? a : Po(Si(a), 0),
            s = s === R ? s : Si(s),
            u -= i ? i.length : 0,
            64 & e) {
                var c = r
                  , d = i;
                r = i = R
            }
            var p = l ? R : fa(t);
            return o = [t, e, n, r, i, c, d, o, a, s],
            p && (n = o[1],
            t = p[1],
            e = n | t,
            r = 128 == t && 8 == n || 128 == t && 256 == n && o[7].length <= p[8] || 384 == t && p[7].length <= p[8] && 8 == n,
            131 > e || r) && (1 & t && (o[2] = p[2],
            e |= 1 & n ? 0 : 4),
            (n = p[3]) && (r = o[3],
            o[3] = r ? jn(r, n, p[4]) : n,
            o[4] = r ? z(o[3], "__lodash_placeholder__") : p[4]),
            (n = p[5]) && (r = o[5],
            o[5] = r ? zn(r, n, p[6]) : n,
            o[6] = r ? z(o[5], "__lodash_placeholder__") : p[6]),
            (n = p[7]) && (o[7] = n),
            128 & t && (o[8] = null == o[8] ? p[8] : Do(o[8], p[8])),
            null == o[9] && (o[9] = p[9]),
            o[0] = p[0],
            o[1] = e),
            t = o[0],
            e = o[1],
            n = o[2],
            r = o[3],
            i = o[4],
            s = o[9] = o[9] === R ? l ? 0 : t.length : Po(o[9] - u, 0),
            !s && 24 & e && (e &= -25),
            l = e && 1 != e ? 8 == e || 16 == e ? Xn(t, e, s) : 32 != e && 33 != e || i.length ? Kn.apply(R, o) : er(t, e, n, r) : qn(t, e, n),
            Nr((p ? ua : ya)(l, o), t, e)
        }
        function lr(t, e, n, r) {
            return t === R || ci(t, ro[n]) && !ao.call(r, n) ? e : t
        }
        function ur(t, e, n, r, i, o) {
            return vi(t) && vi(e) && (o.set(e, t),
            Ke(t, e, R, ur, o),
            o.delete(e)),
            t
        }
        function cr(t) {
            return wi(t) ? R : t
        }
        function dr(t, e, n, r, i, o) {
            var a = 1 & n
              , s = t.length
              , l = e.length;
            if (s != l && !(a && l > s))
                return !1;
            if ((l = o.get(t)) && o.get(e))
                return l == e;
            var l = -1
              , u = !0
              , c = 2 & n ? new Ht : R;
            for (o.set(t, e),
            o.set(e, t); ++l < s; ) {
                var d = t[l]
                  , f = e[l];
                if (r)
                    var h = a ? r(f, d, l, e, t, o) : r(d, f, l, t, e, o);
                if (h !== R) {
                    if (h)
                        continue;
                    u = !1;
                    break
                }
                if (c) {
                    if (!p(e, function(t, e) {
                        if (!A(c, e) && (d === t || i(d, t, n, r, o)))
                            return c.push(e)
                    })) {
                        u = !1;
                        break
                    }
                } else if (d !== f && !i(d, f, n, r, o)) {
                    u = !1;
                    break
                }
            }
            return o.delete(t),
            o.delete(e),
            u
        }
        function pr(t, e, n, r, i, o, a) {
            switch (n) {
            case "[object DataView]":
                if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
                    break;
                t = t.buffer,
                e = e.buffer;
            case "[object ArrayBuffer]":
                if (t.byteLength != e.byteLength || !o(new go(t), new go(e)))
                    break;
                return !0;
            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
                return ci(+t, +e);
            case "[object Error]":
                return t.name == e.name && t.message == e.message;
            case "[object RegExp]":
            case "[object String]":
                return t == e + "";
            case "[object Map]":
                var s = I;
            case "[object Set]":
                if (s || (s = N),
                t.size != e.size && !(1 & r))
                    break;
                return (n = a.get(t)) ? n == e : (r |= 2,
                a.set(t, e),
                e = dr(s(t), s(e), r, i, o, a),
                a.delete(t),
                e);
            case "[object Symbol]":
                if (na)
                    return na.call(t) == na.call(e)
            }
            return !1
        }
        function fr(t) {
            return wa(jr(t, R, Wr), t + "")
        }
        function hr(t) {
            return Te(t, Ii, ha)
        }
        function mr(t) {
            return Te(t, ji, ma)
        }
        function gr(t) {
            for (var e = t.name + "", n = Zo[e], r = ao.call(Zo, e) ? n.length : 0; r--; ) {
                var i = n[r]
                  , o = i.func;
                if (null == o || o == t)
                    return i.name
            }
            return e
        }
        function vr(t) {
            return (ao.call(kt, "placeholder") ? kt : t).placeholder
        }
        function yr() {
            var t = kt.iteratee || Hi
              , t = t === Hi ? We : t;
            return arguments.length ? t(arguments[0], arguments[1]) : t
        }
        function br(t, e) {
            var n = t.__data__
              , r = typeof e;
            return ("string" == r || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== e : null === e) ? n["string" == typeof e ? "string" : "hash"] : n.map
        }
        function wr(t) {
            for (var e = Ii(t), n = e.length; n--; ) {
                var r = e[n]
                  , i = t[r];
                e[n] = [r, i, i === i && !vi(i)]
            }
            return e
        }
        function xr(t, e) {
            var n = null == t ? R : t[e];
            return Fe(n) ? n : R
        }
        function Cr(t, e, n) {
            e = En(e, t);
            for (var r = -1, i = e.length, o = !1; ++r < i; ) {
                var a = $r(e[r]);
                if (!(o = null != t && n(t, a)))
                    break;
                t = t[a]
            }
            return o || ++r != i ? o : (i = null == t ? 0 : t.length,
            !!i && gi(i) && Er(a, i) && (as(t) || os(t)))
        }
        function kr(t) {
            var e = t.length
              , n = new t.constructor(e);
            return e && "string" == typeof t[0] && ao.call(t, "index") && (n.index = t.index,
            n.input = t.input),
            n
        }
        function _r(t) {
            return "function" != typeof t.constructor || Lr(t) ? {} : ia(yo(t))
        }
        function Sr(t, e, n) {
            var r = t.constructor;
            switch (e) {
            case "[object ArrayBuffer]":
                return On(t);
            case "[object Boolean]":
            case "[object Date]":
                return new r((+t));
            case "[object DataView]":
                return e = n ? On(t.buffer) : t.buffer,
                new t.constructor(e,t.byteOffset,t.byteLength);
            case "[object Float32Array]":
            case "[object Float64Array]":
            case "[object Int8Array]":
            case "[object Int16Array]":
            case "[object Int32Array]":
            case "[object Uint8Array]":
            case "[object Uint8ClampedArray]":
            case "[object Uint16Array]":
            case "[object Uint32Array]":
                return Ln(t, n);
            case "[object Map]":
                return new r;
            case "[object Number]":
            case "[object String]":
                return new r(t);
            case "[object RegExp]":
                return e = new t.constructor(t.source,ft.exec(t)),
                e.lastIndex = t.lastIndex,
                e;
            case "[object Set]":
                return new r;
            case "[object Symbol]":
                return na ? Qi(na.call(t)) : {}
            }
        }
        function Tr(t) {
            return as(t) || os(t) || !!(Co && t && t[Co])
        }
        function Er(t, e) {
            var n = typeof t;
            return e = null == e ? 9007199254740991 : e,
            !!e && ("number" == n || "symbol" != n && yt.test(t)) && -1 < t && 0 == t % 1 && t < e
        }
        function Ar(t, e, n) {
            if (!vi(n))
                return !1;
            var r = typeof e;
            return !!("number" == r ? di(n) && Er(e, n.length) : "string" == r && e in n) && ci(n[e], t)
        }
        function Mr(t, e) {
            if (as(t))
                return !1;
            var n = typeof t;
            return !("number" != n && "symbol" != n && "boolean" != n && null != t && !Ci(t)) || tt.test(t) || !J.test(t) || null != e && t in Qi(e)
        }
        function Or(t) {
            var e = gr(t)
              , n = kt[e];
            return "function" == typeof n && e in zt.prototype && (t === n || (e = fa(n),
            !!e && t === e[0]))
        }
        function Lr(t) {
            var e = t && t.constructor;
            return t === ("function" == typeof e && e.prototype || ro)
        }
        function Ir(t, e) {
            return function(n) {
                return null != n && n[t] === e && (e !== R || t in Qi(n))
            }
        }
        function jr(e, n, r) {
            return n = Po(n === R ? e.length - 1 : n, 0),
            function() {
                for (var i = arguments, o = -1, a = Po(i.length - n, 0), s = Xi(a); ++o < a; )
                    s[o] = i[n + o];
                for (o = -1,
                a = Xi(n + 1); ++o < n; )
                    a[o] = i[o];
                return a[n] = r(s),
                t(e, this, a)
            }
        }
        function zr(t, e) {
            if ("__proto__" != e)
                return t[e]
        }
        function Nr(t, e, n) {
            var r = e + "";
            e = wa;
            var i, o = Fr;
            return i = (i = r.match(lt)) ? i[1].split(ut) : [],
            n = o(i, n),
            (o = n.length) && (i = o - 1,
            n[i] = (1 < o ? "& " : "") + n[i],
            n = n.join(2 < o ? ", " : " "),
            r = r.replace(st, "{\n/* [wrapped with " + n + "] */\n")),
            e(t, r)
        }
        function Pr(t) {
            var e = 0
              , n = 0;
            return function() {
                var r = $o()
                  , i = 16 - (r - n);
                if (n = r,
                0 < i) {
                    if (800 <= ++e)
                        return arguments[0]
                } else
                    e = 0;
                return t.apply(R, arguments)
            }
        }
        function Dr(t, e) {
            var n = -1
              , r = t.length
              , i = r - 1;
            for (e = e === R ? r : e; ++n < e; ) {
                var r = on(n, i)
                  , o = t[r];
                t[r] = t[n],
                t[n] = o
            }
            return t.length = e,
            t
        }
        function $r(t) {
            if ("string" == typeof t || Ci(t))
                return t;
            var e = t + "";
            return "0" == e && 1 / t == -F ? "-0" : e
        }
        function Rr(t) {
            if (null != t) {
                try {
                    return oo.call(t)
                } catch (t) {}
                return t + ""
            }
            return ""
        }
        function Fr(t, e) {
            return n(B, function(n) {
                var r = "_." + n[0];
                e & n[1] && !a(t, r) && t.push(r)
            }),
            t.sort()
        }
        function Hr(t) {
            if (t instanceof zt)
                return t.clone();
            var e = new Et(t.__wrapped__,t.__chain__);
            return e.__actions__ = Nn(t.__actions__),
            e.__index__ = t.__index__,
            e.__values__ = t.__values__,
            e
        }
        function Br(t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (n = null == n ? 0 : Si(n),
            0 > n && (n = Po(r + n, 0)),
            h(t, yr(e, 3), n)) : -1
        }
        function qr(t, e, n) {
            var r = null == t ? 0 : t.length;
            if (!r)
                return -1;
            var i = r - 1;
            return n !== R && (i = Si(n),
            i = 0 > n ? Po(r + i, 0) : Do(i, r - 1)),
            h(t, yr(e, 3), i, !0)
        }
        function Wr(t) {
            return (null == t ? 0 : t.length) ? xe(t, 1) : []
        }
        function Ur(t) {
            return t && t.length ? t[0] : R
        }
        function Vr(t) {
            var e = null == t ? 0 : t.length;
            return e ? t[e - 1] : R
        }
        function Xr(t, e) {
            return t && t.length && e && e.length ? nn(t, e) : t
        }
        function Yr(t) {
            return null == t ? t : Ho.call(t)
        }
        function Zr(t) {
            if (!t || !t.length)
                return [];
            var e = 0;
            return t = o(t, function(t) {
                if (pi(t))
                    return e = Po(t.length, e),
                    !0
            }),
            _(e, function(e) {
                return l(t, b(e))
            })
        }
        function Kr(e, n) {
            if (!e || !e.length)
                return [];
            var r = Zr(e);
            return null == n ? r : l(r, function(e) {
                return t(n, R, e)
            })
        }
        function Gr(t) {
            return t = kt(t),
            t.__chain__ = !0,
            t
        }
        function Qr(t, e) {
            return e(t)
        }
        function Jr() {
            return this
        }
        function ti(t, e) {
            return (as(t) ? n : oa)(t, yr(e, 3))
        }
        function ei(t, e) {
            return (as(t) ? r : aa)(t, yr(e, 3))
        }
        function ni(t, e) {
            return (as(t) ? l : Xe)(t, yr(e, 3))
        }
        function ri(t, e, n) {
            return e = n ? R : e,
            e = t && null == e ? t.length : e,
            sr(t, 128, R, R, R, R, e)
        }
        function ii(t, e) {
            var n;
            if ("function" != typeof e)
                throw new eo("Expected a function");
            return t = Si(t),
            function() {
                return 0 < --t && (n = e.apply(this, arguments)),
                1 >= t && (e = R),
                n
            }
        }
        function oi(t, e, n) {
            return e = n ? R : e,
            t = sr(t, 8, R, R, R, R, R, e),
            t.placeholder = oi.placeholder,
            t
        }
        function ai(t, e, n) {
            return e = n ? R : e,
            t = sr(t, 16, R, R, R, R, R, e),
            t.placeholder = ai.placeholder,
            t
        }
        function si(t, e, n) {
            function r(e) {
                var n = l
                  , r = u;
                return l = u = R,
                h = e,
                d = t.apply(r, n)
            }
            function i(t) {
                var n = t - f;
                return t -= h,
                f === R || n >= e || 0 > n || g && t >= c
            }
            function o() {
                var t = Ya();
                if (i(t))
                    return a(t);
                var n, r = ba;
                n = t - h,
                t = e - (t - f),
                n = g ? Do(t, c - n) : t,
                p = r(o, n)
            }
            function a(t) {
                return p = R,
                v && l ? r(t) : (l = u = R,
                d)
            }
            function s() {
                var t = Ya()
                  , n = i(t);
                if (l = arguments,
                u = this,
                f = t,
                n) {
                    if (p === R)
                        return h = t = f,
                        p = ba(o, e),
                        m ? r(t) : d;
                    if (g)
                        return p = ba(o, e),
                        r(f)
                }
                return p === R && (p = ba(o, e)),
                d
            }
            var l, u, c, d, p, f, h = 0, m = !1, g = !1, v = !0;
            if ("function" != typeof t)
                throw new eo("Expected a function");
            return e = Ei(e) || 0,
            vi(n) && (m = !!n.leading,
            c = (g = "maxWait"in n) ? Po(Ei(n.maxWait) || 0, e) : c,
            v = "trailing"in n ? !!n.trailing : v),
            s.cancel = function() {
                p !== R && da(p),
                h = 0,
                l = f = u = p = R
            }
            ,
            s.flush = function() {
                return p === R ? d : a(Ya())
            }
            ,
            s
        }
        function li(t, e) {
            if ("function" != typeof t || null != e && "function" != typeof e)
                throw new eo("Expected a function");
            var n = function() {
                var r = arguments
                  , i = e ? e.apply(this, r) : r[0]
                  , o = n.cache;
                return o.has(i) ? o.get(i) : (r = t.apply(this, r),
                n.cache = o.set(i, r) || o,
                r)
            };
            return n.cache = new (li.Cache || Ft),
            n
        }
        function ui(t) {
            if ("function" != typeof t)
                throw new eo("Expected a function");
            return function() {
                var e = arguments;
                switch (e.length) {
                case 0:
                    return !t.call(this);
                case 1:
                    return !t.call(this, e[0]);
                case 2:
                    return !t.call(this, e[0], e[1]);
                case 3:
                    return !t.call(this, e[0], e[1], e[2])
                }
                return !t.apply(this, e)
            }
        }
        function ci(t, e) {
            return t === e || t !== t && e !== e
        }
        function di(t) {
            return null != t && gi(t.length) && !hi(t)
        }
        function pi(t) {
            return yi(t) && di(t)
        }
        function fi(t) {
            if (!yi(t))
                return !1;
            var e = Ee(t);
            return "[object Error]" == e || "[object DOMException]" == e || "string" == typeof t.message && "string" == typeof t.name && !wi(t)
        }
        function hi(t) {
            return !!vi(t) && (t = Ee(t),
            "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t)
        }
        function mi(t) {
            return "number" == typeof t && t == Si(t)
        }
        function gi(t) {
            return "number" == typeof t && -1 < t && 0 == t % 1 && 9007199254740991 >= t
        }
        function vi(t) {
            var e = typeof t;
            return null != t && ("object" == e || "function" == e)
        }
        function yi(t) {
            return null != t && "object" == typeof t
        }
        function bi(t) {
            return "number" == typeof t || yi(t) && "[object Number]" == Ee(t)
        }
        function wi(t) {
            return !(!yi(t) || "[object Object]" != Ee(t)) && (t = yo(t),
            null === t || (t = ao.call(t, "constructor") && t.constructor,
            "function" == typeof t && t instanceof t && oo.call(t) == co))
        }
        function xi(t) {
            return "string" == typeof t || !as(t) && yi(t) && "[object String]" == Ee(t)
        }
        function Ci(t) {
            return "symbol" == typeof t || yi(t) && "[object Symbol]" == Ee(t)
        }
        function ki(t) {
            if (!t)
                return [];
            if (di(t))
                return xi(t) ? $(t) : Nn(t);
            if (ko && t[ko]) {
                t = t[ko]();
                for (var e, n = []; !(e = t.next()).done; )
                    n.push(e.value);
                return n
            }
            return e = ga(t),
            ("[object Map]" == e ? I : "[object Set]" == e ? N : Ni)(t)
        }
        function _i(t) {
            return t ? (t = Ei(t),
            t === F || t === -F ? 1.7976931348623157e308 * (0 > t ? -1 : 1) : t === t ? t : 0) : 0 === t ? t : 0
        }
        function Si(t) {
            t = _i(t);
            var e = t % 1;
            return t === t ? e ? t - e : t : 0
        }
        function Ti(t) {
            return t ? pe(Si(t), 0, 4294967295) : 0
        }
        function Ei(t) {
            if ("number" == typeof t)
                return t;
            if (Ci(t))
                return H;
            if (vi(t) && (t = "function" == typeof t.valueOf ? t.valueOf() : t,
            t = vi(t) ? t + "" : t),
            "string" != typeof t)
                return 0 === t ? t : +t;
            t = t.replace(it, "");
            var e = mt.test(t);
            return e || vt.test(t) ? Pt(t.slice(2), e ? 2 : 8) : ht.test(t) ? H : +t
        }
        function Ai(t) {
            return Pn(t, ji(t))
        }
        function Mi(t) {
            return null == t ? "" : yn(t)
        }
        function Oi(t, e, n) {
            return t = null == t ? R : Se(t, e),
            t === R ? n : t
        }
        function Li(t, e) {
            return null != t && Cr(t, e, Oe)
        }
        function Ii(t) {
            return di(t) ? Wt(t) : Ue(t)
        }
        function ji(t) {
            if (di(t))
                t = Wt(t, !0);
            else if (vi(t)) {
                var e, n = Lr(t), r = [];
                for (e in t)
                    ("constructor" != e || !n && ao.call(t, e)) && r.push(e);
                t = r
            } else {
                if (e = [],
                null != t)
                    for (n in Qi(t))
                        e.push(n);
                t = e
            }
            return t
        }
        function zi(t, e) {
            if (null == t)
                return {};
            var n = l(mr(t), function(t) {
                return [t]
            });
            return e = yr(e),
            tn(t, n, function(t, n) {
                return e(t, n[0])
            })
        }
        function Ni(t) {
            return null == t ? [] : E(t, Ii(t))
        }
        function Pi(t) {
            return Rs(Mi(t).toLowerCase())
        }
        function Di(t) {
            return (t = Mi(t)) && t.replace(bt, Qt).replace(Tt, "")
        }
        function $i(t, e, n) {
            return t = Mi(t),
            e = n ? R : e,
            e === R ? Ot.test(t) ? t.match(At) || [] : t.match(ct) || [] : t.match(e) || []
        }
        function Ri(t) {
            return function() {
                return t
            }
        }
        function Fi(t) {
            return t
        }
        function Hi(t) {
            return We("function" == typeof t ? t : fe(t, 1))
        }
        function Bi(t, e, r) {
            var i = Ii(e)
              , o = _e(e, i);
            null != r || vi(e) && (o.length || !i.length) || (r = e,
            e = t,
            t = this,
            o = _e(e, Ii(e)));
            var a = !(vi(r) && "chain"in r && !r.chain)
              , s = hi(t);
            return n(o, function(n) {
                var r = e[n];
                t[n] = r,
                s && (t.prototype[n] = function() {
                    var e = this.__chain__;
                    if (a || e) {
                        var n = t(this.__wrapped__);
                        return (n.__actions__ = Nn(this.__actions__)).push({
                            func: r,
                            args: arguments,
                            thisArg: t
                        }),
                        n.__chain__ = e,
                        n
                    }
                    return r.apply(t, u([this.value()], arguments))
                }
                )
            }),
            t
        }
        function qi() {}
        function Wi(t) {
            return Mr(t) ? b($r(t)) : en(t)
        }
        function Ui() {
            return []
        }
        function Vi() {
            return !1
        }
        Ct = null == Ct ? Rt : ee.defaults(Rt.Object(), Ct, ee.pick(Rt, Lt));
        var Xi = Ct.Array
          , Yi = Ct.Date
          , Zi = Ct.Error
          , Ki = Ct.Function
          , Gi = Ct.Math
          , Qi = Ct.Object
          , Ji = Ct.RegExp
          , to = Ct.String
          , eo = Ct.TypeError
          , no = Xi.prototype
          , ro = Qi.prototype
          , io = Ct["__core-js_shared__"]
          , oo = Ki.prototype.toString
          , ao = ro.hasOwnProperty
          , so = 0
          , lo = function() {
            var t = /[^.]+$/.exec(io && io.keys && io.keys.IE_PROTO || "");
            return t ? "Symbol(src)_1." + t : ""
        }()
          , uo = ro.toString
          , co = oo.call(Qi)
          , po = Rt._
          , fo = Ji("^" + oo.call(ao).replace(nt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$")
          , ho = Bt ? Ct.Buffer : R
          , mo = Ct.Symbol
          , go = Ct.Uint8Array
          , vo = ho ? ho.allocUnsafe : R
          , yo = j(Qi.getPrototypeOf, Qi)
          , bo = Qi.create
          , wo = ro.propertyIsEnumerable
          , xo = no.splice
          , Co = mo ? mo.isConcatSpreadable : R
          , ko = mo ? mo.iterator : R
          , _o = mo ? mo.toStringTag : R
          , So = function() {
            try {
                var t = xr(Qi, "defineProperty");
                return t({}, "", {}),
                t
            } catch (t) {}
        }()
          , To = Ct.clearTimeout !== Rt.clearTimeout && Ct.clearTimeout
          , Eo = Yi && Yi.now !== Rt.Date.now && Yi.now
          , Ao = Ct.setTimeout !== Rt.setTimeout && Ct.setTimeout
          , Mo = Gi.ceil
          , Oo = Gi.floor
          , Lo = Qi.getOwnPropertySymbols
          , Io = ho ? ho.isBuffer : R
          , jo = Ct.isFinite
          , zo = no.join
          , No = j(Qi.keys, Qi)
          , Po = Gi.max
          , Do = Gi.min
          , $o = Yi.now
          , Ro = Ct.parseInt
          , Fo = Gi.random
          , Ho = no.reverse
          , Bo = xr(Ct, "DataView")
          , qo = xr(Ct, "Map")
          , Wo = xr(Ct, "Promise")
          , Uo = xr(Ct, "Set")
          , Vo = xr(Ct, "WeakMap")
          , Xo = xr(Qi, "create")
          , Yo = Vo && new Vo
          , Zo = {}
          , Ko = Rr(Bo)
          , Go = Rr(qo)
          , Qo = Rr(Wo)
          , Jo = Rr(Uo)
          , ta = Rr(Vo)
          , ea = mo ? mo.prototype : R
          , na = ea ? ea.valueOf : R
          , ra = ea ? ea.toString : R
          , ia = function() {
            function t() {}
            return function(e) {
                return vi(e) ? bo ? bo(e) : (t.prototype = e,
                e = new t,
                t.prototype = R,
                e) : {}
            }
        }();
        kt.templateSettings = {
            escape: K,
            evaluate: G,
            interpolate: Q,
            variable: "",
            imports: {
                _: kt
            }
        },
        kt.prototype = _t.prototype,
        kt.prototype.constructor = kt,
        Et.prototype = ia(_t.prototype),
        Et.prototype.constructor = Et,
        zt.prototype = ia(_t.prototype),
        zt.prototype.constructor = zt,
        Dt.prototype.clear = function() {
            this.__data__ = Xo ? Xo(null) : {},
            this.size = 0
        }
        ,
        Dt.prototype.delete = function(t) {
            return t = this.has(t) && delete this.__data__[t],
            this.size -= t ? 1 : 0,
            t
        }
        ,
        Dt.prototype.get = function(t) {
            var e = this.__data__;
            return Xo ? (t = e[t],
            "__lodash_hash_undefined__" === t ? R : t) : ao.call(e, t) ? e[t] : R
        }
        ,
        Dt.prototype.has = function(t) {
            var e = this.__data__;
            return Xo ? e[t] !== R : ao.call(e, t)
        }
        ,
        Dt.prototype.set = function(t, e) {
            var n = this.__data__;
            return this.size += this.has(t) ? 0 : 1,
            n[t] = Xo && e === R ? "__lodash_hash_undefined__" : e,
            this
        }
        ,
        $t.prototype.clear = function() {
            this.__data__ = [],
            this.size = 0
        }
        ,
        $t.prototype.delete = function(t) {
            var e = this.__data__;
            return t = ae(e, t),
            !(0 > t || (t == e.length - 1 ? e.pop() : xo.call(e, t, 1),
            --this.size,
            0))
        }
        ,
        $t.prototype.get = function(t) {
            var e = this.__data__;
            return t = ae(e, t),
            0 > t ? R : e[t][1]
        }
        ,
        $t.prototype.has = function(t) {
            return -1 < ae(this.__data__, t)
        }
        ,
        $t.prototype.set = function(t, e) {
            var n = this.__data__
              , r = ae(n, t);
            return 0 > r ? (++this.size,
            n.push([t, e])) : n[r][1] = e,
            this
        }
        ,
        Ft.prototype.clear = function() {
            this.size = 0,
            this.__data__ = {
                hash: new Dt,
                map: new (qo || $t),
                string: new Dt
            }
        }
        ,
        Ft.prototype.delete = function(t) {
            return t = br(this, t).delete(t),
            this.size -= t ? 1 : 0,
            t
        }
        ,
        Ft.prototype.get = function(t) {
            return br(this, t).get(t)
        }
        ,
        Ft.prototype.has = function(t) {
            return br(this, t).has(t)
        }
        ,
        Ft.prototype.set = function(t, e) {
            var n = br(this, t)
              , r = n.size;
            return n.set(t, e),
            this.size += n.size == r ? 0 : 1,
            this
        }
        ,
        Ht.prototype.add = Ht.prototype.push = function(t) {
            return this.__data__.set(t, "__lodash_hash_undefined__"),
            this
        }
        ,
        Ht.prototype.has = function(t) {
            return this.__data__.has(t)
        }
        ,
        qt.prototype.clear = function() {
            this.__data__ = new $t,
            this.size = 0
        }
        ,
        qt.prototype.delete = function(t) {
            var e = this.__data__;
            return t = e.delete(t),
            this.size = e.size,
            t
        }
        ,
        qt.prototype.get = function(t) {
            return this.__data__.get(t)
        }
        ,
        qt.prototype.has = function(t) {
            return this.__data__.has(t)
        }
        ,
        qt.prototype.set = function(t, e) {
            var n = this.__data__;
            if (n instanceof $t) {
                var r = n.__data__;
                if (!qo || 199 > r.length)
                    return r.push([t, e]),
                    this.size = ++n.size,
                    this;
                n = this.__data__ = new Ft(r)
            }
            return n.set(t, e),
            this.size = n.size,
            this
        }
        ;
        var oa = Hn(Ce)
          , aa = Hn(ke, !0)
          , sa = Bn()
          , la = Bn(!0)
          , ua = Yo ? function(t, e) {
            return Yo.set(t, e),
            t
        }
        : Fi
          , ca = So ? function(t, e) {
            return So(t, "toString", {
                configurable: !0,
                enumerable: !1,
                value: Ri(e),
                writable: !0
            })
        }
        : Fi
          , da = To || function(t) {
            return Rt.clearTimeout(t)
        }
          , pa = Uo && 1 / N(new Uo([, -0]))[1] == F ? function(t) {
            return new Uo(t)
        }
        : qi
          , fa = Yo ? function(t) {
            return Yo.get(t)
        }
        : qi
          , ha = Lo ? function(t) {
            return null == t ? [] : (t = Qi(t),
            o(Lo(t), function(e) {
                return wo.call(t, e)
            }))
        }
        : Ui
          , ma = Lo ? function(t) {
            for (var e = []; t; )
                u(e, ha(t)),
                t = yo(t);
            return e
        }
        : Ui
          , ga = Ee;
        (Bo && "[object DataView]" != ga(new Bo(new ArrayBuffer(1))) || qo && "[object Map]" != ga(new qo) || Wo && "[object Promise]" != ga(Wo.resolve()) || Uo && "[object Set]" != ga(new Uo) || Vo && "[object WeakMap]" != ga(new Vo)) && (ga = function(t) {
            var e = Ee(t);
            if (t = (t = "[object Object]" == e ? t.constructor : R) ? Rr(t) : "")
                switch (t) {
                case Ko:
                    return "[object DataView]";
                case Go:
                    return "[object Map]";
                case Qo:
                    return "[object Promise]";
                case Jo:
                    return "[object Set]";
                case ta:
                    return "[object WeakMap]"
                }
            return e
        }
        );
        var va = io ? hi : Vi
          , ya = Pr(ua)
          , ba = Ao || function(t, e) {
            return Rt.setTimeout(t, e)
        }
          , wa = Pr(ca)
          , xa = function(t) {
            t = li(t, function(t) {
                return 500 === e.size && e.clear(),
                t
            });
            var e = t.cache;
            return t
        }(function(t) {
            var e = [];
            return 46 === t.charCodeAt(0) && e.push(""),
            t.replace(et, function(t, n, r, i) {
                e.push(r ? i.replace(dt, "$1") : n || t)
            }),
            e
        })
          , Ca = sn(function(t, e) {
            return pi(t) ? ve(t, xe(e, 1, pi, !0)) : []
        })
          , ka = sn(function(t, e) {
            var n = Vr(e);
            return pi(n) && (n = R),
            pi(t) ? ve(t, xe(e, 1, pi, !0), yr(n, 2)) : []
        })
          , _a = sn(function(t, e) {
            var n = Vr(e);
            return pi(n) && (n = R),
            pi(t) ? ve(t, xe(e, 1, pi, !0), R, n) : []
        })
          , Sa = sn(function(t) {
            var e = l(t, Sn);
            return e.length && e[0] === t[0] ? Le(e) : []
        })
          , Ta = sn(function(t) {
            var e = Vr(t)
              , n = l(t, Sn);
            return e === Vr(n) ? e = R : n.pop(),
            n.length && n[0] === t[0] ? Le(n, yr(e, 2)) : []
        })
          , Ea = sn(function(t) {
            var e = Vr(t)
              , n = l(t, Sn);
            return (e = "function" == typeof e ? e : R) && n.pop(),
            n.length && n[0] === t[0] ? Le(n, R, e) : []
        })
          , Aa = sn(Xr)
          , Ma = fr(function(t, e) {
            var n = null == t ? 0 : t.length
              , r = de(t, e);
            return rn(t, l(e, function(t) {
                return Er(t, n) ? +t : t
            }).sort(In)),
            r
        })
          , Oa = sn(function(t) {
            return bn(xe(t, 1, pi, !0))
        })
          , La = sn(function(t) {
            var e = Vr(t);
            return pi(e) && (e = R),
            bn(xe(t, 1, pi, !0), yr(e, 2))
        })
          , Ia = sn(function(t) {
            var e = Vr(t)
              , e = "function" == typeof e ? e : R;
            return bn(xe(t, 1, pi, !0), R, e)
        })
          , ja = sn(function(t, e) {
            return pi(t) ? ve(t, e) : []
        })
          , za = sn(function(t) {
            return kn(o(t, pi))
        })
          , Na = sn(function(t) {
            var e = Vr(t);
            return pi(e) && (e = R),
            kn(o(t, pi), yr(e, 2))
        })
          , Pa = sn(function(t) {
            var e = Vr(t)
              , e = "function" == typeof e ? e : R;
            return kn(o(t, pi), R, e)
        })
          , Da = sn(Zr)
          , $a = sn(function(t) {
            var e = t.length
              , e = 1 < e ? t[e - 1] : R
              , e = "function" == typeof e ? (t.pop(),
            e) : R;
            return Kr(t, e)
        })
          , Ra = fr(function(t) {
            var e = t.length
              , n = e ? t[0] : 0
              , r = this.__wrapped__
              , i = function(e) {
                return de(e, t)
            };
            return !(1 < e || this.__actions__.length) && r instanceof zt && Er(n) ? (r = r.slice(n, +n + (e ? 1 : 0)),
            r.__actions__.push({
                func: Qr,
                args: [i],
                thisArg: R
            }),
            new Et(r,this.__chain__).thru(function(t) {
                return e && !t.length && t.push(R),
                t
            })) : this.thru(i)
        })
          , Fa = Rn(function(t, e, n) {
            ao.call(t, n) ? ++t[n] : ce(t, n, 1)
        })
          , Ha = Yn(Br)
          , Ba = Yn(qr)
          , qa = Rn(function(t, e, n) {
            ao.call(t, n) ? t[n].push(e) : ce(t, n, [e])
        })
          , Wa = sn(function(e, n, r) {
            var i = -1
              , o = "function" == typeof n
              , a = di(e) ? Xi(e.length) : [];
            return oa(e, function(e) {
                a[++i] = o ? t(n, e, r) : je(e, n, r)
            }),
            a
        })
          , Ua = Rn(function(t, e, n) {
            ce(t, n, e)
        })
          , Va = Rn(function(t, e, n) {
            t[n ? 0 : 1].push(e)
        }, function() {
            return [[], []]
        })
          , Xa = sn(function(t, e) {
            if (null == t)
                return [];
            var n = e.length;
            return 1 < n && Ar(t, e[0], e[1]) ? e = [] : 2 < n && Ar(e[0], e[1], e[2]) && (e = [e[0]]),
            Qe(t, xe(e, 1), [])
        })
          , Ya = Eo || function() {
            return Rt.Date.now()
        }
          , Za = sn(function(t, e, n) {
            var r = 1;
            if (n.length)
                var i = z(n, vr(Za))
                  , r = 32 | r;
            return sr(t, r, e, n, i)
        })
          , Ka = sn(function(t, e, n) {
            var r = 3;
            if (n.length)
                var i = z(n, vr(Ka))
                  , r = 32 | r;
            return sr(e, r, t, n, i)
        })
          , Ga = sn(function(t, e) {
            return ge(t, 1, e)
        })
          , Qa = sn(function(t, e, n) {
            return ge(t, Ei(e) || 0, n)
        });
        li.Cache = Ft;
        var Ja = sn(function(e, n) {
            n = 1 == n.length && as(n[0]) ? l(n[0], T(yr())) : l(xe(n, 1), T(yr()));
            var r = n.length;
            return sn(function(i) {
                for (var o = -1, a = Do(i.length, r); ++o < a; )
                    i[o] = n[o].call(this, i[o]);
                return t(e, this, i)
            })
        })
          , ts = sn(function(t, e) {
            return sr(t, 32, R, e, z(e, vr(ts)))
        })
          , es = sn(function(t, e) {
            return sr(t, 64, R, e, z(e, vr(es)))
        })
          , ns = fr(function(t, e) {
            return sr(t, 256, R, R, R, e)
        })
          , rs = rr(Ae)
          , is = rr(function(t, e) {
            return t >= e
        })
          , os = ze(function() {
            return arguments
        }()) ? ze : function(t) {
            return yi(t) && ao.call(t, "callee") && !wo.call(t, "callee")
        }
          , as = Xi.isArray
          , ss = Ut ? T(Ut) : Ne
          , ls = Io || Vi
          , us = Vt ? T(Vt) : Pe
          , cs = Xt ? T(Xt) : $e
          , ds = Yt ? T(Yt) : He
          , ps = Zt ? T(Zt) : Be
          , fs = Kt ? T(Kt) : qe
          , hs = rr(Ve)
          , ms = rr(function(t, e) {
            return t <= e
        })
          , gs = Fn(function(t, e) {
            if (Lr(e) || di(e))
                Pn(e, Ii(e), t);
            else
                for (var n in e)
                    ao.call(e, n) && oe(t, n, e[n])
        })
          , vs = Fn(function(t, e) {
            Pn(e, ji(e), t)
        })
          , ys = Fn(function(t, e, n, r) {
            Pn(e, ji(e), t, r)
        })
          , bs = Fn(function(t, e, n, r) {
            Pn(e, Ii(e), t, r)
        })
          , ws = fr(de)
          , xs = sn(function(t, e) {
            t = Qi(t);
            var n = -1
              , r = e.length
              , i = 2 < r ? e[2] : R;
            for (i && Ar(e[0], e[1], i) && (r = 1); ++n < r; )
                for (var i = e[n], o = ji(i), a = -1, s = o.length; ++a < s; ) {
                    var l = o[a]
                      , u = t[l];
                    (u === R || ci(u, ro[l]) && !ao.call(t, l)) && (t[l] = i[l])
                }
            return t
        })
          , Cs = sn(function(e) {
            return e.push(R, ur),
            t(Es, R, e)
        })
          , ks = Gn(function(t, e, n) {
            null != e && "function" != typeof e.toString && (e = uo.call(e)),
            t[e] = n
        }, Ri(Fi))
          , _s = Gn(function(t, e, n) {
            null != e && "function" != typeof e.toString && (e = uo.call(e)),
            ao.call(t, e) ? t[e].push(n) : t[e] = [n]
        }, yr)
          , Ss = sn(je)
          , Ts = Fn(function(t, e, n) {
            Ke(t, e, n)
        })
          , Es = Fn(function(t, e, n, r) {
            Ke(t, e, n, r)
        })
          , As = fr(function(t, e) {
            var n = {};
            if (null == t)
                return n;
            var r = !1;
            e = l(e, function(e) {
                return e = En(e, t),
                r || (r = 1 < e.length),
                e
            }),
            Pn(t, mr(t), n),
            r && (n = fe(n, 7, cr));
            for (var i = e.length; i--; )
                wn(n, e[i]);
            return n
        })
          , Ms = fr(function(t, e) {
            return null == t ? {} : Je(t, e)
        })
          , Os = ar(Ii)
          , Ls = ar(ji)
          , Is = Un(function(t, e, n) {
            return e = e.toLowerCase(),
            t + (n ? Pi(e) : e)
        })
          , js = Un(function(t, e, n) {
            return t + (n ? "-" : "") + e.toLowerCase()
        })
          , zs = Un(function(t, e, n) {
            return t + (n ? " " : "") + e.toLowerCase()
        })
          , Ns = Wn("toLowerCase")
          , Ps = Un(function(t, e, n) {
            return t + (n ? "_" : "") + e.toLowerCase()
        })
          , Ds = Un(function(t, e, n) {
            return t + (n ? " " : "") + Rs(e)
        })
          , $s = Un(function(t, e, n) {
            return t + (n ? " " : "") + e.toUpperCase()
        })
          , Rs = Wn("toUpperCase")
          , Fs = sn(function(e, n) {
            try {
                return t(e, R, n)
            } catch (t) {
                return fi(t) ? t : new Zi(t)
            }
        })
          , Hs = fr(function(t, e) {
            return n(e, function(e) {
                e = $r(e),
                ce(t, e, Za(t[e], t))
            }),
            t
        })
          , Bs = Zn()
          , qs = Zn(!0)
          , Ws = sn(function(t, e) {
            return function(n) {
                return je(n, t, e)
            }
        })
          , Us = sn(function(t, e) {
            return function(n) {
                return je(t, n, e)
            }
        })
          , Vs = Jn(l)
          , Xs = Jn(i)
          , Ys = Jn(p)
          , Zs = nr()
          , Ks = nr(!0)
          , Gs = Qn(function(t, e) {
            return t + e
        }, 0)
          , Qs = or("ceil")
          , Js = Qn(function(t, e) {
            return t / e
        }, 1)
          , tl = or("floor")
          , el = Qn(function(t, e) {
            return t * e
        }, 1)
          , nl = or("round")
          , rl = Qn(function(t, e) {
            return t - e
        }, 0);
        return kt.after = function(t, e) {
            if ("function" != typeof e)
                throw new eo("Expected a function");
            return t = Si(t),
            function() {
                if (1 > --t)
                    return e.apply(this, arguments)
            }
        }
        ,
        kt.ary = ri,
        kt.assign = gs,
        kt.assignIn = vs,
        kt.assignInWith = ys,
        kt.assignWith = bs,
        kt.at = ws,
        kt.before = ii,
        kt.bind = Za,
        kt.bindAll = Hs,
        kt.bindKey = Ka,
        kt.castArray = function() {
            if (!arguments.length)
                return [];
            var t = arguments[0];
            return as(t) ? t : [t]
        }
        ,
        kt.chain = Gr,
        kt.chunk = function(t, e, n) {
            if (e = (n ? Ar(t, e, n) : e === R) ? 1 : Po(Si(e), 0),
            n = null == t ? 0 : t.length,
            !n || 1 > e)
                return [];
            for (var r = 0, i = 0, o = Xi(Mo(n / e)); r < n; )
                o[i++] = pn(t, r, r += e);
            return o
        }
        ,
        kt.compact = function(t) {
            for (var e = -1, n = null == t ? 0 : t.length, r = 0, i = []; ++e < n; ) {
                var o = t[e];
                o && (i[r++] = o)
            }
            return i
        }
        ,
        kt.concat = function() {
            var t = arguments.length;
            if (!t)
                return [];
            for (var e = Xi(t - 1), n = arguments[0]; t--; )
                e[t - 1] = arguments[t];
            return u(as(n) ? Nn(n) : [n], xe(e, 1))
        }
        ,
        kt.cond = function(e) {
            var n = null == e ? 0 : e.length
              , r = yr();
            return e = n ? l(e, function(t) {
                if ("function" != typeof t[1])
                    throw new eo("Expected a function");
                return [r(t[0]), t[1]]
            }) : [],
            sn(function(r) {
                for (var i = -1; ++i < n; ) {
                    var o = e[i];
                    if (t(o[0], this, r))
                        return t(o[1], this, r)
                }
            })
        }
        ,
        kt.conforms = function(t) {
            return he(fe(t, 1))
        }
        ,
        kt.constant = Ri,
        kt.countBy = Fa,
        kt.create = function(t, e) {
            var n = ia(t);
            return null == e ? n : le(n, e)
        }
        ,
        kt.curry = oi,
        kt.curryRight = ai,
        kt.debounce = si,
        kt.defaults = xs,
        kt.defaultsDeep = Cs,
        kt.defer = Ga,
        kt.delay = Qa,
        kt.difference = Ca,
        kt.differenceBy = ka,
        kt.differenceWith = _a,
        kt.drop = function(t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (e = n || e === R ? 1 : Si(e),
            pn(t, 0 > e ? 0 : e, r)) : []
        }
        ,
        kt.dropRight = function(t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (e = n || e === R ? 1 : Si(e),
            e = r - e,
            pn(t, 0, 0 > e ? 0 : e)) : []
        }
        ,
        kt.dropRightWhile = function(t, e) {
            return t && t.length ? xn(t, yr(e, 3), !0, !0) : []
        }
        ,
        kt.dropWhile = function(t, e) {
            return t && t.length ? xn(t, yr(e, 3), !0) : []
        }
        ,
        kt.fill = function(t, e, n, r) {
            var i = null == t ? 0 : t.length;
            if (!i)
                return [];
            for (n && "number" != typeof n && Ar(t, e, n) && (n = 0,
            r = i),
            i = t.length,
            n = Si(n),
            0 > n && (n = -n > i ? 0 : i + n),
            r = r === R || r > i ? i : Si(r),
            0 > r && (r += i),
            r = n > r ? 0 : Ti(r); n < r; )
                t[n++] = e;
            return t
        }
        ,
        kt.filter = function(t, e) {
            return (as(t) ? o : we)(t, yr(e, 3))
        }
        ,
        kt.flatMap = function(t, e) {
            return xe(ni(t, e), 1)
        }
        ,
        kt.flatMapDeep = function(t, e) {
            return xe(ni(t, e), F)
        }
        ,
        kt.flatMapDepth = function(t, e, n) {
            return n = n === R ? 1 : Si(n),
            xe(ni(t, e), n)
        }
        ,
        kt.flatten = Wr,
        kt.flattenDeep = function(t) {
            return (null == t ? 0 : t.length) ? xe(t, F) : []
        }
        ,
        kt.flattenDepth = function(t, e) {
            return null != t && t.length ? (e = e === R ? 1 : Si(e),
            xe(t, e)) : []
        }
        ,
        kt.flip = function(t) {
            return sr(t, 512)
        }
        ,
        kt.flow = Bs,
        kt.flowRight = qs,
        kt.fromPairs = function(t) {
            for (var e = -1, n = null == t ? 0 : t.length, r = {}; ++e < n; ) {
                var i = t[e];
                r[i[0]] = i[1]
            }
            return r
        }
        ,
        kt.functions = function(t) {
            return null == t ? [] : _e(t, Ii(t))
        }
        ,
        kt.functionsIn = function(t) {
            return null == t ? [] : _e(t, ji(t))
        }
        ,
        kt.groupBy = qa,
        kt.initial = function(t) {
            return (null == t ? 0 : t.length) ? pn(t, 0, -1) : []
        }
        ,
        kt.intersection = Sa,
        kt.intersectionBy = Ta,
        kt.intersectionWith = Ea,
        kt.invert = ks,
        kt.invertBy = _s,
        kt.invokeMap = Wa,
        kt.iteratee = Hi,
        kt.keyBy = Ua,
        kt.keys = Ii,
        kt.keysIn = ji,
        kt.map = ni,
        kt.mapKeys = function(t, e) {
            var n = {};
            return e = yr(e, 3),
            Ce(t, function(t, r, i) {
                ce(n, e(t, r, i), t)
            }),
            n
        }
        ,
        kt.mapValues = function(t, e) {
            var n = {};
            return e = yr(e, 3),
            Ce(t, function(t, r, i) {
                ce(n, r, e(t, r, i))
            }),
            n
        }
        ,
        kt.matches = function(t) {
            return Ye(fe(t, 1))
        }
        ,
        kt.matchesProperty = function(t, e) {
            return Ze(t, fe(e, 1))
        }
        ,
        kt.memoize = li,
        kt.merge = Ts,
        kt.mergeWith = Es,
        kt.method = Ws,
        kt.methodOf = Us,
        kt.mixin = Bi,
        kt.negate = ui,
        kt.nthArg = function(t) {
            return t = Si(t),
            sn(function(e) {
                return Ge(e, t)
            })
        }
        ,
        kt.omit = As,
        kt.omitBy = function(t, e) {
            return zi(t, ui(yr(e)))
        }
        ,
        kt.once = function(t) {
            return ii(2, t)
        }
        ,
        kt.orderBy = function(t, e, n, r) {
            return null == t ? [] : (as(e) || (e = null == e ? [] : [e]),
            n = r ? R : n,
            as(n) || (n = null == n ? [] : [n]),
            Qe(t, e, n))
        }
        ,
        kt.over = Vs,
        kt.overArgs = Ja,
        kt.overEvery = Xs,
        kt.overSome = Ys,
        kt.partial = ts,
        kt.partialRight = es,
        kt.partition = Va,
        kt.pick = Ms,
        kt.pickBy = zi,
        kt.property = Wi,
        kt.propertyOf = function(t) {
            return function(e) {
                return null == t ? R : Se(t, e)
            }
        }
        ,
        kt.pull = Aa,
        kt.pullAll = Xr,
        kt.pullAllBy = function(t, e, n) {
            return t && t.length && e && e.length ? nn(t, e, yr(n, 2)) : t
        }
        ,
        kt.pullAllWith = function(t, e, n) {
            return t && t.length && e && e.length ? nn(t, e, R, n) : t
        }
        ,
        kt.pullAt = Ma,
        kt.range = Zs,
        kt.rangeRight = Ks,
        kt.rearg = ns,
        kt.reject = function(t, e) {
            return (as(t) ? o : we)(t, ui(yr(e, 3)))
        }
        ,
        kt.remove = function(t, e) {
            var n = [];
            if (!t || !t.length)
                return n;
            var r = -1
              , i = []
              , o = t.length;
            for (e = yr(e, 3); ++r < o; ) {
                var a = t[r];
                e(a, r, t) && (n.push(a),
                i.push(r))
            }
            return rn(t, i),
            n
        }
        ,
        kt.rest = function(t, e) {
            if ("function" != typeof t)
                throw new eo("Expected a function");
            return e = e === R ? e : Si(e),
            sn(t, e)
        }
        ,
        kt.reverse = Yr,
        kt.sampleSize = function(t, e, n) {
            return e = (n ? Ar(t, e, n) : e === R) ? 1 : Si(e),
            (as(t) ? ne : un)(t, e)
        }
        ,
        kt.set = function(t, e, n) {
            return null == t ? t : cn(t, e, n)
        }
        ,
        kt.setWith = function(t, e, n, r) {
            return r = "function" == typeof r ? r : R,
            null == t ? t : cn(t, e, n, r)
        }
        ,
        kt.shuffle = function(t) {
            return (as(t) ? re : dn)(t)
        }
        ,
        kt.slice = function(t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (n && "number" != typeof n && Ar(t, e, n) ? (e = 0,
            n = r) : (e = null == e ? 0 : Si(e),
            n = n === R ? r : Si(n)),
            pn(t, e, n)) : []
        }
        ,
        kt.sortBy = Xa,
        kt.sortedUniq = function(t) {
            return t && t.length ? gn(t) : []
        }
        ,
        kt.sortedUniqBy = function(t, e) {
            return t && t.length ? gn(t, yr(e, 2)) : []
        }
        ,
        kt.split = function(t, e, n) {
            return n && "number" != typeof n && Ar(t, e, n) && (e = n = R),
            n = n === R ? 4294967295 : n >>> 0,
            n ? (t = Mi(t)) && ("string" == typeof e || null != e && !ds(e)) && (e = yn(e),
            !e && Mt.test(t)) ? An($(t), 0, n) : t.split(e, n) : []
        }
        ,
        kt.spread = function(e, n) {
            if ("function" != typeof e)
                throw new eo("Expected a function");
            return n = null == n ? 0 : Po(Si(n), 0),
            sn(function(r) {
                var i = r[n];
                return r = An(r, 0, n),
                i && u(r, i),
                t(e, this, r)
            })
        }
        ,
        kt.tail = function(t) {
            var e = null == t ? 0 : t.length;
            return e ? pn(t, 1, e) : []
        }
        ,
        kt.take = function(t, e, n) {
            return t && t.length ? (e = n || e === R ? 1 : Si(e),
            pn(t, 0, 0 > e ? 0 : e)) : []
        }
        ,
        kt.takeRight = function(t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (e = n || e === R ? 1 : Si(e),
            e = r - e,
            pn(t, 0 > e ? 0 : e, r)) : []
        }
        ,
        kt.takeRightWhile = function(t, e) {
            return t && t.length ? xn(t, yr(e, 3), !1, !0) : []
        }
        ,
        kt.takeWhile = function(t, e) {
            return t && t.length ? xn(t, yr(e, 3)) : []
        }
        ,
        kt.tap = function(t, e) {
            return e(t),
            t
        }
        ,
        kt.throttle = function(t, e, n) {
            var r = !0
              , i = !0;
            if ("function" != typeof t)
                throw new eo("Expected a function");
            return vi(n) && (r = "leading"in n ? !!n.leading : r,
            i = "trailing"in n ? !!n.trailing : i),
            si(t, e, {
                leading: r,
                maxWait: e,
                trailing: i
            })
        }
        ,
        kt.thru = Qr,
        kt.toArray = ki,
        kt.toPairs = Os,
        kt.toPairsIn = Ls,
        kt.toPath = function(t) {
            return as(t) ? l(t, $r) : Ci(t) ? [t] : Nn(xa(Mi(t)))
        }
        ,
        kt.toPlainObject = Ai,
        kt.transform = function(t, e, r) {
            var i = as(t)
              , o = i || ls(t) || fs(t);
            if (e = yr(e, 4),
            null == r) {
                var a = t && t.constructor;
                r = o ? i ? new a : [] : vi(t) && hi(a) ? ia(yo(t)) : {}
            }
            return (o ? n : Ce)(t, function(t, n, i) {
                return e(r, t, n, i)
            }),
            r
        }
        ,
        kt.unary = function(t) {
            return ri(t, 1)
        }
        ,
        kt.union = Oa,
        kt.unionBy = La,
        kt.unionWith = Ia,
        kt.uniq = function(t) {
            return t && t.length ? bn(t) : []
        }
        ,
        kt.uniqBy = function(t, e) {
            return t && t.length ? bn(t, yr(e, 2)) : []
        }
        ,
        kt.uniqWith = function(t, e) {
            return e = "function" == typeof e ? e : R,
            t && t.length ? bn(t, R, e) : []
        }
        ,
        kt.unset = function(t, e) {
            return null == t || wn(t, e)
        }
        ,
        kt.unzip = Zr,
        kt.unzipWith = Kr,
        kt.update = function(t, e, n) {
            return null != t && (n = Tn(n),
            t = cn(t, e, n(Se(t, e)), void 0)),
            t
        }
        ,
        kt.updateWith = function(t, e, n, r) {
            return r = "function" == typeof r ? r : R,
            null != t && (n = Tn(n),
            t = cn(t, e, n(Se(t, e)), r)),
            t
        }
        ,
        kt.values = Ni,
        kt.valuesIn = function(t) {
            return null == t ? [] : E(t, ji(t))
        }
        ,
        kt.without = ja,
        kt.words = $i,
        kt.wrap = function(t, e) {
            return ts(Tn(e), t)
        }
        ,
        kt.xor = za,
        kt.xorBy = Na,
        kt.xorWith = Pa,
        kt.zip = Da,
        kt.zipObject = function(t, e) {
            return _n(t || [], e || [], oe)
        }
        ,
        kt.zipObjectDeep = function(t, e) {
            return _n(t || [], e || [], cn)
        }
        ,
        kt.zipWith = $a,
        kt.entries = Os,
        kt.entriesIn = Ls,
        kt.extend = vs,
        kt.extendWith = ys,
        Bi(kt, kt),
        kt.add = Gs,
        kt.attempt = Fs,
        kt.camelCase = Is,
        kt.capitalize = Pi,
        kt.ceil = Qs,
        kt.clamp = function(t, e, n) {
            return n === R && (n = e,
            e = R),
            n !== R && (n = Ei(n),
            n = n === n ? n : 0),
            e !== R && (e = Ei(e),
            e = e === e ? e : 0),
            pe(Ei(t), e, n)
        }
        ,
        kt.clone = function(t) {
            return fe(t, 4)
        }
        ,
        kt.cloneDeep = function(t) {
            return fe(t, 5)
        }
        ,
        kt.cloneDeepWith = function(t, e) {
            return e = "function" == typeof e ? e : R,
            fe(t, 5, e)
        }
        ,
        kt.cloneWith = function(t, e) {
            return e = "function" == typeof e ? e : R,
            fe(t, 4, e)
        }
        ,
        kt.conformsTo = function(t, e) {
            return null == e || me(t, e, Ii(e))
        }
        ,
        kt.deburr = Di,
        kt.defaultTo = function(t, e) {
            return null == t || t !== t ? e : t
        }
        ,
        kt.divide = Js,
        kt.endsWith = function(t, e, n) {
            t = Mi(t),
            e = yn(e);
            var r = t.length
              , r = n = n === R ? r : pe(Si(n), 0, r);
            return n -= e.length,
            0 <= n && t.slice(n, r) == e
        }
        ,
        kt.eq = ci,
        kt.escape = function(t) {
            return (t = Mi(t)) && Z.test(t) ? t.replace(X, Jt) : t
        }
        ,
        kt.escapeRegExp = function(t) {
            return (t = Mi(t)) && rt.test(t) ? t.replace(nt, "\\$&") : t
        }
        ,
        kt.every = function(t, e, n) {
            var r = as(t) ? i : ye;
            return n && Ar(t, e, n) && (e = R),
            r(t, yr(e, 3))
        }
        ,
        kt.find = Ha,
        kt.findIndex = Br,
        kt.findKey = function(t, e) {
            return f(t, yr(e, 3), Ce)
        }
        ,
        kt.findLast = Ba,
        kt.findLastIndex = qr,
        kt.findLastKey = function(t, e) {
            return f(t, yr(e, 3), ke)
        }
        ,
        kt.floor = tl,
        kt.forEach = ti,
        kt.forEachRight = ei,
        kt.forIn = function(t, e) {
            return null == t ? t : sa(t, yr(e, 3), ji)
        }
        ,
        kt.forInRight = function(t, e) {
            return null == t ? t : la(t, yr(e, 3), ji)
        }
        ,
        kt.forOwn = function(t, e) {
            return t && Ce(t, yr(e, 3))
        }
        ,
        kt.forOwnRight = function(t, e) {
            return t && ke(t, yr(e, 3))
        }
        ,
        kt.get = Oi,
        kt.gt = rs,
        kt.gte = is,
        kt.has = function(t, e) {
            return null != t && Cr(t, e, Me)
        }
        ,
        kt.hasIn = Li,
        kt.head = Ur,
        kt.identity = Fi,
        kt.includes = function(t, e, n, r) {
            return t = di(t) ? t : Ni(t),
            n = n && !r ? Si(n) : 0,
            r = t.length,
            0 > n && (n = Po(r + n, 0)),
            xi(t) ? n <= r && -1 < t.indexOf(e, n) : !!r && -1 < m(t, e, n)
        }
        ,
        kt.indexOf = function(t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (n = null == n ? 0 : Si(n),
            0 > n && (n = Po(r + n, 0)),
            m(t, e, n)) : -1
        }
        ,
        kt.inRange = function(t, e, n) {
            return e = _i(e),
            n === R ? (n = e,
            e = 0) : n = _i(n),
            t = Ei(t),
            t >= Do(e, n) && t < Po(e, n)
        }
        ,
        kt.invoke = Ss,
        kt.isArguments = os,
        kt.isArray = as,
        kt.isArrayBuffer = ss,
        kt.isArrayLike = di,
        kt.isArrayLikeObject = pi,
        kt.isBoolean = function(t) {
            return !0 === t || !1 === t || yi(t) && "[object Boolean]" == Ee(t)
        }
        ,
        kt.isBuffer = ls,
        kt.isDate = us,
        kt.isElement = function(t) {
            return yi(t) && 1 === t.nodeType && !wi(t)
        }
        ,
        kt.isEmpty = function(t) {
            if (null == t)
                return !0;
            if (di(t) && (as(t) || "string" == typeof t || "function" == typeof t.splice || ls(t) || fs(t) || os(t)))
                return !t.length;
            var e = ga(t);
            if ("[object Map]" == e || "[object Set]" == e)
                return !t.size;
            if (Lr(t))
                return !Ue(t).length;
            for (var n in t)
                if (ao.call(t, n))
                    return !1;
            return !0
        }
        ,
        kt.isEqual = function(t, e) {
            return De(t, e)
        }
        ,
        kt.isEqualWith = function(t, e, n) {
            var r = (n = "function" == typeof n ? n : R) ? n(t, e) : R;
            return r === R ? De(t, e, R, n) : !!r
        }
        ,
        kt.isError = fi,
        kt.isFinite = function(t) {
            return "number" == typeof t && jo(t)
        }
        ,
        kt.isFunction = hi,
        kt.isInteger = mi,
        kt.isLength = gi,
        kt.isMap = cs,
        kt.isMatch = function(t, e) {
            return t === e || Re(t, e, wr(e))
        }
        ,
        kt.isMatchWith = function(t, e, n) {
            return n = "function" == typeof n ? n : R,
            Re(t, e, wr(e), n)
        }
        ,
        kt.isNaN = function(t) {
            return bi(t) && t != +t
        }
        ,
        kt.isNative = function(t) {
            if (va(t))
                throw new Zi("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
            return Fe(t)
        }
        ,
        kt.isNil = function(t) {
            return null == t
        }
        ,
        kt.isNull = function(t) {
            return null === t
        }
        ,
        kt.isNumber = bi,
        kt.isObject = vi,
        kt.isObjectLike = yi,
        kt.isPlainObject = wi,
        kt.isRegExp = ds,
        kt.isSafeInteger = function(t) {
            return mi(t) && -9007199254740991 <= t && 9007199254740991 >= t
        }
        ,
        kt.isSet = ps,
        kt.isString = xi,
        kt.isSymbol = Ci,
        kt.isTypedArray = fs,
        kt.isUndefined = function(t) {
            return t === R
        }
        ,
        kt.isWeakMap = function(t) {
            return yi(t) && "[object WeakMap]" == ga(t)
        }
        ,
        kt.isWeakSet = function(t) {
            return yi(t) && "[object WeakSet]" == Ee(t)
        }
        ,
        kt.join = function(t, e) {
            return null == t ? "" : zo.call(t, e)
        }
        ,
        kt.kebabCase = js,
        kt.last = Vr,
        kt.lastIndexOf = function(t, e, n) {
            var r = null == t ? 0 : t.length;
            if (!r)
                return -1;
            var i = r;
            if (n !== R && (i = Si(n),
            i = 0 > i ? Po(r + i, 0) : Do(i, r - 1)),
            e === e)
                t: {
                    for (n = i + 1; n--; )
                        if (t[n] === e) {
                            t = n;
                            break t
                        }
                    t = n
                }
            else
                t = h(t, v, i, !0);
            return t
        }
        ,
        kt.lowerCase = zs,
        kt.lowerFirst = Ns,
        kt.lt = hs,
        kt.lte = ms,
        kt.max = function(t) {
            return t && t.length ? be(t, Fi, Ae) : R
        }
        ,
        kt.maxBy = function(t, e) {
            return t && t.length ? be(t, yr(e, 2), Ae) : R
        }
        ,
        kt.mean = function(t) {
            return y(t, Fi)
        }
        ,
        kt.meanBy = function(t, e) {
            return y(t, yr(e, 2))
        }
        ,
        kt.min = function(t) {
            return t && t.length ? be(t, Fi, Ve) : R
        }
        ,
        kt.minBy = function(t, e) {
            return t && t.length ? be(t, yr(e, 2), Ve) : R
        }
        ,
        kt.stubArray = Ui,
        kt.stubFalse = Vi,
        kt.stubObject = function() {
            return {}
        }
        ,
        kt.stubString = function() {
            return ""
        }
        ,
        kt.stubTrue = function() {
            return !0
        }
        ,
        kt.multiply = el,
        kt.nth = function(t, e) {
            return t && t.length ? Ge(t, Si(e)) : R
        }
        ,
        kt.noConflict = function() {
            return Rt._ === this && (Rt._ = po),
            this
        }
        ,
        kt.noop = qi,
        kt.now = Ya,
        kt.pad = function(t, e, n) {
            t = Mi(t);
            var r = (e = Si(e)) ? D(t) : 0;
            return !e || r >= e ? t : (e = (e - r) / 2,
            tr(Oo(e), n) + t + tr(Mo(e), n))
        }
        ,
        kt.padEnd = function(t, e, n) {
            t = Mi(t);
            var r = (e = Si(e)) ? D(t) : 0;
            return e && r < e ? t + tr(e - r, n) : t
        }
        ,
        kt.padStart = function(t, e, n) {
            t = Mi(t);
            var r = (e = Si(e)) ? D(t) : 0;
            return e && r < e ? tr(e - r, n) + t : t
        }
        ,
        kt.parseInt = function(t, e, n) {
            return n || null == e ? e = 0 : e && (e = +e),
            Ro(Mi(t).replace(ot, ""), e || 0)
        }
        ,
        kt.random = function(t, e, n) {
            if (n && "boolean" != typeof n && Ar(t, e, n) && (e = n = R),
            n === R && ("boolean" == typeof e ? (n = e,
            e = R) : "boolean" == typeof t && (n = t,
            t = R)),
            t === R && e === R ? (t = 0,
            e = 1) : (t = _i(t),
            e === R ? (e = t,
            t = 0) : e = _i(e)),
            t > e) {
                var r = t;
                t = e,
                e = r
            }
            return n || t % 1 || e % 1 ? (n = Fo(),
            Do(t + n * (e - t + Nt("1e-" + ((n + "").length - 1))), e)) : on(t, e)
        }
        ,
        kt.reduce = function(t, e, n) {
            var r = as(t) ? c : x
              , i = 3 > arguments.length;
            return r(t, yr(e, 4), n, i, oa)
        }
        ,
        kt.reduceRight = function(t, e, n) {
            var r = as(t) ? d : x
              , i = 3 > arguments.length;
            return r(t, yr(e, 4), n, i, aa)
        }
        ,
        kt.repeat = function(t, e, n) {
            return e = (n ? Ar(t, e, n) : e === R) ? 1 : Si(e),
            an(Mi(t), e)
        }
        ,
        kt.replace = function() {
            var t = arguments
              , e = Mi(t[0]);
            return 3 > t.length ? e : e.replace(t[1], t[2])
        }
        ,
        kt.result = function(t, e, n) {
            e = En(e, t);
            var r = -1
              , i = e.length;
            for (i || (i = 1,
            t = R); ++r < i; ) {
                var o = null == t ? R : t[$r(e[r])];
                o === R && (r = i,
                o = n),
                t = hi(o) ? o.call(t) : o
            }
            return t
        }
        ,
        kt.round = nl,
        kt.runInContext = w,
        kt.sample = function(t) {
            return (as(t) ? Gt : ln)(t)
        }
        ,
        kt.size = function(t) {
            if (null == t)
                return 0;
            if (di(t))
                return xi(t) ? D(t) : t.length;
            var e = ga(t);
            return "[object Map]" == e || "[object Set]" == e ? t.size : Ue(t).length
        }
        ,
        kt.snakeCase = Ps,
        kt.some = function(t, e, n) {
            var r = as(t) ? p : fn;
            return n && Ar(t, e, n) && (e = R),
            r(t, yr(e, 3))
        }
        ,
        kt.sortedIndex = function(t, e) {
            return hn(t, e)
        }
        ,
        kt.sortedIndexBy = function(t, e, n) {
            return mn(t, e, yr(n, 2))
        }
        ,
        kt.sortedIndexOf = function(t, e) {
            var n = null == t ? 0 : t.length;
            if (n) {
                var r = hn(t, e);
                if (r < n && ci(t[r], e))
                    return r
            }
            return -1
        }
        ,
        kt.sortedLastIndex = function(t, e) {
            return hn(t, e, !0)
        }
        ,
        kt.sortedLastIndexBy = function(t, e, n) {
            return mn(t, e, yr(n, 2), !0)
        }
        ,
        kt.sortedLastIndexOf = function(t, e) {
            if (null == t ? 0 : t.length) {
                var n = hn(t, e, !0) - 1;
                if (ci(t[n], e))
                    return n
            }
            return -1
        }
        ,
        kt.startCase = Ds,
        kt.startsWith = function(t, e, n) {
            return t = Mi(t),
            n = null == n ? 0 : pe(Si(n), 0, t.length),
            e = yn(e),
            t.slice(n, n + e.length) == e
        }
        ,
        kt.subtract = rl,
        kt.sum = function(t) {
            return t && t.length ? k(t, Fi) : 0
        }
        ,
        kt.sumBy = function(t, e) {
            return t && t.length ? k(t, yr(e, 2)) : 0
        }
        ,
        kt.template = function(t, e, n) {
            var r = kt.templateSettings;
            n && Ar(t, e, n) && (e = R),
            t = Mi(t),
            e = ys({}, e, r, lr),
            n = ys({}, e.imports, r.imports, lr);
            var i, o, a = Ii(n), s = E(n, a), l = 0;
            n = e.interpolate || wt;
            var u = "__p+='";
            n = Ji((e.escape || wt).source + "|" + n.source + "|" + (n === Q ? pt : wt).source + "|" + (e.evaluate || wt).source + "|$", "g");
            var c = "sourceURL"in e ? "//# sourceURL=" + e.sourceURL + "\n" : "";
            if (t.replace(n, function(e, n, r, a, s, c) {
                return r || (r = a),
                u += t.slice(l, c).replace(xt, L),
                n && (i = !0,
                u += "'+__e(" + n + ")+'"),
                s && (o = !0,
                u += "';" + s + ";\n__p+='"),
                r && (u += "'+((__t=(" + r + "))==null?'':__t)+'"),
                l = c + e.length,
                e
            }),
            u += "';",
            (e = e.variable) || (u = "with(obj){" + u + "}"),
            u = (o ? u.replace(q, "") : u).replace(W, "$1").replace(U, "$1;"),
            u = "function(" + (e || "obj") + "){" + (e ? "" : "obj||(obj={});") + "var __t,__p=''" + (i ? ",__e=_.escape" : "") + (o ? ",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}" : ";") + u + "return __p}",
            e = Fs(function() {
                return Ki(a, c + "return " + u).apply(R, s)
            }),
            e.source = u,
            fi(e))
                throw e;
            return e
        }
        ,
        kt.times = function(t, e) {
            if (t = Si(t),
            1 > t || 9007199254740991 < t)
                return [];
            var n = 4294967295
              , r = Do(t, 4294967295);
            for (e = yr(e),
            t -= 4294967295,
            r = _(r, e); ++n < t; )
                e(n);
            return r
        }
        ,
        kt.toFinite = _i,
        kt.toInteger = Si,
        kt.toLength = Ti,
        kt.toLower = function(t) {
            return Mi(t).toLowerCase()
        }
        ,
        kt.toNumber = Ei,
        kt.toSafeInteger = function(t) {
            return t ? pe(Si(t), -9007199254740991, 9007199254740991) : 0 === t ? t : 0
        }
        ,
        kt.toString = Mi,
        kt.toUpper = function(t) {
            return Mi(t).toUpperCase()
        }
        ,
        kt.trim = function(t, e, n) {
            return (t = Mi(t)) && (n || e === R) ? t.replace(it, "") : t && (e = yn(e)) ? (t = $(t),
            n = $(e),
            e = M(t, n),
            n = O(t, n) + 1,
            An(t, e, n).join("")) : t
        }
        ,
        kt.trimEnd = function(t, e, n) {
            return (t = Mi(t)) && (n || e === R) ? t.replace(at, "") : t && (e = yn(e)) ? (t = $(t),
            e = O(t, $(e)) + 1,
            An(t, 0, e).join("")) : t
        }
        ,
        kt.trimStart = function(t, e, n) {
            return (t = Mi(t)) && (n || e === R) ? t.replace(ot, "") : t && (e = yn(e)) ? (t = $(t),
            e = M(t, $(e)),
            An(t, e).join("")) : t
        }
        ,
        kt.truncate = function(t, e) {
            var n = 30
              , r = "...";
            if (vi(e))
                var i = "separator"in e ? e.separator : i
                  , n = "length"in e ? Si(e.length) : n
                  , r = "omission"in e ? yn(e.omission) : r;
            t = Mi(t);
            var o = t.length;
            if (Mt.test(t))
                var a = $(t)
                  , o = a.length;
            if (n >= o)
                return t;
            if (o = n - D(r),
            1 > o)
                return r;
            if (n = a ? An(a, 0, o).join("") : t.slice(0, o),
            i === R)
                return n + r;
            if (a && (o += n.length - o),
            ds(i)) {
                if (t.slice(o).search(i)) {
                    var s = n;
                    for (i.global || (i = Ji(i.source, Mi(ft.exec(i)) + "g")),
                    i.lastIndex = 0; a = i.exec(s); )
                        var l = a.index;
                    n = n.slice(0, l === R ? o : l)
                }
            } else
                t.indexOf(yn(i), o) != o && (i = n.lastIndexOf(i),
                -1 < i && (n = n.slice(0, i)));
            return n + r
        }
        ,
        kt.unescape = function(t) {
            return (t = Mi(t)) && Y.test(t) ? t.replace(V, te) : t
        }
        ,
        kt.uniqueId = function(t) {
            var e = ++so;
            return Mi(t) + e
        }
        ,
        kt.upperCase = $s,
        kt.upperFirst = Rs,
        kt.each = ti,
        kt.eachRight = ei,
        kt.first = Ur,
        Bi(kt, function() {
            var t = {};
            return Ce(kt, function(e, n) {
                ao.call(kt.prototype, n) || (t[n] = e)
            }),
            t
        }(), {
            chain: !1
        }),
        kt.VERSION = "4.17.11",
        n("bind bindKey curry curryRight partial partialRight".split(" "), function(t) {
            kt[t].placeholder = kt
        }),
        n(["drop", "take"], function(t, e) {
            zt.prototype[t] = function(n) {
                n = n === R ? 1 : Po(Si(n), 0);
                var r = this.__filtered__ && !e ? new zt(this) : this.clone();
                return r.__filtered__ ? r.__takeCount__ = Do(n, r.__takeCount__) : r.__views__.push({
                    size: Do(n, 4294967295),
                    type: t + (0 > r.__dir__ ? "Right" : "")
                }),
                r
            }
            ,
            zt.prototype[t + "Right"] = function(e) {
                return this.reverse()[t](e).reverse()
            }
        }),
        n(["filter", "map", "takeWhile"], function(t, e) {
            var n = e + 1
              , r = 1 == n || 3 == n;
            zt.prototype[t] = function(t) {
                var e = this.clone();
                return e.__iteratees__.push({
                    iteratee: yr(t, 3),
                    type: n
                }),
                e.__filtered__ = e.__filtered__ || r,
                e
            }
        }),
        n(["head", "last"], function(t, e) {
            var n = "take" + (e ? "Right" : "");
            zt.prototype[t] = function() {
                return this[n](1).value()[0]
            }
        }),
        n(["initial", "tail"], function(t, e) {
            var n = "drop" + (e ? "" : "Right");
            zt.prototype[t] = function() {
                return this.__filtered__ ? new zt(this) : this[n](1)
            }
        }),
        zt.prototype.compact = function() {
            return this.filter(Fi)
        }
        ,
        zt.prototype.find = function(t) {
            return this.filter(t).head()
        }
        ,
        zt.prototype.findLast = function(t) {
            return this.reverse().find(t)
        }
        ,
        zt.prototype.invokeMap = sn(function(t, e) {
            return "function" == typeof t ? new zt(this) : this.map(function(n) {
                return je(n, t, e)
            })
        }),
        zt.prototype.reject = function(t) {
            return this.filter(ui(yr(t)))
        }
        ,
        zt.prototype.slice = function(t, e) {
            t = Si(t);
            var n = this;
            return n.__filtered__ && (0 < t || 0 > e) ? new zt(n) : (0 > t ? n = n.takeRight(-t) : t && (n = n.drop(t)),
            e !== R && (e = Si(e),
            n = 0 > e ? n.dropRight(-e) : n.take(e - t)),
            n)
        }
        ,
        zt.prototype.takeRightWhile = function(t) {
            return this.reverse().takeWhile(t).reverse()
        }
        ,
        zt.prototype.toArray = function() {
            return this.take(4294967295)
        }
        ,
        Ce(zt.prototype, function(t, e) {
            var n = /^(?:filter|find|map|reject)|While$/.test(e)
              , r = /^(?:head|last)$/.test(e)
              , i = kt[r ? "take" + ("last" == e ? "Right" : "") : e]
              , o = r || /^find/.test(e);
            i && (kt.prototype[e] = function() {
                var e = this.__wrapped__
                  , a = r ? [1] : arguments
                  , s = e instanceof zt
                  , l = a[0]
                  , c = s || as(e)
                  , d = function(t) {
                    return t = i.apply(kt, u([t], a)),
                    r && p ? t[0] : t
                };
                c && n && "function" == typeof l && 1 != l.length && (s = c = !1);
                var p = this.__chain__
                  , f = !!this.__actions__.length
                  , l = o && !p
                  , s = s && !f;
                return !o && c ? (e = s ? e : new zt(this),
                e = t.apply(e, a),
                e.__actions__.push({
                    func: Qr,
                    args: [d],
                    thisArg: R
                }),
                new Et(e,p)) : l && s ? t.apply(this, a) : (e = this.thru(d),
                l ? r ? e.value()[0] : e.value() : e)
            }
            )
        }),
        n("pop push shift sort splice unshift".split(" "), function(t) {
            var e = no[t]
              , n = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru"
              , r = /^(?:pop|shift)$/.test(t);
            kt.prototype[t] = function() {
                var t = arguments;
                if (r && !this.__chain__) {
                    var i = this.value();
                    return e.apply(as(i) ? i : [], t)
                }
                return this[n](function(n) {
                    return e.apply(as(n) ? n : [], t)
                })
            }
        }),
        Ce(zt.prototype, function(t, e) {
            var n = kt[e];
            if (n) {
                var r = n.name + "";
                (Zo[r] || (Zo[r] = [])).push({
                    name: e,
                    func: n
                })
            }
        }),
        Zo[Kn(R, 2).name] = [{
            name: "wrapper",
            func: R
        }],
        zt.prototype.clone = function() {
            var t = new zt(this.__wrapped__);
            return t.__actions__ = Nn(this.__actions__),
            t.__dir__ = this.__dir__,
            t.__filtered__ = this.__filtered__,
            t.__iteratees__ = Nn(this.__iteratees__),
            t.__takeCount__ = this.__takeCount__,
            t.__views__ = Nn(this.__views__),
            t
        }
        ,
        zt.prototype.reverse = function() {
            if (this.__filtered__) {
                var t = new zt(this);
                t.__dir__ = -1,
                t.__filtered__ = !0
            } else
                t = this.clone(),
                t.__dir__ *= -1;
            return t
        }
        ,
        zt.prototype.value = function() {
            var t, e = this.__wrapped__.value(), n = this.__dir__, r = as(e), i = 0 > n, o = r ? e.length : 0;
            t = 0;
            for (var a = o, s = this.__views__, l = -1, u = s.length; ++l < u; ) {
                var c = s[l]
                  , d = c.size;
                switch (c.type) {
                case "drop":
                    t += d;
                    break;
                case "dropRight":
                    a -= d;
                    break;
                case "take":
                    a = Do(a, t + d);
                    break;
                case "takeRight":
                    t = Po(t, a - d)
                }
            }
            if (t = {
                start: t,
                end: a
            },
            a = t.start,
            s = t.end,
            t = s - a,
            a = i ? s : a - 1,
            s = this.__iteratees__,
            l = s.length,
            u = 0,
            c = Do(t, this.__takeCount__),
            !r || !i && o == t && c == t)
                return Cn(e, this.__actions__);
            r = [];
            t: for (; t-- && u < c; ) {
                for (a += n,
                i = -1,
                o = e[a]; ++i < l; ) {
                    var p = s[i]
                      , d = p.type
                      , p = (0,
                    p.iteratee)(o);
                    if (2 == d)
                        o = p;
                    else if (!p) {
                        if (1 == d)
                            continue t;
                        break t
                    }
                }
                r[u++] = o
            }
            return r
        }
        ,
        kt.prototype.at = Ra,
        kt.prototype.chain = function() {
            return Gr(this)
        }
        ,
        kt.prototype.commit = function() {
            return new Et(this.value(),this.__chain__)
        }
        ,
        kt.prototype.next = function() {
            this.__values__ === R && (this.__values__ = ki(this.value()));
            var t = this.__index__ >= this.__values__.length;
            return {
                done: t,
                value: t ? R : this.__values__[this.__index__++]
            }
        }
        ,
        kt.prototype.plant = function(t) {
            for (var e, n = this; n instanceof _t; ) {
                var r = Hr(n);
                r.__index__ = 0,
                r.__values__ = R,
                e ? i.__wrapped__ = r : e = r;
                var i = r
                  , n = n.__wrapped__
            }
            return i.__wrapped__ = t,
            e
        }
        ,
        kt.prototype.reverse = function() {
            var t = this.__wrapped__;
            return t instanceof zt ? (this.__actions__.length && (t = new zt(this)),
            t = t.reverse(),
            t.__actions__.push({
                func: Qr,
                args: [Yr],
                thisArg: R
            }),
            new Et(t,this.__chain__)) : this.thru(Yr)
        }
        ,
        kt.prototype.toJSON = kt.prototype.valueOf = kt.prototype.value = function() {
            return Cn(this.__wrapped__, this.__actions__);
        }
        ,
        kt.prototype.first = kt.prototype.head,
        ko && (kt.prototype[ko] = Jr),
        kt
    }();
    "function" == typeof define && "object" == typeof define.amd && define.amd ? (Rt._ = ee,
    define(function() {
        return ee
    })) : Ht ? ((Ht.exports = ee)._ = ee,
    Ft._ = ee) : Rt._ = ee
}
.call(this),
/*! lazysizes.config.js */
// LazySizes Config
window.lazySizesConfig = window.lazySizesConfig || {},
window.lazySizesConfig.loadHidden = !1,
/*! lazysizes.min.js */
/*! lazysizes - v5.1.0 */
!function(t, e) {
    var n = e(t, t.document);
    t.lazySizes = n,
    "object" == typeof module && module.exports && (module.exports = n)
}("undefined" != typeof window ? window : {}, function(t, e) {
    "use strict";
    var n, r;
    if (function() {
        var e, n = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            autosizesClass: "lazyautosizes",
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            minSize: 40,
            customMedia: {},
            init: !0,
            expFactor: 1.5,
            hFac: .8,
            loadMode: 2,
            loadHidden: !0,
            ricTimeout: 0,
            throttleDelay: 125
        };
        r = t.lazySizesConfig || t.lazysizesConfig || {};
        for (e in n)
            e in r || (r[e] = n[e])
    }(),
    !e || !e.getElementsByClassName)
        return {
            init: function() {},
            cfg: r,
            noSupport: !0
        };
    var i = e.documentElement
      , o = t.Date
      , a = t.HTMLPictureElement
      , s = "addEventListener"
      , l = "getAttribute"
      , u = t[s]
      , c = t.setTimeout
      , d = t.requestAnimationFrame || c
      , p = t.requestIdleCallback
      , f = /^picture$/i
      , h = ["load", "error", "lazyincluded", "_lazyloaded"]
      , m = {}
      , g = Array.prototype.forEach
      , v = function(t, e) {
        return m[e] || (m[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")),
        m[e].test(t[l]("class") || "") && m[e]
    }
      , y = function(t, e) {
        v(t, e) || t.setAttribute("class", (t[l]("class") || "").trim() + " " + e)
    }
      , b = function(t, e) {
        var n;
        (n = v(t, e)) && t.setAttribute("class", (t[l]("class") || "").replace(n, " "))
    }
      , w = function(t, e, n) {
        var r = n ? s : "removeEventListener";
        n && w(t, e),
        h.forEach(function(n) {
            t[r](n, e)
        })
    }
      , x = function(t, r, i, o, a) {
        var s = e.createEvent("Event");
        return i || (i = {}),
        i.instance = n,
        s.initEvent(r, !o, !a),
        s.detail = i,
        t.dispatchEvent(s),
        s
    }
      , C = function(e, n) {
        var i;
        !a && (i = t.picturefill || r.pf) ? (n && n.src && !e[l]("srcset") && e.setAttribute("srcset", n.src),
        i({
            reevaluate: !0,
            elements: [e]
        })) : n && n.src && (e.src = n.src)
    }
      , k = function(t, e) {
        return (getComputedStyle(t, null) || {})[e]
    }
      , _ = function(t, e, n) {
        for (n = n || t.offsetWidth; n < r.minSize && e && !t._lazysizesWidth; )
            n = e.offsetWidth,
            e = e.parentNode;
        return n
    }
      , S = function() {
        var t, n, r = [], i = [], o = r, a = function() {
            var e = o;
            for (o = r.length ? i : r,
            t = !0,
            n = !1; e.length; )
                e.shift()();
            t = !1
        }, s = function(r, i) {
            t && !i ? r.apply(this, arguments) : (o.push(r),
            n || (n = !0,
            (e.hidden ? c : d)(a)))
        };
        return s._lsFlush = a,
        s
    }()
      , T = function(t, e) {
        return e ? function() {
            S(t)
        }
        : function() {
            var e = this
              , n = arguments;
            S(function() {
                t.apply(e, n)
            })
        }
    }
      , E = function(t) {
        var e, n = 0, i = r.throttleDelay, a = r.ricTimeout, s = function() {
            e = !1,
            n = o.now(),
            t()
        }, l = p && a > 49 ? function() {
            p(s, {
                timeout: a
            }),
            a !== r.ricTimeout && (a = r.ricTimeout)
        }
        : T(function() {
            c(s)
        }, !0);
        return function(t) {
            var r;
            (t = !0 === t) && (a = 33),
            e || (e = !0,
            r = i - (o.now() - n),
            r < 0 && (r = 0),
            t || r < 9 ? l() : c(l, r))
        }
    }
      , A = function(t) {
        var e, n, r = 99, i = function() {
            e = null,
            t()
        }, a = function() {
            var t = o.now() - n;
            t < r ? c(a, r - t) : (p || i)(i)
        };
        return function() {
            n = o.now(),
            e || (e = c(a, r))
        }
    }
      , M = function() {
        var a, d, p, h, m, _, M, L, I, j, z, N, P = /^img$/i, D = /^iframe$/i, $ = "onscroll"in t && !/(gle|ing)bot/.test(navigator.userAgent), R = 0, F = 0, H = 0, B = -1, q = function(t) {
            H--,
            (!t || H < 0 || !t.target) && (H = 0)
        }, W = function(t) {
            return null == N && (N = "hidden" == k(e.body, "visibility")),
            N || "hidden" != k(t.parentNode, "visibility") && "hidden" != k(t, "visibility")
        }, U = function(t, n) {
            var r, o = t, a = W(t);
            for (L -= n,
            z += n,
            I -= n,
            j += n; a && (o = o.offsetParent) && o != e.body && o != i; )
                (a = (k(o, "opacity") || 1) > 0) && "visible" != k(o, "overflow") && (r = o.getBoundingClientRect(),
                a = j > r.left && I < r.right && z > r.top - 1 && L < r.bottom + 1);
            return a
        }, V = function() {
            var t, o, s, u, c, p, f, m, g, v, y, b, w = n.elements;
            if ((h = r.loadMode) && H < 8 && (t = w.length)) {
                for (o = 0,
                B++; o < t; o++)
                    if (w[o] && !w[o]._lazyRace)
                        if (!$ || n.prematureUnveil && n.prematureUnveil(w[o]))
                            tt(w[o]);
                        else if ((m = w[o][l]("data-expand")) && (p = 1 * m) || (p = F),
                        v || (v = !r.expand || r.expand < 1 ? i.clientHeight > 500 && i.clientWidth > 500 ? 500 : 370 : r.expand,
                        n._defEx = v,
                        y = v * r.expFactor,
                        b = r.hFac,
                        N = null,
                        F < y && H < 1 && B > 2 && h > 2 && !e.hidden ? (F = y,
                        B = 0) : F = h > 1 && B > 1 && H < 6 ? v : R),
                        g !== p && (_ = innerWidth + p * b,
                        M = innerHeight + p,
                        f = -1 * p,
                        g = p),
                        s = w[o].getBoundingClientRect(),
                        (z = s.bottom) >= f && (L = s.top) <= M && (j = s.right) >= f * b && (I = s.left) <= _ && (z || j || I || L) && (r.loadHidden || W(w[o])) && (d && H < 3 && !m && (h < 3 || B < 4) || U(w[o], p))) {
                            if (tt(w[o]),
                            c = !0,
                            H > 9)
                                break
                        } else
                            !c && d && !u && H < 4 && B < 4 && h > 2 && (a[0] || r.preloadAfterLoad) && (a[0] || !m && (z || j || I || L || "auto" != w[o][l](r.sizesAttr))) && (u = a[0] || w[o]);
                u && !c && tt(u)
            }
        }, X = E(V), Y = function(t) {
            var e = t.target;
            return e._lazyCache ? void delete e._lazyCache : (q(t),
            y(e, r.loadedClass),
            b(e, r.loadingClass),
            w(e, K),
            x(e, "lazyloaded"),
            void 0)
        }, Z = T(Y), K = function(t) {
            Z({
                target: t.target
            })
        }, G = function(t, e) {
            try {
                t.contentWindow.location.replace(e)
            } catch (n) {
                t.src = e
            }
        }, Q = function(t) {
            var e, n = t[l](r.srcsetAttr);
            (e = r.customMedia[t[l]("data-media") || t[l]("media")]) && t.setAttribute("media", e),
            n && t.setAttribute("srcset", n)
        }, J = T(function(t, e, n, i, o) {
            var a, s, u, d, h, m;
            (h = x(t, "lazybeforeunveil", e)).defaultPrevented || (i && (n ? y(t, r.autosizesClass) : t.setAttribute("sizes", i)),
            s = t[l](r.srcsetAttr),
            a = t[l](r.srcAttr),
            o && (u = t.parentNode,
            d = u && f.test(u.nodeName || "")),
            m = e.firesLoad || "src"in t && (s || a || d),
            h = {
                target: t
            },
            y(t, r.loadingClass),
            m && (clearTimeout(p),
            p = c(q, 2500),
            w(t, K, !0)),
            d && g.call(u.getElementsByTagName("source"), Q),
            s ? t.setAttribute("srcset", s) : a && !d && (D.test(t.nodeName) ? G(t, a) : t.src = a),
            o && (s || d) && C(t, {
                src: a
            })),
            t._lazyRace && delete t._lazyRace,
            b(t, r.lazyClass),
            S(function() {
                var e = t.complete && t.naturalWidth > 1;
                m && !e || (e && y(t, "ls-is-cached"),
                Y(h),
                t._lazyCache = !0,
                c(function() {
                    "_lazyCache"in t && delete t._lazyCache
                }, 9)),
                "lazy" == t.loading && H--
            }, !0)
        }), tt = function(t) {
            if (!t._lazyRace) {
                var e, n = P.test(t.nodeName), i = n && (t[l](r.sizesAttr) || t[l]("sizes")), o = "auto" == i;
                (!o && d || !n || !t[l]("src") && !t.srcset || t.complete || v(t, r.errorClass) || !v(t, r.lazyClass)) && (e = x(t, "lazyunveilread").detail,
                o && O.updateElem(t, !0, t.offsetWidth),
                t._lazyRace = !0,
                H++,
                J(t, e, o, i, n))
            }
        }, et = A(function() {
            r.loadMode = 3,
            X()
        }), nt = function() {
            3 == r.loadMode && (r.loadMode = 2),
            et()
        }, rt = function() {
            if (!d) {
                if (o.now() - m < 999)
                    return void c(rt, 999);
                d = !0,
                r.loadMode = 3,
                X(),
                u("scroll", nt, !0)
            }
        };
        return {
            _: function() {
                m = o.now(),
                n.elements = e.getElementsByClassName(r.lazyClass),
                a = e.getElementsByClassName(r.lazyClass + " " + r.preloadClass),
                u("scroll", X, !0),
                u("resize", X, !0),
                t.MutationObserver ? new MutationObserver(X).observe(i, {
                    childList: !0,
                    subtree: !0,
                    attributes: !0
                }) : (i[s]("DOMNodeInserted", X, !0),
                i[s]("DOMAttrModified", X, !0),
                setInterval(X, 999)),
                u("hashchange", X, !0),
                ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(t) {
                    e[s](t, X, !0)
                }),
                /d$|^c/.test(e.readyState) ? rt() : (u("load", rt),
                e[s]("DOMContentLoaded", X),
                c(rt, 2e4)),
                n.elements.length ? (V(),
                S._lsFlush()) : X()
            },
            checkElems: X,
            unveil: tt,
            _aLSL: nt
        }
    }()
      , O = function() {
        var t, n = T(function(t, e, n, r) {
            var i, o, a;
            if (t._lazysizesWidth = r,
            r += "px",
            t.setAttribute("sizes", r),
            f.test(e.nodeName || ""))
                for (i = e.getElementsByTagName("source"),
                o = 0,
                a = i.length; o < a; o++)
                    i[o].setAttribute("sizes", r);
            n.detail.dataAttr || C(t, n.detail)
        }), i = function(t, e, r) {
            var i, o = t.parentNode;
            o && (r = _(t, o, r),
            i = x(t, "lazybeforesizes", {
                width: r,
                dataAttr: !!e
            }),
            i.defaultPrevented || (r = i.detail.width) && r !== t._lazysizesWidth && n(t, o, i, r))
        }, o = function() {
            var e, n = t.length;
            if (n)
                for (e = 0; e < n; e++)
                    i(t[e])
        }, a = A(o);
        return {
            _: function() {
                t = e.getElementsByClassName(r.autosizesClass),
                u("resize", a)
            },
            checkElems: a,
            updateElem: i
        }
    }()
      , L = function() {
        !L.i && e.getElementsByClassName && (L.i = !0,
        O._(),
        M._())
    };
    return c(function() {
        r.init && L()
    }),
    n = {
        cfg: r,
        autoSizer: O,
        loader: M,
        init: L,
        uP: C,
        aC: y,
        rC: b,
        hC: v,
        fire: x,
        gW: _,
        rAF: S
    }
}),
/*! lazysizes.respimg.min.js */
/*! lazysizes - v5.1.0 */
!function(t, e) {
    if (t) {
        var n = function() {
            e(t.lazySizes),
            t.removeEventListener("lazyunveilread", n, !0)
        };
        e = e.bind(null, t, t.document),
        "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
    }
}("undefined" != typeof window ? window : 0, function(t, e, n) {
    "use strict";
    var r, i = n.cfg, o = e.createElement("img"), a = "sizes"in o && "srcset"in o, s = /\s+\d+h/g, l = function() {
        var t = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , r = Array.prototype.forEach;
        return function() {
            var o = e.createElement("img")
              , a = function(e) {
                var n, r, o = e.getAttribute(i.srcsetAttr);
                o && (r = o.match(t)) && (n = "w" == r[2] ? r[1] / r[3] : r[3] / r[1],
                n && e.setAttribute("data-aspectratio", n),
                e.setAttribute(i.srcsetAttr, o.replace(s, "")))
            }
              , l = function(t) {
                if (t.detail.instance == n) {
                    var e = t.target.parentNode;
                    e && "PICTURE" == e.nodeName && r.call(e.getElementsByTagName("source"), a),
                    a(t.target)
                }
            }
              , u = function() {
                o.currentSrc && e.removeEventListener("lazybeforeunveil", l)
            };
            e.addEventListener("lazybeforeunveil", l),
            o.onload = u,
            o.onerror = u,
            o.srcset = "data:,a 1w 1h",
            o.complete && u()
        }
    }();
    return i.supportsType || (i.supportsType = function(t) {
        return !t
    }
    ),
    t.HTMLPictureElement && a ? void (!n.hasHDescriptorFix && e.msElementsFromPoint && (n.hasHDescriptorFix = !0,
    l())) : void (t.picturefill || i.pf || (i.pf = function(e) {
        var n, i;
        if (!t.picturefill)
            for (n = 0,
            i = e.elements.length; n < i; n++)
                r(e.elements[n])
    }
    ,
    r = function() {
        var o = function(t, e) {
            return t.w - e.w
        }
          , l = /^\s*\d+\.*\d*px\s*$/
          , u = function(t) {
            var e, n, r = t.length, i = t[r - 1], o = 0;
            for (o; o < r; o++)
                if (i = t[o],
                i.d = i.w / t.w,
                i.d >= t.d) {
                    !i.cached && (e = t[o - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (n = Math.pow(e.d - .6, 1.6),
                    e.cached && (e.d += .15 * n),
                    e.d + (i.d - t.d) * n > t.d && (i = e));
                    break
                }
            return i
        }
          , c = function() {
            var t, e = /(([^,\s].[^\s]+)\s+(\d+)w)/g, n = /\s/, r = function(e, n, r, i) {
                t.push({
                    c: n,
                    u: r,
                    w: 1 * i
                })
            };
            return function(i) {
                return t = [],
                i = i.trim(),
                i.replace(s, "").replace(e, r),
                t.length || !i || n.test(i) || t.push({
                    c: i,
                    u: i,
                    w: 99
                }),
                t
            }
        }()
          , d = function() {
            d.init || (d.init = !0,
            addEventListener("resize", function() {
                var t, n = e.getElementsByClassName("lazymatchmedia"), i = function() {
                    var t, e;
                    for (t = 0,
                    e = n.length; t < e; t++)
                        r(n[t])
                };
                return function() {
                    clearTimeout(t),
                    t = setTimeout(i, 66)
                }
            }()))
        }
          , p = function(e, r) {
            var o, a = e.getAttribute("srcset") || e.getAttribute(i.srcsetAttr);
            !a && r && (a = e._lazypolyfill ? e._lazypolyfill._set : e.getAttribute(i.srcAttr) || e.getAttribute("src")),
            e._lazypolyfill && e._lazypolyfill._set == a || (o = c(a || ""),
            r && e.parentNode && (o.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase(),
            o.isPicture && t.matchMedia && (n.aC(e, "lazymatchmedia"),
            d())),
            o._set = a,
            Object.defineProperty(e, "_lazypolyfill", {
                value: o,
                writable: !0
            }))
        }
          , f = function(e) {
            var r = t.devicePixelRatio || 1
              , i = n.getX && n.getX(e);
            return Math.min(i || r, 2.5, r)
        }
          , h = function(e) {
            return t.matchMedia ? (h = function(t) {
                return !t || (matchMedia(t) || {}).matches
            }
            )(e) : !e
        }
          , m = function(t) {
            var e, r, a, s, c, d, m;
            if (s = t,
            p(s, !0),
            c = s._lazypolyfill,
            c.isPicture)
                for (r = 0,
                e = t.parentNode.getElementsByTagName("source"),
                a = e.length; r < a; r++)
                    if (i.supportsType(e[r].getAttribute("type"), t) && h(e[r].getAttribute("media"))) {
                        s = e[r],
                        p(s),
                        c = s._lazypolyfill;
                        break
                    }
            return c.length > 1 ? (m = s.getAttribute("sizes") || "",
            m = l.test(m) && parseInt(m, 10) || n.gW(t, t.parentNode),
            c.d = f(t),
            !c.src || !c.w || c.w < m ? (c.w = m,
            d = u(c.sort(o)),
            c.src = d) : d = c.src) : d = c[0],
            d
        }
          , g = function(t) {
            if (!a || !t.parentNode || "PICTURE" == t.parentNode.nodeName.toUpperCase()) {
                var e = m(t);
                e && e.u && t._lazypolyfill.cur != e.u && (t._lazypolyfill.cur = e.u,
                e.cached = !0,
                t.setAttribute(i.srcAttr, e.u),
                t.setAttribute("src", e.u))
            }
        };
        return g.parse = c,
        g
    }(),
    i.loadedClass && i.loadingClass && function() {
        var t = [];
        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(e) {
            t.push(e + i.loadedClass),
            t.push(e + i.loadingClass)
        }),
        i.pf({
            elements: e.querySelectorAll(t.join(", "))
        })
    }()))
}),
/*! lazysizes.rias.min.js */
/*! lazysizes - v5.1.0 */
!function(t, e) {
    var n = function() {
        e(t.lazySizes),
        t.removeEventListener("lazyunveilread", n, !0)
    };
    e = e.bind(null, t, t.document),
    "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
}(window, function(t, e, n) {
    "use strict";
    function r(e, n) {
        var r, i, o, a, s = t.getComputedStyle(e);
        i = e.parentNode,
        a = {
            isPicture: !(!i || !f.test(i.nodeName || ""))
        },
        o = function(t, n) {
            var r = e.getAttribute("data-" + t);
            if (!r) {
                var i = s.getPropertyValue("--ls-" + t);
                i && (r = i.trim())
            }
            if (r) {
                if ("true" == r)
                    r = !0;
                else if ("false" == r)
                    r = !1;
                else if (p.test(r))
                    r = parseFloat(r);
                else if ("function" == typeof u[t])
                    r = u[t](e, r);
                else if (v.test(r))
                    try {
                        r = JSON.parse(r)
                    } catch (t) {}
                a[t] = r
            } else
                t in u && "function" != typeof u[t] ? a[t] = u[t] : n && "function" == typeof u[t] && (a[t] = u[t](e, r))
        }
        ;
        for (r in u)
            o(r);
        return n.replace(g, function(t, e) {
            e in a || o(e, !0)
        }),
        a
    }
    function i(t, e) {
        var n = []
          , r = function(t, n) {
            return d[typeof e[n]] ? e[n] : t
        };
        return n.srcset = [],
        e.absUrl && (b.setAttribute("href", t),
        t = b.href),
        t = ((e.prefix || "") + t + (e.postfix || "")).replace(g, r),
        e.widths.forEach(function(r) {
            var i = e.widthmap[r] || r
              , o = e.aspectratio || e.ratio
              , a = !e.aspectratio && u.traditionalRatio
              , s = {
                u: t.replace(h, i).replace(m, o ? a ? Math.round(r * o) : Math.round(r / o) : ""),
                w: r
            };
            n.push(s),
            n.srcset.push(s.c = s.u + " " + r + "w")
        }),
        n
    }
    function o(t, n, r) {
        var o = 0
          , a = 0
          , s = r;
        if (t) {
            if ("container" === n.ratio) {
                for (o = s.scrollWidth,
                a = s.scrollHeight; !(o && a || s === e); )
                    s = s.parentNode,
                    o = s.scrollWidth,
                    a = s.scrollHeight;
                o && a && (n.ratio = a / o)
            }
            t = i(t, n),
            t.isPicture = n.isPicture,
            x && "IMG" == r.nodeName.toUpperCase() ? r.removeAttribute(l.srcsetAttr) : r.setAttribute(l.srcsetAttr, t.srcset.join(", ")),
            Object.defineProperty(r, "_lazyrias", {
                value: t,
                writable: !0
            })
        }
    }
    function a(t, e) {
        var i = r(t, e);
        return u.modifyOptions.call(t, {
            target: t,
            details: i,
            detail: i
        }),
        n.fire(t, "lazyriasmodifyoptions", i),
        i
    }
    function s(t) {
        return t.getAttribute(t.getAttribute("data-srcattr") || u.srcAttr) || t.getAttribute(l.srcsetAttr) || t.getAttribute(l.srcAttr) || t.getAttribute("data-pfsrcset") || ""
    }
    var l, u, c = n.cfg, d = {
        string: 1,
        number: 1
    }, p = /^\-*\+*\d+\.*\d*$/, f = /^picture$/i, h = /\s*\{\s*width\s*\}\s*/i, m = /\s*\{\s*height\s*\}\s*/i, g = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, v = /^\[.*\]|\{.*\}$/, y = /^(?:auto|\d+(px)?)$/, b = e.createElement("a"), w = e.createElement("img"), x = "srcset"in w && !("sizes"in w), C = !!t.HTMLPictureElement && !x;
    !function() {
        var t, e = function() {}, r = {
            prefix: "",
            postfix: "",
            srcAttr: "data-src",
            absUrl: !1,
            modifyOptions: e,
            widthmap: {},
            ratio: !1,
            traditionalRatio: !1,
            aspectratio: !1
        };
        l = n && n.cfg,
        l.supportsType || (l.supportsType = function(t) {
            return !t
        }
        ),
        l.rias || (l.rias = {}),
        "widths"in (u = l.rias) || (u.widths = [],
        function(t) {
            for (var e, n = 0; !e || e < 3e3; )
                n += 5,
                n > 30 && (n += 1),
                e = 36 * n,
                t.push(e)
        }(u.widths));
        for (t in r)
            t in u || (u[t] = r[t])
    }(),
    addEventListener("lazybeforesizes", function(t) {
        if (t.detail.instance == n) {
            var e, r, i, c, d, p, f, m, g, v, b, w, x;
            if (e = t.target,
            t.detail.dataAttr && !t.defaultPrevented && !u.disabled && (g = e.getAttribute(l.sizesAttr) || e.getAttribute("sizes")) && y.test(g)) {
                if (r = s(e),
                i = a(e, r),
                b = h.test(i.prefix) || h.test(i.postfix),
                i.isPicture && (c = e.parentNode))
                    for (d = c.getElementsByTagName("source"),
                    p = 0,
                    f = d.length; p < f; p++)
                        (b || h.test(m = s(d[p]))) && (o(m, i, d[p]),
                        w = !0);
                b || h.test(r) ? (o(r, i, e),
                w = !0) : w && (x = [],
                x.srcset = [],
                x.isPicture = !0,
                Object.defineProperty(e, "_lazyrias", {
                    value: x,
                    writable: !0
                })),
                w && (C ? e.removeAttribute(l.srcAttr) : "auto" != g && (v = {
                    width: parseInt(g, 10)
                },
                k({
                    target: e,
                    detail: v
                })))
            }
        }
    }, !0);
    var k = function() {
        var r = function(t, e) {
            return t.w - e.w
        }
          , i = function(t) {
            var e, n, r = t.length, i = t[r - 1], o = 0;
            for (o; o < r; o++)
                if (i = t[o],
                i.d = i.w / t.w,
                i.d >= t.d) {
                    !i.cached && (e = t[o - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (n = Math.pow(e.d - .6, 1.6),
                    e.cached && (e.d += .15 * n),
                    e.d + (i.d - t.d) * n > t.d && (i = e));
                    break
                }
            return i
        }
          , o = function(t, e) {
            var r;
            return !t._lazyrias && n.pWS && (r = n.pWS(t.getAttribute(l.srcsetAttr || ""))).length && (Object.defineProperty(t, "_lazyrias", {
                value: r,
                writable: !0
            }),
            e && t.parentNode && (r.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase())),
            t._lazyrias
        }
          , a = function(e) {
            var r = t.devicePixelRatio || 1
              , i = n.getX && n.getX(e);
            return Math.min(i || r, 2.4, r)
        }
          , s = function(e, n) {
            var s, l, u, c, d, p;
            if (d = e._lazyrias,
            d.isPicture && t.matchMedia)
                for (l = 0,
                s = e.parentNode.getElementsByTagName("source"),
                u = s.length; l < u; l++)
                    if (o(s[l]) && !s[l].getAttribute("type") && (!(c = s[l].getAttribute("media")) || (matchMedia(c) || {}).matches)) {
                        d = s[l]._lazyrias;
                        break
                    }
            return (!d.w || d.w < n) && (d.w = n,
            d.d = a(e),
            p = i(d.sort(r))),
            p
        }
          , u = function(r) {
            if (r.detail.instance == n) {
                var i, a = r.target;
                if (!x && (t.respimage || t.picturefill || c.pf))
                    return void e.removeEventListener("lazybeforesizes", u);
                ("_lazyrias"in a || r.detail.dataAttr && o(a, !0)) && (i = s(a, r.detail.width)) && i.u && a._lazyrias.cur != i.u && (a._lazyrias.cur = i.u,
                i.cached = !0,
                n.rAF(function() {
                    a.setAttribute(l.srcAttr, i.u),
                    a.setAttribute("src", i.u)
                }))
            }
        };
        return C ? u = function() {}
        : addEventListener("lazybeforesizes", u),
        u
    }()
}),
/*! lazysizes.optimumx.min.js */
/*! lazysizes - v5.1.0 */
!function(t, e) {
    if (t) {
        var n = function() {
            e(t.lazySizes),
            t.removeEventListener("lazyunveilread", n, !0)
        };
        e = e.bind(null, t, t.document),
        "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
    }
}("undefined" != typeof window ? window : 0, function(t, e, n) {
    "use strict";
    if (t.addEventListener) {
        var r, i = /^picture$/i, o = e.documentElement, a = function() {
            var t, e = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g, n = function(e, n, r, i, o, a, s, l) {
                t.push({
                    c: n,
                    u: r,
                    w: 1 * ("w" == l ? s : i)
                })
            };
            return function(r) {
                return t = [],
                r.replace(e, n),
                t
            }
        }(), s = function() {
            var t = function(t, e) {
                return t.w - e.w
            }
              , e = function(e, r) {
                var i = {
                    srcset: e.getAttribute(n.cfg.srcsetAttr) || ""
                }
                  , o = a(i.srcset);
                return Object.defineProperty(e, r, {
                    value: i,
                    writable: !0
                }),
                i.cands = o,
                i.index = 0,
                i.dirty = !1,
                o[0] && o[0].w ? (o.sort(t),
                i.cSrcset = [o[i.index].c]) : (i.cSrcset = i.srcset ? [i.srcset] : [],
                i.cands = []),
                i
            };
            return function(t, n) {
                var r, o, a, s;
                if (!t[n] && (s = t.parentNode || {},
                t[n] = e(t, n),
                t[n].isImg = !0,
                i.test(s.nodeName || "")))
                    for (t[n].picture = !0,
                    r = s.getElementsByTagName("source"),
                    o = 0,
                    a = r.length; o < a; o++)
                        e(r[o], n).isImg = !1;
                return t[n]
            }
        }(), l = {
            _lazyOptimumx: function() {
                var t = function(t, e, n) {
                    var r, i;
                    return !t || !t.d || (i = n > .7 ? .6 : .4,
                    !(t.d >= n) && (r = Math.pow(t.d - i, 1.6) || .1,
                    r < .1 ? r = .1 : r > 3 && (r = 3),
                    t.d + (e - n) * r < n))
                };
                return function(e, n, r) {
                    var i, o;
                    for (i = 0; i < e.cands.length; i++)
                        if (o = e.cands[i],
                        o.d = (o.w || 1) / n,
                        !(e.index >= i)) {
                            if (!(o.d <= r || t(e.cands[i - 1], o.d, r)))
                                break;
                            e.cSrcset.push(o.c),
                            e.index = i
                        }
                }
            }()
        }, u = function() {
            var t = function(t, e, n, r, i) {
                var o, a = t[i];
                a && (o = a.index,
                l[i](a, e, n),
                a.dirty && o == a.index || (a.cSrcset.join(", "),
                t.setAttribute(r, a.cSrcset.join(", ")),
                a.dirty = !0))
            };
            return function(e, n, r, i, o) {
                var a, s, l, u, c = e[o];
                if (c.width = n,
                c.picture && (s = e.parentNode))
                    for (a = s.getElementsByTagName("source"),
                    u = 0,
                    l = a.length; u < l; u++)
                        t(a[u], n, r, i, o);
                t(e, n, r, i, o)
            }
        }(), c = function(t) {
            var e = t.getAttribute("data-optimumx") || t.getAttribute("data-maxdpr");
            return !e && r.constrainPixelDensity && (e = "auto"),
            e && (e = "auto" == e ? r.getOptimumX(t) : parseFloat(e, 10)),
            e
        }, d = function() {
            n && !n.getOptimumX && (n.getX = c,
            n.pWS = a,
            o.removeEventListener("lazybeforeunveil", d))
        };
        o.addEventListener("lazybeforeunveil", d),
        setTimeout(d),
        r = n && n.cfg,
        "function" != typeof r.getOptimumX && (r.getOptimumX = function() {
            var e = t.devicePixelRatio || 1;
            return e > 2.6 ? e *= .6 : e > 1.9 ? e *= .8 : e -= .01,
            Math.min(Math.round(100 * e) / 100, 2)
        }
        ),
        t.devicePixelRatio && addEventListener("lazybeforesizes", function(t) {
            if (t.detail.instance == n) {
                var e, i, o, a, l = t.target, d = t.detail, p = d.dataAttr;
                t.defaultPrevented || !(e = c(l)) || e >= devicePixelRatio || (!p || !l._lazyOptimumx || d.reloaded || r.unloadedClass && n.hC(l, r.unloadedClass) || (l._lazyOptimumx = null),
                i = s(l, "_lazyOptimumx"),
                (o = d.width) && (i.width || 0) < o && (a = p ? n.cfg.srcsetAttr : "srcset",
                n.rAF(function() {
                    u(l, o, e, a, "_lazyOptimumx")
                })))
            }
        })
    }
}),
/*! lazysizes.parentfit.min.js */
/*! lazysizes - v5.1.0 */
!function(t, e) {
    if (t) {
        var n = function() {
            e(t.lazySizes),
            t.removeEventListener("lazyunveilread", n, !0)
        };
        e = e.bind(null, t, t.document),
        "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
    }
}("undefined" != typeof window ? window : 0, function(t, e, n) {
    "use strict";
    if (t.addEventListener) {
        var r = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , i = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/
          , o = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/
          , a = /^picture$/i
          , s = n.cfg
          , l = function(t) {
            return getComputedStyle(t, null) || {}
        }
          , u = {
            getParent: function(e, n) {
                var r = e
                  , i = e.parentNode;
                return n && "prev" != n || !i || !a.test(i.nodeName || "") || (i = i.parentNode),
                "self" != n && (r = "prev" == n ? e.previousElementSibling : n && (i.closest || t.jQuery) ? (i.closest ? i.closest(n) : jQuery(i).closest(n)[0]) || i : i),
                r
            },
            getFit: function(t) {
                var e, n, r = l(t), a = r.content || r.fontFamily, s = {
                    fit: t._lazysizesParentFit || t.getAttribute("data-parent-fit")
                };
                return !s.fit && a && (e = a.match(i)) && (s.fit = e[1]),
                s.fit ? (n = t._lazysizesParentContainer || t.getAttribute("data-parent-container"),
                !n && a && (e = a.match(o)) && (n = e[1]),
                s.parent = u.getParent(t, n)) : s.fit = r.objectFit,
                s
            },
            getImageRatio: function(e) {
                var n, i, o, l, u, c, d, p = e.parentNode, f = p && a.test(p.nodeName || "") ? p.querySelectorAll("source, img") : [e];
                for (n = 0; n < f.length; n++)
                    if (e = f[n],
                    i = e.getAttribute(s.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || "",
                    o = e._lsMedia || e.getAttribute("media"),
                    o = s.customMedia[e.getAttribute("data-media") || o] || o,
                    i && (!o || (t.matchMedia && matchMedia(o) || {}).matches)) {
                        l = parseFloat(e.getAttribute("data-aspectratio")),
                        l || (u = i.match(r),
                        u ? "w" == u[2] ? (c = u[1],
                        d = u[3]) : (c = u[3],
                        d = u[1]) : (c = e.getAttribute("width"),
                        d = e.getAttribute("height")),
                        l = c / d);
                        break
                    }
                return l
            },
            calculateSize: function(t, e) {
                var n, r, i, o, a = this.getFit(t), s = a.fit, l = a.parent;
                return "width" == s || ("contain" == s || "cover" == s) && (i = this.getImageRatio(t)) ? (l ? e = l.clientWidth : l = t,
                o = e,
                "width" == s ? o = e : (r = l.clientHeight) > 40 && (n = e / r) && ("cover" == s && n < i || "contain" == s && n > i) && (o = e * (i / n)),
                o) : e
            }
        };
        n.parentFit = u,
        e.addEventListener("lazybeforesizes", function(t) {
            if (!t.defaultPrevented && t.detail.instance == n) {
                var e = t.target;
                t.detail.width = u.calculateSize(e, t.detail.width)
            }
        })
    }
}),
/*! lazysizes.bgset.min.js */
/*! lazysizes - v5.1.0 */
!function(t, e) {
    var n = function() {
        e(t.lazySizes),
        t.removeEventListener("lazyunveilread", n, !0)
    };
    e = e.bind(null, t, t.document),
    "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
}(window, function(t, e, n) {
    "use strict";
    if (t.addEventListener) {
        var r = n.cfg
          , i = /\s+/g
          , o = /\s*\|\s+|\s+\|\s*/g
          , a = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/
          , s = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/
          , l = /\(|\)|'/
          , u = {
            contain: 1,
            cover: 1
        }
          , c = function(t) {
            var e = n.gW(t, t.parentNode);
            return (!t._lazysizesWidth || e > t._lazysizesWidth) && (t._lazysizesWidth = e),
            t._lazysizesWidth
        }
          , d = function(t) {
            var e;
            return e = (getComputedStyle(t) || {
                getPropertyValue: function() {}
            }).getPropertyValue("background-size"),
            !u[e] && u[t.style.backgroundSize] && (e = t.style.backgroundSize),
            e
        }
          , p = function(t, e) {
            if (e) {
                var n = e.match(s);
                n && n[1] ? t.setAttribute("type", n[1]) : t.setAttribute("media", r.customMedia[e] || e)
            }
        }
          , f = function(t, n, s) {
            var l = e.createElement("picture")
              , u = n.getAttribute(r.sizesAttr)
              , c = n.getAttribute("data-ratio")
              , d = n.getAttribute("data-optimumx");
            n._lazybgset && n._lazybgset.parentNode == n && n.removeChild(n._lazybgset),
            Object.defineProperty(s, "_lazybgset", {
                value: n,
                writable: !0
            }),
            Object.defineProperty(n, "_lazybgset", {
                value: l,
                writable: !0
            }),
            t = t.replace(i, " ").split(o),
            l.style.display = "none",
            s.className = r.lazyClass,
            1 != t.length || u || (u = "auto"),
            t.forEach(function(t) {
                var n, i = e.createElement("source");
                u && "auto" != u && i.setAttribute("sizes", u),
                (n = t.match(a)) ? (i.setAttribute(r.srcsetAttr, n[1]),
                p(i, n[2]),
                p(i, n[3])) : i.setAttribute(r.srcsetAttr, t),
                l.appendChild(i)
            }),
            u && (s.setAttribute(r.sizesAttr, u),
            n.removeAttribute(r.sizesAttr),
            n.removeAttribute("sizes")),
            d && s.setAttribute("data-optimumx", d),
            c && s.setAttribute("data-ratio", c),
            l.appendChild(s),
            n.appendChild(l)
        }
          , h = function(t) {
            if (t.target._lazybgset) {
                var e = t.target
                  , r = e._lazybgset
                  , i = e.currentSrc || e.src;
                if (i) {
                    var o = n.fire(r, "bgsetproxy", {
                        src: i,
                        useSrc: l.test(i) ? JSON.stringify(i) : i
                    });
                    o.defaultPrevented || (r.style.backgroundImage = "url(" + o.detail.useSrc + ")")
                }
                e._lazybgsetLoading && (n.fire(r, "_lazyloaded", {}, !1, !0),
                delete e._lazybgsetLoading)
            }
        };
        addEventListener("lazybeforeunveil", function(t) {
            var r, i, o;
            !t.defaultPrevented && (r = t.target.getAttribute("data-bgset")) && (o = t.target,
            i = e.createElement("img"),
            i.alt = "",
            i._lazybgsetLoading = !0,
            t.detail.firesLoad = !0,
            f(r, o, i),
            setTimeout(function() {
                n.loader.unveil(i),
                n.rAF(function() {
                    n.fire(i, "_lazyloaded", {}, !0, !0),
                    i.complete && h({
                        target: i
                    })
                })
            }))
        }),
        e.addEventListener("load", h, !0),
        t.addEventListener("lazybeforesizes", function(t) {
            if (t.detail.instance == n && t.target._lazybgset && t.detail.dataAttr) {
                var e = t.target._lazybgset
                  , r = d(e);
                u[r] && (t.target._lazysizesParentFit = r,
                n.rAF(function() {
                    t.target.setAttribute("data-parent-fit", r),
                    t.target._lazysizesParentFit && delete t.target._lazysizesParentFit
                }))
            }
        }, !0),
        e.documentElement.addEventListener("lazybeforesizes", function(t) {
            !t.defaultPrevented && t.target._lazybgset && t.detail.instance == n && (t.detail.width = c(t.target._lazybgset))
        })
    }
});
for (var elems = document.querySelectorAll('a[href*="/account"], a[href*="/checkout"], a[href*="/cart"]'), i = elems.length - 1; i >= 0; i--) {
    elems[i].setAttribute("data-no-instant", "");
}
/*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */
window.onload = function () {
/*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */

let mouseoverTimer
let lastTouchTimestamp
const prefetches = new Set()
const prefetchElement = document.createElement('link')
const isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports('prefetch')
                    && window.IntersectionObserver && 'isIntersecting' in IntersectionObserverEntry.prototype
const allowQueryString = 'instantAllowQueryString' in document.body.dataset
const allowExternalLinks = 'instantAllowExternalLinks' in document.body.dataset
const useWhitelist = 'instantWhitelist' in document.body.dataset
const mousedownShortcut = 'instantMousedownShortcut' in document.body.dataset
const DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111

let delayOnHover = 65
let useMousedown = false
let useMousedownOnly = false
let useViewport = false

if ('instantIntensity' in document.body.dataset) {
  const intensity = document.body.dataset.instantIntensity

  if (intensity.substr(0, 'mousedown'.length) == 'mousedown') {
    useMousedown = true
    if (intensity == 'mousedown-only') {
      useMousedownOnly = true
    }
  }
  else if (intensity.substr(0, 'viewport'.length) == 'viewport') {
    if (!(navigator.connection && (navigator.connection.saveData || (navigator.connection.effectiveType && navigator.connection.effectiveType.includes('2g'))))) {
      if (intensity == "viewport") {
        /* Biggest iPhone resolution (which we want): 414 × 896 = 370944
         * Small 7" tablet resolution (which we don’t want): 600 × 1024 = 614400
         * Note that the viewport (which we check here) is smaller than the resolution due to the UI’s chrome */
        if (document.documentElement.clientWidth * document.documentElement.clientHeight < 450000) {
          useViewport = true
        }
      }
      else if (intensity == "viewport-all") {
        useViewport = true
      }
    }
  }
  else {
    const milliseconds = parseInt(intensity)
    if (!isNaN(milliseconds)) {
      delayOnHover = milliseconds
    }
  }
}

if (isSupported) {
  const eventListenersOptions = {
    capture: true,
    passive: true,
  }

  if (!useMousedownOnly) {
    document.addEventListener('touchstart', touchstartListener, eventListenersOptions)
  }

  if (!useMousedown) {
    document.addEventListener('mouseover', mouseoverListener, eventListenersOptions)
  }
  else if (!mousedownShortcut) {
      document.addEventListener('mousedown', mousedownListener, eventListenersOptions)
  }

  if (mousedownShortcut) {
    document.addEventListener('mousedown', mousedownShortcutListener, eventListenersOptions)
  }

  if (useViewport) {
    let triggeringFunction
    if (window.requestIdleCallback) {
      triggeringFunction = (callback) => {
        requestIdleCallback(callback, {
          timeout: 1500,
        })
      }
    }
    else {
      triggeringFunction = (callback) => {
        callback()
      }
    }

    triggeringFunction(() => {
      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const linkElement = entry.target
            intersectionObserver.unobserve(linkElement)
            preload(linkElement.href)
          }
        })
      })

      document.querySelectorAll('a').forEach((linkElement) => {
        if (isPreloadable(linkElement)) {
          intersectionObserver.observe(linkElement)
        }
      })
    })
  }
}

function touchstartListener(event) {
  /* Chrome on Android calls mouseover before touchcancel so `lastTouchTimestamp`
   * must be assigned on touchstart to be measured on mouseover. */
  lastTouchTimestamp = performance.now()

  const linkElement = event.target.closest('a')

  if (!isPreloadable(linkElement)) {
    return
  }

  preload(linkElement.href)
}

function mouseoverListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return
  }

  const linkElement = event.target.closest('a')

  if (!isPreloadable(linkElement)) {
    return
  }

  linkElement.addEventListener('mouseout', mouseoutListener, {passive: true})

  mouseoverTimer = setTimeout(() => {
    preload(linkElement.href)
    mouseoverTimer = undefined
  }, delayOnHover)
}

function mousedownListener(event) {
  const linkElement = event.target.closest('a')

  if (!isPreloadable(linkElement)) {
    return
  }

  preload(linkElement.href)
}

function mouseoutListener(event) {
  if (event.relatedTarget && event.target.closest('a') == event.relatedTarget.closest('a')) {
    return
  }

  if (mouseoverTimer) {
    clearTimeout(mouseoverTimer)
    mouseoverTimer = undefined
  }
}

function mousedownShortcutListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return
  }

  const linkElement = event.target.closest('a')

  if (event.which > 1 || event.metaKey || event.ctrlKey) {
    return
  }

  if (!linkElement) {
    return
  }

  linkElement.addEventListener('click', function (event) {
    if (event.detail == 1337) {
      return
    }

    event.preventDefault()
  }, {capture: true, passive: false, once: true})

  const customEvent = new MouseEvent('click', {view: window, bubbles: true, cancelable: false, detail: 1337})
  linkElement.dispatchEvent(customEvent)
}

function isPreloadable(linkElement) {
  if (!linkElement || !linkElement.href) {
    return
  }

  if (useWhitelist && !('instant' in linkElement.dataset)) {
    return
  }

  if (!allowExternalLinks && linkElement.origin != location.origin && !('instant' in linkElement.dataset)) {
    return
  }

  if (!['http:', 'https:'].includes(linkElement.protocol)) {
    return
  }

  if (linkElement.protocol == 'http:' && location.protocol == 'https:') {
    return
  }

  if (!allowQueryString && linkElement.search && !('instant' in linkElement.dataset)) {
    return
  }

  if (linkElement.hash && linkElement.pathname + linkElement.search == location.pathname + location.search) {
    return
  }

  if ('noInstant' in linkElement.dataset) {
    return
  }

  return true
}

function preload(url) {
  if (prefetches.has(url)) {
    return
  }

  const prefetcher = document.createElement('link')
  prefetcher.rel = 'prefetch'
  prefetcher.href = url
  document.head.appendChild(prefetcher)

  prefetches.add(url)
}
}
/*! preparetransition.min.js */
/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
!function(t) {
    t.fn.prepareTransition = function() {
        return this.each(function() {
            var e = t(this);
            e.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
                e.removeClass("is-transitioning")
            });
            var n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"]
              , r = 0;
            t.each(n, function(t, n) {
                r || (r = parseFloat(e.css(n)))
            }),
            0 != r && (e.addClass("is-transitioning"),
            e[0].offsetWidth)
        })
    }
}(jQuery),
/*! body-scroll-lock.min.js */
/*!
tua-body-scroll-lock
https://github.com/tuateam/tua-body-scroll-lock
*/
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = t || self).bodyScrollLock = {})
}(this, function(t) {
    "use strict";
    function e(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n,
        t
    }
    function n(t) {
        for (var n = 1; n < arguments.length; n++) {
            var r = null != arguments[n] ? arguments[n] : {}
              , i = Object.keys(r);
            "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(r).filter(function(t) {
                return Object.getOwnPropertyDescriptor(r, t).enumerable
            }))),
            i.forEach(function(n) {
                e(t, n, r[n])
            })
        }
        return t
    }
    var r, i = 0, o = 0, a = null, s = !1, l = "undefined" == typeof window, u = [], c = !l && document.querySelector.bind(document);
    if (!l) {
        var d = {
            get passive() {
                r = {
                    passive: !1
                }
            }
        };
        window.addEventListener("__TUA_BSL_TEST_PASSIVE__", null, d),
        window.removeEventListener("__TUA_BSL_TEST_PASSIVE__", null, d)
    }
    var p = function() {
        var t = navigator.userAgent
          , e = /(iPad).*OS\s([\d_]+)/.test(t)
          , n = !e && /(iPhone\sOS)\s([\d_]+)/.test(t)
          , r = /(Android);?[\s\/]+([\d.]+)?/.test(t);
        return {
            os: r ? "android" : "ios",
            ios: n || e,
            ipad: e,
            iphone: n,
            android: r
        }
    }
      , f = function(t) {
        t.cancelable && t.preventDefault()
    };
    t.lock = function(t) {
        var e, d, h, m, g;
        l || (p().ios ? (t && -1 === u.indexOf(t) && (t.ontouchstart = function(t) {
            o = t.targetTouches[0].clientY
        }
        ,
        t.ontouchmove = function(e) {
            1 === e.targetTouches.length && function(t, e) {
                var n = t.targetTouches[0].clientY - o;
                if (e) {
                    var r = e.scrollTop
                      , i = e.scrollHeight
                      , a = e.clientHeight;
                    if (n > 0 && 0 === r || n < 0 && r + a + 1 >= i)
                        return f(t)
                }
                t.stopPropagation()
            }(e, t)
        }
        ,
        u.push(t)),
        s || (document.addEventListener("touchmove", f, r),
        s = !0)) : i <= 0 && (a = p().android ? (e = c("html"),
        d = c("body"),
        h = e.scrollTop || d.scrollTop,
        m = n({}, e.style),
        g = n({}, d.style),
        e.style.height = "100%",
        e.style.overflow = "hidden",
        d.style.top = "-".concat(h, "px"),
        d.style.width = "100%",
        d.style.height = "auto",
        d.style.position = "fixed",
        d.style.overflow = "hidden",
        function() {
            e.style.height = m.height || "",
            e.style.overflow = m.overflow || "",
            ["top", "width", "height", "overflow", "position"].forEach(function(t) {
                d.style[t] = g[t] || ""
            }),
            window.scrollTo(0, h)
        }
        ) : function() {
            var t = c("body")
              , e = n({}, t.style)
              , r = window.innerWidth - document.body.clientWidth;
            return t.style.overflow = "hidden",
            t.style.boxSizing = "border-box",
            t.style.paddingRight = "".concat(r, "px"),
            function() {
                ["overflow", "boxSizing", "paddingRight"].forEach(function(n) {
                    t.style[n] = e[n] || ""
                })
            }
        }()),
        i += 1)
    }
    ,
    t.unlock = function(t) {
        if (!(l || (i -= 1) > 0))
            if (p().ios) {
                var e = u.indexOf(t);
                -1 !== e && (t.ontouchmove = null,
                t.ontouchstart = null,
                u.splice(e, 1)),
                s && (document.removeEventListener("touchmove", f, r),
                s = !1)
            } else
                i <= 0 && "function" == typeof a && a()
    }
    ,
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}),
/*! enquire.min.js */
/*! enquire.js v2.1.6 (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js MIT License */
!function(t) {
    if ("object" == typeof exports && "undefined" != typeof module)
        module.exports = t();
    else if ("function" == typeof define && define.amd)
        define([], t);
    else {
        var e;
        e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this,
        e.enquire = t()
    }
}(function() {
    return function t(e, n, r) {
        function i(a, s) {
            if (!n[a]) {
                if (!e[a]) {
                    var l = "function" == typeof require && require;
                    if (!s && l)
                        return l(a, !0);
                    if (o)
                        return o(a, !0);
                    var u = new Error("Cannot find module '" + a + "'");
                    throw u.code = "MODULE_NOT_FOUND",
                    u
                }
                var c = n[a] = {
                    exports: {}
                };
                e[a][0].call(c.exports, function(t) {
                    var n = e[a][1][t];
                    return i(n ? n : t)
                }, c, c.exports, t, e, n, r)
            }
            return n[a].exports
        }
        for (var o = "function" == typeof require && require, a = 0; a < r.length; a++)
            i(r[a]);
        return i
    }({
        1: [function(t, e, n) {
            function r(t, e) {
                this.query = t,
                this.isUnconditional = e,
                this.handlers = [],
                this.mql = window.matchMedia(t);
                var n = this;
                this.listener = function(t) {
                    n.mql = t.currentTarget || t,
                    n.assess()
                }
                ,
                this.mql.addListener(this.listener)
            }
            var i = t(3)
              , o = t(4).each;
            r.prototype = {
                constuctor: r,
                addHandler: function(t) {
                    var e = new i(t);
                    this.handlers.push(e),
                    this.matches() && e.on()
                },
                removeHandler: function(t) {
                    var e = this.handlers;
                    o(e, function(n, r) {
                        if (n.equals(t))
                            return n.destroy(),
                            !e.splice(r, 1)
                    })
                },
                matches: function() {
                    return this.mql.matches || this.isUnconditional
                },
                clear: function() {
                    o(this.handlers, function(t) {
                        t.destroy()
                    }),
                    this.mql.removeListener(this.listener),
                    this.handlers.length = 0
                },
                assess: function() {
                    var t = this.matches() ? "on" : "off";
                    o(this.handlers, function(e) {
                        e[t]()
                    })
                }
            },
            e.exports = r
        }
        , {
            3: 3,
            4: 4
        }],
        2: [function(t, e, n) {
            function r() {
                if (!window.matchMedia)
                    throw new Error("matchMedia not present, legacy browsers require a polyfill");
                this.queries = {},
                this.browserIsIncapable = !window.matchMedia("only all").matches
            }
            var i = t(1)
              , o = t(4)
              , a = o.each
              , s = o.isFunction
              , l = o.isArray;
            r.prototype = {
                constructor: r,
                register: function(t, e, n) {
                    var r = this.queries
                      , o = n && this.browserIsIncapable;
                    return r[t] || (r[t] = new i(t,o)),
                    s(e) && (e = {
                        match: e
                    }),
                    l(e) || (e = [e]),
                    a(e, function(e) {
                        s(e) && (e = {
                            match: e
                        }),
                        r[t].addHandler(e)
                    }),
                    this
                },
                unregister: function(t, e) {
                    var n = this.queries[t];
                    return n && (e ? n.removeHandler(e) : (n.clear(),
                    delete this.queries[t])),
                    this
                }
            },
            e.exports = r
        }
        , {
            1: 1,
            4: 4
        }],
        3: [function(t, e, n) {
            function r(t) {
                this.options = t,
                !t.deferSetup && this.setup()
            }
            r.prototype = {
                constructor: r,
                setup: function() {
                    this.options.setup && this.options.setup(),
                    this.initialised = !0
                },
                on: function() {
                    !this.initialised && this.setup(),
                    this.options.match && this.options.match()
                },
                off: function() {
                    this.options.unmatch && this.options.unmatch()
                },
                destroy: function() {
                    this.options.destroy ? this.options.destroy() : this.off()
                },
                equals: function(t) {
                    return this.options === t || this.options.match === t
                }
            },
            e.exports = r
        }
        , {}],
        4: [function(t, e, n) {
            function r(t, e) {
                var n = 0
                  , r = t.length;
                for (n; n < r && e(t[n], n) !== !1; n++)
                    ;
            }
            function i(t) {
                return "[object Array]" === Object.prototype.toString.apply(t)
            }
            function o(t) {
                return "function" == typeof t
            }
            e.exports = {
                isFunction: o,
                isArray: i,
                each: r
            }
        }
        , {}],
        5: [function(t, e, n) {
            var r = t(2);
            e.exports = new r
        }
        , {
            2: 2
        }]
    }, {}, [5])(5)
}),
/*! mobile-sniff.min.js */
/* isMobile.js v0.4.1 https://github.com/kaimallea/isMobile/ */
!function(t) {
    var e = /iPhone/i
      , n = /iPod/i
      , r = /iPad/i
      , i = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i
      , o = /Android/i
      , a = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i
      , s = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i
      , l = /Windows Phone/i
      , u = /(?=.*\bWindows\b)(?=.*\bARM\b)/i
      , c = /BlackBerry/i
      , d = /BB10/i
      , p = /Opera Mini/i
      , f = /(CriOS|Chrome)(?=.*\bMobile\b)/i
      , h = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i
      , m = new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i")
      , g = function(t, e) {
        return t.test(e)
    }
      , v = function(t) {
        var v = t || navigator.userAgent
          , y = v.split("[FBAN");
        if ("undefined" != typeof y[1] && (v = y[0]),
        y = v.split("Twitter"),
        "undefined" != typeof y[1] && (v = y[0]),
        this.apple = {
            phone: g(e, v),
            ipod: g(n, v),
            tablet: !g(e, v) && g(r, v),
            device: g(e, v) || g(n, v) || g(r, v)
        },
        this.amazon = {
            phone: g(a, v),
            tablet: !g(a, v) && g(s, v),
            device: g(a, v) || g(s, v)
        },
        this.android = {
            phone: g(a, v) || g(i, v),
            tablet: !g(a, v) && !g(i, v) && (g(s, v) || g(o, v)),
            device: g(a, v) || g(s, v) || g(i, v) || g(o, v)
        },
        this.windows = {
            phone: g(l, v),
            tablet: g(u, v),
            device: g(l, v) || g(u, v)
        },
        this.other = {
            blackberry: g(c, v),
            blackberry10: g(d, v),
            opera: g(p, v),
            firefox: g(h, v),
            chrome: g(f, v),
            device: g(c, v) || g(d, v) || g(p, v) || g(h, v) || g(f, v)
        },
        this.seven_inch = g(m, v),
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch,
        this.phone = this.apple.phone || this.android.phone || this.windows.phone,
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet,
        "undefined" == typeof window)
            return this
    }
      , y = function() {
        var t = new v;
        return t.Class = v,
        t
    };
    "undefined" != typeof module && module.exports && "undefined" == typeof window ? module.exports = v : "undefined" != typeof module && module.exports && "undefined" != typeof window ? module.exports = y() : "function" == typeof define && define.amd ? define("isMobile", [], t.isMobile = y()) : t.isMobile = y()
}(this),
/*! anime.min.js */
/*
 * anime.js v3.0.1
 * (c) 2019 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.anime = e()
}(this, function() {
    "use strict";
    function t(t, e, n) {
        return Math.min(Math.max(t, e), n)
    }
    function e(t, e) {
        return t.indexOf(e) > -1
    }
    function n(t, e) {
        return t.apply(null, e)
    }
    function r(t) {
        var e = /\(([^)]+)\)/.exec(t);
        return e ? e[1].split(",").map(function(t) {
            return parseFloat(t)
        }) : []
    }
    function i(e, n) {
        function i(t) {
            var e = n ? n * t / 1e3 : t;
            return e = d < 1 ? Math.exp(-e * d * c) * (f * Math.cos(p * e) + h * Math.sin(p * e)) : (f + h * e) * Math.exp(-e * c),
            0 === t || 1 === t ? t : 1 - e
        }
        var o = r(e)
          , a = t(Z.und(o[0]) ? 1 : o[0], .1, 100)
          , s = t(Z.und(o[1]) ? 100 : o[1], .1, 100)
          , l = t(Z.und(o[2]) ? 10 : o[2], .1, 100)
          , u = t(Z.und(o[3]) ? 0 : o[3], .1, 100)
          , c = Math.sqrt(s / a)
          , d = l / (2 * Math.sqrt(s * a))
          , p = d < 1 ? c * Math.sqrt(1 - d * d) : 0
          , f = 1
          , h = d < 1 ? (d * c - u) / p : -u + c;
        return n ? i : function() {
            var t = Y.springs[e];
            if (t)
                return t;
            for (var n = 0, r = 0; ; )
                if (1 === i(n += 1 / 6)) {
                    if (++r >= 16)
                        break
                } else
                    r = 0;
            var o = n * (1 / 6) * 1e3;
            return Y.springs[e] = o,
            o
        }
    }
    function o(e, n) {
        void 0 === e && (e = 1),
        void 0 === n && (n = .5);
        var r = t(e, 1, 10)
          , i = t(n, .1, 2);
        return function(t) {
            return 0 === t || 1 === t ? t : -r * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - i / (2 * Math.PI) * Math.asin(1 / r)) * (2 * Math.PI) / i)
        }
    }
    function a(t) {
        return void 0 === t && (t = 10),
        function(e) {
            return Math.round(e * t) * (1 / t)
        }
    }
    function s(t, e) {
        if (Z.fnc(t))
            return t;
        var o = t.split("(")[0]
          , s = G[o]
          , l = r(t);
        switch (o) {
        case "spring":
            return i(t, e);
        case "cubicBezier":
            return n(K, l);
        case "steps":
            return n(a, l);
        default:
            return Z.fnc(s) ? n(s, l) : n(K, s)
        }
    }
    function l(t) {
        try {
            return document.querySelectorAll(t)
        } catch (t) {
            return
        }
    }
    function u(t, e) {
        for (var n = t.length, r = arguments.length >= 2 ? arguments[1] : void 0, i = [], o = 0; o < n; o++)
            if (o in t) {
                var a = t[o];
                e.call(r, a, o, t) && i.push(a)
            }
        return i
    }
    function c(t) {
        return t.reduce(function(t, e) {
            return t.concat(Z.arr(e) ? c(e) : e)
        }, [])
    }
    function d(t) {
        return Z.arr(t) ? t : (Z.str(t) && (t = l(t) || t),
        t instanceof NodeList || t instanceof HTMLCollection ? [].slice.call(t) : [t])
    }
    function p(t, e) {
        return t.some(function(t) {
            return t === e
        })
    }
    function f(t) {
        var e = {};
        for (var n in t)
            e[n] = t[n];
        return e
    }
    function h(t, e) {
        var n = f(t);
        for (var r in t)
            n[r] = e.hasOwnProperty(r) ? e[r] : t[r];
        return n
    }
    function m(t, e) {
        var n = f(t);
        for (var r in e)
            n[r] = Z.und(t[r]) ? e[r] : t[r];
        return n
    }
    function g(t) {
        return Z.rgb(t) ? (n = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(e = t)) ? "rgba(" + n[1] + ",1)" : e : Z.hex(t) ? (r = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(t, e, n, r) {
            return e + e + n + n + r + r
        }),
        i = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(r),
        "rgba(" + parseInt(i[1], 16) + "," + parseInt(i[2], 16) + "," + parseInt(i[3], 16) + ",1)") : Z.hsl(t) ? function(t) {
            function e(t, e, n) {
                return n < 0 && (n += 1),
                n > 1 && (n -= 1),
                n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t
            }
            var n, r, i, o = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t), a = parseInt(o[1], 10) / 360, s = parseInt(o[2], 10) / 100, l = parseInt(o[3], 10) / 100, u = o[4] || 1;
            if (0 == s)
                n = r = i = l;
            else {
                var c = l < .5 ? l * (1 + s) : l + s - l * s
                  , d = 2 * l - c;
                n = e(d, c, a + 1 / 3),
                r = e(d, c, a),
                i = e(d, c, a - 1 / 3)
            }
            return "rgba(" + 255 * n + "," + 255 * r + "," + 255 * i + "," + u + ")"
        }(t) : void 0;
        var e, n, r, i
    }
    function v(t) {
        var e = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t);
        if (e)
            return e[2]
    }
    function y(t, e) {
        return Z.fnc(t) ? t(e.target, e.id, e.total) : t
    }
    function b(t, e) {
        return t.getAttribute(e)
    }
    function w(t, e, n) {
        if (p([n, "deg", "rad", "turn"], v(e)))
            return e;
        var r = Y.CSS[e + n];
        if (!Z.und(r))
            return r;
        var i = document.createElement(t.tagName)
          , o = t.parentNode && t.parentNode !== document ? t.parentNode : document.body;
        o.appendChild(i),
        i.style.position = "absolute",
        i.style.width = 100 + n;
        var a = 100 / i.offsetWidth;
        o.removeChild(i);
        var s = a * parseFloat(e);
        return Y.CSS[e + n] = s,
        s
    }
    function x(t, e, n) {
        if (e in t.style) {
            var r = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
              , i = t.style[e] || getComputedStyle(t).getPropertyValue(r) || "0";
            return n ? w(t, i, n) : i
        }
    }
    function C(t, e) {
        return Z.dom(t) && !Z.inp(t) && (b(t, e) || Z.svg(t) && t[e]) ? "attribute" : Z.dom(t) && p(X, e) ? "transform" : Z.dom(t) && "transform" !== e && x(t, e) ? "css" : null != t[e] ? "object" : void 0
    }
    function k(t) {
        if (Z.dom(t)) {
            for (var e, n = t.style.transform || "", r = /(\w+)\(([^)]*)\)/g, i = new Map; e = r.exec(n); )
                i.set(e[1], e[2]);
            return i
        }
    }
    function _(t, n, r, i) {
        var o, a = e(n, "scale") ? 1 : 0 + (e(o = n, "translate") || "perspective" === o ? "px" : e(o, "rotate") || e(o, "skew") ? "deg" : void 0), s = k(t).get(n) || a;
        return r && (r.transforms.list.set(n, s),
        r.transforms.last = n),
        i ? w(t, s, i) : s
    }
    function S(t, e, n, r) {
        switch (C(t, e)) {
        case "transform":
            return _(t, e, r, n);
        case "css":
            return x(t, e, n);
        case "attribute":
            return b(t, e);
        default:
            return t[e] || 0
        }
    }
    function T(t, e) {
        var n = /^(\*=|\+=|-=)/.exec(t);
        if (!n)
            return t;
        var r = v(t) || 0
          , i = parseFloat(e)
          , o = parseFloat(t.replace(n[0], ""));
        switch (n[0][0]) {
        case "+":
            return i + o + r;
        case "-":
            return i - o + r;
        case "*":
            return i * o + r
        }
    }
    function E(t, e) {
        if (Z.col(t))
            return g(t);
        var n = v(t)
          , r = n ? t.substr(0, t.length - n.length) : t;
        return e && !/\s/g.test(t) ? r + e : r
    }
    function A(t, e) {
        return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))
    }
    function M(t) {
        for (var e, n = t.points, r = 0, i = 0; i < n.numberOfItems; i++) {
            var o = n.getItem(i);
            i > 0 && (r += A(e, o)),
            e = o
        }
        return r
    }
    function O(t) {
        if (t.getTotalLength)
            return t.getTotalLength();
        switch (t.tagName.toLowerCase()) {
        case "circle":
            return o = t,
            2 * Math.PI * b(o, "r");
        case "rect":
            return 2 * b(i = t, "width") + 2 * b(i, "height");
        case "line":
            return A({
                x: b(r = t, "x1"),
                y: b(r, "y1")
            }, {
                x: b(r, "x2"),
                y: b(r, "y2")
            });
        case "polyline":
            return M(t);
        case "polygon":
            return n = (e = t).points,
            M(e) + A(n.getItem(n.numberOfItems - 1), n.getItem(0))
        }
        var e, n, r, i, o
    }
    function L(t, e) {
        var n = e || {}
          , r = n.el || function(t) {
            for (var e = t.parentNode; Z.svg(e) && (e = e.parentNode,
            Z.svg(e.parentNode)); )
                ;
            return e
        }(t)
          , i = r.getBoundingClientRect()
          , o = b(r, "viewBox")
          , a = i.width
          , s = i.height
          , l = n.viewBox || (o ? o.split(" ") : [0, 0, a, s]);
        return {
            el: r,
            viewBox: l,
            x: l[0] / 1,
            y: l[1] / 1,
            w: a / l[2],
            h: s / l[3]
        }
    }
    function I(t, e) {
        function n(n) {
            void 0 === n && (n = 0);
            var r = e + n >= 1 ? e + n : 0;
            return t.el.getPointAtLength(r)
        }
        var r = L(t.el, t.svg)
          , i = n()
          , o = n(-1)
          , a = n(1);
        switch (t.property) {
        case "x":
            return (i.x - r.x) * r.w;
        case "y":
            return (i.y - r.y) * r.h;
        case "angle":
            return 180 * Math.atan2(a.y - o.y, a.x - o.x) / Math.PI
        }
    }
    function j(t, e) {
        var n = /-?\d*\.?\d+/g
          , r = E(Z.pth(t) ? t.totalLength : t, e) + "";
        return {
            original: r,
            numbers: r.match(n) ? r.match(n).map(Number) : [0],
            strings: Z.str(t) || e ? r.split(n) : []
        }
    }
    function z(t) {
        return u(t ? c(Z.arr(t) ? t.map(d) : d(t)) : [], function(t, e, n) {
            return n.indexOf(t) === e
        })
    }
    function N(t) {
        var e = z(t);
        return e.map(function(t, n) {
            return {
                target: t,
                id: n,
                total: e.length,
                transforms: {
                    list: k(t)
                }
            }
        })
    }
    function P(t, e) {
        var n = f(e);
        if (/^spring/.test(n.easing) && (n.duration = i(n.easing)),
        Z.arr(t)) {
            var r = t.length;
            2 !== r || Z.obj(t[0]) ? Z.fnc(e.duration) || (n.duration = e.duration / r) : t = {
                value: t
            }
        }
        var o = Z.arr(t) ? t : [t];
        return o.map(function(t, n) {
            var r = Z.obj(t) && !Z.pth(t) ? t : {
                value: t
            };
            return Z.und(r.delay) && (r.delay = n ? 0 : e.delay),
            Z.und(r.endDelay) && (r.endDelay = n === o.length - 1 ? e.endDelay : 0),
            r
        }).map(function(t) {
            return m(t, n)
        })
    }
    function D(t, e) {
        var n = []
          , r = e.keyframes;
        for (var i in r && (e = m(function(t) {
            for (var e = u(c(t.map(function(t) {
                return Object.keys(t)
            })), function(t) {
                return Z.key(t)
            }).reduce(function(t, e) {
                return t.indexOf(e) < 0 && t.push(e),
                t
            }, []), n = {}, r = function(r) {
                var i = e[r];
                n[i] = t.map(function(t) {
                    var e = {};
                    for (var n in t)
                        Z.key(n) ? n == i && (e.value = t[n]) : e[n] = t[n];
                    return e
                })
            }, i = 0; i < e.length; i++)
                r(i);
            return n
        }(r), e)),
        e)
            Z.key(i) && n.push({
                name: i,
                tweens: P(e[i], t)
            });
        return n
    }
    function $(t, e) {
        var n;
        return t.tweens.map(function(r) {
            var i = function(t, e) {
                var n = {};
                for (var r in t) {
                    var i = y(t[r], e);
                    Z.arr(i) && 1 === (i = i.map(function(t) {
                        return y(t, e)
                    })).length && (i = i[0]),
                    n[r] = i
                }
                return n.duration = parseFloat(n.duration),
                n.delay = parseFloat(n.delay),
                n
            }(r, e)
              , o = i.value
              , a = Z.arr(o) ? o[1] : o
              , l = v(a)
              , u = S(e.target, t.name, l, e)
              , c = n ? n.to.original : u
              , d = Z.arr(o) ? o[0] : c
              , p = v(d) || v(u)
              , f = l || p;
            return Z.und(a) && (a = c),
            i.from = j(d, f),
            i.to = j(T(a, d), f),
            i.start = n ? n.end : 0,
            i.end = i.start + i.delay + i.duration + i.endDelay,
            i.easing = s(i.easing, i.duration),
            i.isPath = Z.pth(o),
            i.isColor = Z.col(i.from.original),
            i.isColor && (i.round = 1),
            n = i,
            i
        })
    }
    function R(t, e) {
        N(t).forEach(function(t) {
            for (var n in e) {
                var r = y(e[n], t)
                  , i = t.target
                  , o = v(r)
                  , a = S(i, n, o, t)
                  , s = T(E(r, o || v(a)), a)
                  , l = C(i, n);
                Q[l](i, n, s, t.transforms, !0)
            }
        })
    }
    function F(t, e) {
        return u(c(t.map(function(t) {
            return e.map(function(e) {
                return function(t, e) {
                    var n = C(t.target, e.name);
                    if (n) {
                        var r = $(e, t)
                          , i = r[r.length - 1];
                        return {
                            type: n,
                            property: e.name,
                            animatable: t,
                            tweens: r,
                            duration: i.end,
                            delay: r[0].delay,
                            endDelay: i.endDelay
                        }
                    }
                }(t, e)
            })
        })), function(t) {
            return !Z.und(t)
        })
    }
    function H(t, e) {
        var n = t.length
          , r = function(t) {
            return t.timelineOffset ? t.timelineOffset : 0
        }
          , i = {};
        return i.duration = n ? Math.max.apply(Math, t.map(function(t) {
            return r(t) + t.duration
        })) : e.duration,
        i.delay = n ? Math.min.apply(Math, t.map(function(t) {
            return r(t) + t.delay
        })) : e.delay,
        i.endDelay = n ? i.duration - Math.max.apply(Math, t.map(function(t) {
            return r(t) + t.duration - t.endDelay
        })) : e.endDelay,
        i
    }
    function B(e) {
        function n(t) {
            var e = window.Promise && new Promise(function(t) {
                return T = t
            }
            );
            return t.finished = e,
            e
        }
        function r() {
            var t = E.direction;
            "alternate" !== t && (E.direction = "normal" !== t ? "normal" : "reverse"),
            E.reversed = !E.reversed,
            d.forEach(function(t) {
                return t.reversed = E.reversed
            })
        }
        function i(t) {
            return E.reversed ? E.duration - t : t
        }
        function o() {
            C = 0,
            k = i(E.currentTime) * (1 / B.speed)
        }
        function a(t, e) {
            e && e.seek(t - e.timelineOffset)
        }
        function s(e) {
            for (var n = 0, r = E.animations, i = r.length; n < i; ) {
                var o = r[n]
                  , a = o.animatable
                  , s = o.tweens
                  , l = s.length - 1
                  , c = s[l];
                l && (c = u(s, function(t) {
                    return e < t.end
                })[0] || c);
                for (var d = t(e - c.start - c.delay, 0, c.duration) / c.duration, p = isNaN(d) ? 1 : c.easing(d), f = c.to.strings, h = c.round, m = [], g = c.to.numbers.length, v = void 0, y = 0; y < g; y++) {
                    var b = void 0
                      , w = c.to.numbers[y]
                      , x = c.from.numbers[y] || 0;
                    b = c.isPath ? I(c.value, p * w) : x + p * (w - x),
                    h && (c.isColor && y > 2 || (b = Math.round(b * h) / h)),
                    m.push(b)
                }
                var C = f.length;
                if (C) {
                    v = f[0];
                    for (var k = 0; k < C; k++) {
                        f[k];
                        var _ = f[k + 1]
                          , S = m[k];
                        isNaN(S) || (v += _ ? S + _ : S + " ")
                    }
                } else
                    v = m[0];
                Q[o.type](a.target, o.property, v, a.transforms),
                o.currentValue = v,
                n++
            }
        }
        function l(t) {
            E[t] && !E.passThrough && E[t](E)
        }
        function c(e) {
            var o = E.duration
              , u = E.delay
              , c = o - E.endDelay
              , p = i(e);
            E.progress = t(p / o * 100, 0, 100),
            E.reversePlayback = p < E.currentTime,
            d && function(t) {
                if (E.reversePlayback)
                    for (var e = S; e--; )
                        a(t, d[e]);
                else
                    for (var n = 0; n < S; n++)
                        a(t, d[n])
            }(p),
            !E.began && E.currentTime > 0 && (E.began = !0,
            l("begin"),
            l("loopBegin")),
            p <= u && 0 !== E.currentTime && s(0),
            (p >= c && E.currentTime !== o || !o) && s(o),
            p > u && p < c ? (E.changeBegan || (E.changeBegan = !0,
            E.changeCompleted = !1,
            l("changeBegin")),
            l("change"),
            s(p)) : E.changeBegan && (E.changeCompleted = !0,
            E.changeBegan = !1,
            l("changeComplete")),
            E.currentTime = t(p, 0, o),
            E.began && l("update"),
            e >= o && (k = 0,
            E.remaining && !0 !== E.remaining && E.remaining--,
            E.remaining ? (C = _,
            l("loopComplete"),
            l("loopBegin"),
            "alternate" === E.direction && r()) : (E.paused = !0,
            E.completed || (E.completed = !0,
            l("loopComplete"),
            l("complete"),
            !E.passThrough && "Promise"in window && (T(),
            n(E)))))
        }
        void 0 === e && (e = {});
        var d, p, f, g, v, y, b, w, x, C = 0, k = 0, _ = 0, S = 0, T = null, E = (f = h(U, p = e),
        g = h(V, p),
        v = D(g, p),
        y = N(p.targets),
        b = F(y, v),
        w = H(b, g),
        x = J,
        J++,
        m(f, {
            id: x,
            children: [],
            animatables: y,
            animations: b,
            duration: w.duration,
            delay: w.delay,
            endDelay: w.endDelay
        }));
        return n(E),
        E.reset = function() {
            var t = E.direction;
            E.passThrough = !1,
            E.currentTime = 0,
            E.progress = 0,
            E.paused = !0,
            E.began = !1,
            E.changeBegan = !1,
            E.completed = !1,
            E.changeCompleted = !1,
            E.reversePlayback = !1,
            E.reversed = "reverse" === t,
            E.remaining = E.loop,
            d = E.children;
            for (var e = S = d.length; e--; )
                E.children[e].reset();
            (E.reversed && !0 !== E.loop || "alternate" === t && 1 === E.loop) && E.remaining++,
            s(0)
        }
        ,
        E.set = function(t, e) {
            return R(t, e),
            E
        }
        ,
        E.tick = function(t) {
            _ = t,
            C || (C = _),
            c((_ + (k - C)) * B.speed)
        }
        ,
        E.seek = function(t) {
            c(i(t))
        }
        ,
        E.pause = function() {
            E.paused = !0,
            o()
        }
        ,
        E.play = function() {
            E.paused && (E.completed && E.reset(),
            E.paused = !1,
            tt.push(E),
            o(),
            W || nt())
        }
        ,
        E.reverse = function() {
            r(),
            o()
        }
        ,
        E.restart = function() {
            E.reset(),
            E.play()
        }
        ,
        E.reset(),
        E.autoplay && E.play(),
        E
    }
    function q(t, e) {
        for (var n = e.length; n--; )
            p(t, e[n].animatable.target) && e.splice(n, 1)
    }
    var W, U = {
        update: null,
        begin: null,
        loopBegin: null,
        changeBegin: null,
        change: null,
        changeComplete: null,
        loopComplete: null,
        complete: null,
        loop: 1,
        direction: "normal",
        autoplay: !0,
        timelineOffset: 0
    }, V = {
        duration: 1e3,
        delay: 0,
        endDelay: 0,
        easing: "easeOutElastic(1, .5)",
        round: 0
    }, X = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective"], Y = {
        CSS: {},
        springs: {}
    }, Z = {
        arr: function(t) {
            return Array.isArray(t)
        },
        obj: function(t) {
            return e(Object.prototype.toString.call(t), "Object")
        },
        pth: function(t) {
            return Z.obj(t) && t.hasOwnProperty("totalLength")
        },
        svg: function(t) {
            return t instanceof SVGElement
        },
        inp: function(t) {
            return t instanceof HTMLInputElement
        },
        dom: function(t) {
            return t.nodeType || Z.svg(t)
        },
        str: function(t) {
            return "string" == typeof t
        },
        fnc: function(t) {
            return "function" == typeof t
        },
        und: function(t) {
            return void 0 === t
        },
        hex: function(t) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)
        },
        rgb: function(t) {
            return /^rgb/.test(t)
        },
        hsl: function(t) {
            return /^hsl/.test(t)
        },
        col: function(t) {
            return Z.hex(t) || Z.rgb(t) || Z.hsl(t)
        },
        key: function(t) {
            return !U.hasOwnProperty(t) && !V.hasOwnProperty(t) && "targets" !== t && "keyframes" !== t
        }
    }, K = function() {
        function t(t, e) {
            return 1 - 3 * e + 3 * t
        }
        function e(t, e) {
            return 3 * e - 6 * t
        }
        function n(t) {
            return 3 * t
        }
        function r(r, i, o) {
            return ((t(i, o) * r + e(i, o)) * r + n(i)) * r
        }
        function i(r, i, o) {
            return 3 * t(i, o) * r * r + 2 * e(i, o) * r + n(i)
        }
        var o = 11
          , a = 1 / (o - 1);
        return function(t, e, n, s) {
            function l(e) {
                for (var s = 0, l = 1, c = o - 1; l !== c && u[l] <= e; ++l)
                    s += a;
                var d = s + (e - u[--l]) / (u[l + 1] - u[l]) * a
                  , p = i(d, t, n);
                return p >= .001 ? function(t, e, n, o) {
                    for (var a = 0; a < 4; ++a) {
                        var s = i(e, n, o);
                        if (0 === s)
                            return e;
                        e -= (r(e, n, o) - t) / s
                    }
                    return e
                }(e, d, t, n) : 0 === p ? d : function(t, e, n, i, o) {
                    for (var a, s, l = 0; (a = r(s = e + (n - e) / 2, i, o) - t) > 0 ? n = s : e = s,
                    Math.abs(a) > 1e-7 && ++l < 10; )
                        ;
                    return s
                }(e, s, s + a, t, n)
            }
            if (0 <= t && t <= 1 && 0 <= n && n <= 1) {
                var u = new Float32Array(o);
                if (t !== e || n !== s)
                    for (var c = 0; c < o; ++c)
                        u[c] = r(c * a, t, n);
                return function(i) {
                    return t === e && n === s ? i : 0 === i || 1 === i ? i : r(l(i), e, s)
                }
            }
        }
    }(), G = function() {
        var t = ["Quad", "Cubic", "Quart", "Quint", "Sine", "Expo", "Circ", "Back", "Elastic"]
          , e = {
            In: [[.55, .085, .68, .53], [.55, .055, .675, .19], [.895, .03, .685, .22], [.755, .05, .855, .06], [.47, 0, .745, .715], [.95, .05, .795, .035], [.6, .04, .98, .335], [.6, -.28, .735, .045], o],
            Out: [[.25, .46, .45, .94], [.215, .61, .355, 1], [.165, .84, .44, 1], [.23, 1, .32, 1], [.39, .575, .565, 1], [.19, 1, .22, 1], [.075, .82, .165, 1], [.175, .885, .32, 1.275], function(t, e) {
                return function(n) {
                    return 1 - o(t, e)(1 - n)
                }
            }
            ],
            InOut: [[.455, .03, .515, .955], [.645, .045, .355, 1], [.77, 0, .175, 1], [.86, 0, .07, 1], [.445, .05, .55, .95], [1, 0, 0, 1], [.785, .135, .15, .86], [.68, -.55, .265, 1.55], function(t, e) {
                return function(n) {
                    return n < .5 ? o(t, e)(2 * n) / 2 : 1 - o(t, e)(-2 * n + 2) / 2
                }
            }
            ]
        }
          , n = {
            linear: [.25, .25, .75, .75]
        }
          , r = function(r) {
            e[r].forEach(function(e, i) {
                n["ease" + r + t[i]] = e
            })
        };
        for (var i in e)
            r(i);
        return n
    }(), Q = {
        css: function(t, e, n) {
            return t.style[e] = n
        },
        attribute: function(t, e, n) {
            return t.setAttribute(e, n)
        },
        object: function(t, e, n) {
            return t[e] = n
        },
        transform: function(t, e, n, r, i) {
            if (r.list.set(e, n),
            e === r.last || i) {
                var o = "";
                r.list.forEach(function(t, e) {
                    o += e + "(" + t + ") "
                }),
                t.style.transform = o
            }
        }
    }, J = 0, tt = [], et = [], nt = function() {
        function t() {
            W = requestAnimationFrame(e)
        }
        function e(e) {
            var n = tt.length;
            if (n) {
                for (var r = 0; r < n; ) {
                    var i = tt[r];
                    if (i.paused) {
                        var o = tt.indexOf(i);
                        o > -1 && (tt.splice(o, 1),
                        n = tt.length)
                    } else
                        i.tick(e);
                    r++
                }
                t()
            } else
                W = cancelAnimationFrame(W)
        }
        return t
    }();
    return "undefined" != typeof document && document.addEventListener("visibilitychange", function() {
        document.hidden ? (tt.forEach(function(t) {
            return t.pause()
        }),
        et = tt.slice(0),
        tt = []) : et.forEach(function(t) {
            return t.play()
        })
    }),
    B.version = "3.0.1",
    B.speed = 1,
    B.running = tt,
    B.remove = function(t) {
        for (var e = z(t), n = tt.length; n--; ) {
            var r = tt[n]
              , i = r.animations
              , o = r.children;
            q(e, i);
            for (var a = o.length; a--; ) {
                var s = o[a]
                  , l = s.animations;
                q(e, l),
                l.length || s.children.length || o.splice(a, 1)
            }
            i.length || o.length || r.pause()
        }
    }
    ,
    B.get = S,
    B.set = R,
    B.convertPx = w,
    B.path = function(t, e) {
        var n = Z.str(t) ? l(t)[0] : t
          , r = e || 100;
        return function(t) {
            return {
                property: t,
                el: n,
                svg: L(n),
                totalLength: O(n) * (r / 100)
            }
        }
    }
    ,
    B.setDashoffset = function(t) {
        var e = O(t);
        return t.setAttribute("stroke-dasharray", e),
        e
    }
    ,
    B.stagger = function(t, e) {
        void 0 === e && (e = {});
        var n = e.direction || "normal"
          , r = e.easing ? s(e.easing) : null
          , i = e.grid
          , o = e.axis
          , a = e.from || 0
          , l = "first" === a
          , u = "center" === a
          , c = "last" === a
          , d = Z.arr(t)
          , p = d ? parseFloat(t[0]) : parseFloat(t)
          , f = d ? parseFloat(t[1]) : 0
          , h = v(d ? t[1] : t) || 0
          , m = e.start || 0 + (d ? p : 0)
          , g = []
          , y = 0;
        return function(t, e, s) {
            if (l && (a = 0),
            u && (a = (s - 1) / 2),
            c && (a = s - 1),
            !g.length) {
                for (var v = 0; v < s; v++) {
                    if (i) {
                        var b = u ? (i[0] - 1) / 2 : a % i[0]
                          , w = u ? (i[1] - 1) / 2 : Math.floor(a / i[0])
                          , x = b - v % i[0]
                          , C = w - Math.floor(v / i[0])
                          , k = Math.sqrt(x * x + C * C);
                        "x" === o && (k = -x),
                        "y" === o && (k = -C),
                        g.push(k)
                    } else
                        g.push(Math.abs(a - v));
                    y = Math.max.apply(Math, g)
                }
                r && (g = g.map(function(t) {
                    return r(t / y) * y
                })),
                "reverse" === n && (g = g.map(function(t) {
                    return o ? t < 0 ? -1 * t : -t : Math.abs(y - t)
                }))
            }
            return m + (d ? (f - p) / y : p) * (Math.round(100 * g[e]) / 100) + h
        }
    }
    ,
    B.timeline = function(t) {
        void 0 === t && (t = {});
        var e = B(t);
        return e.duration = 0,
        e.add = function(n, r) {
            function i(t) {
                t.passThrough = !0
            }
            var o = tt.indexOf(e)
              , a = e.children;
            o > -1 && tt.splice(o, 1);
            for (var s = 0; s < a.length; s++)
                i(a[s]);
            var l = m(n, h(V, t));
            l.targets = l.targets || t.targets;
            var u = e.duration;
            l.autoplay = !1,
            l.direction = e.direction,
            l.timelineOffset = Z.und(r) ? u : T(r, u),
            i(e),
            e.seek(l.timelineOffset);
            var c = B(l);
            i(c),
            a.push(c);
            var d = H(a, t);
            return e.delay = d.delay,
            e.endDelay = d.endDelay,
            e.duration = d.duration,
            e.seek(0),
            e.reset(),
            e.autoplay && e.play(),
            e
        }
        ,
        e
    }
    ,
    B.easing = s,
    B.penner = G,
    B.random = function(t, e) {
        return Math.floor(Math.random() * (e - t + 1)) + t
    }
    ,
    B
}),
/*! slick.min.js 1.8.1 */
/* Slick 1.9.0 by Ken Wheeler under MIT license from https://github.com/kenwheeler/slick/ */
function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    "use strict";
    var e = window.Slick || {};
    e = function() {
        function e(e, r) {
            var i, o = this;
            o.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: t(e),
                appendDots: t(e),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(e, n) {
                    return t('<button type="button" />').text(n + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            },
            o.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            },
            t.extend(o, o.initials),
            o.activeBreakpoint = null,
            o.animType = null,
            o.animProp = null,
            o.breakpoints = [],
            o.breakpointSettings = [],
            o.cssTransitions = !1,
            o.focussed = !1,
            o.interrupted = !1,
            o.hidden = "hidden",
            o.paused = !0,
            o.positionProp = null,
            o.respondTo = null,
            o.rowCount = 1,
            o.shouldClick = !0,
            o.$slider = t(e),
            o.$slidesCache = null,
            o.transformType = null,
            o.transitionType = null,
            o.visibilityChange = "visibilitychange",
            o.windowWidth = 0,
            o.windowTimer = null,
            i = t(e).data("slick") || {},
            o.options = t.extend({}, o.defaults, r, i),
            o.currentSlide = o.options.initialSlide,
            o.originalSettings = o.options,
            "undefined" != typeof document.mozHidden ? (o.hidden = "mozHidden",
            o.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.webkitHidden && (o.hidden = "webkitHidden",
            o.visibilityChange = "webkitvisibilitychange"),
            o.autoPlay = t.proxy(o.autoPlay, o),
            o.autoPlayClear = t.proxy(o.autoPlayClear, o),
            o.autoPlayIterator = t.proxy(o.autoPlayIterator, o),
            o.changeSlide = t.proxy(o.changeSlide, o),
            o.clickHandler = t.proxy(o.clickHandler, o),
            o.selectHandler = t.proxy(o.selectHandler, o),
            o.setPosition = t.proxy(o.setPosition, o),
            o.swipeHandler = t.proxy(o.swipeHandler, o),
            o.dragHandler = t.proxy(o.dragHandler, o),
            o.keyHandler = t.proxy(o.keyHandler, o),
            o.instanceUid = n++,
            o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
            o.registerBreakpoints(),
            o.init(!0)
        }
        var n = 0;
        return e
    }(),
    e.prototype.activateADA = function() {
        var t = this;
        t.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }
    ,
    e.prototype.addSlide = e.prototype.slickAdd = function(e, n, r) {
        var i = this;
        if ("boolean" == typeof n)
            r = n,
            n = null;
        else if (n < 0 || n >= i.slideCount)
            return !1;
        i.unload(),
        "number" == typeof n ? 0 === n && 0 === i.$slides.length ? t(e).appendTo(i.$slideTrack) : r ? t(e).insertBefore(i.$slides.eq(n)) : t(e).insertAfter(i.$slides.eq(n)) : r === !0 ? t(e).prependTo(i.$slideTrack) : t(e).appendTo(i.$slideTrack),
        i.$slides = i.$slideTrack.children(this.options.slide),
        i.$slideTrack.children(this.options.slide).detach(),
        i.$slideTrack.append(i.$slides),
        i.$slides.each(function(e, n) {
            t(n).attr("data-slick-index", e)
        }),
        i.$slidesCache = i.$slides,
        i.reinit()
    }
    ,
    e.prototype.animateHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && t.options.adaptiveHeight === !0 && t.options.vertical === !1) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.animate({
                height: e
            }, t.options.speed)
        }
    }
    ,
    e.prototype.animateSlide = function(e, n) {
        var r = {}
          , i = this;
        i.animateHeight(),
        i.options.rtl === !0 && i.options.vertical === !1 && (e = -e),
        i.transformsEnabled === !1 ? i.options.vertical === !1 ? i.$slideTrack.animate({
            left: e
        }, i.options.speed, i.options.easing, n) : i.$slideTrack.animate({
            top: e
        }, i.options.speed, i.options.easing, n) : i.cssTransitions === !1 ? (i.options.rtl === !0 && (i.currentLeft = -i.currentLeft),
        t({
            animStart: i.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: i.options.speed,
            easing: i.options.easing,
            step: function(t) {
                t = Math.ceil(t),
                i.options.vertical === !1 ? (r[i.animType] = "translate(" + t + "px, 0px)",
                i.$slideTrack.css(r)) : (r[i.animType] = "translate(0px," + t + "px)",
                i.$slideTrack.css(r))
            },
            complete: function() {
                n && n.call()
            }
        })) : (i.applyTransition(),
        e = Math.ceil(e),
        i.options.vertical === !1 ? r[i.animType] = "translate3d(" + e + "px, 0px, 0px)" : r[i.animType] = "translate3d(0px," + e + "px, 0px)",
        i.$slideTrack.css(r),
        n && setTimeout(function() {
            i.disableTransition(),
            n.call()
        }, i.options.speed))
    }
    ,
    e.prototype.getNavTarget = function() {
        var e = this
          , n = e.options.asNavFor;
        return n && null !== n && (n = t(n).not(e.$slider)),
        n
    }
    ,
    e.prototype.asNavFor = function(e) {
        var n = this
          , r = n.getNavTarget();
        null !== r && "object" == typeof r && r.each(function() {
            var n = t(this).slick("getSlick");
            n.unslicked || n.slideHandler(e, !0)
        })
    }
    ,
    e.prototype.applyTransition = function(t) {
        var e = this
          , n = {};
        e.options.fade === !1 ? n[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : n[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase,
        e.options.fade === !1 ? e.$slideTrack.css(n) : e.$slides.eq(t).css(n)
    }
    ,
    e.prototype.autoPlay = function() {
        var t = this;
        t.autoPlayClear(),
        t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
    }
    ,
    e.prototype.autoPlayClear = function() {
        var t = this;
        t.autoPlayTimer && clearInterval(t.autoPlayTimer)
    }
    ,
    e.prototype.autoPlayIterator = function() {
        var t = this
          , e = t.currentSlide + t.options.slidesToScroll;
        t.paused || t.interrupted || t.focussed || (t.options.infinite === !1 && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll,
        t.currentSlide - 1 === 0 && (t.direction = 1))),
        t.slideHandler(e))
    }
    ,
    e.prototype.buildArrows = function() {
        var e = this;
        e.options.arrows === !0 && (e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow"),
        e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow"),
        e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
        e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
        e.options.infinite !== !0 && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }
    ,
    e.prototype.buildDots = function() {
        var e, n, r = this;
        if (r.options.dots === !0 && r.slideCount > r.options.slidesToShow) {
            for (r.$slider.addClass("slick-dotted"),
            n = t("<ul />").addClass(r.options.dotsClass),
            e = 0; e <= r.getDotCount(); e += 1)
                n.append(t("<li />").append(r.options.customPaging.call(this, r, e)));
            r.$dots = n.appendTo(r.options.appendDots),
            r.$dots.find("li").first().addClass("slick-active")
        }
    }
    ,
    e.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
        e.slideCount = e.$slides.length,
        e.$slides.each(function(e, n) {
            t(n).attr("data-slick-index", e).data("originalStyling", t(n).attr("style") || "")
        }),
        e.$slider.addClass("slick-slider"),
        e.$slideTrack = 0 === e.slideCount ? t('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(),
        e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(),
        e.$slideTrack.css("opacity", 0),
        e.options.centerMode !== !0 && e.options.swipeToSlide !== !0 || (e.options.slidesToScroll = 1),
        t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
        e.setupInfinite(),
        e.buildArrows(),
        e.buildDots(),
        e.updateDots(),
        e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
        e.options.draggable === !0 && e.$list.addClass("draggable")
    }
    ,
    e.prototype.buildRows = function() {
        var t, e, n, r, i, o, a, s = this;
        if (r = document.createDocumentFragment(),
        o = s.$slider.children(),
        s.options.rows > 0) {
            for (a = s.options.slidesPerRow * s.options.rows,
            i = Math.ceil(o.length / a),
            t = 0; t < i; t++) {
                var l = document.createElement("div");
                for (e = 0; e < s.options.rows; e++) {
                    var u = document.createElement("div");
                    for (n = 0; n < s.options.slidesPerRow; n++) {
                        var c = t * a + (e * s.options.slidesPerRow + n);
                        o.get(c) && u.appendChild(o.get(c))
                    }
                    l.appendChild(u)
                }
                r.appendChild(l)
            }
            s.$slider.empty().append(r),
            s.$slider.children().children().children().css({
                width: 100 / s.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }
    ,
    e.prototype.checkResponsive = function(e, n) {
        var r, i, o, a = this, s = !1, l = a.$slider.width(), u = window.innerWidth || t(window).width();
        if ("window" === a.respondTo ? o = u : "slider" === a.respondTo ? o = l : "min" === a.respondTo && (o = Math.min(u, l)),
        a.options.responsive && a.options.responsive.length && null !== a.options.responsive) {
            i = null;
            for (r in a.breakpoints)
                a.breakpoints.hasOwnProperty(r) && (a.originalSettings.mobileFirst === !1 ? o < a.breakpoints[r] && (i = a.breakpoints[r]) : o > a.breakpoints[r] && (i = a.breakpoints[r]));
            null !== i ? null !== a.activeBreakpoint ? (i !== a.activeBreakpoint || n) && (a.activeBreakpoint = i,
            "unslick" === a.breakpointSettings[i] ? a.unslick(i) : (a.options = t.extend({}, a.originalSettings, a.breakpointSettings[i]),
            e === !0 && (a.currentSlide = a.options.initialSlide),
            a.refresh(e)),
            s = i) : (a.activeBreakpoint = i,
            "unslick" === a.breakpointSettings[i] ? a.unslick(i) : (a.options = t.extend({}, a.originalSettings, a.breakpointSettings[i]),
            e === !0 && (a.currentSlide = a.options.initialSlide),
            a.refresh(e)),
            s = i) : null !== a.activeBreakpoint && (a.activeBreakpoint = null,
            a.options = a.originalSettings,
            e === !0 && (a.currentSlide = a.options.initialSlide),
            a.refresh(e),
            s = i),
            e || s === !1 || a.$slider.trigger("breakpoint", [a, s])
        }
    }
    ,
    e.prototype.changeSlide = function(e, n) {
        var r, i, o, a = this, s = t(e.currentTarget);
        switch (s.is("a") && e.preventDefault(),
        s.is("li") || (s = s.closest("li")),
        o = a.slideCount % a.options.slidesToScroll !== 0,
        r = o ? 0 : (a.slideCount - a.currentSlide) % a.options.slidesToScroll,
        e.data.message) {
        case "previous":
            i = 0 === r ? a.options.slidesToScroll : a.options.slidesToShow - r,
            a.slideCount > a.options.slidesToShow && a.slideHandler(a.currentSlide - i, !1, n);
            break;
        case "next":
            i = 0 === r ? a.options.slidesToScroll : r,
            a.slideCount > a.options.slidesToShow && a.slideHandler(a.currentSlide + i, !1, n);
            break;
        case "index":
            var l = 0 === e.data.index ? 0 : e.data.index || s.index() * a.options.slidesToScroll;
            a.slideHandler(a.checkNavigable(l), !1, n),
            s.children().trigger("focus");
            break;
        default:
            return
        }
    }
    ,
    e.prototype.checkNavigable = function(t) {
        var e, n, r = this;
        if (e = r.getNavigableIndexes(),
        n = 0,
        t > e[e.length - 1])
            t = e[e.length - 1];
        else
            for (var i in e) {
                if (t < e[i]) {
                    t = n;
                    break
                }
                n = e[i]
            }
        return t
    }
    ,
    e.prototype.cleanUpEvents = function() {
        var e = this;
        e.options.dots && null !== e.$dots && (t("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", t.proxy(e.interrupt, e, !0)).off("mouseleave.slick", t.proxy(e.interrupt, e, !1)),
        e.options.accessibility === !0 && e.$dots.off("keydown.slick", e.keyHandler)),
        e.$slider.off("focus.slick blur.slick"),
        e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
        e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
        e.options.accessibility === !0 && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
        e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
        e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
        e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
        e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
        e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
        e.$list.off("click.slick", e.clickHandler),
        t(document).off(e.visibilityChange, e.visibility),
        e.cleanUpSlideEvents(),
        e.options.accessibility === !0 && e.$list.off("keydown.slick", e.keyHandler),
        e.options.focusOnSelect === !0 && t(e.$slideTrack).children().off("click.slick", e.selectHandler),
        t(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
        t(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
        t("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
        t(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }
    ,
    e.prototype.cleanUpSlideEvents = function() {
        var e = this;
        e.$list.off("mouseenter.slick", t.proxy(e.interrupt, e, !0)),
        e.$list.off("mouseleave.slick", t.proxy(e.interrupt, e, !1))
    }
    ,
    e.prototype.cleanUpRows = function() {
        var t, e = this;
        e.options.rows > 0 && (t = e.$slides.children().children(),
        t.removeAttr("style"),
        e.$slider.empty().append(t))
    }
    ,
    e.prototype.clickHandler = function(t) {
        var e = this;
        e.shouldClick === !1 && (t.stopImmediatePropagation(),
        t.stopPropagation(),
        t.preventDefault())
    }
    ,
    e.prototype.destroy = function(e) {
        var n = this;
        n.autoPlayClear(),
        n.touchObject = {},
        n.cleanUpEvents(),
        t(".slick-cloned", n.$slider).detach(),
        n.$dots && n.$dots.remove(),
        n.$prevArrow && n.$prevArrow.length && (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
        n.$nextArrow && n.$nextArrow.length && (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
        n.$slides && (n.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            t(this).attr("style", t(this).data("originalStyling"))
        }),
        n.$slideTrack.children(this.options.slide).detach(),
        n.$slideTrack.detach(),
        n.$list.detach(),
        n.$slider.append(n.$slides)),
        n.cleanUpRows(),
        n.$slider.removeClass("slick-slider"),
        n.$slider.removeClass("slick-initialized"),
        n.$slider.removeClass("slick-dotted"),
        n.unslicked = !0,
        e || n.$slider.trigger("destroy", [n])
    }
    ,
    e.prototype.disableTransition = function(t) {
        var e = this
          , n = {};
        n[e.transitionType] = "",
        e.options.fade === !1 ? e.$slideTrack.css(n) : e.$slides.eq(t).css(n)
    }
    ,
    e.prototype.fadeSlide = function(t, e) {
        var n = this;
        n.cssTransitions === !1 ? (n.$slides.eq(t).css({
            zIndex: n.options.zIndex
        }),
        n.$slides.eq(t).animate({
            opacity: 1
        }, n.options.speed, n.options.easing, e)) : (n.applyTransition(t),
        n.$slides.eq(t).css({
            opacity: 1,
            zIndex: n.options.zIndex
        }),
        e && setTimeout(function() {
            n.disableTransition(t),
            e.call()
        }, n.options.speed))
    }
    ,
    e.prototype.fadeSlideOut = function(t) {
        var e = this;
        e.cssTransitions === !1 ? e.$slides.eq(t).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(t),
        e.$slides.eq(t).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }
    ,
    e.prototype.filterSlides = e.prototype.slickFilter = function(t) {
        var e = this;
        null !== t && (e.$slidesCache = e.$slides,
        e.unload(),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slidesCache.filter(t).appendTo(e.$slideTrack),
        e.reinit())
    }
    ,
    e.prototype.focusHandler = function() {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick", "*", function(n) {
            var r = t(this);
            setTimeout(function() {
                e.options.pauseOnFocus && r.is(":focus") && (e.focussed = !0,
                e.autoPlay())
            }, 0)
        }).on("blur.slick", "*", function(n) {
            t(this),
            e.options.pauseOnFocus && (e.focussed = !1,
            e.autoPlay())
        })
    }
    ,
    e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
        var t = this;
        return t.currentSlide
    }
    ,
    e.prototype.getDotCount = function() {
        var t = this
          , e = 0
          , n = 0
          , r = 0;
        if (t.options.infinite === !0)
            if (t.slideCount <= t.options.slidesToShow)
                ++r;
            else
                for (; e < t.slideCount; )
                    ++r,
                    e = n + t.options.slidesToScroll,
                    n += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        else if (t.options.centerMode === !0)
            r = t.slideCount;
        else if (t.options.asNavFor)
            for (; e < t.slideCount; )
                ++r,
                e = n + t.options.slidesToScroll,
                n += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        else
            r = 1 + Math.ceil((t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll);
        return r - 1
    }
    ,
    e.prototype.getLeft = function(t) {
        var e, n, r, i, o = this, a = 0;
        return o.slideOffset = 0,
        n = o.$slides.first().outerHeight(!0),
        o.options.infinite === !0 ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1,
        i = -1,
        o.options.vertical === !0 && o.options.centerMode === !0 && (2 === o.options.slidesToShow ? i = -1.5 : 1 === o.options.slidesToShow && (i = -2)),
        a = n * o.options.slidesToShow * i),
        o.slideCount % o.options.slidesToScroll !== 0 && t + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (t > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (t - o.slideCount)) * o.slideWidth * -1,
        a = (o.options.slidesToShow - (t - o.slideCount)) * n * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1,
        a = o.slideCount % o.options.slidesToScroll * n * -1))) : t + o.options.slidesToShow > o.slideCount && (o.slideOffset = (t + o.options.slidesToShow - o.slideCount) * o.slideWidth,
        a = (t + o.options.slidesToShow - o.slideCount) * n),
        o.slideCount <= o.options.slidesToShow && (o.slideOffset = 0,
        a = 0),
        o.options.centerMode === !0 && o.slideCount <= o.options.slidesToShow ? o.slideOffset = o.slideWidth * Math.floor(o.options.slidesToShow) / 2 - o.slideWidth * o.slideCount / 2 : o.options.centerMode === !0 && o.options.infinite === !0 ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : o.options.centerMode === !0 && (o.slideOffset = 0,
        o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)),
        e = o.options.vertical === !1 ? t * o.slideWidth * -1 + o.slideOffset : t * n * -1 + a,
        o.options.variableWidth === !0 && (r = o.slideCount <= o.options.slidesToShow || o.options.infinite === !1 ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow),
        e = o.options.rtl === !0 ? r[0] ? (o.$slideTrack.width() - r[0].offsetLeft - r.width()) * -1 : 0 : r[0] ? r[0].offsetLeft * -1 : 0,
        o.options.centerMode === !0 && (r = o.slideCount <= o.options.slidesToShow || o.options.infinite === !1 ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow + 1),
        e = o.options.rtl === !0 ? r[0] ? (o.$slideTrack.width() - r[0].offsetLeft - r.width()) * -1 : 0 : r[0] ? r[0].offsetLeft * -1 : 0,
        e += (o.$list.width() - r.outerWidth()) / 2)),
        e
    }
    ,
    e.prototype.getOption = e.prototype.slickGetOption = function(t) {
        var e = this;
        return e.options[t]
    }
    ,
    e.prototype.getNavigableIndexes = function() {
        var t, e = this, n = 0, r = 0, i = [];
        for (e.options.infinite === !1 ? t = e.slideCount : (n = e.options.slidesToScroll * -1,
        r = e.options.slidesToScroll * -1,
        t = 2 * e.slideCount); n < t; )
            i.push(n),
            n = r + e.options.slidesToScroll,
            r += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return i
    }
    ,
    e.prototype.getSlick = function() {
        return this
    }
    ,
    e.prototype.getSlideCount = function() {
        var e, n, r, i, o = this;
        return i = o.options.centerMode === !0 ? Math.floor(o.$list.width() / 2) : 0,
        r = o.swipeLeft * -1 + i,
        o.options.swipeToSlide === !0 ? (o.$slideTrack.find(".slick-slide").each(function(e, i) {
            var a, s, l;
            if (a = t(i).outerWidth(),
            s = i.offsetLeft,
            o.options.centerMode !== !0 && (s += a / 2),
            l = s + a,
            r < l)
                return n = i,
                !1
        }),
        e = Math.abs(t(n).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }
    ,
    e.prototype.goTo = e.prototype.slickGoTo = function(t, e) {
        var n = this;
        n.changeSlide({
            data: {
                message: "index",
                index: parseInt(t)
            }
        }, e)
    }
    ,
    e.prototype.init = function(e) {
        var n = this;
        t(n.$slider).hasClass("slick-initialized") || (t(n.$slider).addClass("slick-initialized"),
        n.buildRows(),
        n.buildOut(),
        n.setProps(),
        n.startLoad(),
        n.loadSlider(),
        n.initializeEvents(),
        n.updateArrows(),
        n.updateDots(),
        n.checkResponsive(!0),
        n.focusHandler()),
        e && n.$slider.trigger("init", [n]),
        n.options.accessibility === !0 && n.initADA(),
        n.options.autoplay && (n.paused = !1,
        n.autoPlay())
    }
    ,
    e.prototype.initADA = function() {
        var e = this
          , n = Math.ceil(e.slideCount / e.options.slidesToShow)
          , r = e.getNavigableIndexes().filter(function(t) {
            return t >= 0 && t < e.slideCount
        });
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }),
        null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(n) {
            var i = r.indexOf(n);
            if (t(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e.instanceUid + n,
                tabindex: -1
            }),
            i !== -1) {
                var o = "slick-slide-control" + e.instanceUid + i;
                t("#" + o).length && t(this).attr({
                    "aria-describedby": o
                })
            }
        }),
        e.$dots.attr("role", "tablist").find("li").each(function(i) {
            var o = r[i];
            t(this).attr({
                role: "presentation"
            }),
            t(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + e.instanceUid + i,
                "aria-controls": "slick-slide" + e.instanceUid + o,
                "aria-label": i + 1 + " of " + n,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(e.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var i = e.currentSlide, o = i + e.options.slidesToShow; i < o; i++)
            e.options.focusOnChange ? e.$slides.eq(i).attr({
                tabindex: "0"
            }) : e.$slides.eq(i).removeAttr("tabindex");
        e.activateADA()
    }
    ,
    e.prototype.initArrowEvents = function() {
        var t = this;
        t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, t.changeSlide),
        t.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, t.changeSlide),
        t.options.accessibility === !0 && (t.$prevArrow.on("keydown.slick", t.keyHandler),
        t.$nextArrow.on("keydown.slick", t.keyHandler)))
    }
    ,
    e.prototype.initDotEvents = function() {
        var e = this;
        e.options.dots === !0 && e.slideCount > e.options.slidesToShow && (t("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide),
        e.options.accessibility === !0 && e.$dots.on("keydown.slick", e.keyHandler)),
        e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.slideCount > e.options.slidesToShow && t("li", e.$dots).on("mouseenter.slick", t.proxy(e.interrupt, e, !0)).on("mouseleave.slick", t.proxy(e.interrupt, e, !1))
    }
    ,
    e.prototype.initSlideEvents = function() {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", t.proxy(e.interrupt, e, !0)),
        e.$list.on("mouseleave.slick", t.proxy(e.interrupt, e, !1)))
    }
    ,
    e.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(),
        e.initDotEvents(),
        e.initSlideEvents(),
        e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler),
        e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler),
        e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler),
        e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler),
        e.$list.on("click.slick", e.clickHandler),
        t(document).on(e.visibilityChange, t.proxy(e.visibility, e)),
        e.options.accessibility === !0 && e.$list.on("keydown.slick", e.keyHandler),
        e.options.focusOnSelect === !0 && t(e.$slideTrack).children().on("click.slick", e.selectHandler),
        t(window).on("orientationchange.slick.slick-" + e.instanceUid, t.proxy(e.orientationChange, e)),
        t(window).on("resize.slick.slick-" + e.instanceUid, t.proxy(e.resize, e)),
        t("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
        t(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
        t(e.setPosition)
    }
    ,
    e.prototype.initUI = function() {
        var t = this;
        t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.show(),
        t.$nextArrow.show()),
        t.options.dots === !0 && t.slideCount > t.options.slidesToShow && t.$dots.show()
    }
    ,
    e.prototype.keyHandler = function(t) {
        var e = this;
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && e.options.accessibility === !0 ? e.changeSlide({
            data: {
                message: e.options.rtl === !0 ? "next" : "previous"
            }
        }) : 39 === t.keyCode && e.options.accessibility === !0 && e.changeSlide({
            data: {
                message: e.options.rtl === !0 ? "previous" : "next"
            }
        }))
    }
    ,
    e.prototype.lazyLoad = function() {
        function e(e) {
            t("img[data-lazy]", e).each(function() {
                var e = t(this)
                  , n = t(this).attr("data-lazy")
                  , r = t(this).attr("data-srcset")
                  , i = t(this).attr("data-sizes") || a.$slider.attr("data-sizes")
                  , o = document.createElement("img");
                o.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        r && (e.attr("srcset", r),
                        i && e.attr("sizes", i)),
                        e.attr("src", n).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }),
                        a.$slider.trigger("lazyLoaded", [a, e, n])
                    })
                }
                ,
                o.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                    a.$slider.trigger("lazyLoadError", [a, e, n])
                }
                ,
                o.src = n
            })
        }
        var n, r, i, o, a = this;
        if (a.options.centerMode === !0 ? a.options.infinite === !0 ? (i = a.currentSlide + (a.options.slidesToShow / 2 + 1),
        o = i + a.options.slidesToShow + 2) : (i = Math.max(0, a.currentSlide - (a.options.slidesToShow / 2 + 1)),
        o = 2 + (a.options.slidesToShow / 2 + 1) + a.currentSlide) : (i = a.options.infinite ? a.options.slidesToShow + a.currentSlide : a.currentSlide,
        o = Math.ceil(i + a.options.slidesToShow),
        a.options.fade === !0 && (i > 0 && i--,
        o <= a.slideCount && o++)),
        n = a.$slider.find(".slick-slide").slice(i, o),
        "anticipated" === a.options.lazyLoad)
            for (var s = i - 1, l = o, u = a.$slider.find(".slick-slide"), c = 0; c < a.options.slidesToScroll; c++)
                s < 0 && (s = a.slideCount - 1),
                n = n.add(u.eq(s)),
                n = n.add(u.eq(l)),
                s--,
                l++;
        e(n),
        a.slideCount <= a.options.slidesToShow ? (r = a.$slider.find(".slick-slide"),
        e(r)) : a.currentSlide >= a.slideCount - a.options.slidesToShow ? (r = a.$slider.find(".slick-cloned").slice(0, a.options.slidesToShow),
        e(r)) : 0 === a.currentSlide && (r = a.$slider.find(".slick-cloned").slice(a.options.slidesToShow * -1),
        e(r))
    }
    ,
    e.prototype.loadSlider = function() {
        var t = this;
        t.setPosition(),
        t.$slideTrack.css({
            opacity: 1
        }),
        t.$slider.removeClass("slick-loading"),
        t.initUI(),
        "progressive" === t.options.lazyLoad && t.progressiveLazyLoad()
    }
    ,
    e.prototype.next = e.prototype.slickNext = function() {
        var t = this;
        t.changeSlide({
            data: {
                message: "next"
            }
        })
    }
    ,
    e.prototype.orientationChange = function() {
        var t = this;
        t.checkResponsive(),
        t.setPosition()
    }
    ,
    e.prototype.pause = e.prototype.slickPause = function() {
        var t = this;
        t.autoPlayClear(),
        t.paused = !0
    }
    ,
    e.prototype.play = e.prototype.slickPlay = function() {
        var t = this;
        t.autoPlay(),
        t.options.autoplay = !0,
        t.paused = !1,
        t.focussed = !1,
        t.interrupted = !1
    }
    ,
    e.prototype.postSlide = function(e) {
        var n = this;
        if (!n.unslicked && (n.$slider.trigger("afterChange", [n, e]),
        n.animating = !1,
        n.slideCount > n.options.slidesToShow && n.setPosition(),
        n.swipeLeft = null,
        n.options.autoplay && n.autoPlay(),
        n.options.accessibility === !0 && (n.initADA(),
        n.options.focusOnChange))) {
            var r = t(n.$slides.get(n.currentSlide));
            r.attr("tabindex", 0).focus()
        }
    }
    ,
    e.prototype.prev = e.prototype.slickPrev = function() {
        var t = this;
        t.changeSlide({
            data: {
                message: "previous"
            }
        })
    }
    ,
    e.prototype.preventDefault = function(t) {
        t.preventDefault()
    }
    ,
    e.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var n, r, i, o, a, s = this, l = t("img[data-lazy]", s.$slider);
        l.length ? (n = l.first(),
        r = n.attr("data-lazy"),
        i = n.attr("data-srcset"),
        o = n.attr("data-sizes") || s.$slider.attr("data-sizes"),
        a = document.createElement("img"),
        a.onload = function() {
            i && (n.attr("srcset", i),
            o && n.attr("sizes", o)),
            n.attr("src", r).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
            s.options.adaptiveHeight === !0 && s.setPosition(),
            s.$slider.trigger("lazyLoaded", [s, n, r]),
            s.progressiveLazyLoad()
        }
        ,
        a.onerror = function() {
            e < 3 ? setTimeout(function() {
                s.progressiveLazyLoad(e + 1)
            }, 500) : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
            s.$slider.trigger("lazyLoadError", [s, n, r]),
            s.progressiveLazyLoad())
        }
        ,
        a.src = r) : s.$slider.trigger("allImagesLoaded", [s])
    }
    ,
    e.prototype.refresh = function(e) {
        var n, r, i = this;
        r = i.slideCount - i.options.slidesToShow,
        !i.options.infinite && i.currentSlide > r && (i.currentSlide = r),
        i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
        n = i.currentSlide,
        i.destroy(!0),
        t.extend(i, i.initials, {
            currentSlide: n
        }),
        i.init(),
        e || i.changeSlide({
            data: {
                message: "index",
                index: n
            }
        }, !1)
    }
    ,
    e.prototype.registerBreakpoints = function() {
        var e, n, r, i = this, o = i.options.responsive || null;
        if ("array" === t.type(o) && o.length) {
            i.respondTo = i.options.respondTo || "window";
            for (e in o)
                if (r = i.breakpoints.length - 1,
                o.hasOwnProperty(e)) {
                    for (n = o[e].breakpoint; r >= 0; )
                        i.breakpoints[r] && i.breakpoints[r] === n && i.breakpoints.splice(r, 1),
                        r--;
                    i.breakpoints.push(n),
                    i.breakpointSettings[n] = o[e].settings
                }
            i.breakpoints.sort(function(t, e) {
                return i.options.mobileFirst ? t - e : e - t
            })
        }
    }
    ,
    e.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"),
        e.slideCount = e.$slides.length,
        e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
        e.registerBreakpoints(),
        e.setProps(),
        e.setupInfinite(),
        e.buildArrows(),
        e.updateArrows(),
        e.initArrowEvents(),
        e.buildDots(),
        e.updateDots(),
        e.initDotEvents(),
        e.cleanUpSlideEvents(),
        e.initSlideEvents(),
        e.checkResponsive(!1, !0),
        e.options.focusOnSelect === !0 && t(e.$slideTrack).children().on("click.slick", e.selectHandler),
        e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
        e.setPosition(),
        e.focusHandler(),
        e.paused = !e.options.autoplay,
        e.autoPlay(),
        e.$slider.trigger("reInit", [e])
    }
    ,
    e.prototype.resize = function() {
        var e = this;
        t(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay),
        e.windowDelay = window.setTimeout(function() {
            e.windowWidth = t(window).width(),
            e.checkResponsive(),
            e.unslicked || e.setPosition()
        }, 50))
    }
    ,
    e.prototype.removeSlide = e.prototype.slickRemove = function(t, e, n) {
        var r = this;
        return "boolean" == typeof t ? (e = t,
        t = e === !0 ? 0 : r.slideCount - 1) : t = e === !0 ? --t : t,
        !(r.slideCount < 1 || t < 0 || t > r.slideCount - 1) && (r.unload(),
        n === !0 ? r.$slideTrack.children().remove() : r.$slideTrack.children(this.options.slide).eq(t).remove(),
        r.$slides = r.$slideTrack.children(this.options.slide),
        r.$slideTrack.children(this.options.slide).detach(),
        r.$slideTrack.append(r.$slides),
        r.$slidesCache = r.$slides,
        void r.reinit())
    }
    ,
    e.prototype.setCSS = function(t) {
        var e, n, r = this, i = {};
        r.options.rtl === !0 && (t = -t),
        e = "left" == r.positionProp ? Math.ceil(t) + "px" : "0px",
        n = "top" == r.positionProp ? Math.ceil(t) + "px" : "0px",
        i[r.positionProp] = t,
        r.transformsEnabled === !1 ? r.$slideTrack.css(i) : (i = {},
        r.cssTransitions === !1 ? (i[r.animType] = "translate(" + e + ", " + n + ")",
        r.$slideTrack.css(i)) : (i[r.animType] = "translate3d(" + e + ", " + n + ", 0px)",
        r.$slideTrack.css(i)))
    }
    ,
    e.prototype.setDimensions = function() {
        var t = this;
        t.options.vertical === !1 ? t.options.centerMode === !0 && t.$list.css({
            padding: "0px " + t.options.centerPadding
        }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow),
        t.options.centerMode === !0 && t.$list.css({
            padding: t.options.centerPadding + " 0px"
        })),
        t.listWidth = t.$list.width(),
        t.listHeight = t.$list.height(),
        t.options.vertical === !1 && t.options.variableWidth === !1 ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow),
        t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : t.options.variableWidth === !0 ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth),
        t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        t.options.variableWidth === !1 && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
    }
    ,
    e.prototype.setFade = function() {
        var e, n = this;
        n.$slides.each(function(r, i) {
            e = n.slideWidth * r * -1,
            n.options.rtl === !0 ? t(i).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            }) : t(i).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            })
        }),
        n.$slides.eq(n.currentSlide).css({
            zIndex: n.options.zIndex - 1,
            opacity: 1
        })
    }
    ,
    e.prototype.setHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && t.options.adaptiveHeight === !0 && t.options.vertical === !1) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.css("height", e)
        }
    }
    ,
    e.prototype.setOption = e.prototype.slickSetOption = function() {
        var e, n, r, i, o, a = this, s = !1;
        if ("object" === t.type(arguments[0]) ? (r = arguments[0],
        s = arguments[1],
        o = "multiple") : "string" === t.type(arguments[0]) && (r = arguments[0],
        i = arguments[1],
        s = arguments[2],
        "responsive" === arguments[0] && "array" === t.type(arguments[1]) ? o = "responsive" : "undefined" != typeof arguments[1] && (o = "single")),
        "single" === o)
            a.options[r] = i;
        else if ("multiple" === o)
            t.each(r, function(t, e) {
                a.options[t] = e
            });
        else if ("responsive" === o)
            for (n in i)
                if ("array" !== t.type(a.options.responsive))
                    a.options.responsive = [i[n]];
                else {
                    for (e = a.options.responsive.length - 1; e >= 0; )
                        a.options.responsive[e].breakpoint === i[n].breakpoint && a.options.responsive.splice(e, 1),
                        e--;
                    a.options.responsive.push(i[n])
                }
        s && (a.unload(),
        a.reinit())
    }
    ,
    e.prototype.setPosition = function() {
        var t = this;
        t.setDimensions(),
        t.setHeight(),
        t.options.fade === !1 ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(),
        t.$slider.trigger("setPosition", [t])
    }
    ,
    e.prototype.setProps = function() {
        var t = this
          , e = document.body.style;
        t.positionProp = t.options.vertical === !0 ? "top" : "left",
        "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"),
        void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || t.options.useCSS === !0 && (t.cssTransitions = !0),
        t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex),
        void 0 !== e.OTransform && (t.animType = "OTransform",
        t.transformType = "-o-transform",
        t.transitionType = "OTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)),
        void 0 !== e.MozTransform && (t.animType = "MozTransform",
        t.transformType = "-moz-transform",
        t.transitionType = "MozTransition",
        void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)),
        void 0 !== e.webkitTransform && (t.animType = "webkitTransform",
        t.transformType = "-webkit-transform",
        t.transitionType = "webkitTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)),
        void 0 !== e.msTransform && (t.animType = "msTransform",
        t.transformType = "-ms-transform",
        t.transitionType = "msTransition",
        void 0 === e.msTransform && (t.animType = !1)),
        void 0 !== e.transform && t.animType !== !1 && (t.animType = "transform",
        t.transformType = "transform",
        t.transitionType = "transition"),
        t.transformsEnabled = t.options.useTransform && null !== t.animType && t.animType !== !1
    }
    ,
    e.prototype.setSlideClasses = function(t) {
        var e, n, r, i, o = this;
        if (n = o.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
        o.$slides.eq(t).addClass("slick-current"),
        o.options.centerMode === !0) {
            var a = o.options.slidesToShow % 2 === 0 ? 1 : 0;
            e = Math.floor(o.options.slidesToShow / 2),
            o.options.infinite === !0 && (t >= e && t <= o.slideCount - 1 - e ? o.$slides.slice(t - e + a, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (r = o.options.slidesToShow + t,
            n.slice(r - e + 1 + a, r + e + 2).addClass("slick-active").attr("aria-hidden", "false")),
            0 === t ? n.eq(n.length - 1 - o.options.slidesToShow).addClass("slick-center") : t === o.slideCount - 1 && n.eq(o.options.slidesToShow).addClass("slick-center")),
            o.$slides.eq(t).addClass("slick-center")
        } else
            t >= 0 && t <= o.slideCount - o.options.slidesToShow ? o.$slides.slice(t, t + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= o.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (i = o.slideCount % o.options.slidesToShow,
            r = o.options.infinite === !0 ? o.options.slidesToShow + t : t,
            o.options.slidesToShow == o.options.slidesToScroll && o.slideCount - t < o.options.slidesToShow ? n.slice(r - (o.options.slidesToShow - i), r + i).addClass("slick-active").attr("aria-hidden", "false") : n.slice(r, r + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== o.options.lazyLoad && "anticipated" !== o.options.lazyLoad || o.lazyLoad()
    }
    ,
    e.prototype.setupInfinite = function() {
        var e, n, r, i = this;
        if (i.options.fade === !0 && (i.options.centerMode = !1),
        i.options.infinite === !0 && i.options.fade === !1 && (n = null,
        i.slideCount > i.options.slidesToShow)) {
            for (r = i.options.centerMode === !0 ? i.options.slidesToShow + 1 : i.options.slidesToShow,
            e = i.slideCount; e > i.slideCount - r; e -= 1)
                n = e - 1,
                t(i.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n - i.slideCount).prependTo(i.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < r + i.slideCount; e += 1)
                n = e,
                t(i.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n + i.slideCount).appendTo(i.$slideTrack).addClass("slick-cloned");
            i.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                t(this).attr("id", "")
            })
        }
    }
    ,
    e.prototype.interrupt = function(t) {
        var e = this;
        t || e.autoPlay(),
        e.interrupted = t
    }
    ,
    e.prototype.selectHandler = function(e) {
        var n = this
          , r = t(e.target).is(".slick-slide") ? t(e.target) : t(e.target).parents(".slick-slide")
          , i = parseInt(r.attr("data-slick-index"));
        return i || (i = 0),
        n.slideCount <= n.options.slidesToShow ? void n.slideHandler(i, !1, !0) : void n.slideHandler(i)
    }
    ,
    e.prototype.slideHandler = function(t, e, n) {
        var r, i, o, a, s, l = null, u = this;
        if (e = e || !1,
        !(u.animating === !0 && u.options.waitForAnimate === !0 || u.options.fade === !0 && u.currentSlide === t))
            return e === !1 && u.asNavFor(t),
            r = t,
            l = u.getLeft(r),
            a = u.getLeft(u.currentSlide),
            u.currentLeft = null === u.swipeLeft ? a : u.swipeLeft,
            u.options.infinite === !1 && u.options.centerMode === !1 && (t < 0 || t > u.getDotCount() * u.options.slidesToScroll) ? void (u.options.fade === !1 && (r = u.currentSlide,
            n !== !0 && u.slideCount > u.options.slidesToShow ? u.animateSlide(a, function() {
                u.postSlide(r)
            }) : u.postSlide(r))) : u.options.infinite === !1 && u.options.centerMode === !0 && (t < 0 || t > u.slideCount - u.options.slidesToScroll) ? void (u.options.fade === !1 && (r = u.currentSlide,
            n !== !0 && u.slideCount > u.options.slidesToShow ? u.animateSlide(a, function() {
                u.postSlide(r)
            }) : u.postSlide(r))) : (u.options.autoplay && clearInterval(u.autoPlayTimer),
            i = r < 0 ? u.slideCount % u.options.slidesToScroll !== 0 ? u.slideCount - u.slideCount % u.options.slidesToScroll : u.slideCount + r : r >= u.slideCount ? u.slideCount % u.options.slidesToScroll !== 0 ? 0 : r - u.slideCount : r,
            u.animating = !0,
            u.$slider.trigger("beforeChange", [u, u.currentSlide, i]),
            o = u.currentSlide,
            u.currentSlide = i,
            u.setSlideClasses(u.currentSlide),
            u.options.asNavFor && (s = u.getNavTarget(),
            s = s.slick("getSlick"),
            s.slideCount <= s.options.slidesToShow && s.setSlideClasses(u.currentSlide)),
            u.updateDots(),
            u.updateArrows(),
            u.options.fade === !0 ? (n !== !0 ? (u.fadeSlideOut(o),
            u.fadeSlide(i, function() {
                u.postSlide(i)
            })) : u.postSlide(i),
            void u.animateHeight()) : void (n !== !0 && u.slideCount > u.options.slidesToShow ? u.animateSlide(l, function() {
                u.postSlide(i)
            }) : u.postSlide(i)))
    }
    ,
    e.prototype.startLoad = function() {
        var t = this;
        t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(),
        t.$nextArrow.hide()),
        t.options.dots === !0 && t.slideCount > t.options.slidesToShow && t.$dots.hide(),
        t.$slider.addClass("slick-loading")
    }
    ,
    e.prototype.swipeDirection = function() {
        var t, e, n, r, i = this;
        return t = i.touchObject.startX - i.touchObject.curX,
        e = i.touchObject.startY - i.touchObject.curY,
        n = Math.atan2(e, t),
        r = Math.round(180 * n / Math.PI),
        r < 0 && (r = 360 - Math.abs(r)),
        r <= 45 && r >= 0 ? i.options.rtl === !1 ? "left" : "right" : r <= 360 && r >= 315 ? i.options.rtl === !1 ? "left" : "right" : r >= 135 && r <= 225 ? i.options.rtl === !1 ? "right" : "left" : i.options.verticalSwiping === !0 ? r >= 35 && r <= 135 ? "down" : "up" : "vertical"
    }
    ,
    e.prototype.swipeEnd = function(t) {
        var e, n, r = this;
        if (r.dragging = !1,
        r.swiping = !1,
        r.scrolling)
            return r.scrolling = !1,
            !1;
        if (r.interrupted = !1,
        r.shouldClick = !(r.touchObject.swipeLength > 10),
        void 0 === r.touchObject.curX)
            return !1;
        if (r.touchObject.edgeHit === !0 && r.$slider.trigger("edge", [r, r.swipeDirection()]),
        r.touchObject.swipeLength >= r.touchObject.minSwipe) {
            switch (n = r.swipeDirection()) {
            case "left":
            case "down":
                e = r.options.swipeToSlide ? r.checkNavigable(r.currentSlide + r.getSlideCount()) : r.currentSlide + r.getSlideCount(),
                r.currentDirection = 0;
                break;
            case "right":
            case "up":
                e = r.options.swipeToSlide ? r.checkNavigable(r.currentSlide - r.getSlideCount()) : r.currentSlide - r.getSlideCount(),
                r.currentDirection = 1
            }
            "vertical" != n && (r.slideHandler(e),
            r.touchObject = {},
            r.$slider.trigger("swipe", [r, n]))
        } else
            r.touchObject.startX !== r.touchObject.curX && (r.slideHandler(r.currentSlide),
            r.touchObject = {})
    }
    ,
    e.prototype.swipeHandler = function(t) {
        var e = this;
        if (!(e.options.swipe === !1 || "ontouchend"in document && e.options.swipe === !1 || e.options.draggable === !1 && t.type.indexOf("mouse") !== -1))
            switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1,
            e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold,
            e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
            t.data.action) {
            case "start":
                e.swipeStart(t);
                break;
            case "move":
                e.swipeMove(t);
                break;
            case "end":
                e.swipeEnd(t)
            }
    }
    ,
    e.prototype.swipeMove = function(t) {
        var e, n, r, i, o, a, s = this;
        return o = void 0 !== t.originalEvent ? t.originalEvent.touches : null,
        !(!s.dragging || s.scrolling || o && 1 !== o.length) && (e = s.getLeft(s.currentSlide),
        s.touchObject.curX = void 0 !== o ? o[0].pageX : t.clientX,
        s.touchObject.curY = void 0 !== o ? o[0].pageY : t.clientY,
        s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))),
        a = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2))),
        !s.options.verticalSwiping && !s.swiping && a > 4 ? (s.scrolling = !0,
        !1) : (s.options.verticalSwiping === !0 && (s.touchObject.swipeLength = a),
        n = s.swipeDirection(),
        void 0 !== t.originalEvent && s.touchObject.swipeLength > 4 && (s.swiping = !0,
        t.preventDefault()),
        i = (s.options.rtl === !1 ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1),
        s.options.verticalSwiping === !0 && (i = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
        r = s.touchObject.swipeLength,
        s.touchObject.edgeHit = !1,
        s.options.infinite === !1 && (0 === s.currentSlide && "right" === n || s.currentSlide >= s.getDotCount() && "left" === n) && (r = s.touchObject.swipeLength * s.options.edgeFriction,
        s.touchObject.edgeHit = !0),
        s.options.vertical === !1 ? s.swipeLeft = e + r * i : s.swipeLeft = e + r * (s.$list.height() / s.listWidth) * i,
        s.options.verticalSwiping === !0 && (s.swipeLeft = e + r * i),
        s.options.fade !== !0 && s.options.touchMove !== !1 && (s.animating === !0 ? (s.swipeLeft = null,
        !1) : void s.setCSS(s.swipeLeft))))
    }
    ,
    e.prototype.swipeStart = function(t) {
        var e, n = this;
        return n.interrupted = !0,
        1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow ? (n.touchObject = {},
        !1) : (void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]),
        n.touchObject.startX = n.touchObject.curX = void 0 !== e ? e.pageX : t.clientX,
        n.touchObject.startY = n.touchObject.curY = void 0 !== e ? e.pageY : t.clientY,
        void (n.dragging = !0))
    }
    ,
    e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
        var t = this;
        null !== t.$slidesCache && (t.unload(),
        t.$slideTrack.children(this.options.slide).detach(),
        t.$slidesCache.appendTo(t.$slideTrack),
        t.reinit())
    }
    ,
    e.prototype.unload = function() {
        var e = this;
        t(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
        e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
        e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }
    ,
    e.prototype.unslick = function(t) {
        var e = this;
        e.$slider.trigger("unslick", [e, t]),
        e.destroy()
    }
    ,
    e.prototype.updateArrows = function() {
        var t, e = this;
        t = Math.floor(e.options.slidesToShow / 2),
        e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }
    ,
    e.prototype.updateDots = function() {
        var t = this;
        null !== t.$dots && (t.$dots.find("li").removeClass("slick-active").end(),
        t.$dots.find("li").eq(Math.floor(t.currentSlide / t.options.slidesToScroll)).addClass("slick-active"))
    }
    ,
    e.prototype.visibility = function() {
        var t = this;
        t.options.autoplay && (document[t.hidden] ? t.interrupted = !0 : t.interrupted = !1)
    }
    ,
    t.fn.slick = function() {
        var t, n, r = this, i = arguments[0], o = Array.prototype.slice.call(arguments, 1), a = r.length;
        for (t = 0; t < a; t++)
            if ("object" == typeof i || "undefined" == typeof i ? r[t].slick = new e(r[t],i) : n = r[t].slick[i].apply(r[t].slick, o),
            "undefined" != typeof n)
                return n;
        return r
    }
}),
/*! photoswipe.min.js */
/*! PhotoSwipe - v4.1.2 - 2017-04-05 http://photoswipe.com (c) 2017 Dmitry Semenov; */
!function(t, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.PhotoSwipe = e()
}(this, function() {
    "use strict";
    var t = function(t, e, n, r) {
        var i = {
            features: null,
            bind: function(t, e, n, r) {
                var i = (r ? "remove" : "add") + "EventListener";
                e = e.split(" ");
                for (var o = 0; o < e.length; o++)
                    e[o] && t[i](e[o], n, !1)
            },
            isArray: function(t) {
                return t instanceof Array
            },
            createEl: function(t, e) {
                var n = document.createElement(e || "div");
                return t && (n.className = t),
                n
            },
            getScrollY: function() {
                var t = window.pageYOffset;
                return void 0 !== t ? t : document.documentElement.scrollTop
            },
            unbind: function(t, e, n) {
                i.bind(t, e, n, !0)
            },
            removeClass: function(t, e) {
                var n = new RegExp("(\\s|^)" + e + "(\\s|$)");
                t.className = t.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
            },
            addClass: function(t, e) {
                i.hasClass(t, e) || (t.className += (t.className ? " " : "") + e)
            },
            hasClass: function(t, e) {
                return t.className && new RegExp("(^|\\s)" + e + "(\\s|$)").test(t.className)
            },
            getChildByClass: function(t, e) {
                for (var n = t.firstChild; n; ) {
                    if (i.hasClass(n, e))
                        return n;
                    n = n.nextSibling
                }
            },
            arraySearch: function(t, e, n) {
                for (var r = t.length; r--; )
                    if (t[r][n] === e)
                        return r;
                return -1
            },
            extend: function(t, e, n) {
                for (var r in e)
                    if (e.hasOwnProperty(r)) {
                        if (n && t.hasOwnProperty(r))
                            continue;
                        t[r] = e[r]
                    }
            },
            easing: {
                sine: {
                    out: function(t) {
                        return Math.sin(t * (Math.PI / 2))
                    },
                    inOut: function(t) {
                        return -(Math.cos(Math.PI * t) - 1) / 2
                    }
                },
                cubic: {
                    out: function(t) {
                        return --t * t * t + 1
                    }
                }
            },
            detectFeatures: function() {
                if (i.features)
                    return i.features;
                var t = i.createEl()
                  , e = t.style
                  , n = ""
                  , r = {};
                if (r.oldIE = document.all && !document.addEventListener,
                r.touch = "ontouchstart"in window,
                window.requestAnimationFrame && (r.raf = window.requestAnimationFrame,
                r.caf = window.cancelAnimationFrame),
                r.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled,
                !r.pointerEvent) {
                    var o = navigator.userAgent;
                    if (/iP(hone|od)/.test(navigator.platform)) {
                        var a = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        a && a.length > 0 && (a = parseInt(a[1], 10),
                        a >= 1 && a < 8 && (r.isOldIOSPhone = !0))
                    }
                    var s = o.match(/Android\s([0-9\.]*)/)
                      , l = s ? s[1] : 0;
                    l = parseFloat(l),
                    l >= 1 && (l < 4.4 && (r.isOldAndroid = !0),
                    r.androidVersion = l),
                    r.isMobileOpera = /opera mini|opera mobi/i.test(o)
                }
                for (var u, c, d = ["transform", "perspective", "animationName"], p = ["", "webkit", "Moz", "ms", "O"], f = 0; f < 4; f++) {
                    n = p[f];
                    for (var h = 0; h < 3; h++)
                        u = d[h],
                        c = n + (n ? u.charAt(0).toUpperCase() + u.slice(1) : u),
                        !r[u] && c in e && (r[u] = c);
                    n && !r.raf && (n = n.toLowerCase(),
                    r.raf = window[n + "RequestAnimationFrame"],
                    r.raf && (r.caf = window[n + "CancelAnimationFrame"] || window[n + "CancelRequestAnimationFrame"]))
                }
                if (!r.raf) {
                    var m = 0;
                    r.raf = function(t) {
                        var e = (new Date).getTime()
                          , n = Math.max(0, 16 - (e - m))
                          , r = window.setTimeout(function() {
                            t(e + n)
                        }, n);
                        return m = e + n,
                        r
                    }
                    ,
                    r.caf = function(t) {
                        clearTimeout(t)
                    }
                }
                return r.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect,
                i.features = r,
                r
            }
        };
        i.detectFeatures(),
        i.features.oldIE && (i.bind = function(t, e, n, r) {
            e = e.split(" ");
            for (var i, o = (r ? "detach" : "attach") + "Event", a = function() {
                n.handleEvent.call(n)
            }, s = 0; s < e.length; s++)
                if (i = e[s])
                    if ("object" == typeof n && n.handleEvent) {
                        if (r) {
                            if (!n["oldIE" + i])
                                return !1
                        } else
                            n["oldIE" + i] = a;
                        t[o]("on" + i, n["oldIE" + i])
                    } else
                        t[o]("on" + i, n)
        }
        );
        var o = this
          , a = 25
          , s = 3
          , l = {
            allowPanToNext: !0,
            spacing: .12,
            bgOpacity: 1,
            mouseUsed: !1,
            loop: !0,
            pinchToClose: !0,
            closeOnScroll: !0,
            closeOnVerticalDrag: !0,
            verticalDragRange: .75,
            hideAnimationDuration: 333,
            showAnimationDuration: 333,
            showHideOpacity: !1,
            focus: !0,
            escKey: !0,
            arrowKeys: !0,
            mainScrollEndFriction: .35,
            panEndFriction: .35,
            isClickableElement: function(t) {
                return "A" === t.tagName
            },
            getDoubleTapZoom: function(t, e) {
                return t ? 1 : e.initialZoomLevel < .7 ? 1 : 1.33
            },
            maxSpreadZoom: 1.33,
            modal: !0,
            scaleMode: "fit"
        };
        i.extend(l, r);
        var u, c, d, p, f, h, m, g, v, y, b, w, x, C, k, _, S, T, E, A, M, O, L, I, j, z, N, P, D, $, R, F, H, B, q, W, U, V, X, Y, Z, K, G, Q, J, tt, et, nt, rt, it, ot, at, st, lt, ut, ct, dt, pt = function() {
            return {
                x: 0,
                y: 0
            }
        }, ft = pt(), ht = pt(), mt = pt(), gt = {}, vt = 0, yt = {}, bt = pt(), wt = 0, xt = !0, Ct = [], kt = {}, _t = !1, St = function(t, e) {
            i.extend(o, e.publicMethods),
            Ct.push(t)
        }, Tt = function(t) {
            var e = tn();
            return t > e - 1 ? t - e : t < 0 ? e + t : t
        }, Et = {}, At = function(t, e) {
            return Et[t] || (Et[t] = []),
            Et[t].push(e)
        }, Mt = function(t) {
            var e = Et[t];
            if (e) {
                var n = Array.prototype.slice.call(arguments);
                n.shift();
                for (var r = 0; r < e.length; r++)
                    e[r].apply(o, n)
            }
        }, Ot = function() {
            return (new Date).getTime()
        }, Lt = function(t) {
            ut = t,
            o.bg.style.opacity = t * l.bgOpacity
        }, It = function(t, e, n, r, i) {
            (!_t || i && i !== o.currItem) && (r /= i ? i.fitRatio : o.currItem.fitRatio),
            t[O] = w + e + "px, " + n + "px" + x + " scale(" + r + ")"
        }, jt = function(t) {
            it && (t && (y > o.currItem.fitRatio ? _t || (fn(o.currItem, !1, !0),
            _t = !0) : _t && (fn(o.currItem),
            _t = !1)),
            It(it, mt.x, mt.y, y))
        }, zt = function(t) {
            t.container && It(t.container.style, t.initialPosition.x, t.initialPosition.y, t.initialZoomLevel, t)
        }, Nt = function(t, e) {
            e[O] = w + t + "px, 0px" + x
        }, Pt = function(t, e) {
            if (!l.loop && e) {
                var n = p + (bt.x * vt - t) / bt.x
                  , r = Math.round(t - be.x);
                (n < 0 && r > 0 || n >= tn() - 1 && r < 0) && (t = be.x + r * l.mainScrollEndFriction)
            }
            be.x = t,
            Nt(t, f)
        }, Dt = function(t, e) {
            var n = we[t] - yt[t];
            return ht[t] + ft[t] + n - n * (e / b)
        }, $t = function(t, e) {
            t.x = e.x,
            t.y = e.y,
            e.id && (t.id = e.id)
        }, Rt = function(t) {
            t.x = Math.round(t.x),
            t.y = Math.round(t.y)
        }, Ft = null, Ht = function() {
            Ft && (i.unbind(document, "mousemove", Ht),
            i.addClass(t, "pswp--has_mouse"),
            l.mouseUsed = !0,
            Mt("mouseUsed")),
            Ft = setTimeout(function() {
                Ft = null
            }, 100)
        }, Bt = function() {
            i.bind(document, "keydown", o),
            R.transform && i.bind(o.scrollWrap, "click", o),
            l.mouseUsed || i.bind(document, "mousemove", Ht),
            i.bind(window, "resize scroll orientationchange", o),
            Mt("bindEvents")
        }, qt = function() {
            i.unbind(window, "resize scroll orientationchange", o),
            i.unbind(window, "scroll", v.scroll),
            i.unbind(document, "keydown", o),
            i.unbind(document, "mousemove", Ht),
            R.transform && i.unbind(o.scrollWrap, "click", o),
            X && i.unbind(window, m, o),
            clearTimeout(F),
            Mt("unbindEvents")
        }, Wt = function(t, e) {
            var n = un(o.currItem, gt, t);
            return e && (rt = n),
            n
        }, Ut = function(t) {
            return t || (t = o.currItem),
            t.initialZoomLevel
        }, Vt = function(t) {
            return t || (t = o.currItem),
            t.w > 0 ? l.maxSpreadZoom : 1
        }, Xt = function(t, e, n, r) {
            return r === o.currItem.initialZoomLevel ? (n[t] = o.currItem.initialPosition[t],
            !0) : (n[t] = Dt(t, r),
            n[t] > e.min[t] ? (n[t] = e.min[t],
            !0) : n[t] < e.max[t] && (n[t] = e.max[t],
            !0))
        }, Yt = function() {
            if (O) {
                var e = R.perspective && !I;
                return w = "translate" + (e ? "3d(" : "("),
                void (x = R.perspective ? ", 0px)" : ")")
            }
            O = "left",
            i.addClass(t, "pswp--ie"),
            Nt = function(t, e) {
                e.left = t + "px"
            }
            ,
            zt = function(t) {
                var e = t.fitRatio > 1 ? 1 : t.fitRatio
                  , n = t.container.style
                  , r = e * t.w
                  , i = e * t.h;
                n.width = r + "px",
                n.height = i + "px",
                n.left = t.initialPosition.x + "px",
                n.top = t.initialPosition.y + "px"
            }
            ,
            jt = function() {
                if (it) {
                    var t = it
                      , e = o.currItem
                      , n = e.fitRatio > 1 ? 1 : e.fitRatio
                      , r = n * e.w
                      , i = n * e.h;
                    t.width = r + "px",
                    t.height = i + "px",
                    t.left = mt.x + "px",
                    t.top = mt.y + "px"
                }
            }
        }, Zt = function(t) {
            var e = "";
            l.escKey && 27 === t.keyCode ? e = "close" : l.arrowKeys && (37 === t.keyCode ? e = "prev" : 39 === t.keyCode && (e = "next")),
            e && (t.ctrlKey || t.altKey || t.shiftKey || t.metaKey || (t.preventDefault ? t.preventDefault() : t.returnValue = !1,
            o[e]()))
        }, Kt = function(t) {
            t && (K || Z || ot || U) && (t.preventDefault(),
            t.stopPropagation())
        }, Gt = function() {
            o.setScrollOffset(0, i.getScrollY())
        }, Qt = {}, Jt = 0, te = function(t) {
            Qt[t] && (Qt[t].raf && z(Qt[t].raf),
            Jt--,
            delete Qt[t])
        }, ee = function(t) {
            Qt[t] && te(t),
            Qt[t] || (Jt++,
            Qt[t] = {})
        }, ne = function() {
            for (var t in Qt)
                Qt.hasOwnProperty(t) && te(t)
        }, re = function(t, e, n, r, i, o, a) {
            var s, l = Ot();
            ee(t);
            var u = function() {
                if (Qt[t]) {
                    if (s = Ot() - l,
                    s >= r)
                        return te(t),
                        o(n),
                        void (a && a());
                    o((n - e) * i(s / r) + e),
                    Qt[t].raf = j(u)
                }
            };
            u()
        }, ie = {
            shout: Mt,
            listen: At,
            viewportSize: gt,
            options: l,
            isMainScrollAnimating: function() {
                return ot
            },
            getZoomLevel: function() {
                return y
            },
            getCurrentIndex: function() {
                return p
            },
            isDragging: function() {
                return X
            },
            isZooming: function() {
                return tt
            },
            setScrollOffset: function(t, e) {
                yt.x = t,
                $ = yt.y = e,
                Mt("updateScrollOffset", yt)
            },
            applyZoomPan: function(t, e, n, r) {
                mt.x = e,
                mt.y = n,
                y = t,
                jt(r)
            },
            init: function() {
                if (!u && !c) {
                    var n;
                    o.framework = i,
                    o.template = t,
                    o.bg = i.getChildByClass(t, "pswp__bg"),
                    N = t.className,
                    u = !0,
                    R = i.detectFeatures(),
                    j = R.raf,
                    z = R.caf,
                    O = R.transform,
                    D = R.oldIE,
                    o.scrollWrap = i.getChildByClass(t, "pswp__scroll-wrap"),
                    o.container = i.getChildByClass(o.scrollWrap, "pswp__container"),
                    f = o.container.style,
                    o.itemHolders = _ = [{
                        el: o.container.children[0],
                        wrap: 0,
                        index: -1
                    }, {
                        el: o.container.children[1],
                        wrap: 0,
                        index: -1
                    }, {
                        el: o.container.children[2],
                        wrap: 0,
                        index: -1
                    }],
                    _[0].el.style.display = _[2].el.style.display = "none",
                    Yt(),
                    v = {
                        resize: o.updateSize,
                        orientationchange: function() {
                            clearTimeout(F),
                            F = setTimeout(function() {
                                gt.x !== o.scrollWrap.clientWidth && o.updateSize()
                            }, 500)
                        },
                        scroll: Gt,
                        keydown: Zt,
                        click: Kt
                    };
                    var r = R.isOldIOSPhone || R.isOldAndroid || R.isMobileOpera;
                    for (R.animationName && R.transform && !r || (l.showAnimationDuration = l.hideAnimationDuration = 0),
                    n = 0; n < Ct.length; n++)
                        o["init" + Ct[n]]();
                    if (e) {
                        var a = o.ui = new e(o,i);
                        a.init()
                    }
                    Mt("firstUpdate"),
                    p = p || l.index || 0,
                    (isNaN(p) || p < 0 || p >= tn()) && (p = 0),
                    o.currItem = Je(p),
                    (R.isOldIOSPhone || R.isOldAndroid) && (xt = !1),
                    t.setAttribute("aria-hidden", "false"),
                    l.modal && (xt ? t.style.position = "fixed" : (t.style.position = "absolute",
                    t.style.top = i.getScrollY() + "px")),
                    void 0 === $ && (Mt("initialLayout"),
                    $ = P = i.getScrollY());
                    var d = "pswp--open ";
                    for (l.mainClass && (d += l.mainClass + " "),
                    l.showHideOpacity && (d += "pswp--animate_opacity "),
                    d += I ? "pswp--touch" : "pswp--notouch",
                    d += R.animationName ? " pswp--css_animation" : "",
                    d += R.svg ? " pswp--svg" : "",
                    i.addClass(t, d),
                    o.updateSize(),
                    h = -1,
                    wt = null,
                    n = 0; n < s; n++)
                        Nt((n + h) * bt.x, _[n].el.style);
                    D || i.bind(o.scrollWrap, g, o),
                    At("initialZoomInEnd", function() {
                        o.setContent(_[0], p - 1),
                        o.setContent(_[2], p + 1),
                        _[0].el.style.display = _[2].el.style.display = "block",
                        l.focus && t.focus(),
                        Bt()
                    }),
                    o.setContent(_[1], p),
                    o.updateCurrItem(),
                    Mt("afterInit"),
                    xt || (C = setInterval(function() {
                        Jt || X || tt || y !== o.currItem.initialZoomLevel || o.updateSize()
                    }, 1e3)),
                    i.addClass(t, "pswp--visible")
                }
            },
            close: function() {
                u && (u = !1,
                c = !0,
                Mt("close"),
                qt(),
                nn(o.currItem, null, !0, o.destroy))
            },
            destroy: function() {
                Mt("destroy"),
                Ze && clearTimeout(Ze),
                t.setAttribute("aria-hidden", "true"),
                t.className = N,
                C && clearInterval(C),
                i.unbind(o.scrollWrap, g, o),
                i.unbind(window, "scroll", o),
                Se(),
                ne(),
                Et = null
            },
            panTo: function(t, e, n) {
                n || (t > rt.min.x ? t = rt.min.x : t < rt.max.x && (t = rt.max.x),
                e > rt.min.y ? e = rt.min.y : e < rt.max.y && (e = rt.max.y)),
                mt.x = t,
                mt.y = e,
                jt()
            },
            handleEvent: function(t) {
                t = t || window.event,
                v[t.type] && v[t.type](t)
            },
            goTo: function(t) {
                t = Tt(t);
                var e = t - p;
                wt = e,
                p = t,
                o.currItem = Je(p),
                vt -= e,
                Pt(bt.x * vt),
                ne(),
                ot = !1,
                o.updateCurrItem()
            },
            next: function() {
                o.goTo(p + 1)
            },
            prev: function() {
                o.goTo(p - 1)
            },
            updateCurrZoomItem: function(t) {
                if (t && Mt("beforeChange", 0),
                _[1].el.children.length) {
                    var e = _[1].el.children[0];
                    it = i.hasClass(e, "pswp__zoom-wrap") ? e.style : null
                } else
                    it = null;
                rt = o.currItem.bounds,
                b = y = o.currItem.initialZoomLevel,
                mt.x = rt.center.x,
                mt.y = rt.center.y,
                t && Mt("afterChange")
            },
            invalidateCurrItems: function() {
                k = !0;
                for (var t = 0; t < s; t++)
                    _[t].item && (_[t].item.needsUpdate = !0)
            },
            updateCurrItem: function(t) {
                if (0 !== wt) {
                    var e, n = Math.abs(wt);
                    if (!(t && n < 2)) {
                        o.currItem = Je(p),
                        _t = !1,
                        Mt("beforeChange", wt),
                        n >= s && (h += wt + (wt > 0 ? -s : s),
                        n = s);
                        for (var r = 0; r < n; r++)
                            wt > 0 ? (e = _.shift(),
                            _[s - 1] = e,
                            h++,
                            Nt((h + 2) * bt.x, e.el.style),
                            o.setContent(e, p - n + r + 1 + 1)) : (e = _.pop(),
                            _.unshift(e),
                            h--,
                            Nt(h * bt.x, e.el.style),
                            o.setContent(e, p + n - r - 1 - 1));
                        if (it && 1 === Math.abs(wt)) {
                            var i = Je(S);
                            i.initialZoomLevel !== y && (un(i, gt),
                            fn(i),
                            zt(i))
                        }
                        wt = 0,
                        o.updateCurrZoomItem(),
                        S = p,
                        Mt("afterChange")
                    }
                }
            },
            updateSize: function(e) {
                if (!xt && l.modal) {
                    var n = i.getScrollY();
                    if ($ !== n && (t.style.top = n + "px",
                    $ = n),
                    !e && kt.x === window.innerWidth && kt.y === window.innerHeight)
                        return;
                    kt.x = window.innerWidth,
                    kt.y = window.innerHeight,
                    t.style.height = kt.y + "px"
                }
                if (gt.x = o.scrollWrap.clientWidth,
                gt.y = o.scrollWrap.clientHeight,
                Gt(),
                bt.x = gt.x + Math.round(gt.x * l.spacing),
                bt.y = gt.y,
                Pt(bt.x * vt),
                Mt("beforeResize"),
                void 0 !== h) {
                    for (var r, a, u, c = 0; c < s; c++)
                        r = _[c],
                        Nt((c + h) * bt.x, r.el.style),
                        u = p + c - 1,
                        l.loop && tn() > 2 && (u = Tt(u)),
                        a = Je(u),
                        a && (k || a.needsUpdate || !a.bounds) ? (o.cleanSlide(a),
                        o.setContent(r, u),
                        1 === c && (o.currItem = a,
                        o.updateCurrZoomItem(!0)),
                        a.needsUpdate = !1) : r.index === -1 && u >= 0 && o.setContent(r, u),
                        a && a.container && (un(a, gt),
                        fn(a),
                        zt(a));
                    k = !1
                }
                b = y = o.currItem.initialZoomLevel,
                rt = o.currItem.bounds,
                rt && (mt.x = rt.center.x,
                mt.y = rt.center.y,
                jt(!0)),
                Mt("resize")
            },
            zoomTo: function(t, e, n, r, o) {
                e && (b = y,
                we.x = Math.abs(e.x) - mt.x,
                we.y = Math.abs(e.y) - mt.y,
                $t(ht, mt));
                var a = Wt(t, !1)
                  , s = {};
                Xt("x", a, s, t),
                Xt("y", a, s, t);
                var l = y
                  , u = {
                    x: mt.x,
                    y: mt.y
                };
                Rt(s);
                var c = function(e) {
                    1 === e ? (y = t,
                    mt.x = s.x,
                    mt.y = s.y) : (y = (t - l) * e + l,
                    mt.x = (s.x - u.x) * e + u.x,
                    mt.y = (s.y - u.y) * e + u.y),
                    o && o(e),
                    jt(1 === e)
                };
                n ? re("customZoomTo", 0, 1, n, r || i.easing.sine.inOut, c) : c(1)
            }
        }, oe = 30, ae = 10, se = {}, le = {}, ue = {}, ce = {}, de = {}, pe = [], fe = {}, he = [], me = {}, ge = 0, ve = pt(), ye = 0, be = pt(), we = pt(), xe = pt(), Ce = function(t, e) {
            return t.x === e.x && t.y === e.y
        }, ke = function(t, e) {
            return Math.abs(t.x - e.x) < a && Math.abs(t.y - e.y) < a
        }, _e = function(t, e) {
            return me.x = Math.abs(t.x - e.x),
            me.y = Math.abs(t.y - e.y),
            Math.sqrt(me.x * me.x + me.y * me.y)
        }, Se = function() {
            G && (z(G),
            G = null)
        }, Te = function() {
            X && (G = j(Te),
            Be())
        }, Ee = function() {
            return !("fit" === l.scaleMode && y === o.currItem.initialZoomLevel)
        }, Ae = function(t, e) {
            return !(!t || t === document) && !(t.getAttribute("class") && t.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (e(t) ? t : Ae(t.parentNode, e))
        }, Me = {}, Oe = function(t, e) {
            return Me.prevent = !Ae(t.target, l.isClickableElement),
            Mt("preventDragEvent", t, e, Me),
            Me.prevent
        }, Le = function(t, e) {
            return e.x = t.pageX,
            e.y = t.pageY,
            e.id = t.identifier,
            e
        }, Ie = function(t, e, n) {
            n.x = .5 * (t.x + e.x),
            n.y = .5 * (t.y + e.y)
        }, je = function(t, e, n) {
            if (t - B > 50) {
                var r = he.length > 2 ? he.shift() : {};
                r.x = e,
                r.y = n,
                he.push(r),
                B = t
            }
        }, ze = function() {
            var t = mt.y - o.currItem.initialPosition.y;
            return 1 - Math.abs(t / (gt.y / 2))
        }, Ne = {}, Pe = {}, De = [], $e = function(t) {
            for (; De.length > 0; )
                De.pop();
            return L ? (dt = 0,
            pe.forEach(function(t) {
                0 === dt ? De[0] = t : 1 === dt && (De[1] = t),
                dt++
            })) : t.type.indexOf("touch") > -1 ? t.touches && t.touches.length > 0 && (De[0] = Le(t.touches[0], Ne),
            t.touches.length > 1 && (De[1] = Le(t.touches[1], Pe))) : (Ne.x = t.pageX,
            Ne.y = t.pageY,
            Ne.id = "",
            De[0] = Ne),
            De
        }, Re = function(t, e) {
            var n, r, i, a, s = 0, u = mt[t] + e[t], c = e[t] > 0, d = be.x + e.x, p = be.x - fe.x;
            return n = u > rt.min[t] || u < rt.max[t] ? l.panEndFriction : 1,
            u = mt[t] + e[t] * n,
            !l.allowPanToNext && y !== o.currItem.initialZoomLevel || (it ? "h" !== at || "x" !== t || Z || (c ? (u > rt.min[t] && (n = l.panEndFriction,
            s = rt.min[t] - u,
            r = rt.min[t] - ht[t]),
            (r <= 0 || p < 0) && tn() > 1 ? (a = d,
            p < 0 && d > fe.x && (a = fe.x)) : rt.min.x !== rt.max.x && (i = u)) : (u < rt.max[t] && (n = l.panEndFriction,
            s = u - rt.max[t],
            r = ht[t] - rt.max[t]),
            (r <= 0 || p > 0) && tn() > 1 ? (a = d,
            p > 0 && d < fe.x && (a = fe.x)) : rt.min.x !== rt.max.x && (i = u))) : a = d,
            "x" !== t) ? void (ot || Q || y > o.currItem.fitRatio && (mt[t] += e[t] * n)) : (void 0 !== a && (Pt(a, !0),
            Q = a !== fe.x),
            rt.min.x !== rt.max.x && (void 0 !== i ? mt.x = i : Q || (mt.x += e.x * n)),
            void 0 !== a)
        }, Fe = function(t) {
            if (!("mousedown" === t.type && t.button > 0)) {
                if (Qe)
                    return void t.preventDefault();
                if (!V || "mousedown" !== t.type) {
                    if (Oe(t, !0) && t.preventDefault(),
                    Mt("pointerDown"),
                    L) {
                        var e = i.arraySearch(pe, t.pointerId, "id");
                        e < 0 && (e = pe.length),
                        pe[e] = {
                            x: t.pageX,
                            y: t.pageY,
                            id: t.pointerId
                        }
                    }
                    var n = $e(t)
                      , r = n.length;
                    J = null,
                    ne(),
                    X && 1 !== r || (X = st = !0,
                    i.bind(window, m, o),
                    W = ct = lt = U = Q = K = Y = Z = !1,
                    at = null,
                    Mt("firstTouchStart", n),
                    $t(ht, mt),
                    ft.x = ft.y = 0,
                    $t(ce, n[0]),
                    $t(de, ce),
                    fe.x = bt.x * vt,
                    he = [{
                        x: ce.x,
                        y: ce.y
                    }],
                    B = H = Ot(),
                    Wt(y, !0),
                    Se(),
                    Te()),
                    !tt && r > 1 && !ot && !Q && (b = y,
                    Z = !1,
                    tt = Y = !0,
                    ft.y = ft.x = 0,
                    $t(ht, mt),
                    $t(se, n[0]),
                    $t(le, n[1]),
                    Ie(se, le, xe),
                    we.x = Math.abs(xe.x) - mt.x,
                    we.y = Math.abs(xe.y) - mt.y,
                    et = nt = _e(se, le))
                }
            }
        }, He = function(t) {
            if (t.preventDefault(),
            L) {
                var e = i.arraySearch(pe, t.pointerId, "id");
                if (e > -1) {
                    var n = pe[e];
                    n.x = t.pageX,
                    n.y = t.pageY
                }
            }
            if (X) {
                var r = $e(t);
                if (at || K || tt)
                    J = r;
                else if (be.x !== bt.x * vt)
                    at = "h";
                else {
                    var o = Math.abs(r[0].x - ce.x) - Math.abs(r[0].y - ce.y);
                    Math.abs(o) >= ae && (at = o > 0 ? "h" : "v",
                    J = r)
                }
            }
        }, Be = function() {
            if (J) {
                var t = J.length;
                if (0 !== t)
                    if ($t(se, J[0]),
                    ue.x = se.x - ce.x,
                    ue.y = se.y - ce.y,
                    tt && t > 1) {
                        if (ce.x = se.x,
                        ce.y = se.y,
                        !ue.x && !ue.y && Ce(J[1], le))
                            return;
                        $t(le, J[1]),
                        Z || (Z = !0,
                        Mt("zoomGestureStarted"));
                        var e = _e(se, le)
                          , n = Xe(e);
                        n > o.currItem.initialZoomLevel + o.currItem.initialZoomLevel / 15 && (ct = !0);
                        var r = 1
                          , i = Ut()
                          , a = Vt();
                        if (n < i)
                            if (l.pinchToClose && !ct && b <= o.currItem.initialZoomLevel) {
                                var s = i - n
                                  , u = 1 - s / (i / 1.2);
                                Lt(u),
                                Mt("onPinchClose", u),
                                lt = !0
                            } else
                                r = (i - n) / i,
                                r > 1 && (r = 1),
                                n = i - r * (i / 3);
                        else
                            n > a && (r = (n - a) / (6 * i),
                            r > 1 && (r = 1),
                            n = a + r * i);
                        r < 0 && (r = 0),
                        et = e,
                        Ie(se, le, ve),
                        ft.x += ve.x - xe.x,
                        ft.y += ve.y - xe.y,
                        $t(xe, ve),
                        mt.x = Dt("x", n),
                        mt.y = Dt("y", n),
                        W = n > y,
                        y = n,
                        jt()
                    } else {
                        if (!at)
                            return;
                        if (st && (st = !1,
                        Math.abs(ue.x) >= ae && (ue.x -= J[0].x - de.x),
                        Math.abs(ue.y) >= ae && (ue.y -= J[0].y - de.y)),
                        ce.x = se.x,
                        ce.y = se.y,
                        0 === ue.x && 0 === ue.y)
                            return;
                        if ("v" === at && l.closeOnVerticalDrag && !Ee()) {
                            ft.y += ue.y,
                            mt.y += ue.y;
                            var c = ze();
                            return U = !0,
                            Mt("onVerticalDrag", c),
                            Lt(c),
                            void jt()
                        }
                        je(Ot(), se.x, se.y),
                        K = !0,
                        rt = o.currItem.bounds;
                        var d = Re("x", ue);
                        d || (Re("y", ue),
                        Rt(mt),
                        jt())
                    }
            }
        }, qe = function(t) {
            if (R.isOldAndroid) {
                if (V && "mouseup" === t.type)
                    return;
                t.type.indexOf("touch") > -1 && (clearTimeout(V),
                V = setTimeout(function() {
                    V = 0
                }, 600))
            }
            Mt("pointerUp"),
            Oe(t, !1) && t.preventDefault();
            var e;
            if (L) {
                var n = i.arraySearch(pe, t.pointerId, "id");
                if (n > -1)
                    if (e = pe.splice(n, 1)[0],
                    navigator.pointerEnabled)
                        e.type = t.pointerType || "mouse";
                    else {
                        var r = {
                            4: "mouse",
                            2: "touch",
                            3: "pen"
                        };
                        e.type = r[t.pointerType],
                        e.type || (e.type = t.pointerType || "mouse")
                    }
            }
            var a, s = $e(t), u = s.length;
            if ("mouseup" === t.type && (u = 0),
            2 === u)
                return J = null,
                !0;
            1 === u && $t(de, s[0]),
            0 !== u || at || ot || (e || ("mouseup" === t.type ? e = {
                x: t.pageX,
                y: t.pageY,
                type: "mouse"
            } : t.changedTouches && t.changedTouches[0] && (e = {
                x: t.changedTouches[0].pageX,
                y: t.changedTouches[0].pageY,
                type: "touch"
            })),
            Mt("touchRelease", t, e));
            var c = -1;
            if (0 === u && (X = !1,
            i.unbind(window, m, o),
            Se(),
            tt ? c = 0 : ye !== -1 && (c = Ot() - ye)),
            ye = 1 === u ? Ot() : -1,
            a = c !== -1 && c < 150 ? "zoom" : "swipe",
            tt && u < 2 && (tt = !1,
            1 === u && (a = "zoomPointerUp"),
            Mt("zoomGestureEnded")),
            J = null,
            K || Z || ot || U)
                if (ne(),
                q || (q = We()),
                q.calculateSwipeSpeed("x"),
                U) {
                    var d = ze();
                    if (d < l.verticalDragRange)
                        o.close();
                    else {
                        var p = mt.y
                          , f = ut;
                        re("verticalDrag", 0, 1, 300, i.easing.cubic.out, function(t) {
                            mt.y = (o.currItem.initialPosition.y - p) * t + p,
                            Lt((1 - f) * t + f),
                            jt()
                        }),
                        Mt("onVerticalDrag", 1)
                    }
                } else {
                    if ((Q || ot) && 0 === u) {
                        var h = Ve(a, q);
                        if (h)
                            return;
                        a = "zoomPointerUp"
                    }
                    if (!ot)
                        return "swipe" !== a ? void Ye() : void (!Q && y > o.currItem.fitRatio && Ue(q))
                }
        }, We = function() {
            var t, e, n = {
                lastFlickOffset: {},
                lastFlickDist: {},
                lastFlickSpeed: {},
                slowDownRatio: {},
                slowDownRatioReverse: {},
                speedDecelerationRatio: {},
                speedDecelerationRatioAbs: {},
                distanceOffset: {},
                backAnimDestination: {},
                backAnimStarted: {},
                calculateSwipeSpeed: function(r) {
                    he.length > 1 ? (t = Ot() - B + 50,
                    e = he[he.length - 2][r]) : (t = Ot() - H,
                    e = de[r]),
                    n.lastFlickOffset[r] = ce[r] - e,
                    n.lastFlickDist[r] = Math.abs(n.lastFlickOffset[r]),
                    n.lastFlickDist[r] > 20 ? n.lastFlickSpeed[r] = n.lastFlickOffset[r] / t : n.lastFlickSpeed[r] = 0,
                    Math.abs(n.lastFlickSpeed[r]) < .1 && (n.lastFlickSpeed[r] = 0),
                    n.slowDownRatio[r] = .95,
                    n.slowDownRatioReverse[r] = 1 - n.slowDownRatio[r],
                    n.speedDecelerationRatio[r] = 1
                },
                calculateOverBoundsAnimOffset: function(t, e) {
                    n.backAnimStarted[t] || (mt[t] > rt.min[t] ? n.backAnimDestination[t] = rt.min[t] : mt[t] < rt.max[t] && (n.backAnimDestination[t] = rt.max[t]),
                    void 0 !== n.backAnimDestination[t] && (n.slowDownRatio[t] = .7,
                    n.slowDownRatioReverse[t] = 1 - n.slowDownRatio[t],
                    n.speedDecelerationRatioAbs[t] < .05 && (n.lastFlickSpeed[t] = 0,
                    n.backAnimStarted[t] = !0,
                    re("bounceZoomPan" + t, mt[t], n.backAnimDestination[t], e || 300, i.easing.sine.out, function(e) {
                        mt[t] = e,
                        jt()
                    }))))
                },
                calculateAnimOffset: function(t) {
                    n.backAnimStarted[t] || (n.speedDecelerationRatio[t] = n.speedDecelerationRatio[t] * (n.slowDownRatio[t] + n.slowDownRatioReverse[t] - n.slowDownRatioReverse[t] * n.timeDiff / 10),
                    n.speedDecelerationRatioAbs[t] = Math.abs(n.lastFlickSpeed[t] * n.speedDecelerationRatio[t]),
                    n.distanceOffset[t] = n.lastFlickSpeed[t] * n.speedDecelerationRatio[t] * n.timeDiff,
                    mt[t] += n.distanceOffset[t])
                },
                panAnimLoop: function() {
                    if (Qt.zoomPan && (Qt.zoomPan.raf = j(n.panAnimLoop),
                    n.now = Ot(),
                    n.timeDiff = n.now - n.lastNow,
                    n.lastNow = n.now,
                    n.calculateAnimOffset("x"),
                    n.calculateAnimOffset("y"),
                    jt(),
                    n.calculateOverBoundsAnimOffset("x"),
                    n.calculateOverBoundsAnimOffset("y"),
                    n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05))
                        return mt.x = Math.round(mt.x),
                        mt.y = Math.round(mt.y),
                        jt(),
                        void te("zoomPan")
                }
            };
            return n
        }, Ue = function(t) {
            return t.calculateSwipeSpeed("y"),
            rt = o.currItem.bounds,
            t.backAnimDestination = {},
            t.backAnimStarted = {},
            Math.abs(t.lastFlickSpeed.x) <= .05 && Math.abs(t.lastFlickSpeed.y) <= .05 ? (t.speedDecelerationRatioAbs.x = t.speedDecelerationRatioAbs.y = 0,
            t.calculateOverBoundsAnimOffset("x"),
            t.calculateOverBoundsAnimOffset("y"),
            !0) : (ee("zoomPan"),
            t.lastNow = Ot(),
            void t.panAnimLoop())
        }, Ve = function(t, e) {
            var n;
            ot || (ge = p);
            var r;
            if ("swipe" === t) {
                var a = ce.x - de.x
                  , s = e.lastFlickDist.x < 10;
                a > oe && (s || e.lastFlickOffset.x > 20) ? r = -1 : a < -oe && (s || e.lastFlickOffset.x < -20) && (r = 1)
            }
            var u;
            r && (p += r,
            p < 0 ? (p = l.loop ? tn() - 1 : 0,
            u = !0) : p >= tn() && (p = l.loop ? 0 : tn() - 1,
            u = !0),
            u && !l.loop || (wt += r,
            vt -= r,
            n = !0));
            var c, d = bt.x * vt, f = Math.abs(d - be.x);
            return n || d > be.x == e.lastFlickSpeed.x > 0 ? (c = Math.abs(e.lastFlickSpeed.x) > 0 ? f / Math.abs(e.lastFlickSpeed.x) : 333,
            c = Math.min(c, 400),
            c = Math.max(c, 250)) : c = 333,
            ge === p && (n = !1),
            ot = !0,
            Mt("mainScrollAnimStart"),
            re("mainScroll", be.x, d, c, i.easing.cubic.out, Pt, function() {
                ne(),
                ot = !1,
                ge = -1,
                (n || ge !== p) && o.updateCurrItem(),
                Mt("mainScrollAnimComplete")
            }),
            n && o.updateCurrItem(!0),
            n
        }, Xe = function(t) {
            return 1 / nt * t * b
        }, Ye = function() {
            var t = y
              , e = Ut()
              , n = Vt();
            y < e ? t = e : y > n && (t = n);
            var r, a = 1, s = ut;
            return lt && !W && !ct && y < e ? (o.close(),
            !0) : (lt && (r = function(t) {
                Lt((a - s) * t + s)
            }
            ),
            o.zoomTo(t, 0, 200, i.easing.cubic.out, r),
            !0)
        };
        St("Gestures", {
            publicMethods: {
                initGestures: function() {
                    var t = function(t, e, n, r, i) {
                        T = t + e,
                        E = t + n,
                        A = t + r,
                        M = i ? t + i : ""
                    };
                    L = R.pointerEvent,
                    L && R.touch && (R.touch = !1),
                    L ? navigator.pointerEnabled ? t("pointer", "down", "move", "up", "cancel") : t("MSPointer", "Down", "Move", "Up", "Cancel") : R.touch ? (t("touch", "start", "move", "end", "cancel"),
                    I = !0) : t("mouse", "down", "move", "up"),
                    m = E + " " + A + " " + M,
                    g = T,
                    L && !I && (I = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
                    o.likelyTouchDevice = I,
                    v[T] = Fe,
                    v[E] = He,
                    v[A] = qe,
                    M && (v[M] = v[A]),
                    R.touch && (g += " mousedown",
                    m += " mousemove mouseup",
                    v.mousedown = v[T],
                    v.mousemove = v[E],
                    v.mouseup = v[A]),
                    I || (l.allowPanToNext = !1)
                }
            }
        });
        var Ze, Ke, Ge, Qe, Je, tn, en, nn = function(e, n, r, a) {
            Ze && clearTimeout(Ze),
            Qe = !0,
            Ge = !0;
            var s;
            e.initialLayout ? (s = e.initialLayout,
            e.initialLayout = null) : s = l.getThumbBoundsFn && l.getThumbBoundsFn(p);
            var u = r ? l.hideAnimationDuration : l.showAnimationDuration
              , c = function() {
                te("initialZoom"),
                r ? (o.template.removeAttribute("style"),
                o.bg.removeAttribute("style")) : (Lt(1),
                n && (n.style.display = "block"),
                i.addClass(t, "pswp--animated-in"),
                Mt("initialZoom" + (r ? "OutEnd" : "InEnd"))),
                a && a(),
                Qe = !1
            };
            if (!u || !s || void 0 === s.x)
                return Mt("initialZoom" + (r ? "Out" : "In")),
                y = e.initialZoomLevel,
                $t(mt, e.initialPosition),
                jt(),
                t.style.opacity = r ? 0 : 1,
                Lt(1),
                void (u ? setTimeout(function() {
                    c()
                }, u) : c());
            var f = function() {
                var n = d
                  , a = !o.currItem.src || o.currItem.loadError || l.showHideOpacity;
                e.miniImg && (e.miniImg.style.webkitBackfaceVisibility = "hidden"),
                r || (y = s.w / e.w,
                mt.x = s.x,
                mt.y = s.y - P,
                o[a ? "template" : "bg"].style.opacity = .001,
                jt()),
                ee("initialZoom"),
                r && !n && i.removeClass(t, "pswp--animated-in"),
                a && (r ? i[(n ? "remove" : "add") + "Class"](t, "pswp--animate_opacity") : setTimeout(function() {
                    i.addClass(t, "pswp--animate_opacity")
                }, 30)),
                Ze = setTimeout(function() {
                    if (Mt("initialZoom" + (r ? "Out" : "In")),
                    r) {
                        var o = s.w / e.w
                          , l = {
                            x: mt.x,
                            y: mt.y
                        }
                          , d = y
                          , p = ut
                          , f = function(e) {
                            1 === e ? (y = o,
                            mt.x = s.x,
                            mt.y = s.y - $) : (y = (o - d) * e + d,
                            mt.x = (s.x - l.x) * e + l.x,
                            mt.y = (s.y - $ - l.y) * e + l.y),
                            jt(),
                            a ? t.style.opacity = 1 - e : Lt(p - e * p)
                        };
                        n ? re("initialZoom", 0, 1, u, i.easing.cubic.out, f, c) : (f(1),
                        Ze = setTimeout(c, u + 20))
                    } else
                        y = e.initialZoomLevel,
                        $t(mt, e.initialPosition),
                        jt(),
                        Lt(1),
                        a ? t.style.opacity = 1 : Lt(1),
                        Ze = setTimeout(c, u + 20)
                }, r ? 25 : 90)
            };
            f()
        }, rn = {}, on = [], an = {
            index: 0,
            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
            forceProgressiveLoading: !1,
            preload: [1, 1],
            getNumItemsFn: function() {
                return Ke.length
            }
        }, sn = function() {
            return {
                center: {
                    x: 0,
                    y: 0
                },
                max: {
                    x: 0,
                    y: 0
                },
                min: {
                    x: 0,
                    y: 0
                }
            }
        }, ln = function(t, e, n) {
            var r = t.bounds;
            r.center.x = Math.round((rn.x - e) / 2),
            r.center.y = Math.round((rn.y - n) / 2) + t.vGap.top,
            r.max.x = e > rn.x ? Math.round(rn.x - e) : r.center.x,
            r.max.y = n > rn.y ? Math.round(rn.y - n) + t.vGap.top : r.center.y,
            r.min.x = e > rn.x ? 0 : r.center.x,
            r.min.y = n > rn.y ? t.vGap.top : r.center.y
        }, un = function(t, e, n) {
            if (t.src && !t.loadError) {
                var r = !n;
                if (r && (t.vGap || (t.vGap = {
                    top: 0,
                    bottom: 0
                }),
                Mt("parseVerticalMargin", t)),
                rn.x = e.x,
                rn.y = e.y - t.vGap.top - t.vGap.bottom,
                r) {
                    var i = rn.x / t.w
                      , o = rn.y / t.h;
                    t.fitRatio = i < o ? i : o;
                    var a = l.scaleMode;
                    "orig" === a ? n = 1 : "fit" === a && (n = t.fitRatio),
                    n > 1 && (n = 1),
                    t.initialZoomLevel = n,
                    t.bounds || (t.bounds = sn())
                }
                if (!n)
                    return;
                return ln(t, t.w * n, t.h * n),
                r && n === t.initialZoomLevel && (t.initialPosition = t.bounds.center),
                t.bounds
            }
            return t.w = t.h = 0,
            t.initialZoomLevel = t.fitRatio = 1,
            t.bounds = sn(),
            t.initialPosition = t.bounds.center,
            t.bounds
        }, cn = function(t, e, n, r, i, a) {
            e.loadError || r && (e.imageAppended = !0,
            fn(e, r, e === o.currItem && _t),
            n.appendChild(r),
            a && setTimeout(function() {
                e && e.loaded && e.placeholder && (e.placeholder.style.display = "none",
                e.placeholder = null)
            }, 500))
        }, dn = function(t) {
            t.loading = !0,
            t.loaded = !1;
            var e = t.img = i.createEl("pswp__img", "img")
              , n = function() {
                t.loading = !1,
                t.loaded = !0,
                t.loadComplete ? t.loadComplete(t) : t.img = null,
                e.onload = e.onerror = null,
                e = null
            };
            return e.onload = n,
            e.onerror = function() {
                t.loadError = !0,
                n()
            }
            ,
            e.src = t.src,
            e
        }, pn = function(t, e) {
            if (t.src && t.loadError && t.container)
                return e && (t.container.innerHTML = ""),
                t.container.innerHTML = l.errorMsg.replace("%url%", t.src),
                !0
        }, fn = function(t, e, n) {
            if (t.src) {
                e || (e = t.container.lastChild);
                var r = n ? t.w : Math.round(t.w * t.fitRatio)
                  , i = n ? t.h : Math.round(t.h * t.fitRatio);
                t.placeholder && !t.loaded && (t.placeholder.style.width = r + "px",
                t.placeholder.style.height = i + "px"),
                e.style.width = r + "px",
                e.style.height = i + "px"
            }
        }, hn = function() {
            if (on.length) {
                for (var t, e = 0; e < on.length; e++)
                    t = on[e],
                    t.holder.index === t.index && cn(t.index, t.item, t.baseDiv, t.img, !1, t.clearPlaceholder);
                on = []
            }
        };
        St("Controller", {
            publicMethods: {
                lazyLoadItem: function(t) {
                    t = Tt(t);
                    var e = Je(t);
                    e && (!e.loaded && !e.loading || k) && (Mt("gettingData", t, e),
                    e.src && dn(e))
                },
                initController: function() {
                    i.extend(l, an, !0),
                    o.items = Ke = n,
                    Je = o.getItemAt,
                    tn = l.getNumItemsFn,
                    en = l.loop,
                    tn() < 3 && (l.loop = !1),
                    At("beforeChange", function(t) {
                        var e, n = l.preload, r = null === t || t >= 0, i = Math.min(n[0], tn()), a = Math.min(n[1], tn());
                        for (e = 1; e <= (r ? a : i); e++)
                            o.lazyLoadItem(p + e);
                        for (e = 1; e <= (r ? i : a); e++)
                            o.lazyLoadItem(p - e)
                    }),
                    At("initialLayout", function() {
                        o.currItem.initialLayout = l.getThumbBoundsFn && l.getThumbBoundsFn(p)
                    }),
                    At("mainScrollAnimComplete", hn),
                    At("initialZoomInEnd", hn),
                    At("destroy", function() {
                        for (var t, e = 0; e < Ke.length; e++)
                            t = Ke[e],
                            t.container && (t.container = null),
                            t.placeholder && (t.placeholder = null),
                            t.img && (t.img = null),
                            t.preloader && (t.preloader = null),
                            t.loadError && (t.loaded = t.loadError = !1);
                        on = null
                    })
                },
                getItemAt: function(t) {
                    return t >= 0 && void 0 !== Ke[t] && Ke[t]
                },
                allowProgressiveImg: function() {
                    return l.forceProgressiveLoading || !I || l.mouseUsed || screen.width > 1200
                },
                setContent: function(t, e) {
                    l.loop && (e = Tt(e));
                    var n = o.getItemAt(t.index);
                    n && (n.container = null);
                    var r, a = o.getItemAt(e);
                    if (!a)
                        return void (t.el.innerHTML = "");
                    Mt("gettingData", e, a),
                    t.index = e,
                    t.item = a;
                    var s = a.container = i.createEl("pswp__zoom-wrap");
                    if (!a.src && a.html && (a.html.tagName ? s.appendChild(a.html) : s.innerHTML = a.html),
                    pn(a),
                    un(a, gt),
                    !a.src || a.loadError || a.loaded)
                        a.src && !a.loadError && (r = i.createEl("pswp__img", "img"),
                        r.style.opacity = 1,
                        r.src = a.src,
                        fn(a, r),
                        cn(e, a, s, r, !0));
                    else {
                        if (a.loadComplete = function(n) {
                            if (u) {
                                if (t && t.index === e) {
                                    if (pn(n, !0))
                                        return n.loadComplete = n.img = null,
                                        un(n, gt),
                                        zt(n),
                                        void (t.index === p && o.updateCurrZoomItem());
                                    n.imageAppended ? !Qe && n.placeholder && (n.placeholder.style.display = "none",
                                    n.placeholder = null) : R.transform && (ot || Qe) ? on.push({
                                        item: n,
                                        baseDiv: s,
                                        img: n.img,
                                        index: e,
                                        holder: t,
                                        clearPlaceholder: !0
                                    }) : cn(e, n, s, n.img, ot || Qe, !0)
                                }
                                n.loadComplete = null,
                                n.img = null,
                                Mt("imageLoadComplete", e, n)
                            }
                        }
                        ,
                        i.features.transform) {
                            var c = "pswp__img pswp__img--placeholder";
                            c += a.msrc ? "" : " pswp__img--placeholder--blank";
                            var d = i.createEl(c, a.msrc ? "img" : "");
                            a.msrc && (d.src = a.msrc),
                            fn(a, d),
                            s.appendChild(d),
                            a.placeholder = d
                        }
                        a.loading || dn(a),
                        o.allowProgressiveImg() && (!Ge && R.transform ? on.push({
                            item: a,
                            baseDiv: s,
                            img: a.img,
                            index: e,
                            holder: t
                        }) : cn(e, a, s, a.img, !0, !0))
                    }
                    Ge || e !== p ? zt(a) : (it = s.style,
                    nn(a, r || a.img)),
                    t.el.innerHTML = "",
                    t.el.appendChild(s)
                },
                cleanSlide: function(t) {
                    t.img && (t.img.onload = t.img.onerror = null),
                    t.loaded = t.loading = t.img = t.imageAppended = !1
                }
            }
        });
        var mn, gn = {}, vn = function(t, e, n) {
            var r = document.createEvent("CustomEvent")
              , i = {
                origEvent: t,
                target: t.target,
                releasePoint: e,
                pointerType: n || "touch"
            };
            r.initCustomEvent("pswpTap", !0, !0, i),
            t.target.dispatchEvent(r)
        };
        St("Tap", {
            publicMethods: {
                initTap: function() {
                    At("firstTouchStart", o.onTapStart),
                    At("touchRelease", o.onTapRelease),
                    At("destroy", function() {
                        gn = {},
                        mn = null
                    })
                },
                onTapStart: function(t) {
                    t.length > 1 && (clearTimeout(mn),
                    mn = null)
                },
                onTapRelease: function(t, e) {
                    if (e && !K && !Y && !Jt) {
                        var n = e;
                        if (mn && (clearTimeout(mn),
                        mn = null,
                        ke(n, gn)))
                            return void Mt("doubleTap", n);
                        if ("mouse" === e.type)
                            return void vn(t, e, "mouse");
                        var r = t.target.tagName.toUpperCase();
                        if ("BUTTON" === r || i.hasClass(t.target, "pswp__single-tap"))
                            return void vn(t, e);
                        $t(gn, n),
                        mn = setTimeout(function() {
                            vn(t, e),
                            mn = null
                        }, 300)
                    }
                }
            }
        });
        var yn;
        St("DesktopZoom", {
            publicMethods: {
                initDesktopZoom: function() {
                    D || (I ? At("mouseUsed", function() {
                        o.setupDesktopZoom()
                    }) : o.setupDesktopZoom(!0))
                },
                setupDesktopZoom: function(e) {
                    yn = {};
                    var n = "wheel mousewheel DOMMouseScroll";
                    At("bindEvents", function() {
                        i.bind(t, n, o.handleMouseWheel)
                    }),
                    At("unbindEvents", function() {
                        yn && i.unbind(t, n, o.handleMouseWheel)
                    }),
                    o.mouseZoomedIn = !1;
                    var r, a = function() {
                        o.mouseZoomedIn && (i.removeClass(t, "pswp--zoomed-in"),
                        o.mouseZoomedIn = !1),
                        y < 1 ? i.addClass(t, "pswp--zoom-allowed") : i.removeClass(t, "pswp--zoom-allowed"),
                        s()
                    }, s = function() {
                        r && (i.removeClass(t, "pswp--dragging"),
                        r = !1)
                    };
                    At("resize", a),
                    At("afterChange", a),
                    At("pointerDown", function() {
                        o.mouseZoomedIn && (r = !0,
                        i.addClass(t, "pswp--dragging"))
                    }),
                    At("pointerUp", s),
                    e || a()
                },
                handleMouseWheel: function(t) {
                    if (y <= o.currItem.fitRatio)
                        return l.modal && (!l.closeOnScroll || Jt || X ? t.preventDefault() : O && Math.abs(t.deltaY) > 2 && (d = !0,
                        o.close())),
                        !0;
                    if (t.stopPropagation(),
                    yn.x = 0,
                    "deltaX"in t)
                        1 === t.deltaMode ? (yn.x = 18 * t.deltaX,
                        yn.y = 18 * t.deltaY) : (yn.x = t.deltaX,
                        yn.y = t.deltaY);
                    else if ("wheelDelta"in t)
                        t.wheelDeltaX && (yn.x = -.16 * t.wheelDeltaX),
                        t.wheelDeltaY ? yn.y = -.16 * t.wheelDeltaY : yn.y = -.16 * t.wheelDelta;
                    else {
                        if (!("detail"in t))
                            return;
                        yn.y = t.detail
                    }
                    Wt(y, !0);
                    var e = mt.x - yn.x
                      , n = mt.y - yn.y;
                    (l.modal || e <= rt.min.x && e >= rt.max.x && n <= rt.min.y && n >= rt.max.y) && t.preventDefault(),
                    o.panTo(e, n)
                },
                toggleDesktopZoom: function(e) {
                    e = e || {
                        x: gt.x / 2 + yt.x,
                        y: gt.y / 2 + yt.y
                    };
                    var n = l.getDoubleTapZoom(!0, o.currItem)
                      , r = y === n;
                    o.mouseZoomedIn = !r,
                    o.zoomTo(r ? o.currItem.initialZoomLevel : n, e, 333),
                    i[(r ? "remove" : "add") + "Class"](t, "pswp--zoomed-in")
                }
            }
        });
        var bn, wn, xn, Cn, kn, _n, Sn, Tn, En, An, Mn, On, Ln = {
            history: !0,
            galleryUID: 1
        }, In = function() {
            return Mn.hash.substring(1)
        }, jn = function() {
            bn && clearTimeout(bn),
            xn && clearTimeout(xn)
        }, zn = function() {
            var t = In()
              , e = {};
            if (t.length < 5)
                return e;
            var n, r = t.split("&");
            for (n = 0; n < r.length; n++)
                if (r[n]) {
                    var i = r[n].split("=");
                    i.length < 2 || (e[i[0]] = i[1])
                }
            if (l.galleryPIDs) {
                var o = e.pid;
                for (e.pid = 0,
                n = 0; n < Ke.length; n++)
                    if (Ke[n].pid === o) {
                        e.pid = n;
                        break
                    }
            } else
                e.pid = parseInt(e.pid, 10) - 1;
            return e.pid < 0 && (e.pid = 0),
            e
        }, Nn = function() {
            if (xn && clearTimeout(xn),
            Jt || X)
                return void (xn = setTimeout(Nn, 500));
            Cn ? clearTimeout(wn) : Cn = !0;
            var t = p + 1
              , e = Je(p);
            e.hasOwnProperty("pid") && (t = e.pid);
            var n = Sn + "&gid=" + l.galleryUID + "&pid=" + t;
            Tn || Mn.hash.indexOf(n) === -1 && (An = !0);
            var r = Mn.href.split("#")[0] + "#" + n;
            On ? "#" + n !== window.location.hash && history[Tn ? "replaceState" : "pushState"]("", document.title, r) : Tn ? Mn.replace(r) : Mn.hash = n,
            Tn = !0,
            wn = setTimeout(function() {
                Cn = !1
            }, 60)
        };
        St("History", {
            publicMethods: {
                initHistory: function() {
                    if (i.extend(l, Ln, !0),
                    l.history) {
                        Mn = window.location,
                        An = !1,
                        En = !1,
                        Tn = !1,
                        Sn = In(),
                        On = "pushState"in history,
                        Sn.indexOf("gid=") > -1 && (Sn = Sn.split("&gid=")[0],
                        Sn = Sn.split("?gid=")[0]),
                        At("afterChange", o.updateURL),
                        At("unbindEvents", function() {
                            i.unbind(window, "hashchange", o.onHashChange)
                        });
                        var t = function() {
                            _n = !0,
                            En || (An ? history.back() : Sn ? Mn.hash = Sn : On ? history.pushState("", document.title, Mn.pathname + Mn.search) : Mn.hash = ""),
                            jn()
                        };
                        At("unbindEvents", function() {
                            d && t()
                        }),
                        At("destroy", function() {
                            _n || t()
                        }),
                        At("firstUpdate", function() {
                            p = zn().pid
                        });
                        var e = Sn.indexOf("pid=");
                        e > -1 && (Sn = Sn.substring(0, e),
                        "&" === Sn.slice(-1) && (Sn = Sn.slice(0, -1))),
                        setTimeout(function() {
                            u && i.bind(window, "hashchange", o.onHashChange)
                        }, 40)
                    }
                },
                onHashChange: function() {
                    return In() === Sn ? (En = !0,
                    void o.close()) : void (Cn || (kn = !0,
                    o.goTo(zn().pid),
                    kn = !1))
                },
                updateURL: function() {
                    jn(),
                    kn || (Tn ? bn = setTimeout(Nn, 800) : Nn())
                }
            }
        }),
        i.extend(o, ie)
    };
    return t
}),
/*! PhotoSwipe Default UI - 4.1.2 - 2017-04-05 http://photoswipe.com (c) 2017 Dmitry Semenov; */
!function(t, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.PhotoSwipeUI_Default = e()
}(this, function() {
    "use strict";
    var t = function(t, e) {
        var n, r, i, o, a, s, l, u, c, d, p, f, h, m, g, v, y, b, w, x = this, C = !1, k = !0, _ = !0, S = {
            barsSize: {
                top: 44,
                bottom: "auto"
            },
            closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
            timeToIdle: 4e3,
            timeToIdleOutside: 1e3,
            loadingIndicatorDelay: 1e3,
            addCaptionHTMLFn: function(t, e) {
                return t.title ? (e.children[0].innerHTML = t.title,
                !0) : (e.children[0].innerHTML = "",
                !1)
            },
            closeEl: !0,
            captionEl: !0,
            fullscreenEl: !0,
            zoomEl: !0,
            shareEl: !0,
            counterEl: !0,
            arrowEl: !0,
            preloaderEl: !0,
            tapToClose: !1,
            tapToToggleControls: !0,
            clickToCloseNonZoomable: !0,
            shareButtons: [{
                id: "facebook",
                label: "Share on Facebook",
                url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
            }, {
                id: "twitter",
                label: "Tweet",
                url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
            }, {
                id: "pinterest",
                label: "Pin it",
                url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
            }, {
                id: "download",
                label: "Download image",
                url: "{{raw_image_url}}",
                download: !0
            }],
            getImageURLForShare: function() {
                return t.currItem.src || ""
            },
            getPageURLForShare: function() {
                return window.location.href
            },
            getTextForShare: function() {
                return t.currItem.title || ""
            },
            indexIndicatorSep: " / ",
            fitControlsWidth: 1200
        }, T = function(t) {
            if (v)
                return !0;
            t = t || window.event,
            g.timeToIdle && g.mouseUsed && !c && P();
            for (var n, r, i = t.target || t.srcElement, o = i.getAttribute("class") || "", a = 0; a < W.length; a++)
                n = W[a],
                n.onTap && o.indexOf("pswp__" + n.name) > -1 && (n.onTap(),
                r = !0);
            if (r) {
                t.stopPropagation && t.stopPropagation(),
                v = !0;
                var s = e.features.isOldAndroid ? 600 : 30;
                y = setTimeout(function() {
                    v = !1
                }, s)
            }
        }, E = function() {
            return !t.likelyTouchDevice || g.mouseUsed || screen.width > g.fitControlsWidth
        }, A = function(t, n, r) {
            e[(r ? "add" : "remove") + "Class"](t, "pswp__" + n)
        }, M = function() {
            var t = 1 === g.getNumItemsFn();
            t !== m && (A(r, "ui--one-slide", t),
            m = t)
        }, O = function() {
            A(l, "share-modal--hidden", _)
        }, L = function() {
            return _ = !_,
            _ ? (e.removeClass(l, "pswp__share-modal--fade-in"),
            setTimeout(function() {
                _ && O()
            }, 300)) : (O(),
            setTimeout(function() {
                _ || e.addClass(l, "pswp__share-modal--fade-in")
            }, 30)),
            _ || j(),
            !1
        }, I = function(e) {
            e = e || window.event;
            var n = e.target || e.srcElement;
            return t.shout("shareLinkClick", e, n),
            !(!n.href || !n.hasAttribute("download") && (window.open(n.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)),
            _ || L(),
            1))
        }, j = function() {
            for (var t, e, n, r, i, o = "", a = 0; a < g.shareButtons.length; a++)
                t = g.shareButtons[a],
                n = g.getImageURLForShare(t),
                r = g.getPageURLForShare(t),
                i = g.getTextForShare(t),
                e = t.url.replace("{{url}}", encodeURIComponent(r)).replace("{{image_url}}", encodeURIComponent(n)).replace("{{raw_image_url}}", n).replace("{{text}}", encodeURIComponent(i)),
                o += '<a href="' + e + '" target="_blank" class="pswp__share--' + t.id + '"' + (t.download ? "download" : "") + ">" + t.label + "</a>",
                g.parseShareButtonOut && (o = g.parseShareButtonOut(t, o));
            l.children[0].innerHTML = o,
            l.children[0].onclick = I
        }, z = function(t) {
            for (var n = 0; n < g.closeElClasses.length; n++)
                if (e.hasClass(t, "pswp__" + g.closeElClasses[n]))
                    return !0
        }, N = 0, P = function() {
            clearTimeout(w),
            N = 0,
            c && x.setIdle(!1)
        }, D = function(t) {
            t = t ? t : window.event;
            var e = t.relatedTarget || t.toElement;
            e && "HTML" !== e.nodeName || (clearTimeout(w),
            w = setTimeout(function() {
                x.setIdle(!0)
            }, g.timeToIdleOutside))
        }, $ = function() {
            g.fullscreenEl && !e.features.isOldAndroid && (n || (n = x.getFullscreenAPI()),
            n ? (e.bind(document, n.eventK, x.updateFullscreen),
            x.updateFullscreen(),
            e.addClass(t.template, "pswp--supports-fs")) : e.removeClass(t.template, "pswp--supports-fs"))
        }, R = function() {
            g.preloaderEl && (F(!0),
            d("beforeChange", function() {
                clearTimeout(h),
                h = setTimeout(function() {
                    t.currItem && t.currItem.loading ? (!t.allowProgressiveImg() || t.currItem.img && !t.currItem.img.naturalWidth) && F(!1) : F(!0)
                }, g.loadingIndicatorDelay)
            }),
            d("imageLoadComplete", function(e, n) {
                t.currItem === n && F(!0)
            }))
        }, F = function(t) {
            f !== t && (A(p, "preloader--active", !t),
            f = t)
        }, H = function(t) {
            var n = t.vGap;
            if (E()) {
                var a = g.barsSize;
                if (g.captionEl && "auto" === a.bottom)
                    if (o || (o = e.createEl("pswp__caption pswp__caption--fake"),
                    o.appendChild(e.createEl("pswp__caption__center")),
                    r.insertBefore(o, i),
                    e.addClass(r, "pswp__ui--fit")),
                    g.addCaptionHTMLFn(t, o, !0)) {
                        var s = o.clientHeight;
                        n.bottom = parseInt(s, 10) || 44
                    } else
                        n.bottom = a.top;
                else
                    n.bottom = "auto" === a.bottom ? 0 : a.bottom;
                n.top = a.top
            } else
                n.top = n.bottom = 0
        }, B = function() {
            g.timeToIdle && d("mouseUsed", function() {
                e.bind(document, "mousemove", P),
                e.bind(document, "mouseout", D),
                b = setInterval(function() {
                    N++,
                    2 === N && x.setIdle(!0)
                }, g.timeToIdle / 2)
            })
        }, q = function() {
            d("onVerticalDrag", function(t) {
                k && t < .95 ? x.hideControls() : !k && t >= .95 && x.showControls()
            });
            var t;
            d("onPinchClose", function(e) {
                k && e < .9 ? (x.hideControls(),
                t = !0) : t && !k && e > .9 && x.showControls()
            }),
            d("zoomGestureEnded", function() {
                t = !1,
                t && !k && x.showControls()
            })
        }, W = [{
            name: "caption",
            option: "captionEl",
            onInit: function(t) {
                i = t
            }
        }, {
            name: "share-modal",
            option: "shareEl",
            onInit: function(t) {
                l = t
            },
            onTap: function() {
                L()
            }
        }, {
            name: "button--share",
            option: "shareEl",
            onInit: function(t) {
                s = t
            },
            onTap: function() {
                L()
            }
        }, {
            name: "button--zoom",
            option: "zoomEl",
            onTap: t.toggleDesktopZoom
        }, {
            name: "counter",
            option: "counterEl",
            onInit: function(t) {
                a = t
            }
        }, {
            name: "button--close",
            option: "closeEl",
            onTap: t.close
        }, {
            name: "button--arrow--left",
            option: "arrowEl",
            onTap: t.prev
        }, {
            name: "button--arrow--right",
            option: "arrowEl",
            onTap: t.next
        }, {
            name: "button--fs",
            option: "fullscreenEl",
            onTap: function() {
                n.isFullscreen() ? n.exit() : n.enter()
            }
        }, {
            name: "preloader",
            option: "preloaderEl",
            onInit: function(t) {
                p = t
            }
        }], U = function() {
            var t, n, i, o = function(r) {
                if (r)
                    for (var o = r.length, a = 0; a < o; a++) {
                        t = r[a],
                        n = t.className;
                        for (var s = 0; s < W.length; s++)
                            i = W[s],
                            n.indexOf("pswp__" + i.name) > -1 && (g[i.option] ? (e.removeClass(t, "pswp__element--disabled"),
                            i.onInit && i.onInit(t)) : e.addClass(t, "pswp__element--disabled"))
                    }
            };
            o(r.children);
            var a = e.getChildByClass(r, "pswp__top-bar");
            a && o(a.children)
        };
        x.init = function() {
            e.extend(t.options, S, !0),
            g = t.options,
            r = e.getChildByClass(t.scrollWrap, "pswp__ui"),
            d = t.listen,
            q(),
            d("beforeChange", x.update),
            d("doubleTap", function(e) {
                var n = t.currItem.initialZoomLevel;
                t.getZoomLevel() !== n ? t.zoomTo(n, e, 333) : t.zoomTo(g.getDoubleTapZoom(!1, t.currItem), e, 333)
            }),
            d("preventDragEvent", function(t, e, n) {
                var r = t.target || t.srcElement;
                r && r.getAttribute("class") && t.type.indexOf("mouse") > -1 && (r.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(r.tagName)) && (n.prevent = !1)
            }),
            d("bindEvents", function() {
                e.bind(r, "pswpTap click", T),
                e.bind(t.scrollWrap, "pswpTap", x.onGlobalTap),
                t.likelyTouchDevice || e.bind(t.scrollWrap, "mouseover", x.onMouseOver)
            }),
            d("unbindEvents", function() {
                _ || L(),
                b && clearInterval(b),
                e.unbind(document, "mouseout", D),
                e.unbind(document, "mousemove", P),
                e.unbind(r, "pswpTap click", T),
                e.unbind(t.scrollWrap, "pswpTap", x.onGlobalTap),
                e.unbind(t.scrollWrap, "mouseover", x.onMouseOver),
                n && (e.unbind(document, n.eventK, x.updateFullscreen),
                n.isFullscreen() && (g.hideAnimationDuration = 0,
                n.exit()),
                n = null)
            }),
            d("destroy", function() {
                g.captionEl && (o && r.removeChild(o),
                e.removeClass(i, "pswp__caption--empty")),
                l && (l.children[0].onclick = null),
                e.removeClass(r, "pswp__ui--over-close"),
                e.addClass(r, "pswp__ui--hidden"),
                x.setIdle(!1)
            }),
            g.showAnimationDuration || e.removeClass(r, "pswp__ui--hidden"),
            d("initialZoomIn", function() {
                g.showAnimationDuration && e.removeClass(r, "pswp__ui--hidden")
            }),
            d("initialZoomOut", function() {
                e.addClass(r, "pswp__ui--hidden")
            }),
            d("parseVerticalMargin", H),
            U(),
            g.shareEl && s && l && (_ = !0),
            M(),
            B(),
            $(),
            R()
        }
        ,
        x.setIdle = function(t) {
            c = t,
            A(r, "ui--idle", t)
        }
        ,
        x.update = function() {
            k && t.currItem ? (x.updateIndexIndicator(),
            g.captionEl && (g.addCaptionHTMLFn(t.currItem, i),
            A(i, "caption--empty", !t.currItem.title)),
            C = !0) : C = !1,
            _ || L(),
            M()
        }
        ,
        x.updateFullscreen = function(r) {
            r && setTimeout(function() {
                t.setScrollOffset(0, e.getScrollY())
            }, 50),
            e[(n.isFullscreen() ? "add" : "remove") + "Class"](t.template, "pswp--fs")
        }
        ,
        x.updateIndexIndicator = function() {
            g.counterEl && (a.innerHTML = t.getCurrentIndex() + 1 + g.indexIndicatorSep + g.getNumItemsFn())
        }
        ,
        x.onGlobalTap = function(n) {
            n = n || window.event;
            var r = n.target || n.srcElement;
            if (!v)
                if (n.detail && "mouse" === n.detail.pointerType) {
                    if (z(r))
                        return void t.close();
                    e.hasClass(r, "pswp__img") && (1 === t.getZoomLevel() && t.getZoomLevel() <= t.currItem.fitRatio ? g.clickToCloseNonZoomable && t.close() : t.toggleDesktopZoom(n.detail.releasePoint))
                } else if (g.tapToToggleControls && (k ? x.hideControls() : x.showControls()),
                g.tapToClose && (e.hasClass(r, "pswp__img") || z(r)))
                    return void t.close()
        }
        ,
        x.onMouseOver = function(t) {
            t = t || window.event;
            var e = t.target || t.srcElement;
            A(r, "ui--over-close", z(e))
        }
        ,
        x.hideControls = function() {
            e.addClass(r, "pswp__ui--hidden"),
            k = !1
        }
        ,
        x.showControls = function() {
            k = !0,
            C || x.update(),
            e.removeClass(r, "pswp__ui--hidden")
        }
        ,
        x.supportsFullscreen = function() {
            var t = document;
            return !!(t.exitFullscreen || t.mozCancelFullScreen || t.webkitExitFullscreen || t.msExitFullscreen)
        }
        ,
        x.getFullscreenAPI = function() {
            var e, n = document.documentElement, r = "fullscreenchange";
            return n.requestFullscreen ? e = {
                enterK: "requestFullscreen",
                exitK: "exitFullscreen",
                elementK: "fullscreenElement",
                eventK: r
            } : n.mozRequestFullScreen ? e = {
                enterK: "mozRequestFullScreen",
                exitK: "mozCancelFullScreen",
                elementK: "mozFullScreenElement",
                eventK: "moz" + r
            } : n.webkitRequestFullscreen ? e = {
                enterK: "webkitRequestFullscreen",
                exitK: "webkitExitFullscreen",
                elementK: "webkitFullscreenElement",
                eventK: "webkit" + r
            } : n.msRequestFullscreen && (e = {
                enterK: "msRequestFullscreen",
                exitK: "msExitFullscreen",
                elementK: "msFullscreenElement",
                eventK: "MSFullscreenChange"
            }),
            e && (e.enter = function() {
                return u = g.closeOnScroll,
                g.closeOnScroll = !1,
                "webkitRequestFullscreen" !== this.enterK ? t.template[this.enterK]() : void t.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
            }
            ,
            e.exit = function() {
                return g.closeOnScroll = u,
                document[this.exitK]()
            }
            ,
            e.isFullscreen = function() {
                return document[this.elementK]
            }
            ),
            e
        }
    };
    return t
}),
/*! tinybind.min.js */
/* tinybind https://github.com/blikblum/tinybind */
// Fix overwrite default prefix in bind
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.tinybind = e()
}(this, function() {
    "use strict";
    function t(t) {
        var e = 0
          , n = t;
        return c.test(t) ? n = t.slice(1, -1) : "true" === t ? n = !0 : "false" === t ? n = !1 : "null" === t ? n = null : "undefined" === t ? n = void 0 : isNaN(t) ? e = 1 : n = Number(t),
        {
            type: e,
            value: n
        }
    }
    function e(t, e) {
        for (var n, r = t.length, i = 0, o = 0, a = e[0], s = e[1]; o < r; ) {
            if ((i = t.indexOf(a, o)) < 0) {
                n && n.push({
                    type: 0,
                    value: t.slice(o)
                });
                break
            }
            if (n || (n = []),
            0 < i && o < i && n.push({
                type: 0,
                value: t.slice(o, i)
            }),
            o = i + a.length,
            (i = t.indexOf(s, o)) < 0) {
                var l = t.slice(o - s.length)
                  , u = n[n.length - 1];
                u && 0 === u.type ? u.value += l : n.push({
                    type: 0,
                    value: l
                });
                break
            }
            var c = t.slice(o, i).trim();
            n.push({
                type: 1,
                value: c
            }),
            o = i + s.length
        }
        return n
    }
    function n(t) {
        return "object" == typeof t && null !== t
    }
    function r(t, e, r) {
        this.keypath = e,
        this.callback = r,
        this.objectPath = [],
        this.parse(),
        this.obj = this.getRootObject(t),
        n(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback)
    }
    function i(t, e, n) {
        var r = t.el.cloneNode(!0)
          , i = new x(r,e,t.view.options);
        return i.bind(),
        t.marker.parentNode.insertBefore(r, n),
        i
    }
    var o, a, s, l = ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler"], u = ["binders", "formatters", "adapters"], c = /^'.*'$|^".*"$/, d = {
        binders: {},
        formatters: {},
        adapters: {},
        _prefix: "rv",
        _fullPrefix: "rv-",
        get prefix() {
            return this._prefix
        },
        set prefix(t) {
            this._prefix = t,
            this._fullPrefix = t + "-"
        },
        parseTemplate: e,
        parseType: t,
        templateDelimiters: ["{", "}"],
        rootInterface: ".",
        preloadData: !0,
        handler: function(t, e, n) {
            this.call(t, e, n.view.models)
        },
        fallbackBinder: function(t, e) {
            null != e ? t.setAttribute(this.type, e) : t.removeAttribute(this.type)
        },
        configure: function(t) {
            var e = this;
            t && Object.keys(t).forEach(function(n) {
                var r = t[n];
                -1 < u.indexOf(n) ? Object.keys(r).forEach(function(t) {
                    e[n][t] = r[t]
                }) : e[n] = r
            })
        }
    };
    r.updateOptions = function(t) {
        o = t.adapters,
        a = Object.keys(o),
        s = t.rootInterface
    }
    ,
    r.tokenize = function(t, e) {
        var n, r, i = [], o = {
            i: e,
            path: ""
        };
        for (n = 0; n < t.length; n++)
            r = t.charAt(n),
            ~a.indexOf(r) ? (i.push(o),
            o = {
                i: r,
                path: ""
            }) : o.path += r;
        return i.push(o),
        i
    }
    ,
    r.prototype.parse = function() {
        var t, e;
        a.length || function(t) {
            throw new Error("[Observer] " + t)
        }("Must define at least one adapter interface."),
        ~a.indexOf(this.keypath[0]) ? (e = this.keypath[0],
        t = this.keypath.substr(1)) : (e = s,
        t = this.keypath),
        this.tokens = r.tokenize(t, e),
        this.key = this.tokens.pop()
    }
    ,
    r.prototype.realize = function() {
        for (var t, e, r = this.obj, i = -1, o = 0; o < this.tokens.length; o++)
            e = this.tokens[o],
            n(r) ? (void 0 !== this.objectPath[o] ? r !== (t = this.objectPath[o]) && (this.set(!1, e, t, this),
            this.set(!0, e, r, this),
            this.objectPath[o] = r) : (this.set(!0, e, r, this),
            this.objectPath[o] = r),
            r = this.get(e, r)) : (-1 === i && (i = o),
            (t = this.objectPath[o]) && this.set(!1, e, t, this));
        return -1 !== i && this.objectPath.splice(i),
        r
    }
    ,
    r.prototype.sync = function() {
        var t, e, r;
        (t = this.realize()) !== this.target ? (n(this.target) && this.set(!1, this.key, this.target, this.callback),
        n(t) && this.set(!0, this.key, t, this.callback),
        e = this.value(),
        this.target = t,
        ((r = this.value()) !== e || r instanceof Function) && this.callback.sync()) : t instanceof Array && this.callback.sync()
    }
    ,
    r.prototype.value = function() {
        if (n(this.target))
            return this.get(this.key, this.target)
    }
    ,
    r.prototype.setValue = function(t) {
        n(this.target) && o[this.key.i].set(this.target, this.key.path, t)
    }
    ,
    r.prototype.get = function(t, e) {
        return o[t.i].get(e, t.path)
    }
    ,
    r.prototype.set = function(t, e, n, r) {
        var i = t ? "observe" : "unobserve";
        o[e.i][i](n, e.path, r)
    }
    ,
    r.prototype.unobserve = function() {
        for (var t, e, r = 0; r < this.tokens.length; r++)
            e = this.tokens[r],
            (t = this.objectPath[r]) && this.set(!1, e, t, this);
        n(this.target) && this.set(!1, this.key, this.target, this.callback)
    }
    ,
    r.prototype.getRootObject = function(t) {
        var e, n;
        if (!t.$parent)
            return t;
        for (e = this.tokens.length ? this.tokens[0].path : this.key.path,
        n = t; n.$parent && void 0 === n[e]; )
            n = n.$parent;
        return n
    }
    ;
    var p = function(t, e) {
        if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function")
    }
      , f = /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g
      , h = /\s+/
      , m = function() {
        function e(t, n, r, i, o, a, s) {
            p(this, e),
            this.view = t,
            this.el = n,
            this.type = r,
            this.keypath = i,
            this.binder = o,
            this.arg = a,
            this.formatters = s,
            this.formatterObservers = {},
            this.model = void 0
        }
        return e.prototype.observe = function(t, e) {
            return new r(t,e,this)
        }
        ,
        e.prototype.parseTarget = function() {
            if (this.keypath) {
                var e = t(this.keypath);
                0 === e.type ? this.value = e.value : (this.observer = this.observe(this.view.models, this.keypath),
                this.model = this.observer.target)
            } else
                this.value = void 0
        }
        ,
        e.prototype.parseFormatterArguments = function(e, n) {
            var r = this;
            return e.map(t).map(function(t, e) {
                var i = t.type
                  , o = t.value;
                if (0 === i)
                    return o;
                r.formatterObservers[n] || (r.formatterObservers[n] = {});
                var a = r.formatterObservers[n][e];
                return a || (a = r.observe(r.view.models, o),
                r.formatterObservers[n][e] = a),
                a.value()
            })
        }
        ,
        e.prototype.formattedValue = function(t) {
            var e = this;
            return this.formatters.reduce(function(t, n, r) {
                var i = n.match(f)
                  , o = i.shift()
                  , a = e.view.options.formatters[o]
                  , s = e.parseFormatterArguments(i, r);
                return a && a.read instanceof Function ? t = a.read.apply(a, [t].concat(s)) : a instanceof Function && (t = a.apply(void 0, [t].concat(s))),
                t
            }, t)
        }
        ,
        e.prototype.eventHandler = function(t) {
            var e = this
              , n = e.view.options.handler;
            return function(r) {
                n.call(t, this, r, e)
            }
        }
        ,
        e.prototype.set = function(t) {
            t = t instanceof Function && !this.binder.function ? this.formattedValue(t.call(this.model)) : this.formattedValue(t);
            var e = this.binder.routine || this.binder;
            e instanceof Function && e.call(this, this.el, t)
        }
        ,
        e.prototype.sync = function() {
            this.observer ? (this.model = this.observer.target,
            this.set(this.observer.value())) : this.set(this.value)
        }
        ,
        e.prototype.publish = function() {
            var t = this;
            if (this.observer) {
                var e = this.formatters.reduceRight(function(e, n, r) {
                    var i = n.split(h)
                      , o = i.shift()
                      , a = t.view.options.formatters[o]
                      , s = t.parseFormatterArguments(i, r);
                    return a && a.publish && (e = a.publish.apply(a, [e].concat(s))),
                    e
                }, this.getValue(this.el));
                this.observer.setValue(e)
            }
        }
        ,
        e.prototype.bind = function() {
            this.parseTarget(),
            this.binder.hasOwnProperty("bind") && this.binder.bind.call(this, this.el),
            this.view.options.preloadData && this.sync()
        }
        ,
        e.prototype.unbind = function() {
            var t = this;
            this.binder.unbind && this.binder.unbind.call(this, this.el),
            this.observer && this.observer.unobserve(),
            Object.keys(this.formatterObservers).forEach(function(e) {
                var n = t.formatterObservers[e];
                Object.keys(n).forEach(function(t) {
                    n[t].unobserve()
                })
            }),
            this.formatterObservers = {}
        }
        ,
        e.prototype.update = function() {
            var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
            this.observer && (this.model = this.observer.target),
            this.binder.update && this.binder.update.call(this, t)
        }
        ,
        e.prototype.getValue = function(t) {
            return this.binder && this.binder.getValue ? this.binder.getValue.call(this, t) : (n = [],
            "checkbox" === (e = t).type ? e.checked : "select-multiple" === e.type ? (e.options.forEach(function(t) {
                t.selected && n.push(t.value)
            }),
            n) : e.value);
            var e, n
        }
        ,
        e
    }()
      , g = {
        routine: function(t, e) {
            t.data = null != e ? e : ""
        }
    }
      , v = /((?:'[^']*')*(?:(?:[^\|']*(?:'[^']*')+[^\|']*)+|[^\|]+))|^$/g
      , y = function t(n, r) {
        var i = !1;
        if (3 === r.nodeType) {
            var o = e(r.data, d.templateDelimiters);
            if (o) {
                for (var a = 0; a < o.length; a++) {
                    var s = o[a]
                      , l = document.createTextNode(s.value);
                    r.parentNode.insertBefore(l, r),
                    1 === s.type && n.buildBinding(l, null, s.value, g, null)
                }
                r.parentNode.removeChild(r)
            }
            i = !0
        } else
            1 === r.nodeType && (i = n.traverse(r));
        if (!i)
            for (var u = 0; u < r.childNodes.length; u++)
                t(n, r.childNodes[u])
    }
      , b = function(t, e) {
        var n = t.binder && t.binder.priority || 0;
        return (e.binder && e.binder.priority || 0) - n
    }
      , w = function(t) {
        return t.trim()
    }
      , x = function() {
        function t(e, n, r) {
            p(this, t),
            e.jquery || e instanceof Array ? this.els = e : this.els = [e],
            this.models = n,
            this.options = r,
            this.build()
        }
        return t.prototype.buildBinding = function(t, e, n, r, i) {
            var o = n.match(v).map(w)
              , a = o.shift();
            this.bindings.push(new m(this,t,e,a,r,i,o))
        }
        ,
        t.prototype.build = function() {
            this.bindings = [];
            var t, e = this.els, n = void 0;
            for (n = 0,
            t = e.length; n < t; n++)
                y(this, e[n]);
            this.bindings.sort(b)
        }
        ,
        t.prototype.traverse = function(t) {
            for (var e, n, r, i, o = this.options.prefix ? this.options.prefix + "-" : d._fullPrefix, a = "SCRIPT" === t.nodeName || "STYLE" === t.nodeName, s = t.attributes, l = [], u = this.options.starBinders, c = 0, p = s.length; c < p; c++) {
                var f = s[c];
                if (0 === f.name.indexOf(o)) {
                    if (e = f.name.slice(o.length),
                    i = void 0,
                    !(n = this.options.binders[e]))
                        for (var h = 0; h < u.length; h++)
                            if (r = u[h],
                            e.slice(0, r.length - 1) === r.slice(0, -1)) {
                                n = this.options.binders[r],
                                i = e.slice(r.length - 1);
                                break
                            }
                    if (n || (n = d.fallbackBinder),
                    n.block)
                        return this.buildBinding(t, e, f.value, n, i),
                        t.removeAttribute(f.name),
                        !0;
                    l.push({
                        attr: f,
                        binder: n,
                        type: e,
                        arg: i
                    })
                }
            }
            for (var m = 0; m < l.length; m++) {
                var g = l[m];
                this.buildBinding(t, g.type, g.attr.value, g.binder, g.arg),
                t.removeAttribute(g.attr.name)
            }
            return a
        }
        ,
        t.prototype.bind = function() {
            this.bindings.forEach(function(t) {
                t.bind()
            })
        }
        ,
        t.prototype.unbind = function() {
            this.bindings.forEach(function(t) {
                t.unbind()
            })
        }
        ,
        t.prototype.sync = function() {
            this.bindings.forEach(function(t) {
                t.sync()
            })
        }
        ,
        t.prototype.publish = function() {
            this.bindings.forEach(function(t) {
                t.binder && t.binder.publishes && t.publish()
            })
        }
        ,
        t.prototype.update = function() {
            var t = this
              , e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
            Object.keys(e).forEach(function(n) {
                t.models[n] = e[n]
            }),
            this.bindings.forEach(function(t) {
                t.update && t.update(e)
            })
        }
        ,
        t
    }()
      , C = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"]
      , k = {
        counter: 0,
        weakmap: {},
        weakReference: function(t) {
            if (!t.hasOwnProperty("__rv")) {
                var e = this.counter++;
                Object.defineProperty(t, "__rv", {
                    value: e
                })
            }
            return this.weakmap[t.__rv] || (this.weakmap[t.__rv] = {
                callbacks: {}
            }),
            this.weakmap[t.__rv]
        },
        cleanupWeakReference: function(t, e) {
            Object.keys(t.callbacks).length || t.pointers && Object.keys(t.pointers).length || delete this.weakmap[e]
        },
        stubFunction: function(t, e) {
            var n = t[e]
              , r = this.weakReference(t)
              , i = this.weakmap;
            t[e] = function() {
                for (var e = arguments.length, o = Array(e), a = 0; a < e; a++)
                    o[a] = arguments[a];
                var s = n.apply(t, o);
                return Object.keys(r.pointers).forEach(function(t) {
                    var e = r.pointers[t];
                    i[t] && i[t].callbacks[e]instanceof Array && i[t].callbacks[e].forEach(function(t) {
                        t.sync()
                    })
                }),
                s
            }
        },
        observeMutations: function(t, e, n) {
            var r = this;
            if (t instanceof Array) {
                var i = this.weakReference(t);
                i.pointers || (i.pointers = {},
                C.forEach(function(e) {
                    r.stubFunction(t, e)
                })),
                i.pointers[e] || (i.pointers[e] = []),
                -1 === i.pointers[e].indexOf(n) && i.pointers[e].push(n)
            }
        },
        unobserveMutations: function(t, e, n) {
            if (t instanceof Array && null != t.__rv) {
                var r = this.weakmap[t.__rv];
                if (r) {
                    var i = r.pointers[e];
                    if (i) {
                        var o = i.indexOf(n);
                        -1 < o && i.splice(o, 1),
                        i.length || delete r.pointers[e],
                        this.cleanupWeakReference(r, t.__rv)
                    }
                }
            }
        },
        observe: function(t, e, n) {
            var r, i = this, o = this.weakReference(t).callbacks;
            if (!o[e]) {
                o[e] = [];
                var a = Object.getOwnPropertyDescriptor(t, e);
                a && (a.get || a.set || !a.configurable) || (r = t[e],
                Object.defineProperty(t, e, {
                    enumerable: !0,
                    get: function() {
                        return r
                    },
                    set: function(n) {
                        if (n !== r) {
                            i.unobserveMutations(r, t.__rv, e),
                            r = n;
                            var o = i.weakmap[t.__rv];
                            if (o) {
                                var a = o.callbacks[e];
                                a && a.forEach(function(t) {
                                    t.sync()
                                }),
                                i.observeMutations(n, t.__rv, e)
                            }
                        }
                    }
                }))
            }
            -1 === o[e].indexOf(n) && o[e].push(n),
            this.observeMutations(t[e], t.__rv, e)
        },
        unobserve: function(t, e, n) {
            var r = this.weakmap[t.__rv];
            if (r) {
                var i = r.callbacks[e];
                if (i) {
                    var o = i.indexOf(n);
                    -1 < o && (i.splice(o, 1),
                    i.length || (delete r.callbacks[e],
                    this.unobserveMutations(t[e], t.__rv, e))),
                    this.cleanupWeakReference(r, t.__rv)
                }
            }
        },
        get: function(t, e) {
            return t[e]
        },
        set: function(t, e, n) {
            t[e] = n
        }
    }
      , _ = function(t) {
        return null != t ? t.toString() : void 0
    }
      , S = {
        "on-*": {
            function: !0,
            priority: 1e3,
            unbind: function(t) {
                this.handler && t.removeEventListener(this.arg, this.handler)
            },
            routine: function(t, e) {
                this.handler && t.removeEventListener(this.arg, this.handler),
                this.handler = this.eventHandler(e),
                t.addEventListener(this.arg, this.handler)
            }
        },
        "each-*": {
            block: !0,
            priority: 4e3,
            bind: function(t) {
                this.marker ? this.iterated.forEach(function(t) {
                    t.bind()
                }) : (this.marker = document.createComment(" tinybind: " + this.type + " "),
                this.iterated = [],
                t.parentNode.insertBefore(this.marker, t),
                t.parentNode.removeChild(t))
            },
            unbind: function(t) {
                this.iterated && this.iterated.forEach(function(t) {
                    t.unbind()
                })
            },
            routine: function(t, e) {
                var n = this
                  , r = this.arg;
                e = e || [];
                var o = t.getAttribute("index-property") || "$index";
                e.forEach(function(t, e) {
                    var a = {
                        $parent: n.view.models
                    };
                    a[o] = e,
                    a[r] = t;
                    var s = n.iterated[e];
                    if (s)
                        if (s.models[r] !== t) {
                            for (var l = void 0, u = void 0, c = e + 1; c < n.iterated.length; c++)
                                if ((u = n.iterated[c]).models[r] === t) {
                                    l = c;
                                    break
                                }
                            void 0 !== l ? (n.iterated.splice(l, 1),
                            n.marker.parentNode.insertBefore(u.els[0], s.els[0]),
                            u.models[o] = e) : u = i(n, a, s.els[0]),
                            n.iterated.splice(e, 0, u)
                        } else
                            s.models[o] = e;
                    else {
                        var d = n.marker;
                        n.iterated.length && (d = n.iterated[n.iterated.length - 1].els[0]),
                        s = i(n, a, d.nextSibling),
                        n.iterated.push(s)
                    }
                }),
                this.iterated.length > e.length && function(t, e) {
                    for (var n = 0; n < t; n++)
                        e()
                }(this.iterated.length - e.length, function() {
                    var t = n.iterated.pop();
                    t.unbind(),
                    n.marker.parentNode.removeChild(t.els[0])
                }),
                "OPTION" === t.nodeName && this.view.bindings.forEach(function(t) {
                    t.el === n.marker.parentNode && "value" === t.type && t.sync()
                })
            },
            update: function(t) {
                var e = this
                  , n = {};
                Object.keys(t).forEach(function(r) {
                    r !== e.arg && (n[r] = t[r])
                }),
                this.iterated.forEach(function(t) {
                    t.update(n)
                })
            }
        },
        "class-*": function(t, e) {
            var n = " " + t.className + " ";
            !e == -1 < n.indexOf(" " + this.arg + " ") && (t.className = e ? t.className + " " + this.arg : n.replace(" " + this.arg + " ", " ").trim())
        },
        text: function(t, e) {
            t.textContent = null != e ? e : ""
        },
        html: function(t, e) {
            t.innerHTML = null != e ? e : ""
        },
        show: function(t, e) {
            t.style.display = e ? "" : "none"
        },
        hide: function(t, e) {
            t.style.display = e ? "none" : ""
        },
        enabled: function(t, e) {
            t.disabled = !e
        },
        disabled: function(t, e) {
            t.disabled = !!e
        },
        checked: {
            publishes: !0,
            priority: 2e3,
            bind: function(t) {
                var e = this;
                this.callback || (this.callback = function() {
                    e.publish()
                }
                ),
                t.addEventListener("change", this.callback)
            },
            unbind: function(t) {
                t.removeEventListener("change", this.callback)
            },
            routine: function(t, e) {
                "radio" === t.type ? t.checked = _(t.value) === _(e) : t.checked = !!e
            }
        },
        value: {
            publishes: !0,
            priority: 3e3,
            bind: function(t) {
                if (this.isRadio = "INPUT" === t.tagName && "radio" === t.type,
                !this.isRadio) {
                    this.event = t.getAttribute("event-name") || ("SELECT" === t.tagName ? "change" : "input");
                    var e = this;
                    this.callback || (this.callback = function() {
                        e.publish()
                    }
                    ),
                    t.addEventListener(this.event, this.callback)
                }
            },
            unbind: function(t) {
                this.isRadio || t.removeEventListener(this.event, this.callback)
            },
            routine: function(t, e) {
                if (this.isRadio)
                    t.setAttribute("value", e);
                else if ("select-multiple" === t.type) {
                    if (e instanceof Array)
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.selected = -1 < e.indexOf(r.value)
                        }
                } else
                    _(e) !== _(t.value) && (t.value = null != e ? e : "")
            }
        },
        if: {
            block: !0,
            priority: 4e3,
            bind: function(t) {
                this.marker ? !1 === this.bound && this.nested && this.nested.bind() : (this.marker = document.createComment(" tinybind: " + this.type + " " + this.keypath + " "),
                this.attached = !1,
                t.parentNode.insertBefore(this.marker, t),
                t.parentNode.removeChild(t)),
                this.bound = !0
            },
            unbind: function() {
                this.nested && (this.nested.unbind(),
                this.bound = !1)
            },
            routine: function(t, e) {
                !!e !== this.attached && (e ? (this.nested || (this.nested = new x(t,this.view.models,this.view.options),
                this.nested.bind()),
                this.marker.parentNode.insertBefore(t, this.marker.nextSibling),
                this.attached = !0) : (t.parentNode.removeChild(t),
                this.attached = !1))
            },
            update: function(t) {
                this.nested && this.nested.update(t)
            }
        }
    };
    return d.binders = S,
    d.adapters["."] = k,
    d.bind = function(t, e, n) {
        var i = {};
        e = e || {},
        n = n || {},
        u.forEach(function(t) {
            i[t] = Object.create(null),
            n[t] && Object.keys(n[t]).forEach(function(e) {
                i[t][e] = n[t][e]
            }),
            Object.keys(d[t]).forEach(function(e) {
                i[t][e] || (i[t][e] = d[t][e])
            })
        }),
        l.forEach(function(t) {
            var e = n[t];
            i[t] = null != e ? e : d[t]
        }),
        i.starBinders = Object.keys(i.binders).filter(function(t) {
            return 0 < t.indexOf("*")
        }),
        r.updateOptions(i);
        var o = new x(t,e,i);
        return o.bind(),
        o
    }
    ,
    d.formatters.negate = d.formatters.not = function(t) {
        return !t
    }
    ,
    d
}),
/*! cart.mod.js */
// Cart.js
// version: 0.4.1
// author: Gavin Ballard
// license: MIT
// Updated with:
// - Error handling from https://github.com/discolabs/cartjs/issues/68#issuecomment-261418409
// - Properties regex pattern modified to support spaces
// - Removed rivets, replaced with tinybind
// - Added NProgress loading bar increment on queue step
// - Prevents AJAX forms when active file inputs exist in form
// - RequestComplete event now returns updated lines
// - Improved Tinybind array element formatter logic
// - Tinybind money formatter removes trailing '.00' in result
function() {
    var t, e, n, r, i, o, a, s = function(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    };
    e = function() {
        function t() {
            this.update = s(this.update, this)
        }
        return t.prototype.update = function(t) {
            var e, n, i;
            for (n in t)
                i = t[n],
                "items" !== n && (this[n] = i);
            return this.items = function() {
                var n, i, o, a;
                for (o = t.items,
                a = [],
                n = 0,
                i = o.length; n < i; n++)
                    e = o[n],
                    a.push(new r(e));
                return a
            }()
        }
        ,
        t
    }(),
    r = function() {
        function t(t) {
            this.propertyArray = s(this.propertyArray, this),
            this.update = s(this.update, this),
            this.update(t)
        }
        return t.prototype.update = function(t) {
            var e, r;
            for (e in t)
                r = t[e],
                "properties" !== e && (this[e] = r);
            return this.properties = n.Utils.extend({}, t.properties)
        }
        ,
        t.prototype.propertyArray = function() {
            var t, e, n, r;
            n = this.properties,
            r = [];
            for (t in n)
                e = n[t],
                r.push({
                    name: t,
                    value: e
                });
            return r
        }
        ,
        t
    }(),
    n = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            tinybindModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0,
            errorHandling: {
                cartError: function(t) {
                    this.description ? console.log("There was an error adding an item to the cart:", this.description) : console.log("There was an error adding an item to the cart:", this)
                }
            }
        },
        cart: new e
    },
    n.init = function(t, e) {
        return null == e && (e = {}),
        n.configure(e),
        n.Utils.log("Initialising CartJS."),
        n.cart.update(t),
        n.settings.dataAPI && (n.Utils.log('"dataAPI" setting is true, initialising Data API.'),
        n.Data.init()),
        n.settings.requestBodyClass && (n.Utils.log('"requestBodyClass" set, adding event listeners.'),
        jQuery(document).on("cart.requestStarted", function() {
            return jQuery("body").addClass(n.settings.requestBodyClass)
        }),
        jQuery(document).on("cart.requestComplete", function() {
            return jQuery("body").removeClass(n.settings.requestBodyClass)
        })),
        n.tinybind.init(),
        jQuery(document).trigger("cart.ready", [n.cart])
    }
    ,
    n.configure = function(t) {
        return null == t && (t = {}),
        n.Utils.extend(n.settings, t)
    }
    ,
    null == window.console && (window.console = {},
    window.console.log = function() {}
    ),
    n.Utils = {
        log: function() {
            return n.Utils.console(console.log, arguments)
        },
        error: function() {
            return n.Utils.console(console.error, arguments)
        },
        console: function(t, e) {
            if (n.settings.debug && "undefined" != typeof console && null !== console)
                return e = Array.prototype.slice.call(e),
                e.unshift("[CartJS]:"),
                t.apply(console, e)
        },
        wrapKeys: function(t, e, n) {
            var r, i, o;
            null == e && (e = "properties"),
            o = {};
            for (r in t)
                i = t[r],
                o["" + e + "[" + r + "]"] = null != n ? n : i;
            return o
        },
        unwrapKeys: function(t, e, n) {
            var r, i, o, a;
            null == e && (e = "properties"),
            i = {};
            for (r in t)
                a = t[r],
                o = r.replace("" + e + "[", "").replace("]", ""),
                i[o] = null != n ? n : a;
            return i
        },
        extend: function(t, e) {
            var n, r;
            for (n in e)
                r = e[n],
                t[n] = r;
            return t
        },
        clone: function(t) {
            var e, n;
            if (null == t || "object" != typeof t)
                return t;
            n = new t.constructor;
            for (e in t)
                n[e] = clone(t[e]);
            return n
        },
        isArray: Array.isArray || function(t) {
            return "[object Array]" === {}.toString.call(t)
        }
        ,
        ensureArray: function(t) {
            return n.Utils.isArray(t) ? t : null != t ? [t] : []
        },
        formatMoney: function(t, e, r, i) {
            var o, a;
            return null == i && (i = ""),
            i || (i = n.settings.currency),
            null != window.Currency && i !== n.settings.currency && (t = Currency.convert(t, n.settings.currency, i),
            null != (null != (o = window.Currency) ? o.moneyFormats : void 0) && i in window.Currency.moneyFormats && (e = window.Currency.moneyFormats[i][r])),
            null != (null != (a = window.Shopify) ? a.formatMoney : void 0) ? Shopify.formatMoney(t, e) : t
        },
        getSizedImageUrl: function(t, e) {
            var n, r;
            return null != (null != (n = window.Shopify) && null != (r = n.Image) ? r.getSizedImageUrl : void 0) ? t ? Shopify.Image.getSizedImageUrl(t, e) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", e).replace("-_", "-") : t ? t : "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
        }
    },
    o = [],
    a = [],
    i = !1,
    n.Queue = {
        add: function(t, e, r) {
            var a;
            if (null == r && (r = {}),
            a = {
                url: t,
                data: e,
                type: r.type || "POST",
                dataType: r.dataType || "json",
                statusCode: {
                    422: function(t) {
                        "function" == typeof n.settings.errorHandling.cartError && n.settings.errorHandling.cartError.call(t.responseJSON)
                    }
                },
                success: n.Utils.ensureArray(r.success),
                error: n.Utils.ensureArray(r.error),
                complete: n.Utils.ensureArray(r.complete)
            },
            r.updateCart && a.success.push(n.cart.update),
            o.push(a),
            !i)
                return jQuery(document).trigger("cart.requestStarted", [n.cart]),
                n.Queue.process()
        },
        process: function(t) {
          Shopify.getCart(function(cart){
            var e;
            if (t && t.responseJSON.id && a.push(t.responseJSON),
            !o.length) {
                i = !1;
                var r = n.cart;
                return r.updatedLineItems = a,
                jQuery(document).trigger("cart.requestComplete", [r]),
                void (a = [])
            }
            return "NProgress"in window && $("#nprogress").length && NProgress.inc(),
            i = !0,
            e = o.shift(),
            e.complete = n.Queue.process,
            jQuery.ajax(e)
          });
        }
    },
    n.Core = {
        getCart: function(t) {
            return null == t && (t = {}),
            t.type = "GET",
            t.updateCart = !0,
            n.Queue.add("/cart.js", {}, t)
        },
        addItem: function(t, e, r, i) {
            var o;
            return null == e && (e = 1),
            null == r && (r = {}),
            null == i && (i = {}),
            o = n.Utils.wrapKeys(r),
            o.id = t,
            o.quantity = e,
            n.Queue.add("/cart/add.js", o, i),
            n.Core.getCart()
        },
        updateItem: function(t, e, r, i) {
            var o;
            return null == r && (r = {}),
            null == i && (i = {}),
            o = n.Utils.wrapKeys(r),
            o.line = t,
            null != e && (o.quantity = e),
            i.updateCart = !0,
            n.Queue.add("/cart/change.js", o, i)
        },
        removeItem: function(t, e) {
            return null == e && (e = {}),
            n.Core.updateItem(t, 0, {}, e)
        },
        updateItemById: function(t, e, r, i) {
            var o;
            return null == r && (r = {}),
            null == i && (i = {}),
            o = n.Utils.wrapKeys(r),
            o.id = t,
            null != e && (o.quantity = e),
            i.updateCart = !0,
            n.Queue.add("/cart/change.js", o, i)
        },
        updateItemQuantitiesById: function(t, e) {
            return null == t && (t = {}),
            null == e && (e = {}),
            e.updateCart = !0,
            n.Queue.add("/cart/update.js", {
                updates: t
            }, e)
        },
        removeItemById: function(t, e) {
            var r;
            return null == e && (e = {}),
            r = {
                id: t,
                quantity: 0
            },
            e.updateCart = !0,
            n.Queue.add("/cart/change.js", r, e)
        },
        clear: function(t) {
            return null == t && (t = {}),
            t.updateCart = !0,
            n.Queue.add("/cart/clear.js", {}, t)
        },
        getAttribute: function(t, e) {
            return t in n.cart.attributes ? n.cart.attributes[t] : e
        },
        setAttribute: function(t, e, r) {
            var i;
            return null == r && (r = {}),
            i = {},
            i[t] = e,
            n.Core.setAttributes(i, r)
        },
        getAttributes: function() {
            return n.cart.attributes
        },
        setAttributes: function(t, e) {
            return null == t && (t = {}),
            null == e && (e = {}),
            e.updateCart = !0,
            n.Queue.add("/cart/update.js", n.Utils.wrapKeys(t, "attributes"), e)
        },
        clearAttributes: function(t) {
            return null == t && (t = {}),
            t.updateCart = !0,
            n.Queue.add("/cart/update.js", n.Utils.wrapKeys(n.Core.getAttributes(), "attributes", ""), t)
        },
        getNote: function() {
            return n.cart.note
        },
        setNote: function(t, e) {
            return null == e && (e = {}),
            e.updateCart = !0,
            n.Queue.add("/cart/update.js", {
                note: t
            }, e)
        }
    },
    t = null,
    n.Data = {
        init: function() {
            return t = jQuery(document),
            n.Data.setEventListeners("on"),
            n.Data.render(null, n.cart)
        },
        destroy: function() {
            return n.Data.setEventListeners("off")
        },
        setEventListeners: function(e) {
            return t[e]("click", "[data-cart-add]", n.Data.add),
            t[e]("click", "[data-cart-remove]", n.Data.remove),
            t[e]("click", "[data-cart-remove-id]", n.Data.removeById),
            t[e]("click", "[data-cart-update]", n.Data.update),
            t[e]("click", "[data-cart-update-id]", n.Data.updateById),
            t[e]("click", "[data-cart-clear]", n.Data.clear),
            t[e]("change", "[data-cart-toggle]", n.Data.toggle),
            t[e]("change", "[data-cart-toggle-attribute]", n.Data.toggleAttribute),
            t[e]("submit", "[data-cart-submit]", n.Data.submit),
            t[e]("cart.requestComplete", n.Data.render)
        },
        add: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            n.Core.addItem(e.attr("data-cart-add"), e.attr("data-cart-quantity"))
        },
        remove: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            n.Core.removeItem(e.attr("data-cart-remove"))
        },
        removeById: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            n.Core.removeItemById(e.attr("data-cart-remove-id"))
        },
        update: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            n.Core.updateItem(e.attr("data-cart-update"), e.attr("data-cart-quantity"))
        },
        updateById: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            n.Core.updateItemById(e.attr("data-cart-update-id"), e.attr("data-cart-quantity"))
        },
        clear: function(t) {
            return t.preventDefault(),
            n.Core.clear()
        },
        toggle: function(t) {
            var e, r;
            return e = jQuery(this),
            r = e.attr("data-cart-toggle"),
            e.is(":checked") ? n.Core.addItem(r) : n.Core.removeItemById(r)
        },
        toggleAttribute: function(t) {
            var e, r;
            return e = jQuery(this),
            r = e.attr("data-cart-toggle-attribute"),
            n.Core.setAttribute(r, e.is(":checked") ? "Yes" : "")
        },
        submit: function(t) {
            var e, r, i, o;
            if (!jQuery(this).find('input[type="file"]:enabled').length)
                return t.preventDefault(),
                e = jQuery(this).serializeArray(),
                r = void 0,
                o = void 0,
                i = {},
                jQuery.each(e, function(t, e) {
                    return "id" === e.name ? r = e.value : "quantity" === e.name ? o = e.value : e.name.match(/^properties\[[-\w\s]+\]$/) ? i[e.name] = e.value : void 0
                }),
                n.Core.addItem(r, o, n.Utils.unwrapKeys(i))
        },
        render: function(t, e) {
            var r;
            return r = {
                item_count: e.item_count,
                total_price: e.total_price,
                total_price_money: n.Utils.formatMoney(e.total_price, n.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: n.Utils.formatMoney(e.total_price, n.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            },
            jQuery("[data-cart-render]").each(function() {
                var t;
                return t = jQuery(this),
                t.html(r[t.attr("data-cart-render")])
            })
        }
    },
    "tinybind"in window ? (n.tinybind = {
        model: null,
        boundViews: [],
        init: function() {
            return n.tinybind.bindViews()
        },
        destroy: function() {
            return n.tinybind.unbindViews()
        },
        bindViews: function() {
            return n.Utils.log("tinybind.js is present, binding views."),
            n.tinybind.unbindViews(),
            n.tinybind.model = n.Utils.extend({
                cart: n.cart
            }, n.settings.tinybindModels),
            null != window.Currency && (n.tinybind.model.Currency = window.Currency),
            jQuery("[data-cart-view]").each(function() {
                var t;
                return t = tinybind.bind(jQuery(this), n.tinybind.model),
                n.tinybind.boundViews.push(t)
            })
        },
        unbindViews: function() {
            var t, e, r, i;
            for (i = n.tinybind.boundViews,
            e = 0,
            r = i.length; e < r; e++)
                t = i[e],
                t.unbind();
            return n.tinybind.boundViews = []
        }
    },
    tinybind.formatters.eq = function(t, e) {
        return t === e
    }
    ,
    tinybind.formatters.includes = function(t, e) {
        return t.indexOf(e) >= 0
    }
    ,
    tinybind.formatters.match = function(t, e, n) {
        return t.match(new RegExp(e,n))
    }
    ,
    tinybind.formatters.lt = function(t, e) {
        return "number" == typeof t && "number" == typeof e && t < e
    }
    ,
    tinybind.formatters.gt = function(t, e) {
        return "number" == typeof t && "number" == typeof e && t > e
    }
    ,
    tinybind.formatters.empty = function(t) {
        return !t || !t.length
    }
    ,
    tinybind.formatters.plus = function(t, e) {
        return parseInt(t) + parseInt(e)
    }
    ,
    tinybind.formatters.minus = function(t, e) {
        return parseInt(t) - parseInt(e)
    }
    ,
    tinybind.formatters.times = function(t, e) {
        return t * e
    }
    ,
    tinybind.formatters.divided_by = function(t, e) {
        return t / e
    }
    ,
    tinybind.formatters.modulo = function(t, e) {
        return t % e
    }
    ,
    tinybind.formatters.prepend = function(t, e) {
        return e + t
    }
    ,
    tinybind.formatters.append = function(t, e) {
        return t + e
    }
    ,
    tinybind.formatters.slice = function(t, e, n) {
        return t.slice(e, n)
    }
    ,
    tinybind.formatters.pluralize = function(t, e, r) {
        return null == r && (r = e + "s"),
        n.Utils.isArray(t) && (t = t.length),
        1 === t ? e : r
    }
    ,
    tinybind.formatters.array_element = function(t, e) {
        return t ? t[e] : null
    }
    ,
    tinybind.formatters.array_first = function(t) {
        return t[0]
    }
    ,
    tinybind.formatters.array_last = function(t) {
        return t[t.length - 1]
    }
    ,
    tinybind.formatters.money = function(t, e) {
        return n.Utils.formatMoney(t, n.settings.moneyFormat, "money_format", e)
    }
    ,
    tinybind.formatters.money_without_trailing_zeros = function(t, e) {
        return n.Utils.formatMoney(t, n.settings.moneyFormat, "money_format", e).replace(/\.00$/, "")
    }
    ,
    tinybind.formatters.money_with_currency = function(t, e) {
        return n.Utils.formatMoney(t, n.settings.moneyWithCurrencyFormat, "money_with_currency_format", e).replace(".00", "")
    }
    ,
    tinybind.formatters.weight = function(t) {
        switch (n.settings.weightUnit) {
        case "kg":
            return (t / 1e3).toFixed(n.settings.weightPrecision);
        case "oz":
            return (.035274 * t).toFixed(n.settings.weightPrecision);
        case "lb":
            return (.00220462 * t).toFixed(n.settings.weightPrecision);
        default:
            return t.toFixed(n.settings.weightPrecision)
        }
    }
    ,
    tinybind.formatters.weight_with_unit = function(t) {
        return tinybind.formatters.weight(t) + n.settings.weightUnit
    }
    ,
    tinybind.formatters.product_image_size = function(t, e) {
        return n.Utils.getSizedImageUrl(t, e)
    }
    ,
    tinybind.formatters.moneyWithCurrency = tinybind.formatters.money_with_currency,
    tinybind.formatters.weightWithUnit = tinybind.formatters.weight_with_unit,
    tinybind.formatters.productImageSize = tinybind.formatters.product_image_size,
    tinybind.formatters.round_brackets = function(t) {
        return "(" + t + ")"
    }
    ) : n.tinybind = {
        init: function() {},
        destroy: function() {}
    },
    n.factory = function(t) {
        return t.init = n.init,
        t.configure = n.configure,
        t.cart = n.cart,
        t.settings = n.settings,
        t.getCart = n.Core.getCart,
        t.addItem = n.Core.addItem,
        t.updateItem = n.Core.updateItem,
        t.updateItemById = n.Core.updateItemById,
        t.updateItemQuantitiesById = n.Core.updateItemQuantitiesById,
        t.removeItem = n.Core.removeItem,
        t.removeItemById = n.Core.removeItemById,
        t.clear = n.Core.clear,
        t.getAttribute = n.Core.getAttribute,
        t.setAttribute = n.Core.setAttribute,
        t.getAttributes = n.Core.getAttributes,
        t.setAttributes = n.Core.setAttributes,
        t.clearAttributes = n.Core.clearAttributes,
        t.getNote = n.Core.getNote,
        t.setNote = n.Core.setNote,
        t.render = n.Data.render
    }
    ,
    "object" == typeof exports ? n.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(t) {
        return n.factory(this.CartJS = t),
        t
    }) : n.factory(this.CartJS = {})
}
.call(this);
/*! object-fit.js */
// object-fit & object-position polyfill, MIT License
// by Federico Brigante https://github.com/bfred-it/object-fit-images
var objectFitImages = function() {
    "use strict";
    function t(t, e) {
        return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + t + "' height='" + e + "'%3E%3C/svg%3E"
    }
    function e(t) {
        if (t.srcset && !h && window.picturefill) {
            var e = window.picturefill._;
            t[e.ns] && t[e.ns].evaled || e.fillImg(t, {
                reselect: !0
            }),
            t[e.ns].curSrc || (t[e.ns].supported = !1,
            e.fillImg(t, {
                reselect: !0
            })),
            t.currentSrc = t[e.ns].curSrc || t.src
        }
    }
    function n(t) {
        for (var e, n = getComputedStyle(t).fontFamily, r = {}; null !== (e = u.exec(n)); )
            r[e[1]] = e[2];
        return r
    }
    function r(e, n, r) {
        var i = t(n || 1, r || 0);
        m.call(e, "src") !== i && g.call(e, "src", i)
    }
    function i(t, e) {
        t.naturalWidth ? e(t) : setTimeout(i, 100, t, e)
    }
    function o(t) {
        var o = n(t)
          , s = t[l];
        if (o["object-fit"] = o["object-fit"] || "fill",
        !s.img) {
            if ("fill" === o["object-fit"])
                return;
            if (!s.skipTest && d && !o["object-position"])
                return
        }
        if (!s.img) {
            s.img = new Image(t.width,t.height),
            s.img.srcset = m.call(t, "data-ofi-srcset") || t.srcset,
            s.img.src = m.call(t, "data-ofi-src") || t.src,
            g.call(t, "data-ofi-src", t.src),
            t.srcset && g.call(t, "data-ofi-srcset", t.srcset),
            r(t, t.naturalWidth || t.width, t.naturalHeight || t.height),
            t.srcset && (t.srcset = "");
            try {
                a(t)
            } catch (t) {
                window.console && console.warn("https://bit.ly/ofi-old-browser")
            }
        }
        e(s.img),
        t.style.backgroundImage = 'url("' + (s.img.currentSrc || s.img.src).replace(/"/g, '\\"') + '")',
        t.style.backgroundPosition = o["object-position"] || "center",
        t.style.backgroundRepeat = "no-repeat",
        t.style.backgroundOrigin = "content-box",
        /scale-down/.test(o["object-fit"]) ? i(s.img, function() {
            s.img.naturalWidth > t.width || s.img.naturalHeight > t.height ? t.style.backgroundSize = "contain" : t.style.backgroundSize = "auto"
        }) : t.style.backgroundSize = o["object-fit"].replace("none", "auto").replace("fill", "100% 100%"),
        i(s.img, function(e) {
            r(t, e.naturalWidth, e.naturalHeight)
        })
    }
    function a(t) {
        var e = {
            get: function(e) {
                return t[l].img[e || "src"]
            },
            set: function(e, n) {
                return t[l].img[n || "src"] = e,
                g.call(t, "data-ofi-" + n, e),
                o(t),
                e
            }
        };
        Object.defineProperty(t, "src", e),
        Object.defineProperty(t, "currentSrc", {
            get: function() {
                return e.get("currentSrc")
            }
        }),
        Object.defineProperty(t, "srcset", {
            get: function() {
                return e.get("srcset")
            },
            set: function(t) {
                return e.set(t, "srcset")
            }
        })
    }
    function s(t, e) {
        var n = !v && !t;
        if (e = e || {},
        t = t || "img",
        p && !e.skipTest || !f)
            return !1;
        "img" === t ? t = document.getElementsByTagName("img") : "string" == typeof t ? t = document.querySelectorAll(t) : "length"in t || (t = [t]);
        for (var r = 0; r < t.length; r++)
            t[r][l] = t[r][l] || {
                skipTest: e.skipTest
            },
            o(t[r]);
        n && (document.body.addEventListener("load", function(t) {
            "IMG" === t.target.tagName && s(t.target, {
                skipTest: e.skipTest
            })
        }, !0),
        v = !0,
        t = "img"),
        e.watchMQ && window.addEventListener("resize", s.bind(null, t, {
            skipTest: e.skipTest
        }))
    }
    var l = "bfred-it:object-fit-images"
      , u = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g
      , c = "undefined" == typeof Image ? {
        style: {
            "object-position": 1
        }
    } : new Image
      , d = "object-fit"in c.style
      , p = "object-position"in c.style
      , f = "background-size"in c.style
      , h = "string" == typeof c.currentSrc
      , m = c.getAttribute
      , g = c.setAttribute
      , v = !1;
    return s.supportsObjectFit = d,
    s.supportsObjectPosition = p,
    function() {
        function t(t, e) {
            return t[l] && t[l].img && ("src" === e || "srcset" === e) ? t[l].img : t
        }
        p || (HTMLImageElement.prototype.getAttribute = function(e) {
            return m.call(t(this, e), e)
        }
        ,
        HTMLImageElement.prototype.setAttribute = function(e, n) {
            return g.call(t(this, e), e, String(n))
        }
        )
    }(),
    s
}();
/*! jquery.cookie.min.js */
/**
* Cookie plugin
*
* Copyright (c) 2006 Klaus Hartl (stilbuero.de)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
*/
jQuery.cookie = function(t, e, n) {
    if ("undefined" == typeof e) {
        var r = null;
        if (document.cookie && "" != document.cookie)
            for (var i = document.cookie.split(";"), o = 0; o < i.length; o++) {
                var a = jQuery.trim(i[o]);
                if (a.substring(0, t.length + 1) == t + "=") {
                    r = decodeURIComponent(a.substring(t.length + 1));
                    break
                }
            }
        return r
    }
    n = n || {},
    null === e && (e = "",
    n.expires = -1);
    var s = "";
    if (n.expires && ("number" == typeof n.expires || n.expires.toUTCString)) {
        var l;
        "number" == typeof n.expires ? (l = new Date,
        l.setTime(l.getTime() + 24 * n.expires * 60 * 60 * 1e3)) : l = n.expires,
        s = "; expires=" + l.toUTCString()
    }
    var u = n.path ? "; path=" + n.path : ""
      , c = n.domain ? "; domain=" + n.domain : ""
      , d = n.secure ? "; secure" : "";
    document.cookie = [t, "=", encodeURIComponent(e), s, u, c, d].join("")
}
;
var checkParams = function(t) {
    if (!t)
        throw new Error("No config object has been provided.");
    "boolean" != typeof t.useTransform && (t.useTransform = !0),
    "number" != typeof t.gutter && (t.gutter = 25),
    t.container || error("container"),
    t.items || t.static || error("items or static")
}
  , error = function(t) {
    throw new Error("Missing property '" + t + "' in MagicGrid config")
}
  , getMin = function(t) {
    var e = t[0]
      , n = !0
      , r = !1
      , i = void 0;
    try {
        for (var o, a = t[Symbol.iterator](); !(n = (o = a.next()).done); n = !0) {
            var s = o.value;
            s.height < e.height && (e = s)
        }
    } catch (t) {
        r = !0,
        i = t
    } finally {
        try {
            n || null == a.return || a.return()
        } finally {
            if (r)
                throw i
        }
    }
    return e
}
  , MagicGrid = function(t) {
    checkParams(t),
    _instanceof(t.container, HTMLElement) ? (this.container = t.container,
    this.containerClass = t.container.className) : (this.containerClass = t.container,
    this.container = document.querySelector(t.container)),
    this.items = this.container.children,
    this.static = t.static || !1,
    this.size = t.items,
    this.gutter = t.gutter,
    this.maxColumns = t.maxColumns || !1,
    this.useMin = t.useMin || !1,
    this.useTransform = t.useTransform,
    this.animate = t.animate || !1,
    this.started = !1,
    this.init()
};
MagicGrid.prototype.init = function() {
    if (this.ready() && !this.started) {
        this.container.style.position = "relative";
        for (var t = 0; t < this.items.length; t++) {
            var e = this.items[t].style;
            e.position = "absolute",
            this.animate && (e.transition = (this.useTransform ? "transform" : "top, left") + " 0.2s ease")
        }
        this.started = !0
    }
}
,
MagicGrid.prototype.colWidth = function() {
    return this.items[0].getBoundingClientRect().width + this.gutter
}
,
MagicGrid.prototype.setup = function() {
    var t = this.container.getBoundingClientRect().width
      , e = this.colWidth()
      , n = Math.floor(t / e) || 1
      , r = [];
    this.maxColumns && n > this.maxColumns && (n = this.maxColumns);
    for (var i = 0; i < n; i++)
        r[i] = {
            height: 0,
            index: i
        };
    return {
        cols: r,
        wSpace: t - n * e + this.gutter
    }
}
,
MagicGrid.prototype.nextCol = function(t, e) {
    return this.useMin ? getMin(t) : t[e % t.length]
}
,
MagicGrid.prototype.positionItems = function() {
    var t = this.setup()
      , e = t.cols
      , n = t.wSpace
      , r = 0
      , i = this.colWidth();
    n = Math.floor(n / 2);
    for (var o = 0; o < this.items.length; o++) {
        var a = this.nextCol(e, o)
          , s = this.items[o]
          , l = a.height ? this.gutter : 0
          , u = a.index * i + n + "px"
          , c = a.height + l + "px";
        this.useTransform ? s.style.transform = "translate(" + u + ", " + c + ")" : (s.style.top = c,
        s.style.left = u),
        a.height += s.getBoundingClientRect().height + l,
        a.height > r && (r = a.height)
    }
    this.container.style.height = r + "px"
}
,
MagicGrid.prototype.ready = function() {
    return !!this.static || this.items.length >= this.size
}
,
MagicGrid.prototype.getReady = function() {
    var t = this
      , e = setInterval(function() {
        t.container = document.querySelector(t.containerClass),
        t.items = t.container.children,
        t.ready() && (clearInterval(e),
        t.init(),
        t.listen())
    }, 100)
}
,
MagicGrid.prototype.listen = function() {
    var t, e = this;
    this.ready() ? (window.addEventListener("resize", function() {
        t || (t = setTimeout(function() {
            e.positionItems(),
            t = null
        }, 200))
    }),
    this.positionItems()) : this.getReady()
}
,
/*! featherlight.mod.js */
/**
 * Featherlight - ultra slim jQuery lightbox
 * Version 1.7.13 - http://noelboss.github.io/featherlight/
 *
 * Copyright 2018, NoÃ«l Raoul Bossart (http://www.noelboss.com)
 * MIT Licensed.
**/
!function(t) {
    "use strict";
    function e(t, n) {
        if (!(this instanceof e)) {
            var r = new e(t,n);
            return r.open(),
            r
        }
        this.id = e.id++,
        this.setup(t, n),
        this.chainCallbacks(e._callbackChain)
    }
    function n(t, e) {
        var n = {};
        for (var r in t)
            r in e && (n[r] = t[r],
            delete t[r]);
        return n
    }
    function r(t, e) {
        var n = {}
          , r = new RegExp("^" + e + "([A-Z])(.*)");
        for (var i in t) {
            var o = i.match(r);
            if (o) {
                var a = (o[1] + o[2].replace(/([A-Z])/g, "-$1")).toLowerCase();
                n[a] = t[i]
            }
        }
        return n
    }
    if ("undefined" == typeof t)
        return void ("console"in window && window.console.info("Too much lightness, Featherlight needs jQuery."));
    if (t.fn.jquery.match(/-ajax/))
        return void ("console"in window && window.console.info("Featherlight needs regular jQuery, not the slim version."));
    var i = []
      , o = function(e) {
        return i = t.grep(i, function(t) {
            return t !== e && t.$instance.closest("body").length > 0
        })
    }
      , a = {
        allow: 1,
        allowfullscreen: 1,
        frameborder: 1,
        height: 1,
        longdesc: 1,
        marginheight: 1,
        marginwidth: 1,
        mozallowfullscreen: 1,
        name: 1,
        referrerpolicy: 1,
        sandbox: 1,
        scrolling: 1,
        src: 1,
        srcdoc: 1,
        style: 1,
        webkitallowfullscreen: 1,
        width: 1
    }
      , s = {
        keyup: "onKeyUp",
        resize: "onResize"
    }
      , l = function(n) {
        t.each(e.opened().reverse(), function() {
            return n.isDefaultPrevented() || !1 !== this[s[n.type]](n) ? void 0 : (n.preventDefault(),
            n.stopPropagation(),
            !1)
        })
    }
      , u = function(n) {
        if (n !== e._globalHandlerInstalled) {
            e._globalHandlerInstalled = n;
            var r = t.map(s, function(t, n) {
                return n + "." + e.prototype.namespace
            }).join(" ");
            t(window)[n ? "on" : "off"](r, l)
        }
    };
    e.prototype = {
        constructor: e,
        namespace: "featherlight",
        targetAttr: "data-featherlight",
        variant: null,
        resetCss: !1,
        background: null,
        openTrigger: "click",
        closeTrigger: "click",
        filter: null,
        root: "body",
        openSpeed: 250,
        closeSpeed: 250,
        closeOnClick: "background",
        closeOnEsc: !0,
        closeIcon: "&#10005;",
        loading: "",
        persist: !1,
        otherClose: null,
        beforeOpen: t.noop,
        beforeContent: t.noop,
        beforeClose: t.noop,
        afterOpen: t.noop,
        afterContent: t.noop,
        afterClose: t.noop,
        onKeyUp: t.noop,
        onResize: t.noop,
        type: null,
        contentFilters: ["jquery", "image", "html", "ajax", "iframe", "text"],
        setup: function(e, n) {
            "object" != typeof e || e instanceof t != 0 || n || (n = e,
            e = void 0);
            var r = t.extend(this, n, {
                target: e
            })
              , i = r.resetCss ? r.namespace + "-reset" : r.namespace
              , o = t(r.background || ['<div class="' + i + "-loading " + i + '">', '<div class="' + i + '-content">', '<button class="' + i + "-close-icon " + r.namespace + '-close" aria-label="Close">', r.closeIcon, "</button>", '<div class="' + r.namespace + '-inner">' + r.loading + "</div>", "</div>", "</div>"].join(""))
              , a = "." + r.namespace + "-close" + (r.otherClose ? "," + r.otherClose : "");
            return r.$instance = o.clone().addClass(r.variant),
            r.$instance.on(r.closeTrigger + "." + r.namespace, function(e) {
                if (!e.isDefaultPrevented()) {
                    var n = t(e.target);
                    ("background" === r.closeOnClick && n.is("." + r.namespace) || "anywhere" === r.closeOnClick || n.closest(a).length) && (r.close(e),
                    e.preventDefault())
                }
            }),
            this
        },
        getContent: function() {
            if (this.persist !== !1 && this.$content)
                return this.$content;
            var e = this
              , n = this.constructor.contentFilters
              , r = function(t) {
                return e.$currentTarget && e.$currentTarget.attr(t)
            }
              , i = r(e.targetAttr)
              , o = e.target || i || ""
              , a = n[e.type];
            if (!a && o in n && (a = n[o],
            o = e.target && i),
            o = o || r("href") || "",
            !a)
                for (var s in n)
                    e[s] && (a = n[s],
                    o = e[s]);
            if (!a) {
                var l = o;
                if (o = null,
                t.each(e.contentFilters, function() {
                    return a = n[this],
                    a.test && (o = a.test(l)),
                    !o && a.regex && l.match && l.match(a.regex) && (o = l),
                    !o
                }),
                !o)
                    return "console"in window && window.console.error("Featherlight: no content filter found " + (l ? ' for "' + l + '"' : " (no target specified)")),
                    !1
            }
            return a.process.call(e, o)
        },
        setContent: function(e) {
            return this.$instance.removeClass(this.namespace + "-loading"),
            this.$instance.toggleClass(this.namespace + "-iframe", e.is("iframe")),
            this.$instance.find("." + this.namespace + "-inner").not(e).slice(1).remove().end().replaceWith(t.contains(this.$instance[0], e[0]) ? "" : e),
            this.$content = e.addClass(this.namespace + "-inner"),
            this
        },
        open: function(e) {
            var n = this;
            if (n.$instance.hide().appendTo(n.root),
            !(e && e.isDefaultPrevented() || n.beforeOpen(e) === !1)) {
                e && e.preventDefault();
                var r = n.getContent();
                if (r)
                    return i.push(n),
                    u(!0),
                    n.$instance.fadeIn(n.openSpeed),
                    n.beforeContent(e),
                    t.when(r).always(function(t) {
                        n.setContent(t),
                        n.afterContent(e)
                    }).then(n.$instance.promise()).done(function() {
                        n.afterOpen(e)
                    })
            }
            return n.$instance.detach(),
            t.Deferred().reject().promise()
        },
        close: function(e) {
            var n = this
              , r = t.Deferred();
            return n.beforeClose(e) === !1 ? r.reject() : (0 === o(n).length && u(!1),
            n.$instance.fadeOut(n.closeSpeed, function() {
                n.$instance.detach(),
                n.afterClose(e),
                r.resolve()
            })),
            r.promise()
        },
        resize: function(t, e) {
            if (t && e) {
                this.$content.css("width", "").css("height", "");
                var n = Math.max(t / (this.$content.parent().width() - 1), e / (this.$content.parent().height() - 1));
                n > 1 && (n = e / Math.floor(e / n),
                this.$content.css("width", "" + t / n + "px").css("height", "" + e / n + "px"))
            }
        },
        chainCallbacks: function(e) {
            for (var n in e)
                this[n] = t.proxy(e[n], this, t.proxy(this[n], this))
        }
    },
    t.extend(e, {
        id: 0,
        autoBind: "[data-featherlight]",
        defaults: e.prototype,
        contentFilters: {
            jquery: {
                regex: /^[#.]\w/,
                test: function(e) {
                    return e instanceof t && e
                },
                process: function(e) {
                    return this.persist !== !1 ? t(e) : t(e).clone(!0)
                }
            },
            image: {
                regex: /\.(png|jpg|jpeg|gif|tiff?|bmp|svg)(\?\S*)?$/i,
                process: function(e) {
                    var n = this
                      , r = t.Deferred()
                      , i = new Image
                      , o = t('<img src="' + e + '" alt="" class="' + n.namespace + '-image" />');
                    return i.onload = function() {
                        o.naturalWidth = i.width,
                        o.naturalHeight = i.height,
                        r.resolve(o)
                    }
                    ,
                    i.onerror = function() {
                        r.reject(o)
                    }
                    ,
                    i.src = e,
                    r.promise()
                }
            },
            html: {
                regex: /^\s*<[\w!][^<]*>/,
                process: function(e) {
                    return t(e)
                }
            },
            ajax: {
                regex: /./,
                process: function(e) {
                    var n = t.Deferred()
                      , r = t("<div></div>").load(e, function(t, e) {
                        "error" !== e && n.resolve(r.contents()),
                        n.fail()
                    });
                    return n.promise()
                }
            },
            iframe: {
                process: function(e) {
                    var i = new t.Deferred
                      , o = t("<iframe/>")
                      , s = r(this, "iframe")
                      , l = n(s, a);
                    return o.hide().attr("src", e).attr(l).css(s).on("load", function() {
                        i.resolve(o.show())
                    }).appendTo(this.$instance.find("." + this.namespace + "-content")),
                    i.promise()
                }
            },
            text: {
                process: function(e) {
                    return t("<div>", {
                        text: e
                    })
                }
            }
        },
        functionAttributes: ["beforeOpen", "afterOpen", "beforeContent", "afterContent", "beforeClose", "afterClose"],
        readElementConfig: function(e, n) {
            var r = this
              , i = new RegExp("^data-" + n + "-(.*)")
              , o = {};
            return e && e.attributes && t.each(e.attributes, function() {
                var e = this.name.match(i);
                if (e) {
                    var n = this.value
                      , a = t.camelCase(e[1]);
                    if (t.inArray(a, r.functionAttributes) >= 0)
                        n = new Function(n);
                    else
                        try {
                            n = JSON.parse(n)
                        } catch (t) {}
                    o[a] = n
                }
            }),
            o
        },
        extend: function(e, n) {
            var r = function() {
                this.constructor = e
            };
            return r.prototype = this.prototype,
            e.prototype = new r,
            e.__super__ = this.prototype,
            t.extend(e, this, n),
            e.defaults = e.prototype,
            e
        },
        attach: function(e, n, r) {
            var i = this;
            "object" != typeof n || n instanceof t != 0 || r || (r = n,
            n = void 0),
            r = t.extend({}, r);
            var o, a = r.namespace || i.defaults.namespace, s = t.extend({}, i.defaults, i.readElementConfig(e[0], a), r), l = function(a) {
                var l = t(a.currentTarget)
                  , u = t.extend({
                    $source: e,
                    $currentTarget: l
                }, i.readElementConfig(e[0], s.namespace), i.readElementConfig(a.currentTarget, s.namespace), r)
                  , c = o || l.data("featherlight-persisted") || new i(n,u);
                "shared" === c.persist ? o = c : c.persist !== !1 && l.data("featherlight-persisted", c),
                u.$currentTarget.blur && u.$currentTarget.blur(),
                c.open(a)
            };
            return e.on(s.openTrigger + "." + s.namespace, s.filter, l),
            {
                filter: s.filter,
                handler: l
            }
        },
        current: function() {
            var t = this.opened();
            return t[t.length - 1] || null
        },
        opened: function() {
            var e = this;
            return o(),
            t.grep(i, function(t) {
                return t instanceof e
            })
        },
        close: function(t) {
            var e = this.current();
            return e ? e.close(t) : void 0
        },
        _onReady: function() {
            var e = this;
            if (e.autoBind) {
                var n = t(e.autoBind);
                n.each(function() {
                    e.attach(t(this))
                }),
                t(document).on("click", e.autoBind, function(r) {
                    if (!r.isDefaultPrevented()) {
                        var i = t(r.currentTarget)
                          , o = n.length;
                        if (n = n.add(i),
                        o !== n.length) {
                            var a = e.attach(i);
                            (!a.filter || t(r.target).parentsUntil(i, a.filter).length > 0) && a.handler(r)
                        }
                    }
                })
            }
        },
        _callbackChain: {
            onKeyUp: function(e, n) {
                return 27 === n.keyCode ? (this.closeOnEsc && t.featherlight.close(n),
                !1) : e(n)
            },
            beforeOpen: function(e, n) {
                return t(document.documentElement).addClass("with-featherlight"),
                this._previouslyActive = document.activeElement,
                this._$previouslyTabbable = t("a, input, select, textarea, iframe, button, iframe, [contentEditable=true]").not("[tabindex]").not(this.$instance.find("button")),
                this._$previouslyWithTabIndex = t("[tabindex]").not('[tabindex="-1"]'),
                this._previousWithTabIndices = this._$previouslyWithTabIndex.map(function(e, n) {
                    return t(n).attr("tabindex")
                }),
                this._$previouslyWithTabIndex.add(this._$previouslyTabbable).attr("tabindex", -1),
                document.activeElement.blur && document.activeElement.blur(),
                e(n)
            },
            afterClose: function(n, r) {
                var i = n(r)
                  , o = this;
                return this._$previouslyTabbable.removeAttr("tabindex"),
                this._$previouslyWithTabIndex.each(function(e, n) {
                    t(n).attr("tabindex", o._previousWithTabIndices[e])
                }),
                this._previouslyActive.focus(),
                0 === e.opened().length && t(document.documentElement).removeClass("with-featherlight"),
                i
            },
            onResize: function(t, e) {
                return this.resize(this.$content.naturalWidth, this.$content.naturalHeight),
                t(e)
            },
            afterContent: function(t, e) {
                var n = t(e);
                return this.$instance.find("[autofocus]:not([disabled])").focus(),
                this.onResize(e),
                n
            }
        }
    }),
    t.featherlight = e,
    t.fn.featherlight = function(t, n) {
        return e.attach(this, t, n),
        this
    }
    ,
    t(document).ready(function() {
        e._onReady()
    })
}(jQuery),
$.fn.odModal = $.fn.featherlight,
$.odModal = $.featherlight,
$.odModal.autoBind = "[data-od-modal]",
$.odModal.defaults.namespace = "od-modal",
theme.settings.closeIcon && ($.odModal.defaults.closeIcon = theme.settings.closeIcon),
$.odModal.defaults.afterContent = function() {
    $(this.$instance).removeClass("od-modal--loading")
}
,
/*! jquery.stickybits.min.js */
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? e() : "function" == typeof define && define.amd ? define(e) : e()
}(0, function() {
    "use strict";
    var t = function() {
        function t(t, e) {
            var n = void 0 !== e ? e : {};
            this.version = "3.3.2",
            this.userAgent = window.navigator.userAgent || "no `userAgent` provided by the browser",
            this.props = {
                customStickyChangeNumber: n.customStickyChangeNumber || null,
                noStyles: n.noStyles || !1,
                stickyBitStickyOffset: n.stickyBitStickyOffset || 0,
                parentClass: n.parentClass || "js-stickybit-parent",
                scrollEl: document.querySelector(n.scrollEl) || window,
                stickyClass: n.stickyClass || "js-is-sticky",
                stuckClass: n.stuckClass || "js-is-stuck",
                stickyChangeClass: n.stickyChangeClass || "js-is-sticky--change",
                useStickyClasses: n.useStickyClasses || !1,
                verticalPosition: n.verticalPosition || "top"
            };
            var r = this.props;
            r.positionVal = this.definePosition() || "fixed";
            var i = r.verticalPosition
              , o = r.noStyles
              , a = r.positionVal;
            this.els = "string" == typeof t ? document.querySelectorAll(t) : t,
            "length"in this.els || (this.els = [this.els]),
            this.instances = [];
            for (var s = 0; s < this.els.length; s += 1) {
                var l = this.els[s]
                  , u = l.style;
                if (u[i] = "top" !== i || o ? "" : r.stickyBitStickyOffset + "px",
                u.position = "fixed" !== a ? a : "",
                "fixed" === a || r.useStickyClasses) {
                    var c = this.addInstance(l, r);
                    this.instances.push(c)
                }
            }
            return this
        }
        var e = t.prototype;
        return e.definePosition = function() {
            for (var t = ["", "-o-", "-webkit-", "-moz-", "-ms-"], e = document.head.style, n = 0; n < t.length; n += 1)
                e.position = t[n] + "sticky";
            var r = e.position ? e.position : "fixed";
            return e.position = "",
            r
        }
        ,
        e.addInstance = function(t, e) {
            var n = this
              , r = {
                el: t,
                parent: t.parentNode,
                props: e
            };
            this.isWin = this.props.scrollEl === window;
            var i = this.isWin ? window : this.getClosestParent(r.el, r.props.scrollEl);
            return this.computeScrollOffsets(r),
            r.parent.className += " " + e.parentClass,
            r.state = "default",
            r.stateContainer = function() {
                return n.manageState(r)
            }
            ,
            i.addEventListener("scroll", r.stateContainer),
            r
        }
        ,
        e.getClosestParent = function(t, e) {
            var n = e
              , r = t;
            if (r.parentElement === n)
                return n;
            for (; r.parentElement !== n; )
                r = r.parentElement;
            return n
        }
        ,
        e.getOffsetTop = function(t) {
            var e = 0;
            do
                e = t.offsetTop + e;
            while (t = t.offsetParent);return e
        }
        ,
        e.computeScrollOffsets = function(t) {
            var e = t
              , n = e.props
              , r = e.el
              , i = e.parent
              , o = !this.isWin && "fixed" === n.positionVal
              , a = "bottom" !== n.verticalPosition
              , s = o ? this.getOffsetTop(n.scrollEl) : 0
              , l = o ? this.getOffsetTop(i) - s : this.getOffsetTop(i)
              , u = null !== n.customStickyChangeNumber ? n.customStickyChangeNumber : r.offsetHeight;
            return e.offset = s + n.stickyBitStickyOffset,
            e.stickyStart = a ? l - e.offset : 0,
            e.stickyChange = e.stickyStart + u,
            e.stickyStop = a ? l + i.offsetHeight - (e.el.offsetHeight + e.offset) : l + i.offsetHeight,
            e
        }
        ,
        e.toggleClasses = function(t, e, n) {
            var r = t
              , i = r.className.split(" ");
            n && -1 === i.indexOf(n) && i.push(n);
            var o = i.indexOf(e);
            -1 !== o && i.splice(o, 1),
            r.className = i.join(" ")
        }
        ,
        e.manageState = function(t) {
            var e = t
              , n = e.el
              , r = e.props
              , i = e.state
              , o = e.stickyStart
              , a = e.stickyChange
              , s = e.stickyStop
              , l = n.style
              , u = r.noStyles
              , c = r.positionVal
              , d = r.scrollEl
              , p = r.stickyClass
              , f = r.stickyChangeClass
              , h = r.stuckClass
              , m = r.verticalPosition
              , g = function(t) {
                t()
            }
              , v = this.isWin && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame) || g
              , y = this.toggleClasses
              , b = this.isWin ? window.scrollY || window.pageYOffset : d.scrollTop
              , w = b <= o && "sticky" === i
              , x = b >= s && "sticky" === i;
            b > o && b < s && ("default" === i || "stuck" === i) ? (e.state = "sticky",
            v(function() {
                y(n, h, p),
                l.position = c,
                u || (l.bottom = "",
                l[m] = r.stickyBitStickyOffset + "px")
            })) : w ? (e.state = "default",
            v(function() {
                y(n, p),
                "fixed" === c && (l.position = "")
            })) : x && (e.state = "stuck",
            v(function() {
                y(n, p, h),
                "fixed" !== c || u || (l.top = "",
                l.bottom = "0",
                l.position = "absolute")
            }));
            var C = b >= a && b <= s;
            return b < a || b > s ? v(function() {
                y(n, f)
            }) : C && v(function() {
                y(n, "stub", f)
            }),
            e
        }
        ,
        e.update = function() {
            for (var t = 0; t < this.instances.length; t += 1) {
                var e = this.instances[t];
                this.computeScrollOffsets(e)
            }
            return this
        }
        ,
        e.removeInstance = function(t) {
            var e = t.el
              , n = t.props
              , r = this.toggleClasses;
            e.style.position = "",
            e.style[n.verticalPosition] = "",
            r(e, n.stickyClass),
            r(e, n.stuckClass),
            r(e.parentNode, n.parentClass)
        }
        ,
        e.cleanup = function() {
            for (var t = 0; t < this.instances.length; t += 1) {
                var e = this.instances[t];
                e.props.scrollEl.removeEventListener("scroll", e.stateContainer),
                this.removeInstance(e)
            }
            this.manageState = !1,
            this.instances = []
        }
        ,
        t
    }();
    if ("undefined" != typeof window) {
        var e = window.$ || window.jQuery || window.Zepto;
        e && (e.fn.stickybits = function(e) {
            new t(this,e)
        }
        )
    }
}),
/*! popper.min.js */
/* popper.js 1.14.4 by Federico Zivolo under MIT License */
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Popper = e()
}(this, function() {
    "use strict";
    function t(t) {
        return t && "[object Function]" === {}.toString.call(t)
    }
    function e(t, e) {
        if (1 !== t.nodeType)
            return [];
        var n = getComputedStyle(t, null);
        return e ? n[e] : n
    }
    function n(t) {
        return "HTML" === t.nodeName ? t : t.parentNode || t.host
    }
    function r(t) {
        if (!t)
            return document.body;
        switch (t.nodeName) {
        case "HTML":
        case "BODY":
            return t.ownerDocument.body;
        case "#document":
            return t.body
        }
        var i = e(t)
          , o = i.overflow
          , a = i.overflowX
          , s = i.overflowY;
        return /(auto|scroll|overlay)/.test(o + s + a) ? t : r(n(t))
    }
    function i(t) {
        return 11 === t ? ot : 10 === t ? at : ot || at
    }
    function o(t) {
        if (!t)
            return document.documentElement;
        for (var n = i(10) ? document.body : null, r = t.offsetParent; r === n && t.nextElementSibling; )
            r = (t = t.nextElementSibling).offsetParent;
        var a = r && r.nodeName;
        return a && "BODY" !== a && "HTML" !== a ? -1 !== ["TD", "TABLE"].indexOf(r.nodeName) && "static" === e(r, "position") ? o(r) : r : t ? t.ownerDocument.documentElement : document.documentElement
    }
    function a(t) {
        var e = t.nodeName;
        return "BODY" !== e && ("HTML" === e || o(t.firstElementChild) === t)
    }
    function s(t) {
        return null === t.parentNode ? t : s(t.parentNode)
    }
    function l(t, e) {
        if (!(t && t.nodeType && e && e.nodeType))
            return document.documentElement;
        var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING
          , r = n ? t : e
          , i = n ? e : t
          , u = document.createRange();
        u.setStart(r, 0),
        u.setEnd(i, 0);
        var c = u.commonAncestorContainer;
        if (t !== c && e !== c || r.contains(i))
            return a(c) ? c : o(c);
        var d = s(t);
        return d.host ? l(d.host, e) : l(t, s(e).host)
    }
    function u(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "top"
          , n = "top" === e ? "scrollTop" : "scrollLeft"
          , r = t.nodeName;
        if ("BODY" === r || "HTML" === r) {
            var i = t.ownerDocument.documentElement
              , o = t.ownerDocument.scrollingElement || i;
            return o[n]
        }
        return t[n]
    }
    function c(t, e) {
        var n = 2 < arguments.length && void 0 !== arguments[2] && arguments[2]
          , r = u(e, "top")
          , i = u(e, "left")
          , o = n ? -1 : 1;
        return t.top += r * o,
        t.bottom += r * o,
        t.left += i * o,
        t.right += i * o,
        t
    }
    function d(t, e) {
        var n = "x" === e ? "Left" : "Top"
          , r = "Left" == n ? "Right" : "Bottom";
        return parseFloat(t["border" + n + "Width"], 10) + parseFloat(t["border" + r + "Width"], 10)
    }
    function p(t, e, n, r) {
        return Q(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], i(10) ? parseInt(n["offset" + t]) + parseInt(r["margin" + ("Height" === t ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === t ? "Bottom" : "Right")]) : 0)
    }
    function f(t) {
        var e = t.body
          , n = t.documentElement
          , r = i(10) && getComputedStyle(n);
        return {
            height: p("Height", e, n, r),
            width: p("Width", e, n, r)
        }
    }
    function h(t) {
        return ct({}, t, {
            right: t.left + t.width,
            bottom: t.top + t.height
        })
    }
    function m(t) {
        var n = {};
        try {
            if (i(10)) {
                n = t.getBoundingClientRect();
                var r = u(t, "top")
                  , o = u(t, "left");
                n.top += r,
                n.left += o,
                n.bottom += r,
                n.right += o
            } else
                n = t.getBoundingClientRect()
        } catch (t) {}
        var a = {
            left: n.left,
            top: n.top,
            width: n.right - n.left,
            height: n.bottom - n.top
        }
          , s = "HTML" === t.nodeName ? f(t.ownerDocument) : {}
          , l = s.width || t.clientWidth || a.right - a.left
          , c = s.height || t.clientHeight || a.bottom - a.top
          , p = t.offsetWidth - l
          , m = t.offsetHeight - c;
        if (p || m) {
            var g = e(t);
            p -= d(g, "x"),
            m -= d(g, "y"),
            a.width -= p,
            a.height -= m
        }
        return h(a)
    }
    function g(t, n) {
        var o = 2 < arguments.length && void 0 !== arguments[2] && arguments[2]
          , a = i(10)
          , s = "HTML" === n.nodeName
          , l = m(t)
          , u = m(n)
          , d = r(t)
          , p = e(n)
          , f = parseFloat(p.borderTopWidth, 10)
          , g = parseFloat(p.borderLeftWidth, 10);
        o && s && (u.top = Q(u.top, 0),
        u.left = Q(u.left, 0));
        var v = h({
            top: l.top - u.top - f,
            left: l.left - u.left - g,
            width: l.width,
            height: l.height
        });
        if (v.marginTop = 0,
        v.marginLeft = 0,
        !a && s) {
            var y = parseFloat(p.marginTop, 10)
              , b = parseFloat(p.marginLeft, 10);
            v.top -= f - y,
            v.bottom -= f - y,
            v.left -= g - b,
            v.right -= g - b,
            v.marginTop = y,
            v.marginLeft = b
        }
        return (a && !o ? n.contains(d) : n === d && "BODY" !== d.nodeName) && (v = c(v, n)),
        v
    }
    function v(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] && arguments[1]
          , n = t.ownerDocument.documentElement
          , r = g(t, n)
          , i = Q(n.clientWidth, window.innerWidth || 0)
          , o = Q(n.clientHeight, window.innerHeight || 0)
          , a = e ? 0 : u(n)
          , s = e ? 0 : u(n, "left")
          , l = {
            top: a - r.top + r.marginTop,
            left: s - r.left + r.marginLeft,
            width: i,
            height: o
        };
        return h(l)
    }
    function y(t) {
        var r = t.nodeName;
        return "BODY" !== r && "HTML" !== r && ("fixed" === e(t, "position") || y(n(t)))
    }
    function b(t) {
        if (!t || !t.parentElement || i())
            return document.documentElement;
        for (var n = t.parentElement; n && "none" === e(n, "transform"); )
            n = n.parentElement;
        return n || document.documentElement
    }
    function w(t, e, i, o) {
        var a = 4 < arguments.length && void 0 !== arguments[4] && arguments[4]
          , s = {
            top: 0,
            left: 0
        }
          , u = a ? b(t) : l(t, e);
        if ("viewport" === o)
            s = v(u, a);
        else {
            var c;
            "scrollParent" === o ? (c = r(n(e)),
            "BODY" === c.nodeName && (c = t.ownerDocument.documentElement)) : c = "window" === o ? t.ownerDocument.documentElement : o;
            var d = g(c, u, a);
            if ("HTML" !== c.nodeName || y(u))
                s = d;
            else {
                var p = f(t.ownerDocument)
                  , h = p.height
                  , m = p.width;
                s.top += d.top - d.marginTop,
                s.bottom = h + d.top,
                s.left += d.left - d.marginLeft,
                s.right = m + d.left
            }
        }
        i = i || 0;
        var w = "number" == typeof i;
        return s.left += w ? i : i.left || 0,
        s.top += w ? i : i.top || 0,
        s.right -= w ? i : i.right || 0,
        s.bottom -= w ? i : i.bottom || 0,
        s
    }
    function x(t) {
        var e = t.width
          , n = t.height;
        return e * n
    }
    function C(t, e, n, r, i) {
        var o = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === t.indexOf("auto"))
            return t;
        var a = w(n, r, o, i)
          , s = {
            top: {
                width: a.width,
                height: e.top - a.top
            },
            right: {
                width: a.right - e.right,
                height: a.height
            },
            bottom: {
                width: a.width,
                height: a.bottom - e.bottom
            },
            left: {
                width: e.left - a.left,
                height: a.height
            }
        }
          , l = Object.keys(s).map(function(t) {
            return ct({
                key: t
            }, s[t], {
                area: x(s[t])
            })
        }).sort(function(t, e) {
            return e.area - t.area
        })
          , u = l.filter(function(t) {
            var e = t.width
              , r = t.height;
            return e >= n.clientWidth && r >= n.clientHeight
        })
          , c = 0 < u.length ? u[0].key : l[0].key
          , d = t.split("-")[1];
        return c + (d ? "-" + d : "")
    }
    function k(t, e, n) {
        var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null
          , i = r ? b(e) : l(e, n);
        return g(n, i, r)
    }
    function _(t) {
        var e = getComputedStyle(t)
          , n = parseFloat(e.marginTop) + parseFloat(e.marginBottom)
          , r = parseFloat(e.marginLeft) + parseFloat(e.marginRight)
          , i = {
            width: t.offsetWidth + r,
            height: t.offsetHeight + n
        };
        return i
    }
    function S(t) {
        var e = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return t.replace(/left|right|bottom|top/g, function(t) {
            return e[t]
        })
    }
    function T(t, e, n) {
        n = n.split("-")[0];
        var r = _(t)
          , i = {
            width: r.width,
            height: r.height
        }
          , o = -1 !== ["right", "left"].indexOf(n)
          , a = o ? "top" : "left"
          , s = o ? "left" : "top"
          , l = o ? "height" : "width"
          , u = o ? "width" : "height";
        return i[a] = e[a] + e[l] / 2 - r[l] / 2,
        i[s] = n === s ? e[s] - r[u] : e[S(s)],
        i
    }
    function E(t, e) {
        return Array.prototype.find ? t.find(e) : t.filter(e)[0]
    }
    function A(t, e, n) {
        if (Array.prototype.findIndex)
            return t.findIndex(function(t) {
                return t[e] === n
            });
        var r = E(t, function(t) {
            return t[e] === n
        });
        return t.indexOf(r)
    }
    function M(e, n, r) {
        var i = void 0 === r ? e : e.slice(0, A(e, "name", r));
        return i.forEach(function(e) {
            e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var r = e.function || e.fn;
            e.enabled && t(r) && (n.offsets.popper = h(n.offsets.popper),
            n.offsets.reference = h(n.offsets.reference),
            n = r(n, e))
        }),
        n
    }
    function O() {
        if (!this.state.isDestroyed) {
            var t = {
                instance: this,
                styles: {},
                arrowStyles: {},
                attributes: {},
                flipped: !1,
                offsets: {}
            };
            t.offsets.reference = k(this.state, this.popper, this.reference, this.options.positionFixed),
            t.placement = C(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding),
            t.originalPlacement = t.placement,
            t.positionFixed = this.options.positionFixed,
            t.offsets.popper = T(this.popper, t.offsets.reference, t.placement),
            t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute",
            t = M(this.modifiers, t),
            this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0,
            this.options.onCreate(t))
        }
    }
    function L(t, e) {
        return t.some(function(t) {
            var n = t.name
              , r = t.enabled;
            return r && n === e
        })
    }
    function I(t) {
        for (var e = [!1, "ms", "Webkit", "Moz", "O"], n = t.charAt(0).toUpperCase() + t.slice(1), r = 0; r < e.length; r++) {
            var i = e[r]
              , o = i ? "" + i + n : t;
            if ("undefined" != typeof document.body.style[o])
                return o
        }
        return null
    }
    function j() {
        return this.state.isDestroyed = !0,
        L(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"),
        this.popper.style.position = "",
        this.popper.style.top = "",
        this.popper.style.left = "",
        this.popper.style.right = "",
        this.popper.style.bottom = "",
        this.popper.style.willChange = "",
        this.popper.style[I("transform")] = ""),
        this.disableEventListeners(),
        this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper),
        this
    }
    function z(t) {
        var e = t.ownerDocument;
        return e ? e.defaultView : window
    }
    function N(t, e, n, i) {
        var o = "BODY" === t.nodeName
          , a = o ? t.ownerDocument.defaultView : t;
        a.addEventListener(e, n, {
            passive: !0
        }),
        o || N(r(a.parentNode), e, n, i),
        i.push(a)
    }
    function P(t, e, n, i) {
        n.updateBound = i,
        z(t).addEventListener("resize", n.updateBound, {
            passive: !0
        });
        var o = r(t);
        return N(o, "scroll", n.updateBound, n.scrollParents),
        n.scrollElement = o,
        n.eventsEnabled = !0,
        n
    }
    function D() {
        this.state.eventsEnabled || (this.state = P(this.reference, this.options, this.state, this.scheduleUpdate))
    }
    function $(t, e) {
        return z(t).removeEventListener("resize", e.updateBound),
        e.scrollParents.forEach(function(t) {
            t.removeEventListener("scroll", e.updateBound)
        }),
        e.updateBound = null,
        e.scrollParents = [],
        e.scrollElement = null,
        e.eventsEnabled = !1,
        e
    }
    function R() {
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate),
        this.state = $(this.reference, this.state))
    }
    function F(t) {
        return "" !== t && !isNaN(parseFloat(t)) && isFinite(t)
    }
    function H(t, e) {
        Object.keys(e).forEach(function(n) {
            var r = "";
            -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && F(e[n]) && (r = "px"),
            t.style[n] = e[n] + r
        })
    }
    function B(t, e) {
        Object.keys(e).forEach(function(n) {
            var r = e[n];
            !1 === r ? t.removeAttribute(n) : t.setAttribute(n, e[n])
        })
    }
    function q(t, e, n) {
        var r = E(t, function(t) {
            var n = t.name;
            return n === e
        })
          , i = !!r && t.some(function(t) {
            return t.name === n && t.enabled && t.order < r.order
        });
        if (!i) {
            var o = "`" + e + "`";
            console.warn("`" + n + "` modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
        }
        return i
    }
    function W(t) {
        return "end" === t ? "start" : "start" === t ? "end" : t
    }
    function U(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] && arguments[1]
          , n = pt.indexOf(t)
          , r = pt.slice(n + 1).concat(pt.slice(0, n));
        return e ? r.reverse() : r
    }
    function V(t, e, n, r) {
        var i = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/)
          , o = +i[1]
          , a = i[2];
        if (!o)
            return t;
        if (0 === a.indexOf("%")) {
            var s;
            switch (a) {
            case "%p":
                s = n;
                break;
            case "%":
            case "%r":
            default:
                s = r
            }
            var l = h(s);
            return l[e] / 100 * o
        }
        if ("vh" === a || "vw" === a) {
            var u;
            return u = "vh" === a ? Q(document.documentElement.clientHeight, window.innerHeight || 0) : Q(document.documentElement.clientWidth, window.innerWidth || 0),
            u / 100 * o
        }
        return o
    }
    function X(t, e, n, r) {
        var i = [0, 0]
          , o = -1 !== ["right", "left"].indexOf(r)
          , a = t.split(/(\+|\-)/).map(function(t) {
            return t.trim()
        })
          , s = a.indexOf(E(a, function(t) {
            return -1 !== t.search(/,|\s/)
        }));
        a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        var l = /\s*,\s*|\s+/
          , u = -1 === s ? [a] : [a.slice(0, s).concat([a[s].split(l)[0]]), [a[s].split(l)[1]].concat(a.slice(s + 1))];
        return u = u.map(function(t, r) {
            var i = (1 === r ? !o : o) ? "height" : "width"
              , a = !1;
            return t.reduce(function(t, e) {
                return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e) ? (t[t.length - 1] = e,
                a = !0,
                t) : a ? (t[t.length - 1] += e,
                a = !1,
                t) : t.concat(e)
            }, []).map(function(t) {
                return V(t, i, e, n)
            })
        }),
        u.forEach(function(t, e) {
            t.forEach(function(n, r) {
                F(n) && (i[e] += n * ("-" === t[r - 1] ? -1 : 1))
            })
        }),
        i
    }
    function Y(t, e) {
        var n, r = e.offset, i = t.placement, o = t.offsets, a = o.popper, s = o.reference, l = i.split("-")[0];
        return n = F(+r) ? [+r, 0] : X(r, a, s, l),
        "left" === l ? (a.top += n[0],
        a.left -= n[1]) : "right" === l ? (a.top += n[0],
        a.left += n[1]) : "top" === l ? (a.left += n[0],
        a.top -= n[1]) : "bottom" === l && (a.left += n[0],
        a.top += n[1]),
        t.popper = a,
        t
    }
    for (var Z = Math.min, K = Math.round, G = Math.floor, Q = Math.max, J = "undefined" != typeof window && "undefined" != typeof document, tt = ["Edge", "Trident", "Firefox"], et = 0, nt = 0; nt < tt.length; nt += 1)
        if (J && 0 <= navigator.userAgent.indexOf(tt[nt])) {
            et = 1;
            break
        }
    var rt = J && window.Promise
      , it = rt ? function(t) {
        var e = !1;
        return function() {
            e || (e = !0,
            window.Promise.resolve().then(function() {
                e = !1,
                t()
            }))
        }
    }
    : function(t) {
        var e = !1;
        return function() {
            e || (e = !0,
            setTimeout(function() {
                e = !1,
                t()
            }, et))
        }
    }
      , ot = J && !(!window.MSInputMethodContext || !document.documentMode)
      , at = J && /MSIE 10/.test(navigator.userAgent)
      , st = function(t, e) {
        if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function")
    }
      , lt = function() {
        function t(t, e) {
            for (var n, r = 0; r < e.length; r++)
                n = e[r],
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(t, n.key, n)
        }
        return function(e, n, r) {
            return n && t(e.prototype, n),
            r && t(e, r),
            e
        }
    }()
      , ut = function(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n,
        t
    }
      , ct = Object.assign || function(t) {
        for (var e, n = 1; n < arguments.length; n++)
            for (var r in e = arguments[n])
                Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t
    }
      , dt = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"]
      , pt = dt.slice(3)
      , ft = {
        FLIP: "flip",
        CLOCKWISE: "clockwise",
        COUNTERCLOCKWISE: "counterclockwise"
    }
      , ht = function() {
        function e(n, r) {
            var i = this
              , o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
            st(this, e),
            this.scheduleUpdate = function() {
                return requestAnimationFrame(i.update)
            }
            ,
            this.update = it(this.update.bind(this)),
            this.options = ct({}, e.Defaults, o),
            this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
            },
            this.reference = n && n.jquery ? n[0] : n,
            this.popper = r && r.jquery ? r[0] : r,
            this.options.modifiers = {},
            Object.keys(ct({}, e.Defaults.modifiers, o.modifiers)).forEach(function(t) {
                i.options.modifiers[t] = ct({}, e.Defaults.modifiers[t] || {}, o.modifiers ? o.modifiers[t] : {})
            }),
            this.modifiers = Object.keys(this.options.modifiers).map(function(t) {
                return ct({
                    name: t
                }, i.options.modifiers[t])
            }).sort(function(t, e) {
                return t.order - e.order
            }),
            this.modifiers.forEach(function(e) {
                e.enabled && t(e.onLoad) && e.onLoad(i.reference, i.popper, i.options, e, i.state)
            }),
            this.update();
            var a = this.options.eventsEnabled;
            a && this.enableEventListeners(),
            this.state.eventsEnabled = a
        }
        return lt(e, [{
            key: "update",
            value: function() {
                return O.call(this)
            }
        }, {
            key: "destroy",
            value: function() {
                return j.call(this)
            }
        }, {
            key: "enableEventListeners",
            value: function() {
                return D.call(this)
            }
        }, {
            key: "disableEventListeners",
            value: function() {
                return R.call(this)
            }
        }]),
        e
    }();
    return ht.Utils = ("undefined" == typeof window ? global : window).PopperUtils,
    ht.placements = dt,
    ht.Defaults = {
        placement: "bottom",
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function() {},
        onUpdate: function() {},
        modifiers: {
            shift: {
                order: 100,
                enabled: !0,
                fn: function(t) {
                    var e = t.placement
                      , n = e.split("-")[0]
                      , r = e.split("-")[1];
                    if (r) {
                        var i = t.offsets
                          , o = i.reference
                          , a = i.popper
                          , s = -1 !== ["bottom", "top"].indexOf(n)
                          , l = s ? "left" : "top"
                          , u = s ? "width" : "height"
                          , c = {
                            start: ut({}, l, o[l]),
                            end: ut({}, l, o[l] + o[u] - a[u])
                        };
                        t.offsets.popper = ct({}, a, c[r])
                    }
                    return t
                }
            },
            offset: {
                order: 200,
                enabled: !0,
                fn: Y,
                offset: 0
            },
            preventOverflow: {
                order: 300,
                enabled: !0,
                fn: function(t, e) {
                    var n = e.boundariesElement || o(t.instance.popper);
                    t.instance.reference === n && (n = o(n));
                    var r = I("transform")
                      , i = t.instance.popper.style
                      , a = i.top
                      , s = i.left
                      , l = i[r];
                    i.top = "",
                    i.left = "",
                    i[r] = "";
                    var u = w(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);
                    i.top = a,
                    i.left = s,
                    i[r] = l,
                    e.boundaries = u;
                    var c = e.priority
                      , d = t.offsets.popper
                      , p = {
                        primary: function(t) {
                            var n = d[t];
                            return d[t] < u[t] && !e.escapeWithReference && (n = Q(d[t], u[t])),
                            ut({}, t, n)
                        },
                        secondary: function(t) {
                            var n = "right" === t ? "left" : "top"
                              , r = d[n];
                            return d[t] > u[t] && !e.escapeWithReference && (r = Z(d[n], u[t] - ("right" === t ? d.width : d.height))),
                            ut({}, n, r)
                        }
                    };
                    return c.forEach(function(t) {
                        var e = -1 === ["left", "top"].indexOf(t) ? "secondary" : "primary";
                        d = ct({}, d, p[e](t))
                    }),
                    t.offsets.popper = d,
                    t
                },
                priority: ["left", "right", "top", "bottom"],
                padding: 5,
                boundariesElement: "scrollParent"
            },
            keepTogether: {
                order: 400,
                enabled: !0,
                fn: function(t) {
                    var e = t.offsets
                      , n = e.popper
                      , r = e.reference
                      , i = t.placement.split("-")[0]
                      , o = G
                      , a = -1 !== ["top", "bottom"].indexOf(i)
                      , s = a ? "right" : "bottom"
                      , l = a ? "left" : "top"
                      , u = a ? "width" : "height";
                    return n[s] < o(r[l]) && (t.offsets.popper[l] = o(r[l]) - n[u]),
                    n[l] > o(r[s]) && (t.offsets.popper[l] = o(r[s])),
                    t
                }
            },
            arrow: {
                order: 500,
                enabled: !0,
                fn: function(t, n) {
                    var r;
                    if (!q(t.instance.modifiers, "arrow", "keepTogether"))
                        return t;
                    var i = n.element;
                    if ("string" == typeof i) {
                        if (i = t.instance.popper.querySelector(i),
                        !i)
                            return t
                    } else if (!t.instance.popper.contains(i))
                        return console.warn("WARNING: `arrow.element` must be child of its popper element!"),
                        t;
                    var o = t.placement.split("-")[0]
                      , a = t.offsets
                      , s = a.popper
                      , l = a.reference
                      , u = -1 !== ["left", "right"].indexOf(o)
                      , c = u ? "height" : "width"
                      , d = u ? "Top" : "Left"
                      , p = d.toLowerCase()
                      , f = u ? "left" : "top"
                      , m = u ? "bottom" : "right"
                      , g = _(i)[c];
                    l[m] - g < s[p] && (t.offsets.popper[p] -= s[p] - (l[m] - g)),
                    l[p] + g > s[m] && (t.offsets.popper[p] += l[p] + g - s[m]),
                    t.offsets.popper = h(t.offsets.popper);
                    var v = l[p] + l[c] / 2 - g / 2
                      , y = e(t.instance.popper)
                      , b = parseFloat(y["margin" + d], 10)
                      , w = parseFloat(y["border" + d + "Width"], 10)
                      , x = v - t.offsets.popper[p] - b - w;
                    return x = Q(Z(s[c] - g, x), 0),
                    t.arrowElement = i,
                    t.offsets.arrow = (r = {},
                    ut(r, p, K(x)),
                    ut(r, f, ""),
                    r),
                    t
                },
                element: "[x-arrow]"
            },
            flip: {
                order: 600,
                enabled: !0,
                fn: function(t, e) {
                    if (L(t.instance.modifiers, "inner"))
                        return t;
                    if (t.flipped && t.placement === t.originalPlacement)
                        return t;
                    var n = w(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed)
                      , r = t.placement.split("-")[0]
                      , i = S(r)
                      , o = t.placement.split("-")[1] || ""
                      , a = [];
                    switch (e.behavior) {
                    case ft.FLIP:
                        a = [r, i];
                        break;
                    case ft.CLOCKWISE:
                        a = U(r);
                        break;
                    case ft.COUNTERCLOCKWISE:
                        a = U(r, !0);
                        break;
                    default:
                        a = e.behavior
                    }
                    return a.forEach(function(s, l) {
                        if (r !== s || a.length === l + 1)
                            return t;
                        r = t.placement.split("-")[0],
                        i = S(r);
                        var u = t.offsets.popper
                          , c = t.offsets.reference
                          , d = G
                          , p = "left" === r && d(u.right) > d(c.left) || "right" === r && d(u.left) < d(c.right) || "top" === r && d(u.bottom) > d(c.top) || "bottom" === r && d(u.top) < d(c.bottom)
                          , f = d(u.left) < d(n.left)
                          , h = d(u.right) > d(n.right)
                          , m = d(u.top) < d(n.top)
                          , g = d(u.bottom) > d(n.bottom)
                          , v = "left" === r && f || "right" === r && h || "top" === r && m || "bottom" === r && g
                          , y = -1 !== ["top", "bottom"].indexOf(r)
                          , b = !!e.flipVariations && (y && "start" === o && f || y && "end" === o && h || !y && "start" === o && m || !y && "end" === o && g);
                        (p || v || b) && (t.flipped = !0,
                        (p || v) && (r = a[l + 1]),
                        b && (o = W(o)),
                        t.placement = r + (o ? "-" + o : ""),
                        t.offsets.popper = ct({}, t.offsets.popper, T(t.instance.popper, t.offsets.reference, t.placement)),
                        t = M(t.instance.modifiers, t, "flip"))
                    }),
                    t
                },
                behavior: "flip",
                padding: 5,
                boundariesElement: "viewport"
            },
            inner: {
                order: 700,
                enabled: !1,
                fn: function(t) {
                    var e = t.placement
                      , n = e.split("-")[0]
                      , r = t.offsets
                      , i = r.popper
                      , o = r.reference
                      , a = -1 !== ["left", "right"].indexOf(n)
                      , s = -1 === ["top", "left"].indexOf(n);
                    return i[a ? "left" : "top"] = o[n] - (s ? i[a ? "width" : "height"] : 0),
                    t.placement = S(e),
                    t.offsets.popper = h(i),
                    t
                }
            },
            hide: {
                order: 800,
                enabled: !0,
                fn: function(t) {
                    if (!q(t.instance.modifiers, "hide", "preventOverflow"))
                        return t;
                    var e = t.offsets.reference
                      , n = E(t.instance.modifiers, function(t) {
                        return "preventOverflow" === t.name
                    }).boundaries;
                    if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
                        if (!0 === t.hide)
                            return t;
                        t.hide = !0,
                        t.attributes["x-out-of-boundaries"] = ""
                    } else {
                        if (!1 === t.hide)
                            return t;
                        t.hide = !1,
                        t.attributes["x-out-of-boundaries"] = !1
                    }
                    return t
                }
            },
            computeStyle: {
                order: 850,
                enabled: !0,
                fn: function(t, e) {
                    var n = e.x
                      , r = e.y
                      , i = t.offsets.popper
                      , a = E(t.instance.modifiers, function(t) {
                        return "applyStyle" === t.name
                    }).gpuAcceleration;
                    void 0 !== a && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                    var s, l, u = void 0 === a ? e.gpuAcceleration : a, c = o(t.instance.popper), d = m(c), p = {
                        position: i.position
                    }, f = {
                        left: G(i.left),
                        top: K(i.top),
                        bottom: K(i.bottom),
                        right: G(i.right)
                    }, h = "bottom" === n ? "top" : "bottom", g = "right" === r ? "left" : "right", v = I("transform");
                    if (l = "bottom" == h ? "HTML" === c.nodeName ? -c.clientHeight + f.bottom : -d.height + f.bottom : f.top,
                    s = "right" == g ? "HTML" === c.nodeName ? -c.clientWidth + f.right : -d.width + f.right : f.left,
                    u && v)
                        p[v] = "translate3d(" + s + "px, " + l + "px, 0)",
                        p[h] = 0,
                        p[g] = 0,
                        p.willChange = "transform";
                    else {
                        var y = "bottom" == h ? -1 : 1
                          , b = "right" == g ? -1 : 1;
                        p[h] = l * y,
                        p[g] = s * b,
                        p.willChange = h + ", " + g
                    }
                    var w = {
                        "x-placement": t.placement
                    };
                    return t.attributes = ct({}, w, t.attributes),
                    t.styles = ct({}, p, t.styles),
                    t.arrowStyles = ct({}, t.offsets.arrow, t.arrowStyles),
                    t
                },
                gpuAcceleration: !0,
                x: "bottom",
                y: "right"
            },
            applyStyle: {
                order: 900,
                enabled: !0,
                fn: function(t) {
                    return H(t.instance.popper, t.styles),
                    B(t.instance.popper, t.attributes),
                    t.arrowElement && Object.keys(t.arrowStyles).length && H(t.arrowElement, t.arrowStyles),
                    t
                },
                onLoad: function(t, e, n, r, i) {
                    var o = k(i, e, t, n.positionFixed)
                      , a = C(n.placement, o, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                    return e.setAttribute("x-placement", a),
                    H(e, {
                        position: n.positionFixed ? "fixed" : "absolute"
                    }),
                    n
                },
                gpuAcceleration: void 0
            }
        }
    },
    ht
}),
/*! tippy.standalone.min.js */
/* Tippy 4.3.5 by https://github.com/atomiks/ under MIT license */
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("popper.js")) : "function" == typeof define && define.amd ? define(["popper.js"], e) : (t = t || self).tippy = e(t.Popper)
}(this, function(t) {
    "use strict";
    function e() {
        return (e = Object.assign || function(t) {
            for (var e = 1; e < arguments.length; e++) {
                var n = arguments[e];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r])
            }
            return t
        }
        ).apply(this, arguments)
    }
    function n(t) {
        return [].slice.call(t)
    }
    function r(t, e) {
        return i(t, function(t) {
            return W.call(t, e)
        })
    }
    function i(t, e) {
        for (; t; ) {
            if (e(t))
                return t;
            t = t.parentElement
        }
        return null
    }
    function o() {
        ut || (ut = !0,
        F && document.body.classList.add(Z),
        window.performance && document.addEventListener("mousemove", a))
    }
    function a() {
        var t = performance.now();
        t - ct < 20 && (ut = !1,
        document.removeEventListener("mousemove", a),
        F || document.body.classList.remove(Z)),
        ct = t
    }
    function s() {
        var t = document.activeElement;
        t && t.blur && t._tippy && t.blur()
    }
    function l(t, e) {
        return {}.hasOwnProperty.call(t, e)
    }
    function u(t, e, n) {
        if (Array.isArray(t)) {
            var r = t[e];
            return null == r ? n : r
        }
        return t
    }
    function c(t, e) {
        return 0 === e ? t : function(r) {
            clearTimeout(n),
            n = setTimeout(function() {
                t(r)
            }, e)
        }
        ;
        var n
    }
    function d(t, e) {
        return t && t.modifiers && t.modifiers[e]
    }
    function p(t, e) {
        return t.indexOf(e) > -1
    }
    function f(t) {
        return t instanceof Element
    }
    function h(t) {
        return !(!t || !l(t, "isVirtual")) || f(t)
    }
    function m(t, e) {
        return "function" == typeof t ? t.apply(null, e) : t
    }
    function g(t, e) {
        t.filter(function(t) {
            return "flip" === t.name
        })[0].enabled = e
    }
    function v() {
        return document.createElement("div")
    }
    function y(t, e) {
        t.forEach(function(t) {
            t && (t.style.transitionDuration = "".concat(e, "ms"))
        })
    }
    function b(t, e) {
        t.forEach(function(t) {
            t && t.setAttribute("data-state", e)
        })
    }
    function w(t, n) {
        var r = e({}, n, {
            content: m(n.content, [t])
        }, n.ignoreAttributes ? {} : function(t) {
            return dt.reduce(function(e, n) {
                var r = (t.getAttribute("data-tippy-".concat(n)) || "").trim();
                if (!r)
                    return e;
                if ("content" === n)
                    e[n] = r;
                else
                    try {
                        e[n] = JSON.parse(r)
                    } catch (t) {
                        e[n] = r
                    }
                return e
            }, {})
        }(t));
        return (r.arrow || R) && (r.animateFill = !1),
        r
    }
    function x(t, e) {
        Object.keys(t).forEach(function(t) {
            if (!l(e, t))
                throw new Error("[tippy]: `".concat(t, "` is not a valid option"))
        })
    }
    function C(t, e) {
        t.innerHTML = f(e) ? e.innerHTML : e
    }
    function k(t, e) {
        f(e.content) ? (C(t, ""),
        t.appendChild(e.content)) : "function" != typeof e.content && (t[e.allowHTML ? "innerHTML" : "textContent"] = e.content)
    }
    function _(t) {
        return {
            tooltip: t.querySelector(it),
            backdrop: t.querySelector(at),
            content: t.querySelector(ot),
            arrow: t.querySelector(st) || t.querySelector(lt)
        }
    }
    function S(t) {
        t.setAttribute("data-inertia", "")
    }
    function T(t) {
        var e = v();
        return "round" === t ? (e.className = nt,
        C(e, '<svg viewBox="0 0 18 7" xmlns="http://www.w3.org/2000/svg"><path d="M0 7s2.021-.015 5.253-4.218C6.584 1.051 7.797.007 9 0c1.203-.007 2.416 1.035 3.761 2.782C16.012 7.005 18 7 18 7H0z"/></svg>')) : e.className = et,
        e
    }
    function E() {
        var t = v();
        return t.className = tt,
        t.setAttribute("data-state", "hidden"),
        t
    }
    function A(t, e) {
        t.setAttribute("tabindex", "-1"),
        e.setAttribute("data-interactive", "")
    }
    function M(t, e, n) {
        var r = R && void 0 !== document.body.style.webkitTransition ? "webkitTransitionEnd" : "transitionend";
        t[e + "EventListener"](r, n)
    }
    function O(t) {
        var e = t.getAttribute(X);
        return e ? e.split("-")[0] : ""
    }
    function L(t, e, n) {
        n.split(" ").forEach(function(n) {
            t.classList[e](n + "-theme")
        })
    }
    function I(t, e) {
        var n = v();
        n.className = G,
        n.id = "tippy-".concat(t),
        n.style.zIndex = "" + e.zIndex,
        n.style.position = "absolute",
        n.style.top = "0",
        n.style.left = "0",
        e.role && n.setAttribute("role", e.role);
        var r = v();
        r.className = Q,
        r.style.maxWidth = e.maxWidth + ("number" == typeof e.maxWidth ? "px" : ""),
        r.setAttribute("data-size", e.size),
        r.setAttribute("data-animation", e.animation),
        r.setAttribute("data-state", "hidden"),
        L(r, "add", e.theme);
        var i = v();
        return i.className = J,
        i.setAttribute("data-state", "hidden"),
        e.interactive && A(n, r),
        e.arrow && r.appendChild(T(e.arrowType)),
        e.animateFill && (r.appendChild(E()),
        r.setAttribute("data-animatefill", "")),
        e.inertia && S(r),
        k(i, e),
        r.appendChild(i),
        n.appendChild(r),
        n
    }
    function j(t, e, n) {
        var r = _(t)
          , i = r.tooltip
          , o = r.content
          , a = r.backdrop
          , s = r.arrow;
        t.style.zIndex = "" + n.zIndex,
        i.setAttribute("data-size", n.size),
        i.setAttribute("data-animation", n.animation),
        i.style.maxWidth = n.maxWidth + ("number" == typeof n.maxWidth ? "px" : ""),
        n.role ? t.setAttribute("role", n.role) : t.removeAttribute("role"),
        e.content !== n.content && k(o, n),
        !e.animateFill && n.animateFill ? (i.appendChild(E()),
        i.setAttribute("data-animatefill", "")) : e.animateFill && !n.animateFill && (i.removeChild(a),
        i.removeAttribute("data-animatefill")),
        !e.arrow && n.arrow ? i.appendChild(T(n.arrowType)) : e.arrow && !n.arrow && i.removeChild(s),
        e.arrow && n.arrow && e.arrowType !== n.arrowType && i.replaceChild(T(n.arrowType), s),
        !e.interactive && n.interactive ? A(t, i) : e.interactive && !n.interactive && function(t, e) {
            t.removeAttribute("tabindex"),
            e.removeAttribute("data-interactive")
        }(t, i),
        !e.inertia && n.inertia ? S(i) : e.inertia && !n.inertia && function(t) {
            t.removeAttribute("data-inertia")
        }(i),
        e.theme !== n.theme && (L(i, "remove", e.theme),
        L(i, "add", n.theme))
    }
    function z(o, a) {
        function s() {
            document.removeEventListener("mousemove", P)
        }
        function h() {
            document.body.removeEventListener("mouseleave", nt),
            document.removeEventListener("mousemove", At),
            ft = ft.filter(function(t) {
                return t !== At
            })
        }
        function v() {
            return It.props.triggerTarget || o
        }
        function C() {
            document.addEventListener("click", it, !0)
        }
        function k() {
            document.removeEventListener("click", it, !0)
        }
        function S() {
            return [It.popperChildren.tooltip, It.popperChildren.backdrop, It.popperChildren.content]
        }
        function T() {
            var t = It.props.followCursor;
            return t && "focus" !== ct || ut && "initial" === t
        }
        function E(t, e) {
            function n(t) {
                t.target === r && (M(r, "remove", n),
                e())
            }
            var r = It.popperChildren.tooltip;
            return 0 === t ? e() : (M(r, "remove", wt),
            M(r, "add", n),
            wt = n,
            void 0)
        }
        function A(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            v().addEventListener(t, e, n),
            Et.push({
                eventType: t,
                handler: e,
                options: n
            })
        }
        function L() {
            It.props.touchHold && !It.props.target && (A("touchstart", D, U),
            A("touchend", F, U)),
            It.props.trigger.trim().split(" ").forEach(function(t) {
                if ("manual" !== t)
                    if (It.props.target)
                        switch (t) {
                        case "mouseenter":
                            A("mouseover", Z),
                            A("mouseout", G);
                            break;
                        case "focus":
                            A("focusin", Z),
                            A("focusout", G);
                            break;
                        case "click":
                            A(t, Z)
                        }
                    else
                        switch (A(t, D),
                        t) {
                        case "mouseenter":
                            A("mouseleave", F);
                            break;
                        case "focus":
                            A($ ? "focusout" : "blur", q)
                        }
            })
        }
        function N() {
            Et.forEach(function(t) {
                var e = t.eventType
                  , n = t.handler
                  , r = t.options;
                v().removeEventListener(e, n, r)
            }),
            Et = []
        }
        function P(t) {
            var n = dt = t
              , r = n.clientX
              , a = n.clientY;
            if (xt) {
                var l = i(t.target, function(t) {
                    return t === o
                })
                  , u = o.getBoundingClientRect()
                  , c = It.props.followCursor
                  , d = "horizontal" === c
                  , f = "vertical" === c
                  , h = p(["top", "bottom"], O(Ot))
                  , m = Ot.getAttribute(X)
                  , g = !!m && !!m.split("-")[1]
                  , v = h ? Ot.offsetWidth : Ot.offsetHeight
                  , y = v / 2
                  , b = h ? 0 : g ? v : y
                  , w = h ? g ? v : y : 0;
                !l && It.props.interactive || (It.popperInstance.reference = e({}, It.popperInstance.reference, {
                    referenceNode: o,
                    clientWidth: 0,
                    clientHeight: 0,
                    getBoundingClientRect: function() {
                        return {
                            width: h ? v : 0,
                            height: h ? 0 : v,
                            top: (d ? u.top : a) - b,
                            bottom: (d ? u.bottom : a) + b,
                            left: (f ? u.left : r) - w,
                            right: (f ? u.right : r) + w
                        }
                    }
                }),
                It.popperInstance.update()),
                "initial" === c && It.state.isVisible && s()
            }
        }
        function D(t) {
            It.state.isEnabled && !Q(t) && (It.state.isVisible || (ct = t.type,
            t instanceof MouseEvent && (dt = t,
            ft.forEach(function(e) {
                return e(t)
            }))),
            "click" === t.type && !1 !== It.props.hideOnClick && It.state.isVisible ? nt() : et(t))
        }
        function R(t) {
            var e = r(t.target, rt) === Ot
              , n = i(t.target, function(t) {
                return t === o
            });
            e || n || function(t, e, n, r) {
                if (!t)
                    return !0;
                var i = n.clientX
                  , o = n.clientY
                  , a = r.interactiveBorder
                  , s = r.distance
                  , l = e.top - o > ("top" === t ? a + s : a)
                  , u = o - e.bottom > ("bottom" === t ? a + s : a)
                  , c = e.left - i > ("left" === t ? a + s : a)
                  , d = i - e.right > ("right" === t ? a + s : a);
                return l || u || c || d
            }(O(Ot), Ot.getBoundingClientRect(), t, It.props) && (h(),
            nt())
        }
        function F(t) {
            if (!Q(t))
                return It.props.interactive ? (document.body.addEventListener("mouseleave", nt),
                document.addEventListener("mousemove", At),
                void ft.push(At)) : void nt()
        }
        function q(t) {
            t.target === v() && (It.props.interactive && t.relatedTarget && Ot.contains(t.relatedTarget) || nt())
        }
        function Z(t) {
            r(t.target, It.props.target) && et(t)
        }
        function G(t) {
            r(t.target, It.props.target) && nt()
        }
        function Q(t) {
            var e = "ontouchstart"in window
              , n = p(t.type, "touch")
              , r = It.props.touchHold;
            return e && ut && r && !n || ut && !r && n
        }
        function J() {
            !Tt && bt && (Tt = !0,
            function(t) {
                t.offsetHeight
            }(Ot),
            bt())
        }
        function tt() {
            function n(t) {
                It.props.flip && !It.props.flipOnUpdate && (t.flipped && (It.popperInstance.options.placement = t.placement),
                g(It.popperInstance.modifiers, !1)),
                a.setAttribute(X, t.placement),
                !1 !== t.attributes[Y] ? a.setAttribute(Y, "") : a.removeAttribute(Y),
                yt && yt !== t.placement && St && (a.style.transition = "none",
                requestAnimationFrame(function() {
                    a.style.transition = ""
                })),
                yt = t.placement,
                St = It.state.isVisible;
                var n = O(Ot)
                  , r = a.style;
                r.top = r.bottom = r.left = r.right = "",
                r[n] = -(It.props.distance - 10) + "px";
                var i = l && void 0 !== l.padding ? l.padding : V
                  , o = "number" == typeof i
                  , s = e({
                    top: o ? i : i.top,
                    bottom: o ? i : i.bottom,
                    left: o ? i : i.left,
                    right: o ? i : i.right
                }, !o && i);
                s[n] = o ? i + It.props.distance : (i[n] || 0) + It.props.distance,
                It.popperInstance.modifiers.filter(function(t) {
                    return "preventOverflow" === t.name
                })[0].padding = s,
                xt = s
            }
            var r = It.props.popperOptions
              , i = It.popperChildren
              , a = i.tooltip
              , s = i.arrow
              , l = d(r, "preventOverflow")
              , u = e({
                eventsEnabled: !1,
                placement: It.props.placement
            }, r, {
                modifiers: e({}, r ? r.modifiers : {}, {
                    preventOverflow: e({
                        boundariesElement: It.props.boundary,
                        padding: V
                    }, l),
                    arrow: e({
                        element: s,
                        enabled: !!s
                    }, d(r, "arrow")),
                    flip: e({
                        enabled: It.props.flip,
                        padding: It.props.distance + V,
                        behavior: It.props.flipBehavior
                    }, d(r, "flip")),
                    offset: e({
                        offset: It.props.offset
                    }, d(r, "offset"))
                }),
                onCreate: function(t) {
                    n(t),
                    J(),
                    r && r.onCreate && r.onCreate(t)
                },
                onUpdate: function(t) {
                    n(t),
                    J(),
                    r && r.onUpdate && r.onUpdate(t)
                }
            });
            It.popperInstance = new t(o,Ot,u)
        }
        function et(t, n) {
            if (ot(),
            !It.state.isVisible) {
                if (It.props.target)
                    return function(t) {
                        if (t) {
                            var n = r(t.target, It.props.target);
                            n && !n._tippy && z(n, e({}, It.props, {
                                content: m(a.content, [n]),
                                appendTo: a.appendTo,
                                target: "",
                                showOnInit: !0
                            }))
                        }
                    }(t);
                if (kt = !0,
                t && !n && It.props.onTrigger(It, t),
                It.props.wait)
                    return It.props.wait(It, t);
                T() && !It.state.isMounted && (It.popperInstance || tt(),
                document.addEventListener("mousemove", P)),
                C();
                var i = u(It.props.delay, 0, H.delay);
                i ? ht = setTimeout(function() {
                    st()
                }, i) : st()
            }
        }
        function nt() {
            if (ot(),
            !It.state.isVisible)
                return s(),
                void k();
            kt = !1;
            var t = u(It.props.delay, 1, H.delay);
            t ? mt = setTimeout(function() {
                It.state.isVisible && lt()
            }, t) : gt = requestAnimationFrame(function() {
                lt()
            })
        }
        function it(t) {
            if (!It.props.interactive || !Ot.contains(t.target)) {
                if (v().contains(t.target)) {
                    if (ut)
                        return;
                    if (It.state.isVisible && p(It.props.trigger, "click"))
                        return
                }
                !0 === It.props.hideOnClick && (ot(),
                lt())
            }
        }
        function ot() {
            clearTimeout(ht),
            clearTimeout(mt),
            cancelAnimationFrame(gt)
        }
        function at(t) {
            x(t = t || {}, H),
            N();
            var n = It.props
              , r = w(o, e({}, It.props, {}, t, {
                ignoreAttributes: !0
            }));
            r.ignoreAttributes = l(t, "ignoreAttributes") ? t.ignoreAttributes || !1 : n.ignoreAttributes,
            It.props = r,
            L(),
            h(),
            At = c(R, r.interactiveDebounce),
            j(Ot, n, r),
            It.popperChildren = _(Ot),
            It.popperInstance && (B.some(function(e) {
                return l(t, e) && t[e] !== n[e]
            }) ? (It.popperInstance.destroy(),
            tt(),
            It.state.isVisible && It.popperInstance.enableEventListeners(),
            It.props.followCursor && dt && P(dt)) : It.popperInstance.update())
        }
        function st() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : u(It.props.duration, 0, H.duration[1]);
            if (!It.state.isDestroyed && It.state.isEnabled && (!ut || It.props.touch) && !v().hasAttribute("disabled") && !1 !== It.props.onShow(It)) {
                C(),
                Ot.style.visibility = "visible",
                It.state.isVisible = !0,
                It.props.interactive && v().classList.add(K);
                var e = S();
                y(e.concat(Ot), 0),
                bt = function() {
                    if (It.state.isVisible) {
                        var n = T();
                        n && dt ? P(dt) : n || It.popperInstance.update(),
                        It.popperChildren.backdrop && (It.popperChildren.content.style.transitionDelay = Math.round(t / 12) + "ms"),
                        It.props.sticky && function() {
                            y([Ot], $ ? 0 : It.props.updateDuration);
                            var t = o.getBoundingClientRect();
                            !function e() {
                                var n = o.getBoundingClientRect();
                                t.top === n.top && t.right === n.right && t.bottom === n.bottom && t.left === n.left || It.popperInstance.scheduleUpdate(),
                                t = n,
                                It.state.isMounted && requestAnimationFrame(e)
                            }()
                        }(),
                        y([Ot], It.props.updateDuration),
                        y(e, t),
                        b(e, "visible"),
                        function(t, e) {
                            E(t, e)
                        }(t, function() {
                            It.props.aria && v().setAttribute("aria-".concat(It.props.aria), Ot.id),
                            It.props.onShown(It),
                            It.state.isShown = !0
                        })
                    }
                }
                ,
                function() {
                    Tt = !1;
                    var t = T();
                    It.popperInstance ? (g(It.popperInstance.modifiers, It.props.flip),
                    t || (It.popperInstance.reference = o,
                    It.popperInstance.enableEventListeners()),
                    It.popperInstance.scheduleUpdate()) : (tt(),
                    t || It.popperInstance.enableEventListeners());
                    var e = It.props.appendTo
                      , n = "parent" === e ? o.parentNode : m(e, [o]);
                    n.contains(Ot) || (n.appendChild(Ot),
                    It.props.onMount(It),
                    It.state.isMounted = !0)
                }()
            }
        }
        function lt() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : u(It.props.duration, 1, H.duration[1]);
            if (!It.state.isDestroyed && (It.state.isEnabled || _t) && (!1 !== It.props.onHide(It) || _t)) {
                k(),
                Ot.style.visibility = "hidden",
                It.state.isVisible = !1,
                It.state.isShown = !1,
                St = !1,
                It.props.interactive && v().classList.remove(K);
                var e = S();
                y(e, t),
                b(e, "hidden"),
                function(t, e) {
                    E(t, function() {
                        !It.state.isVisible && Ot.parentNode && Ot.parentNode.contains(Ot) && e()
                    })
                }(t, function() {
                    kt || s(),
                    It.props.aria && v().removeAttribute("aria-".concat(It.props.aria)),
                    It.popperInstance.disableEventListeners(),
                    It.popperInstance.options.placement = It.props.placement,
                    Ot.parentNode.removeChild(Ot),
                    It.props.onHidden(It),
                    It.state.isMounted = !1
                })
            }
        }
        var ct, dt, ht, mt, gt, vt = w(o, a);
        if (!vt.multiple && o._tippy)
            return null;
        var yt, bt, wt, xt, Ct, kt = !1, _t = !1, St = !1, Tt = !1, Et = [], At = c(R, vt.interactiveDebounce), Mt = pt++, Ot = I(Mt, vt), Lt = _(Ot), It = {
            id: Mt,
            reference: o,
            popper: Ot,
            popperChildren: Lt,
            popperInstance: null,
            props: vt,
            state: {
                isEnabled: !0,
                isVisible: !1,
                isDestroyed: !1,
                isMounted: !1,
                isShown: !1
            },
            clearDelayTimeouts: ot,
            set: at,
            setContent: function(t) {
                at({
                    content: t
                })
            },
            show: st,
            hide: lt,
            enable: function() {
                It.state.isEnabled = !0
            },
            disable: function() {
                It.state.isEnabled = !1
            },
            destroy: function(t) {
                if (!It.state.isDestroyed) {
                    _t = !0,
                    It.state.isMounted && lt(0),
                    N(),
                    delete o._tippy;
                    var e = It.props.target;
                    e && t && f(o) && n(o.querySelectorAll(e)).forEach(function(t) {
                        t._tippy && t._tippy.destroy()
                    }),
                    It.popperInstance && It.popperInstance.destroy(),
                    _t = !1,
                    It.state.isDestroyed = !0
                }
            }
        };
        return o._tippy = It,
        Ot._tippy = It,
        L(),
        vt.lazy || tt(),
        vt.showOnInit && et(),
        !vt.a11y || vt.target || !f(Ct = v()) || W.call(Ct, "a[href],area[href],button,details,input,textarea,select,iframe,[tabindex]") && !Ct.hasAttribute("disabled") || v().setAttribute("tabindex", "0"),
        Ot.addEventListener("mouseenter", function(t) {
            It.props.interactive && It.state.isVisible && "mouseenter" === ct && et(t, !0)
        }),
        Ot.addEventListener("mouseleave", function() {
            It.props.interactive && "mouseenter" === ct && document.addEventListener("mousemove", At)
        }),
        It
    }
    function N(t, r) {
        x(r || {}, H),
        ht || (document.addEventListener("touchstart", o, U),
        window.addEventListener("blur", s),
        ht = !0);
        var i, a = e({}, H, {}, r);
        i = t,
        "[object Object]" !== {}.toString.call(i) || i.addEventListener || function(t) {
            var e = {
                isVirtual: !0,
                attributes: t.attributes || {},
                contains: function() {},
                setAttribute: function(e, n) {
                    t.attributes[e] = n
                },
                getAttribute: function(e) {
                    return t.attributes[e]
                },
                removeAttribute: function(e) {
                    delete t.attributes[e]
                },
                hasAttribute: function(e) {
                    return e in t.attributes
                },
                addEventListener: function() {},
                removeEventListener: function() {},
                classList: {
                    classNames: {},
                    add: function(e) {
                        t.classList.classNames[e] = !0
                    },
                    remove: function(e) {
                        delete t.classList.classNames[e]
                    },
                    contains: function(e) {
                        return e in t.classList.classNames
                    }
                }
            };
            for (var n in e)
                t[n] = e[n]
        }(t);
        var l = function(t) {
            if (h(t))
                return [t];
            if (t instanceof NodeList)
                return n(t);
            if (Array.isArray(t))
                return t;
            try {
                return n(document.querySelectorAll(t))
            } catch (t) {
                return []
            }
        }(t).reduce(function(t, e) {
            var n = e && z(e, a);
            return n && t.push(n),
            t
        }, []);
        return h(t) ? l[0] : l
    }
    t = t && t.hasOwnProperty("default") ? t.default : t;
    var P = "undefined" != typeof window && "undefined" != typeof document
      , D = P ? navigator.userAgent : ""
      , $ = /MSIE |Trident\//.test(D)
      , R = /UCBrowser\//.test(D)
      , F = P && /iPhone|iPad|iPod/.test(navigator.platform) && !window.MSStream
      , H = {
        a11y: !0,
        allowHTML: !0,
        animateFill: !0,
        animation: "shift-away",
        appendTo: function() {
            return document.body
        },
        aria: "describedby",
        arrow: !1,
        arrowType: "sharp",
        boundary: "scrollParent",
        content: "",
        delay: 0,
        distance: 10,
        duration: [325, 275],
        flip: !0,
        flipBehavior: "flip",
        flipOnUpdate: !1,
        followCursor: !1,
        hideOnClick: !0,
        ignoreAttributes: !1,
        inertia: !1,
        interactive: !1,
        interactiveBorder: 2,
        interactiveDebounce: 0,
        lazy: !0,
        maxWidth: 350,
        multiple: !1,
        offset: 0,
        onHidden: function() {},
        onHide: function() {},
        onMount: function() {},
        onShow: function() {},
        onShown: function() {},
        onTrigger: function() {},
        placement: "top",
        popperOptions: {},
        role: "tooltip",
        showOnInit: !1,
        size: "regular",
        sticky: !1,
        target: "",
        theme: "dark",
        touch: !0,
        touchHold: !1,
        trigger: "mouseenter focus",
        triggerTarget: null,
        updateDuration: 0,
        wait: null,
        zIndex: 9999
    }
      , B = ["arrow", "arrowType", "boundary", "distance", "flip", "flipBehavior", "flipOnUpdate", "offset", "placement", "popperOptions"]
      , q = P ? Element.prototype : {}
      , W = q.matches || q.matchesSelector || q.webkitMatchesSelector || q.mozMatchesSelector || q.msMatchesSelector
      , U = {
        passive: !0
    }
      , V = 4
      , X = "x-placement"
      , Y = "x-out-of-boundaries"
      , Z = "tippy-iOS"
      , K = "tippy-active"
      , G = "tippy-popper"
      , Q = "tippy-tooltip"
      , J = "tippy-content"
      , tt = "tippy-backdrop"
      , et = "tippy-arrow"
      , nt = "tippy-roundarrow"
      , rt = ".".concat(G)
      , it = ".".concat(Q)
      , ot = ".".concat(J)
      , at = ".".concat(tt)
      , st = ".".concat(et)
      , lt = ".".concat(nt)
      , ut = !1
      , ct = 0
      , dt = Object.keys(H)
      , pt = 1
      , ft = []
      , ht = !1;
    return N.version = "4.3.5",
    N.defaults = H,
    N.setDefaults = function(t) {
        Object.keys(t).forEach(function(e) {
            H[e] = t[e]
        })
    }
    ,
    N.hideAll = function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
          , e = t.exclude
          , r = t.duration;
        n(document.querySelectorAll(rt)).forEach(function(t) {
            var n, i = t._tippy;
            if (i) {
                var o = !1;
                e && (o = (n = e)._tippy && !W.call(n, rt) ? i.reference === e : t === e.popper),
                o || i.hide(r)
            }
        })
    }
    ,
    N.group = function(t) {
        function n(t) {
            p = t,
            a()
        }
        function r(e) {
            e._originalProps.onShow(e),
            t.forEach(function(t) {
                t.set({
                    duration: d
                }),
                t.state.isVisible && t.hide()
            }),
            n(!0)
        }
        function i(t) {
            t._originalProps.onHide(t),
            n(!1)
        }
        function o(t) {
            t._originalProps.onShown(t),
            t.set({
                duration: t._originalProps.duration
            })
        }
        function a() {
            t.forEach(function(t) {
                t.set({
                    onShow: r,
                    onShown: o,
                    onHide: i,
                    delay: p ? [0, Array.isArray(u) ? u[1] : u] : u,
                    duration: p ? d : t._originalProps.duration
                })
            })
        }
        var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
          , l = s.delay
          , u = void 0 === l ? t[0].props.delay : l
          , c = s.duration
          , d = void 0 === c ? 0 : c
          , p = !1;
        t.forEach(function(t) {
            t._originalProps ? t.set(t._originalProps) : t._originalProps = e({}, t.props)
        }),
        a()
    }
    ,
    P && setTimeout(function() {
        n(document.querySelectorAll("[data-tippy]")).forEach(function(t) {
            var e = t.getAttribute("data-tippy");
            e && N(t, {
                content: e
            })
        })
    }),
    function(t) {
        if (P) {
            var e = document.createElement("style");
            e.type = "text/css",
            e.textContent = t,
            e.setAttribute("data-tippy-stylesheet", "");
            var n = document.head
              , r = n.querySelector("style,link");
            r ? n.insertBefore(e, r) : n.appendChild(e)
        }
    }('.tippy-iOS{cursor:pointer!important;-webkit-tap-highlight-color:transparent}.tippy-popper{transition-timing-function:cubic-bezier(.165,.84,.44,1);max-width:calc(100% - 8px);pointer-events:none;outline:0}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-7px;bottom:-6.5px;-webkit-transform-origin:50% 0;transform-origin:50% 0;margin:0 3px}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;bottom:-7px;margin:0 3px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 25%;transform-origin:0 25%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-55%);transform:scale(1) translate(-50%,-55%)}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%,-45%);transform:scale(.2) translate(-50%,-45%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(-10px);transform:perspective(700px) translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateX(60deg);transform:perspective(700px) rotateX(60deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=top] [data-animation=scale]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px) scale(.5);transform:translateY(-10px) scale(.5)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-7px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;margin:0 3px}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;top:-7px;margin:0 3px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -50%;transform-origin:0 -50%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-45%);transform:scale(1) translate(-50%,-45%)}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%);transform:scale(.2) translate(-50%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(10px);transform:perspective(700px) translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateX(-60deg);transform:perspective(700px) rotateX(-60deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=scale]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px) scale(.5);transform:translateY(10px) scale(.5)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-12px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%;margin:3px 0}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-75%,-50%);transform:scale(.2) translate(-75%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(-10px);transform:perspective(700px) translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateY(-60deg);transform:perspective(700px) rotateY(-60deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=left] [data-animation=scale]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px) scale(.5);transform:translateX(-10px) scale(.5)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-12px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%;margin:3px 0}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-50% 0;transform-origin:-50% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-25%,-50%);transform:scale(.2) translate(-25%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(10px);transform:perspective(700px) translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateY(60deg);transform:perspective(700px) rotateY(60deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=right] [data-animation=scale]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px) scale(.5);transform:translateX(10px) scale(.5)}.tippy-tooltip{position:relative;color:#fff;border-radius:.25rem;font-size:.875rem;padding:.3125rem .5625rem;line-height:1.4;text-align:center;background-color:#333}.tippy-tooltip[data-size=small]{padding:.1875rem .375rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.375rem .75rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:initial}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] .tippy-roundarrow path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:18px;height:7px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;background-color:#333;border-radius:50%;width:calc(110% + 2rem);left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:"";float:left;padding-top:100%}.tippy-backdrop+.tippy-content{transition-property:opacity;will-change:opacity}.tippy-backdrop+.tippy-content[data-state=hidden]{opacity:0}'),
    N
}),
/*! iziToast.min.js */
/*
* iziToast | v1.4.0
* http://izitoast.marcelodolce.com
* by Marcelo Dolce.
*/
!function(t, e) {
    "function" == typeof define && define.amd ? define([], e(t)) : "object" == typeof exports ? module.exports = e(t) : t.iziToast = e(t)
}("undefined" != typeof global ? global : window || this.window || this.global, function(t) {
    "use strict";
    var e = {}
      , n = "iziToast"
      , r = (document.querySelector("body"),
    !!/Mobi/.test(navigator.userAgent))
      , i = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
      , o = "undefined" != typeof InstallTrigger
      , a = "ontouchstart"in document.documentElement
      , s = ["bottomRight", "bottomLeft", "bottomCenter", "topRight", "topLeft", "topCenter", "center"]
      , l = {
        info: {
            color: "blue",
            icon: "ico-info"
        },
        success: {
            color: "green",
            icon: "ico-success"
        },
        warning: {
            color: "orange",
            icon: "ico-warning"
        },
        error: {
            color: "red",
            icon: "ico-error"
        },
        question: {
            color: "yellow",
            icon: "ico-question"
        }
    }
      , u = 568
      , c = {};
    e.children = {};
    var d = {
        id: null,
        class: "",
        title: "",
        titleColor: "",
        titleSize: "",
        titleLineHeight: "",
        message: "",
        messageColor: "",
        messageSize: "",
        messageLineHeight: "",
        backgroundColor: "",
        theme: "light",
        color: "",
        icon: "",
        iconText: "",
        iconColor: "",
        iconUrl: null,
        image: "",
        imageWidth: 50,
        maxWidth: null,
        zindex: null,
        layout: 1,
        balloon: !1,
        close: !0,
        closeOnEscape: !1,
        closeOnClick: !1,
        displayMode: 0,
        position: "bottomRight",
        target: "",
        targetFirst: !0,
        timeout: 5e3,
        rtl: !1,
        animateInside: !0,
        drag: !0,
        pauseOnHover: !0,
        resetOnHover: !1,
        progressBar: !0,
        progressBarColor: "",
        progressBarEasing: "linear",
        overlay: !1,
        overlayClose: !1,
        overlayColor: "rgba(0, 0, 0, 0.6)",
        transitionIn: "fadeInUp",
        transitionOut: "fadeOut",
        transitionInMobile: "fadeInUp",
        transitionOutMobile: "fadeOutDown",
        buttons: {},
        inputs: {},
        onOpening: function() {},
        onOpened: function() {},
        onClosing: function() {},
        onClosed: function() {}
    };
    if ("remove"in Element.prototype || (Element.prototype.remove = function() {
        this.parentNode && this.parentNode.removeChild(this)
    }
    ),
    "function" != typeof window.CustomEvent) {
        var p = function(t, e) {
            e = e || {
                bubbles: !1,
                cancelable: !1,
                detail: void 0
            };
            var n = document.createEvent("CustomEvent");
            return n.initCustomEvent(t, e.bubbles, e.cancelable, e.detail),
            n
        };
        p.prototype = window.Event.prototype,
        window.CustomEvent = p
    }
    var f = function(t, e, n) {
        if ("[object Object]" === Object.prototype.toString.call(t))
            for (var r in t)
                Object.prototype.hasOwnProperty.call(t, r) && e.call(n, t[r], r, t);
        else if (t)
            for (var i = 0, o = t.length; o > i; i++)
                e.call(n, t[i], i, t)
    }
      , h = function(t, e) {
        var n = {};
        return f(t, function(e, r) {
            n[r] = t[r]
        }),
        f(e, function(t, r) {
            n[r] = e[r]
        }),
        n
    }
      , m = function(t) {
        var e = document.createDocumentFragment()
          , n = document.createElement("div");
        for (n.innerHTML = t; n.firstChild; )
            e.appendChild(n.firstChild);
        return e
    }
      , g = function(t) {
        var e = btoa(encodeURIComponent(t));
        return e.replace(/=/g, "")
    }
      , v = function(t) {
        return "#" == t.substring(0, 1) || "rgb" == t.substring(0, 3) || "hsl" == t.substring(0, 3)
    }
      , y = function(t) {
        try {
            return btoa(atob(t)) == t
        } catch (t) {
            return !1
        }
    }
      , b = function() {
        return {
            move: function(t, e, r, a) {
                var s, l = .3, u = 180;
                0 !== a && (t.classList.add(n + "-dragged"),
                t.style.transform = "translateX(" + a + "px)",
                a > 0 ? (s = (u - a) / u,
                l > s && e.hide(h(r, {
                    transitionOut: "fadeOutRight",
                    transitionOutMobile: "fadeOutRight"
                }), t, "drag")) : (s = (u + a) / u,
                l > s && e.hide(h(r, {
                    transitionOut: "fadeOutLeft",
                    transitionOutMobile: "fadeOutLeft"
                }), t, "drag")),
                t.style.opacity = s,
                l > s && ((i || o) && (t.style.left = a + "px"),
                t.parentNode.style.opacity = l,
                this.stopMoving(t, null)))
            },
            startMoving: function(t, e, n, r) {
                r = r || window.event;
                var i = a ? r.touches[0].clientX : r.clientX
                  , o = t.style.transform.replace("px)", "");
                o = o.replace("translateX(", "");
                var s = i - o;
                n.transitionIn && t.classList.remove(n.transitionIn),
                n.transitionInMobile && t.classList.remove(n.transitionInMobile),
                t.style.transition = "",
                a ? document.ontouchmove = function(r) {
                    r.preventDefault(),
                    r = r || window.event;
                    var i = r.touches[0].clientX
                      , o = i - s;
                    b.move(t, e, n, o)
                }
                : document.onmousemove = function(r) {
                    r.preventDefault(),
                    r = r || window.event;
                    var i = r.clientX
                      , o = i - s;
                    b.move(t, e, n, o)
                }
            },
            stopMoving: function(t, e) {
                a ? document.ontouchmove = function() {}
                : document.onmousemove = function() {}
                ,
                t.style.opacity = "",
                t.style.transform = "",
                t.classList.contains(n + "-dragged") && (t.classList.remove(n + "-dragged"),
                t.style.transition = "transform 0.4s ease, opacity 0.4s ease",
                setTimeout(function() {
                    t.style.transition = ""
                }, 400))
            }
        }
    }();
    return e.setSetting = function(t, n, r) {
        e.children[t][n] = r
    }
    ,
    e.getSetting = function(t, n) {
        return e.children[t][n]
    }
    ,
    e.destroy = function() {
        f(document.querySelectorAll("." + n + "-overlay"), function(t, e) {
            t.remove()
        }),
        f(document.querySelectorAll("." + n + "-wrapper"), function(t, e) {
            t.remove()
        }),
        f(document.querySelectorAll("." + n), function(t, e) {
            t.remove()
        }),
        this.children = {},
        document.removeEventListener(n + "-opened", {}, !1),
        document.removeEventListener(n + "-opening", {}, !1),
        document.removeEventListener(n + "-closing", {}, !1),
        document.removeEventListener(n + "-closed", {}, !1),
        document.removeEventListener("keyup", {}, !1),
        c = {}
    }
    ,
    e.settings = function(t) {
        e.destroy(),
        c = t,
        d = h(d, t || {})
    }
    ,
    f(l, function(t, n) {
        e[n] = function(e) {
            var n = h(c, e || {});
            n = h(t, n || {}),
            this.show(n)
        }
    }),
    e.progress = function(t, e, r) {
        var i = this
          , o = e.getAttribute("data-iziToast-ref")
          , a = h(this.children[o], t || {})
          , s = e.querySelector("." + n + "-progressbar div");
        return {
            start: function() {
                "undefined" == typeof a.time.REMAINING && (e.classList.remove(n + "-reseted"),
                null !== s && (s.style.transition = "width " + a.timeout + "ms " + a.progressBarEasing,
                s.style.width = "0%"),
                a.time.START = (new Date).getTime(),
                a.time.END = a.time.START + a.timeout,
                a.time.TIMER = setTimeout(function() {
                    clearTimeout(a.time.TIMER),
                    e.classList.contains(n + "-closing") || (i.hide(a, e, "timeout"),
                    "function" == typeof r && r.apply(i))
                }, a.timeout),
                i.setSetting(o, "time", a.time))
            },
            pause: function() {
                if ("undefined" != typeof a.time.START && !e.classList.contains(n + "-paused") && !e.classList.contains(n + "-reseted")) {
                    if (e.classList.add(n + "-paused"),
                    a.time.REMAINING = a.time.END - (new Date).getTime(),
                    clearTimeout(a.time.TIMER),
                    i.setSetting(o, "time", a.time),
                    null !== s) {
                        var t = window.getComputedStyle(s)
                          , l = t.getPropertyValue("width");
                        s.style.transition = "none",
                        s.style.width = l
                    }
                    "function" == typeof r && setTimeout(function() {
                        r.apply(i)
                    }, 10)
                }
            },
            resume: function() {
                "undefined" != typeof a.time.REMAINING ? (e.classList.remove(n + "-paused"),
                null !== s && (s.style.transition = "width " + a.time.REMAINING + "ms " + a.progressBarEasing,
                s.style.width = "0%"),
                a.time.END = (new Date).getTime() + a.time.REMAINING,
                a.time.TIMER = setTimeout(function() {
                    clearTimeout(a.time.TIMER),
                    e.classList.contains(n + "-closing") || (i.hide(a, e, "timeout"),
                    "function" == typeof r && r.apply(i))
                }, a.time.REMAINING),
                i.setSetting(o, "time", a.time)) : this.start()
            },
            reset: function() {
                clearTimeout(a.time.TIMER),
                delete a.time.REMAINING,
                i.setSetting(o, "time", a.time),
                e.classList.add(n + "-reseted"),
                e.classList.remove(n + "-paused"),
                null !== s && (s.style.transition = "none",
                s.style.width = "100%"),
                "function" == typeof r && setTimeout(function() {
                    r.apply(i)
                }, 10)
            }
        }
    }
    ,
    e.hide = function(t, e, i) {
        "object" != typeof e && (e = document.querySelector(e));
        var o = this
          , a = h(this.children[e.getAttribute("data-iziToast-ref")], t || {});
        a.closedBy = i || null,
        delete a.time.REMAINING,
        e.classList.add(n + "-closing"),
        function() {
            var t = document.querySelector("." + n + "-overlay");
            if (null !== t) {
                var e = t.getAttribute("data-iziToast-ref");
                e = e.split(",");
                var r = e.indexOf(String(a.ref));
                -1 !== r && e.splice(r, 1),
                t.setAttribute("data-iziToast-ref", e.join()),
                0 === e.length && (t.classList.remove("fadeIn"),
                t.classList.add("fadeOut"),
                setTimeout(function() {
                    t.remove()
                }, 700))
            }
        }(),
        a.transitionIn && e.classList.remove(a.transitionIn),
        a.transitionInMobile && e.classList.remove(a.transitionInMobile),
        r || window.innerWidth <= u ? a.transitionOutMobile && e.classList.add(a.transitionOutMobile) : a.transitionOut && e.classList.add(a.transitionOut);
        var s = e.parentNode.offsetHeight;
        e.parentNode.style.height = s + "px",
        e.style.pointerEvents = "none",
        (!r || window.innerWidth > u) && (e.parentNode.style.transitionDelay = "0.2s");
        try {
            var l = new CustomEvent(n + "-closing",{
                detail: a,
                bubbles: !0,
                cancelable: !0
            });
            document.dispatchEvent(l)
        } catch (t) {
            console.warn(t)
        }
        setTimeout(function() {
            e.parentNode.style.height = "0px",
            e.parentNode.style.overflow = "",
            setTimeout(function() {
                delete o.children[a.ref],
                e.parentNode.remove();
                try {
                    var t = new CustomEvent(n + "-closed",{
                        detail: a,
                        bubbles: !0,
                        cancelable: !0
                    });
                    document.dispatchEvent(t)
                } catch (t) {
                    console.warn(t)
                }
                "undefined" != typeof a.onClosed && a.onClosed.apply(null, [a, e, i])
            }, 1e3)
        }, 200),
        "undefined" != typeof a.onClosing && a.onClosing.apply(null, [a, e, i])
    }
    ,
    e.show = function(t) {
        var i = this
          , o = h(c, t || {});
        if (o = h(d, o),
        o.time = {},
        null === o.id && (o.id = g(o.title + o.message + o.color)),
        1 === o.displayMode || "once" == o.displayMode)
            try {
                if (document.querySelectorAll("." + n + "#" + o.id).length > 0)
                    return !1
            } catch (t) {
                console.warn("[" + n + "] Could not find an element with this selector: #" + o.id + ". Try to set an valid id.")
            }
        if (2 === o.displayMode || "replace" == o.displayMode)
            try {
                f(document.querySelectorAll("." + n + "#" + o.id), function(t, e) {
                    i.hide(o, t, "replaced")
                })
            } catch (t) {
                console.warn("[" + n + "] Could not find an element with this selector: #" + o.id + ". Try to set an valid id.")
            }
        o.ref = (new Date).getTime() + Math.floor(1e7 * Math.random() + 1),
        e.children[o.ref] = o;
        var l = {
            body: document.querySelector("body"),
            overlay: document.createElement("div"),
            toast: document.createElement("div"),
            toastBody: document.createElement("div"),
            toastTexts: document.createElement("div"),
            toastCapsule: document.createElement("div"),
            cover: document.createElement("div"),
            buttons: document.createElement("div"),
            inputs: document.createElement("div"),
            icon: o.iconUrl ? document.createElement("img") : document.createElement("i"),
            wrapper: null
        };
        l.toast.setAttribute("data-iziToast-ref", o.ref),
        l.toast.appendChild(l.toastBody),
        l.toastCapsule.appendChild(l.toast),
        function() {
            if (l.toast.classList.add(n),
            l.toast.classList.add(n + "-opening"),
            l.toastCapsule.classList.add(n + "-capsule"),
            l.toastBody.classList.add(n + "-body"),
            l.toastTexts.classList.add(n + "-texts"),
            r || window.innerWidth <= u ? o.transitionInMobile && l.toast.classList.add(o.transitionInMobile) : o.transitionIn && l.toast.classList.add(o.transitionIn),
            o.class) {
                var t = o.class.split(" ");
                f(t, function(t, e) {
                    l.toast.classList.add(t)
                })
            }
            o.id && (l.toast.id = o.id),
            o.rtl && (l.toast.classList.add(n + "-rtl"),
            l.toast.setAttribute("dir", "rtl")),
            o.layout > 1 && l.toast.classList.add(n + "-layout" + o.layout),
            o.balloon && l.toast.classList.add(n + "-balloon"),
            o.maxWidth && (isNaN(o.maxWidth) ? l.toast.style.maxWidth = o.maxWidth : l.toast.style.maxWidth = o.maxWidth + "px"),
            "" === o.theme && "light" === o.theme || l.toast.classList.add(n + "-theme-" + o.theme),
            o.color && (v(o.color) ? l.toast.style.background = o.color : l.toast.classList.add(n + "-color-" + o.color)),
            o.backgroundColor && (l.toast.style.background = o.backgroundColor,
            o.balloon && (l.toast.style.borderColor = o.backgroundColor))
        }(),
        function() {
            o.image && (l.cover.classList.add(n + "-cover"),
            l.cover.style.width = o.imageWidth + "px",
            y(o.image.replace(/ /g, "")) ? l.cover.style.backgroundImage = "url(data:image/png;base64," + o.image.replace(/ /g, "") + ")" : l.cover.style.backgroundImage = "url(" + o.image + ")",
            o.rtl ? l.toastBody.style.marginRight = o.imageWidth + 10 + "px" : l.toastBody.style.marginLeft = o.imageWidth + 10 + "px",
            l.toast.appendChild(l.cover))
        }(),
        function() {
            o.close ? (l.buttonClose = document.createElement("button"),
            l.buttonClose.type = "button",
            l.buttonClose.classList.add(n + "-close"),
            l.buttonClose.addEventListener("click", function(t) {
                t.target,
                i.hide(o, l.toast, "button")
            }),
            l.toast.appendChild(l.buttonClose)) : o.rtl ? l.toast.style.paddingLeft = "18px" : l.toast.style.paddingRight = "18px"
        }(),
        function() {
            o.progressBar && (l.progressBar = document.createElement("div"),
            l.progressBarDiv = document.createElement("div"),
            l.progressBar.classList.add(n + "-progressbar"),
            l.progressBarDiv.style.background = o.progressBarColor,
            l.progressBar.appendChild(l.progressBarDiv),
            l.toast.appendChild(l.progressBar)),
            o.timeout && (o.pauseOnHover && !o.resetOnHover && (l.toast.addEventListener("mouseenter", function(t) {
                i.progress(o, l.toast).pause()
            }),
            l.toast.addEventListener("mouseleave", function(t) {
                i.progress(o, l.toast).resume()
            })),
            o.resetOnHover && (l.toast.addEventListener("mouseenter", function(t) {
                i.progress(o, l.toast).reset()
            }),
            l.toast.addEventListener("mouseleave", function(t) {
                i.progress(o, l.toast).start()
            })))
        }(),
        function() {
            o.iconUrl ? (l.icon.setAttribute("class", n + "-icon"),
            l.icon.setAttribute("src", o.iconUrl)) : o.icon && (l.icon.setAttribute("class", n + "-icon " + o.icon),
            o.iconText && l.icon.appendChild(document.createTextNode(o.iconText)),
            o.iconColor && (l.icon.style.color = o.iconColor)),
            (o.icon || o.iconUrl) && (o.rtl ? l.toastBody.style.paddingRight = "33px" : l.toastBody.style.paddingLeft = "33px",
            l.toastBody.appendChild(l.icon))
        }(),
        function() {
            o.title.length > 0 && (l.strong = document.createElement("strong"),
            l.strong.classList.add(n + "-title"),
            l.strong.appendChild(m(o.title)),
            l.toastTexts.appendChild(l.strong),
            o.titleColor && (l.strong.style.color = o.titleColor),
            o.titleSize && (isNaN(o.titleSize) ? l.strong.style.fontSize = o.titleSize : l.strong.style.fontSize = o.titleSize + "px"),
            o.titleLineHeight && (isNaN(o.titleSize) ? l.strong.style.lineHeight = o.titleLineHeight : l.strong.style.lineHeight = o.titleLineHeight + "px")),
            o.message.length > 0 && (l.p = document.createElement("p"),
            l.p.classList.add(n + "-message"),
            l.p.appendChild(m(o.message)),
            l.toastTexts.appendChild(l.p),
            o.messageColor && (l.p.style.color = o.messageColor),
            o.messageSize && (isNaN(o.titleSize) ? l.p.style.fontSize = o.messageSize : l.p.style.fontSize = o.messageSize + "px"),
            o.messageLineHeight && (isNaN(o.titleSize) ? l.p.style.lineHeight = o.messageLineHeight : l.p.style.lineHeight = o.messageLineHeight + "px")),
            o.title.length > 0 && o.message.length > 0 && (o.rtl ? l.strong.style.marginLeft = "10px" : 2 === o.layout || o.rtl || (l.strong.style.marginRight = "10px"))
        }(),
        l.toastBody.appendChild(l.toastTexts);
        var p;
        !function() {
            o.inputs.length > 0 && (l.inputs.classList.add(n + "-inputs"),
            f(o.inputs, function(t, e) {
                l.inputs.appendChild(m(t[0])),
                p = l.inputs.childNodes,
                p[e].classList.add(n + "-inputs-child"),
                t[3] && setTimeout(function() {
                    p[e].focus()
                }, 300),
                p[e].addEventListener(t[1], function(e) {
                    var n = t[2];
                    return n(i, l.toast, this, e)
                })
            }),
            l.toastBody.appendChild(l.inputs))
        }(),
        function() {
            o.buttons.length > 0 && (l.buttons.classList.add(n + "-buttons"),
            f(o.buttons, function(t, e) {
                l.buttons.appendChild(m(t[0]));
                var r = l.buttons.childNodes;
                r[e].classList.add(n + "-buttons-child"),
                t[2] && setTimeout(function() {
                    r[e].focus()
                }, 300),
                r[e].addEventListener("click", function(e) {
                    e.preventDefault();
                    var n = t[1];
                    return n(i, l.toast, this, e, p)
                })
            })),
            l.toastBody.appendChild(l.buttons)
        }(),
        o.message.length > 0 && (o.inputs.length > 0 || o.buttons.length > 0) && (l.p.style.marginBottom = "0"),
        (o.inputs.length > 0 || o.buttons.length > 0) && (o.rtl ? l.toastTexts.style.marginLeft = "10px" : l.toastTexts.style.marginRight = "10px",
        o.inputs.length > 0 && o.buttons.length > 0 && (o.rtl ? l.inputs.style.marginLeft = "8px" : l.inputs.style.marginRight = "8px")),
        function() {
            l.toastCapsule.style.visibility = "hidden",
            setTimeout(function() {
                var t = l.toast.offsetHeight
                  , e = l.toast.currentStyle || window.getComputedStyle(l.toast)
                  , n = e.marginTop;
                n = n.split("px"),
                n = parseInt(n[0]);
                var r = e.marginBottom;
                r = r.split("px"),
                r = parseInt(r[0]),
                l.toastCapsule.style.visibility = "",
                l.toastCapsule.style.height = t + r + n + "px",
                setTimeout(function() {
                    l.toastCapsule.style.height = "auto",
                    o.target && (l.toastCapsule.style.overflow = "visible")
                }, 500),
                o.timeout && i.progress(o, l.toast).start()
            }, 100)
        }(),
        function() {
            var t = o.position;
            if (o.target)
                l.wrapper = document.querySelector(o.target),
                l.wrapper.classList.add(n + "-target"),
                o.targetFirst ? l.wrapper.insertBefore(l.toastCapsule, l.wrapper.firstChild) : l.wrapper.appendChild(l.toastCapsule);
            else {
                if (-1 == s.indexOf(o.position))
                    return void console.warn("[" + n + "] Incorrect position.\nIt can be › " + s);
                t = r || window.innerWidth <= u ? "bottomLeft" == o.position || "bottomRight" == o.position || "bottomCenter" == o.position ? n + "-wrapper-bottomCenter" : "topLeft" == o.position || "topRight" == o.position || "topCenter" == o.position ? n + "-wrapper-topCenter" : n + "-wrapper-center" : n + "-wrapper-" + t,
                l.wrapper = document.querySelector("." + n + "-wrapper." + t),
                l.wrapper || (l.wrapper = document.createElement("div"),
                l.wrapper.classList.add(n + "-wrapper"),
                l.wrapper.classList.add(t),
                document.body.appendChild(l.wrapper)),
                "topLeft" == o.position || "topCenter" == o.position || "topRight" == o.position ? l.wrapper.insertBefore(l.toastCapsule, l.wrapper.firstChild) : l.wrapper.appendChild(l.toastCapsule)
            }
            isNaN(o.zindex) ? console.warn("[" + n + "] Invalid zIndex.") : l.wrapper.style.zIndex = o.zindex
        }(),
        function() {
            o.overlay && (null !== document.querySelector("." + n + "-overlay.fadeIn") ? (l.overlay = document.querySelector("." + n + "-overlay"),
            l.overlay.setAttribute("data-iziToast-ref", l.overlay.getAttribute("data-iziToast-ref") + "," + o.ref),
            isNaN(o.zindex) || null === o.zindex || (l.overlay.style.zIndex = o.zindex - 1)) : (l.overlay.classList.add(n + "-overlay"),
            l.overlay.classList.add("fadeIn"),
            l.overlay.style.background = o.overlayColor,
            l.overlay.setAttribute("data-iziToast-ref", o.ref),
            isNaN(o.zindex) || null === o.zindex || (l.overlay.style.zIndex = o.zindex - 1),
            document.querySelector("body").appendChild(l.overlay)),
            o.overlayClose ? (l.overlay.removeEventListener("click", {}),
            l.overlay.addEventListener("click", function(t) {
                i.hide(o, l.toast, "overlay")
            })) : l.overlay.removeEventListener("click", {}))
        }(),
        function() {
            if (o.animateInside) {
                l.toast.classList.add(n + "-animateInside");
                var t = [200, 100, 300];
                "bounceInLeft" != o.transitionIn && "bounceInRight" != o.transitionIn || (t = [400, 200, 400]),
                o.title.length > 0 && setTimeout(function() {
                    l.strong.classList.add("slideIn")
                }, t[0]),
                o.message.length > 0 && setTimeout(function() {
                    l.p.classList.add("slideIn")
                }, t[1]),
                (o.icon || o.iconUrl) && setTimeout(function() {
                    l.icon.classList.add("revealIn")
                }, t[2]);
                var e = 150;
                o.buttons.length > 0 && l.buttons && setTimeout(function() {
                    f(l.buttons.childNodes, function(t, n) {
                        setTimeout(function() {
                            t.classList.add("revealIn")
                        }, e),
                        e += 150
                    })
                }, o.inputs.length > 0 ? 150 : 0),
                o.inputs.length > 0 && l.inputs && (e = 150,
                f(l.inputs.childNodes, function(t, n) {
                    setTimeout(function() {
                        t.classList.add("revealIn")
                    }, e),
                    e += 150
                }))
            }
        }(),
        o.onOpening.apply(null, [o, l.toast]);
        try {
            var w = new CustomEvent(n + "-opening",{
                detail: o,
                bubbles: !0,
                cancelable: !0
            });
            document.dispatchEvent(w)
        } catch (t) {
            console.warn(t)
        }
        setTimeout(function() {
            l.toast.classList.remove(n + "-opening"),
            l.toast.classList.add(n + "-opened");
            try {
                var t = new CustomEvent(n + "-opened",{
                    detail: o,
                    bubbles: !0,
                    cancelable: !0
                });
                document.dispatchEvent(t)
            } catch (t) {
                console.warn(t)
            }
            o.onOpened.apply(null, [o, l.toast])
        }, 1e3),
        o.drag && (a ? (l.toast.addEventListener("touchstart", function(t) {
            b.startMoving(this, i, o, t)
        }, !1),
        l.toast.addEventListener("touchend", function(t) {
            b.stopMoving(this, t)
        }, !1)) : (l.toast.addEventListener("mousedown", function(t) {
            t.preventDefault(),
            b.startMoving(this, i, o, t)
        }, !1),
        l.toast.addEventListener("mouseup", function(t) {
            t.preventDefault(),
            b.stopMoving(this, t)
        }, !1))),
        o.closeOnEscape && document.addEventListener("keyup", function(t) {
            t = t || window.event,
            27 == t.keyCode && i.hide(o, l.toast, "esc")
        }),
        o.closeOnClick && l.toast.addEventListener("click", function(t) {
            i.hide(o, l.toast, "toast")
        }),
        i.toast = l.toast
    }
    ,
    e
}),
/*! toggles-switches.js */
/* Toggles & Switches by Digital Surgeons under MIT License https://github.com/digitalsurgeons/toggles-switches */
!function() {
    "use strict";
    function t(t) {
        this.type = t.type,
        this.element = t.element,
        this.target = t.target,
        this.event = t.event || "click",
        this.onEvent = t.onEvent || !1,
        this.offEvent = t.offEvent || !1,
        this.className = t.class || "active",
        this.add = t.add || "active",
        this.remove = t.remove || "inactive",
        this.self = t.self || !1,
        this.stopPropagation = t.stopPropagation || !1,
        this.events = {},
        this.target = this.target ? document.querySelectorAll(this.target) : [this.element],
        this.element.setAttribute("data-toggle-switch", "switch"),
        n.apply(this),
        this.bindEventListeners()
    }
    function e(t) {
        this.type = t.type,
        this.element = t.element,
        this.target = t.target,
        this.className = t.class || "active",
        this.add = t.add || "active",
        this.remove = t.remove || "inactive",
        this.event = t.event || "click",
        this.self = t.self || !1,
        this.stopPropagation = t.stopPropagation || !1,
        this.events = {},
        this.target = this.target ? document.querySelectorAll(this.target) : [this.element],
        this.element.setAttribute("data-toggle-switch", "toggle"),
        n.apply(this),
        this.bindEventListeners()
    }
    function n() {
        this.events = {
            toggled: document.createEvent("Event"),
            added: document.createEvent("Event"),
            removed: document.createEvent("Event"),
            replaced: document.createEvent("Event")
        },
        this.events.toggled.initEvent("ToggleSwitch.toggled", !0, !0),
        this.events.added.initEvent("ToggleSwitch.added", !0, !0),
        this.events.removed.initEvent("ToggleSwitch.removed", !0, !0),
        this.events.replaced.initEvent("ToggleSwitch.replaced", !0, !0)
    }
    function r(t) {
        if (!t || "string" != typeof t || !this.element)
            return !1;
        var e = this.events[t];
        return !!e && void this.element.dispatchEvent(e)
    }
    function i(t) {
        this.element.addEventListener(t, function(t) {
            t.preventDefault(),
            this.stopPropagation && t.stopPropagation(),
            this.fire()
        }
        .bind(this))
    }
    function o() {
        [].forEach.call(this.target, function(t) {
            return !t.classList.contains(this.className) && (t.classList.add(this.className),
            void r.apply(this, ["added"]))
        }
        .bind(this)),
        this.self && this.element.classList.add(this.className)
    }
    function a() {
        [].forEach.call(this.target, function(t) {
            return !!t.classList.contains(this.className) && (t.classList.remove(this.className),
            void r.apply(this, ["removed"]))
        }
        .bind(this)),
        this.self && this.element.classList.remove(this.className)
    }
    function s() {
        [].forEach.call(this.target, function(t) {
            t.classList.toggle(this.className),
            r.apply(this, ["toggled"])
        }
        .bind(this)),
        this.self && this.element.classList.toggle(this.className)
    }
    function l(t) {
        var e = ":not([data-toggle-switch])"
          , n = t.querySelectorAll("[data-toggle]" + e)
          , r = t.querySelectorAll("[data-toggle-replace]" + e)
          , i = t.querySelectorAll("[data-switch-on]" + e)
          , o = t.querySelectorAll("[data-switch-off]" + e)
          , a = t.querySelectorAll("[data-switch-replace]" + e);
        [].forEach.call(n, u.toggles),
        [].forEach.call(r, u.togglesReplace),
        [].forEach.call(i, u.switchesOn),
        [].forEach.call(o, u.switchesOff),
        [].forEach.call(a, u.switchesReplace)
    }
    t.prototype.bindEventListeners = function() {
        ("on" === this.type && this.onEvent ? this.onEvent.split(",") : "off" === this.type && this.offEvent ? this.offEvent.split(",") : this.event.split(",")).forEach(function(t) {
            i.apply(this, [t])
        }
        .bind(this))
    }
    ,
    t.prototype.replaceClass = function() {
        [].forEach.call(this.target, function(t) {
            t.classList.remove(this.remove),
            t.classList.add(this.add),
            r.apply(this, ["replaced"])
        }
        .bind(this))
    }
    ,
    e.prototype.bindEventListeners = function() {
        this.event.split(",").forEach(function(t) {
            i.apply(this, [t])
        }
        .bind(this))
    }
    ,
    e.prototype.replaceClass = function() {
        [].forEach.call(this.target, function(t) {
            !t.classList.contains(this.remove) && !t.classList.contains(this.add) || t.classList.contains(this.remove) ? (t.classList.remove(this.remove),
            t.classList.add(this.add)) : t.classList.contains(this.add) && (t.classList.add(this.remove),
            t.classList.remove(this.add)),
            r.apply(this, ["replaced"])
        }
        .bind(this))
    }
    ,
    t.prototype.fire = function() {
        "replace" === this.type ? this.replaceClass() : "on" === this.type ? o.apply(this) : "off" === this.type && a.apply(this)
    }
    ,
    e.prototype.fire = function() {
        "replace" === this.type ? this.replaceClass() : s.apply(this)
    }
    ;
    var u = {
        toggles: function(t) {
            var n = {
                element: t,
                target: t.getAttribute("data-toggle")
            };
            t.hasAttribute("data-toggle-class") && (n.class = t.getAttribute("data-toggle-class")),
            t.hasAttribute("data-toggle-event") && (n.event = t.getAttribute("data-toggle-event")),
            t.hasAttribute("data-toggle-self") && (n.self = !0),
            t.hasAttribute("data-toggle-stop-propagation") && (n.stopPropagation = !0),
            new e(n)
        },
        togglesReplace: function(t) {
            var n = {
                type: "replace",
                element: t,
                target: t.getAttribute("data-toggle-replace"),
                add: t.getAttribute("data-toggle-add"),
                remove: t.getAttribute("data-toggle-remove")
            };
            t.hasAttribute("data-toggle-stop-propagation") && (n.stopPropagation = !0),
            t.hasAttribute("data-toggle-event") && (n.event = t.getAttribute("data-toggle-event")),
            new e(n)
        },
        switchesOn: function(e) {
            var n = {
                type: "on",
                element: e,
                target: e.getAttribute("data-switch-on")
            };
            e.hasAttribute("data-switch-class") && (n.class = e.getAttribute("data-switch-class")),
            e.hasAttribute("data-switch-event") && (n.event = e.getAttribute("data-switch-event")),
            e.hasAttribute("data-switch-on-event") && (n.onEvent = e.getAttribute("data-switch-on-event")),
            e.hasAttribute("data-switch-self") && (n.self = !0),
            e.hasAttribute("data-switch-stop-propagation") && (n.stopPropagation = !0),
            new t(n)
        },
        switchesOff: function(e) {
            var n = {
                type: "off",
                element: e,
                target: e.getAttribute("data-switch-off")
            };
            e.hasAttribute("data-switch-class") && (n.class = e.getAttribute("data-switch-class")),
            e.hasAttribute("data-switch-event") && (n.event = e.getAttribute("data-switch-event")),
            e.hasAttribute("data-switch-off-event") && (n.offEvent = e.getAttribute("data-switch-off-event")),
            e.hasAttribute("data-switch-self") && (n.self = !0),
            e.hasAttribute("data-switch-stop-propagation") && (n.stopPropagation = !0),
            new t(n)
        },
        switchesReplace: function(e) {
            var n = {
                type: "replace",
                element: e,
                target: e.getAttribute("data-switch-replace"),
                add: e.getAttribute("data-switch-add"),
                remove: e.getAttribute("data-switch-remove")
            };
            e.hasAttribute("data-switch-stop-propagation") && (n.stopPropagation = !0),
            e.hasAttribute("data-switch-event") && (n.event = e.getAttribute("data-switch-event")),
            new t(n)
        }
    };
    void 0 != window.MutationObserver && [].forEach.call(document.querySelectorAll("[data-toggle-switch-watch]"), function(t) {
        new MutationObserver(function(t) {
            l(t[0].target)
        }
        ).observe(t, {
            childList: !0
        })
    }),
    l(document)
}(),
/*! readmore.min.js */
/*!
 * @preserve
 *
 * Readmore.js jQuery plugin
 * Author: @jed_foster
 * Project home: http://jedfoster.github.io/Readmore.js
 * Licensed under the MIT license
 *
 * Debounce function from http://davidwalsh.name/javascript-debounce-function
 */
!function(t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    "use strict";
    function e(t, e, n) {
        var r;
        return function() {
            var i = this
              , o = arguments
              , a = function() {
                r = null,
                n || t.apply(i, o)
            }
              , s = n && !r;
            clearTimeout(r),
            r = setTimeout(a, e),
            s && t.apply(i, o)
        }
    }
    function n(t) {
        var e = ++u;
        return String(null == t ? "rmjs-" : t) + e
    }
    function r(t) {
        var e = t.clone().css({
            height: "auto",
            width: t.width(),
            maxHeight: "none",
            overflow: "hidden"
        }).insertAfter(t)
          , n = e.outerHeight()
          , r = parseInt(e.css({
            maxHeight: ""
        }).css("max-height").replace(/[^-\d\.]/g, ""), 10)
          , i = t.data("defaultHeight");
        e.remove();
        var o = r || t.data("collapsedHeight") || i;
        t.data({
            expandedHeight: n,
            maxHeight: r,
            collapsedHeight: o
        }).css({
            maxHeight: "none"
        })
    }
    function i(t) {
        if (!l[t.selector]) {
            var e = " ";
            t.embedCSS && "" !== t.blockCSS && (e += t.selector + " + [data-readmore-toggle], " + t.selector + "[data-readmore]{" + t.blockCSS + "}"),
            e += t.selector + "[data-readmore]{transition: height " + t.speed + "ms;overflow: hidden;}",
            function(t, e) {
                var n = t.createElement("style");
                n.type = "text/css",
                n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(t.createTextNode(e)),
                t.getElementsByTagName("head")[0].appendChild(n)
            }(document, e),
            l[t.selector] = !0
        }
    }
    function o(e, n) {
        this.element = e,
        this.options = t.extend({}, s, n),
        i(this.options),
        this._defaults = s,
        this._name = a,
        this.init(),
        window.addEventListener ? (window.addEventListener("load", c),
        window.addEventListener("resize", c)) : (window.attachEvent("load", c),
        window.attachEvent("resize", c))
    }
    var a = "readmore"
      , s = {
        speed: 100,
        collapsedHeight: 200,
        heightMargin: 16,
        moreLink: '<a href="#">Read More</a>',
        lessLink: '<a href="#">Close</a>',
        embedCSS: !0,
        blockCSS: "display: block; width: 100%;",
        startOpen: !1,
        blockProcessed: function() {},
        beforeToggle: function() {},
        afterToggle: function() {}
    }
      , l = {}
      , u = 0
      , c = e(function() {
        t("[data-readmore]").each(function() {
            var e = t(this)
              , n = "true" === e.attr("aria-expanded");
            r(e),
            e.css({
                height: e.data(n ? "expandedHeight" : "collapsedHeight")
            })
        })
    }, 100);
    o.prototype = {
        init: function() {
            var e = t(this.element);
            e.data({
                defaultHeight: this.options.collapsedHeight,
                heightMargin: this.options.heightMargin
            }),
            r(e);
            var i = e.data("collapsedHeight")
              , o = e.data("heightMargin");
            if (e.outerHeight(!0) <= i + o)
                return this.options.blockProcessed && "function" == typeof this.options.blockProcessed && this.options.blockProcessed(e, !1),
                !0;
            var a = e.attr("id") || n()
              , s = this.options.startOpen ? this.options.lessLink : this.options.moreLink;
            e.attr({
                "data-readmore": "",
                "aria-expanded": this.options.startOpen,
                id: a
            }),
            e.after(t(s).on("click", function(t) {
                return function(n) {
                    t.toggle(this, e[0], n)
                }
            }(this)).attr({
                "data-readmore-toggle": a,
                "aria-controls": a
            })),
            this.options.startOpen || e.css({
                height: i
            }),
            this.options.blockProcessed && "function" == typeof this.options.blockProcessed && this.options.blockProcessed(e, !0)
        },
        toggle: function(e, n, r) {
            r && r.preventDefault(),
            e || (e = t('[aria-controls="' + this.element.id + '"]')[0]),
            n || (n = this.element);
            var i = t(n)
              , o = ""
              , a = ""
              , s = !1
              , l = i.data("collapsedHeight");
            i.height() <= l ? (o = i.data("expandedHeight") + "px",
            a = "lessLink",
            s = !0) : (o = l,
            a = "moreLink"),
            this.options.beforeToggle && "function" == typeof this.options.beforeToggle && this.options.beforeToggle(e, i, !s),
            i.css({
                height: o
            }),
            i.on("transitionend", function(n) {
                return function() {
                    n.options.afterToggle && "function" == typeof n.options.afterToggle && n.options.afterToggle(e, i, s),
                    t(this).attr({
                        "aria-expanded": s
                    }).off("transitionend")
                }
            }(this)),
            t(e).replaceWith(t(this.options[a]).on("click", function(t) {
                return function(e) {
                    t.toggle(this, n, e)
                }
            }(this)).attr({
                "data-readmore-toggle": i.attr("id"),
                "aria-controls": i.attr("id")
            }))
        },
        destroy: function() {
            t(this.element).each(function() {
                var e = t(this);
                e.attr({
                    "data-readmore": null,
                    "aria-expanded": null
                }).css({
                    maxHeight: "",
                    height: ""
                }).next("[data-readmore-toggle]").remove(),
                e.removeData()
            })
        }
    },
    t.fn.readmore = function(e) {
        var n = arguments
          , r = this.selector;
        return e = e || {},
        "object" == typeof e ? this.each(function() {
            if (t.data(this, "plugin_" + a)) {
                var n = t.data(this, "plugin_" + a);
                n.destroy.apply(n)
            }
            e.selector = r,
            t.data(this, "plugin_" + a, new o(this,e))
        }) : "string" == typeof e && "_" !== e[0] && "init" !== e ? this.each(function() {
            var r = t.data(this, "plugin_" + a);
            r instanceof o && "function" == typeof r[e] && r[e].apply(r, Array.prototype.slice.call(n, 1))
        }) : void 0
    }
}),
/*! favico.min.js */
/* Favico.js 0.3.10 by Miroslav Magda, http://blog.ejci.net under MIT license */
!function() {
    var t = function(t) {
        "use strict";
        function e(t) {
            if (t.paused || t.ended || g)
                return !1;
            try {
                c.clearRect(0, 0, l, s),
                c.drawImage(t, 0, 0, l, s)
            } catch (t) {}
            b = setTimeout(function() {
                e(t)
            }, I.duration),
            L.setIcon(u)
        }
        function n(t) {
            var e = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            t = t.replace(e, function(t, e, n, r) {
                return e + e + n + n + r + r
            });
            var n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
            return !!n && {
                r: parseInt(n[1], 16),
                g: parseInt(n[2], 16),
                b: parseInt(n[3], 16)
            }
        }
        function r(t, e) {
            var n, r = {};
            for (n in t)
                r[n] = t[n];
            for (n in e)
                r[n] = e[n];
            return r
        }
        function i() {
            return w.hidden || w.msHidden || w.webkitHidden || w.mozHidden
        }
        t = t ? t : {};
        var o, a, s, l, u, c, d, p, f, h, m, g, v, y, b, w, x = {
            bgColor: "#d00",
            textColor: "#fff",
            fontFamily: "sans-serif",
            fontStyle: "bold",
            type: "circle",
            position: "down",
            animation: "slide",
            elementId: !1,
            dataUrl: !1,
            win: window
        };
        v = {},
        v.ff = "undefined" != typeof InstallTrigger,
        v.chrome = !!window.chrome,
        v.opera = !!window.opera || navigator.userAgent.indexOf("Opera") >= 0,
        v.ie = /*@cc_on!@*/
        !1,
        v.safari = Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor") > 0,
        v.supported = v.chrome || v.ff || v.opera;
        var C = [];
        m = function() {}
        ,
        p = g = !1;
        var k = function() {
            o = r(x, t),
            o.bgColor = n(o.bgColor),
            o.textColor = n(o.textColor),
            o.position = o.position.toLowerCase(),
            o.animation = I.types["" + o.animation] ? o.animation : x.animation,
            w = o.win.document;
            var e = o.position.indexOf("up") > -1
              , i = o.position.indexOf("left") > -1;
            if (e || i)
                for (var p = 0; p < I.types["" + o.animation].length; p++) {
                    var f = I.types["" + o.animation][p];
                    e && (f.y = f.y < .6 ? f.y - .4 : f.y - 2 * f.y + (1 - f.w)),
                    i && (f.x = f.x < .6 ? f.x - .4 : f.x - 2 * f.x + (1 - f.h)),
                    I.types["" + o.animation][p] = f
                }
            o.type = S["" + o.type] ? o.type : x.type,
            a = L.getIcon(),
            u = document.createElement("canvas"),
            d = document.createElement("img"),
            a.hasAttribute("href") ? (d.setAttribute("crossOrigin", "anonymous"),
            d.onload = function() {
                s = d.height > 0 ? d.height : 32,
                l = d.width > 0 ? d.width : 32,
                u.height = s,
                u.width = l,
                c = u.getContext("2d"),
                _.ready()
            }
            ,
            d.setAttribute("src", a.getAttribute("href"))) : (d.onload = function() {
                s = 32,
                l = 32,
                d.height = s,
                d.width = l,
                u.height = s,
                u.width = l,
                c = u.getContext("2d"),
                _.ready()
            }
            ,
            d.setAttribute("src", ""))
        }
          , _ = {};
        _.ready = function() {
            p = !0,
            _.reset(),
            m()
        }
        ,
        _.reset = function() {
            p && (C = [],
            f = !1,
            h = !1,
            c.clearRect(0, 0, l, s),
            c.drawImage(d, 0, 0, l, s),
            L.setIcon(u),
            window.clearTimeout(y),
            window.clearTimeout(b))
        }
        ,
        _.start = function() {
            if (p && !h) {
                var t = function() {
                    f = C[0],
                    h = !1,
                    C.length > 0 && (C.shift(),
                    _.start())
                };
                if (C.length > 0) {
                    h = !0;
                    var e = function() {
                        ["type", "animation", "bgColor", "textColor", "fontFamily", "fontStyle"].forEach(function(t) {
                            t in C[0].options && (o[t] = C[0].options[t])
                        }),
                        I.run(C[0].options, function() {
                            t()
                        }, !1)
                    };
                    f ? I.run(f.options, function() {
                        e()
                    }, !0) : e()
                }
            }
        }
        ;
        var S = {}
          , T = function(t) {
            return t.n = "number" == typeof t.n ? Math.abs(0 | t.n) : t.n,
            t.x = l * t.x,
            t.y = s * t.y,
            t.w = l * t.w,
            t.h = s * t.h,
            t.len = ("" + t.n).length,
            t
        };
        S.circle = function(t) {
            t = T(t);
            var e = !1;
            2 === t.len ? (t.x = t.x - .4 * t.w,
            t.w = 1.4 * t.w,
            e = !0) : t.len >= 3 && (t.x = t.x - .65 * t.w,
            t.w = 1.65 * t.w,
            e = !0),
            c.clearRect(0, 0, l, s),
            c.drawImage(d, 0, 0, l, s),
            c.beginPath(),
            c.font = o.fontStyle + " " + Math.floor(t.h * (t.n > 99 ? .85 : 1)) + "px " + o.fontFamily,
            c.textAlign = "center",
            e ? (c.moveTo(t.x + t.w / 2, t.y),
            c.lineTo(t.x + t.w - t.h / 2, t.y),
            c.quadraticCurveTo(t.x + t.w, t.y, t.x + t.w, t.y + t.h / 2),
            c.lineTo(t.x + t.w, t.y + t.h - t.h / 2),
            c.quadraticCurveTo(t.x + t.w, t.y + t.h, t.x + t.w - t.h / 2, t.y + t.h),
            c.lineTo(t.x + t.h / 2, t.y + t.h),
            c.quadraticCurveTo(t.x, t.y + t.h, t.x, t.y + t.h - t.h / 2),
            c.lineTo(t.x, t.y + t.h / 2),
            c.quadraticCurveTo(t.x, t.y, t.x + t.h / 2, t.y)) : c.arc(t.x + t.w / 2, t.y + t.h / 2, t.h / 2, 0, 2 * Math.PI),
            c.fillStyle = "rgba(" + o.bgColor.r + "," + o.bgColor.g + "," + o.bgColor.b + "," + t.o + ")",
            c.fill(),
            c.closePath(),
            c.beginPath(),
            c.stroke(),
            c.fillStyle = "rgba(" + o.textColor.r + "," + o.textColor.g + "," + o.textColor.b + "," + t.o + ")",
            "number" == typeof t.n && t.n > 999 ? c.fillText((t.n > 9999 ? 9 : Math.floor(t.n / 1e3)) + "k+", Math.floor(t.x + t.w / 2), Math.floor(t.y + t.h - .2 * t.h)) : c.fillText(t.n, Math.floor(t.x + t.w / 2), Math.floor(t.y + t.h - .15 * t.h)),
            c.closePath()
        }
        ,
        S.rectangle = function(t) {
            t = T(t);
            var e = !1;
            2 === t.len ? (t.x = t.x - .4 * t.w,
            t.w = 1.4 * t.w,
            e = !0) : t.len >= 3 && (t.x = t.x - .65 * t.w,
            t.w = 1.65 * t.w,
            e = !0),
            c.clearRect(0, 0, l, s),
            c.drawImage(d, 0, 0, l, s),
            c.beginPath(),
            c.font = o.fontStyle + " " + Math.floor(t.h * (t.n > 99 ? .9 : 1)) + "px " + o.fontFamily,
            c.textAlign = "center",
            c.fillStyle = "rgba(" + o.bgColor.r + "," + o.bgColor.g + "," + o.bgColor.b + "," + t.o + ")",
            c.fillRect(t.x, t.y, t.w, t.h),
            c.fillStyle = "rgba(" + o.textColor.r + "," + o.textColor.g + "," + o.textColor.b + "," + t.o + ")",
            "number" == typeof t.n && t.n > 999 ? c.fillText((t.n > 9999 ? 9 : Math.floor(t.n / 1e3)) + "k+", Math.floor(t.x + t.w / 2), Math.floor(t.y + t.h - .2 * t.h)) : c.fillText(t.n, Math.floor(t.x + t.w / 2), Math.floor(t.y + t.h - .15 * t.h)),
            c.closePath()
        }
        ;
        var E = function(t, e) {
            e = ("string" == typeof e ? {
                animation: e
            } : e) || {},
            m = function() {
                try {
                    if ("number" == typeof t ? t > 0 : "" !== t) {
                        var r = {
                            type: "badge",
                            options: {
                                n: t
                            }
                        };
                        if ("animation"in e && I.types["" + e.animation] && (r.options.animation = "" + e.animation),
                        "type"in e && S["" + e.type] && (r.options.type = "" + e.type),
                        ["bgColor", "textColor"].forEach(function(t) {
                            t in e && (r.options[t] = n(e[t]))
                        }),
                        ["fontStyle", "fontFamily"].forEach(function(t) {
                            t in e && (r.options[t] = e[t])
                        }),
                        C.push(r),
                        C.length > 100)
                            throw new Error("Too many badges requests in queue.");
                        _.start()
                    } else
                        _.reset()
                } catch (t) {
                    throw new Error("Error setting badge. Message: " + t.message)
                }
            }
            ,
            p && m()
        }
          , A = function(t) {
            m = function() {
                try {
                    var e = t.width
                      , n = t.height
                      , r = document.createElement("img")
                      , i = n / s > e / l ? e / l : n / s;
                    r.setAttribute("crossOrigin", "anonymous"),
                    r.onload = function() {
                        c.clearRect(0, 0, l, s),
                        c.drawImage(r, 0, 0, l, s),
                        L.setIcon(u)
                    }
                    ,
                    r.setAttribute("src", t.getAttribute("src")),
                    r.height = n / i,
                    r.width = e / i
                } catch (t) {
                    throw new Error("Error setting image. Message: " + t.message)
                }
            }
            ,
            p && m()
        }
          , M = function(t) {
            m = function() {
                try {
                    if ("stop" === t)
                        return g = !0,
                        _.reset(),
                        void (g = !1);
                    t.addEventListener("play", function() {
                        e(this)
                    }, !1)
                } catch (t) {
                    throw new Error("Error setting video. Message: " + t.message)
                }
            }
            ,
            p && m()
        }
          , O = function(t) {
            if (window.URL && window.URL.createObjectURL || (window.URL = window.URL || {},
            window.URL.createObjectURL = function(t) {
                return t
            }
            ),
            v.supported) {
                var n = !1;
                navigator.getUserMedia = navigator.getUserMedia || navigator.oGetUserMedia || navigator.msGetUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia,
                m = function() {
                    try {
                        if ("stop" === t)
                            return g = !0,
                            _.reset(),
                            void (g = !1);
                        n = document.createElement("video"),
                        n.width = l,
                        n.height = s,
                        navigator.getUserMedia({
                            video: !0,
                            audio: !1
                        }, function(t) {
                            n.src = URL.createObjectURL(t),
                            n.play(),
                            e(n)
                        }, function() {})
                    } catch (t) {
                        throw new Error("Error setting webcam. Message: " + t.message)
                    }
                }
                ,
                p && m()
            }
        }
          , L = {};
        L.getIcon = function() {
            var t = !1
              , e = function() {
                for (var t = w.getElementsByTagName("head")[0].getElementsByTagName("link"), e = t.length, n = e - 1; n >= 0; n--)
                    if (/(^|\s)icon(\s|$)/i.test(t[n].getAttribute("rel")))
                        return t[n];
                return !1
            };
            return o.element ? t = o.element : o.elementId ? (t = w.getElementById(o.elementId),
            t.setAttribute("href", t.getAttribute("src"))) : (t = e(),
            t === !1 && (t = w.createElement("link"),
            t.setAttribute("rel", "icon"),
            w.getElementsByTagName("head")[0].appendChild(t))),
            t.setAttribute("type", "image/png"),
            t
        }
        ,
        L.setIcon = function(t) {
            var e = t.toDataURL("image/png");
            if (o.dataUrl && o.dataUrl(e),
            o.element)
                o.element.setAttribute("href", e),
                o.element.setAttribute("src", e);
            else if (o.elementId) {
                var n = w.getElementById(o.elementId);
                n.setAttribute("href", e),
                n.setAttribute("src", e)
            } else if (v.ff || v.opera) {
                var r = a;
                a = w.createElement("link"),
                v.opera && a.setAttribute("rel", "icon"),
                a.setAttribute("rel", "icon"),
                a.setAttribute("type", "image/png"),
                w.getElementsByTagName("head")[0].appendChild(a),
                a.setAttribute("href", e),
                r.parentNode && r.parentNode.removeChild(r)
            } else
                a.setAttribute("href", e)
        }
        ;
        var I = {};
        return I.duration = 40,
        I.types = {},
        I.types.fade = [{
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: 0
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .1
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .2
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .3
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .4
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .5
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .6
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .7
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .8
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: .9
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: 1
        }],
        I.types.none = [{
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: 1
        }],
        I.types.pop = [{
            x: 1,
            y: 1,
            w: 0,
            h: 0,
            o: 1
        }, {
            x: .9,
            y: .9,
            w: .1,
            h: .1,
            o: 1
        }, {
            x: .8,
            y: .8,
            w: .2,
            h: .2,
            o: 1
        }, {
            x: .7,
            y: .7,
            w: .3,
            h: .3,
            o: 1
        }, {
            x: .6,
            y: .6,
            w: .4,
            h: .4,
            o: 1
        }, {
            x: .5,
            y: .5,
            w: .5,
            h: .5,
            o: 1
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: 1
        }],
        I.types.popFade = [{
            x: .75,
            y: .75,
            w: 0,
            h: 0,
            o: 0
        }, {
            x: .65,
            y: .65,
            w: .1,
            h: .1,
            o: .2
        }, {
            x: .6,
            y: .6,
            w: .2,
            h: .2,
            o: .4
        }, {
            x: .55,
            y: .55,
            w: .3,
            h: .3,
            o: .6
        }, {
            x: .5,
            y: .5,
            w: .4,
            h: .4,
            o: .8
        }, {
            x: .45,
            y: .45,
            w: .5,
            h: .5,
            o: .9
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: 1
        }],
        I.types.slide = [{
            x: .4,
            y: 1,
            w: .6,
            h: .6,
            o: 1
        }, {
            x: .4,
            y: .9,
            w: .6,
            h: .6,
            o: 1
        }, {
            x: .4,
            y: .9,
            w: .6,
            h: .6,
            o: 1
        }, {
            x: .4,
            y: .8,
            w: .6,
            h: .6,
            o: 1
        }, {
            x: .4,
            y: .7,
            w: .6,
            h: .6,
            o: 1
        }, {
            x: .4,
            y: .6,
            w: .6,
            h: .6,
            o: 1
        }, {
            x: .4,
            y: .5,
            w: .6,
            h: .6,
            o: 1
        }, {
            x: .4,
            y: .4,
            w: .6,
            h: .6,
            o: 1
        }],
        I.run = function(t, e, n, a) {
            var s = I.types[i() ? "none" : o.animation];
            return a = n === !0 ? "undefined" != typeof a ? a : s.length - 1 : "undefined" != typeof a ? a : 0,
            e = e ? e : function() {}
            ,
            a < s.length && a >= 0 ? (S[o.type](r(t, s[a])),
            y = setTimeout(function() {
                n ? a -= 1 : a += 1,
                I.run(t, e, n, a)
            }, I.duration),
            void L.setIcon(u)) : void e()
        }
        ,
        k(),
        {
            badge: E,
            video: M,
            image: A,
            webcam: O,
            reset: _.reset,
            browser: {
                supported: v.supported
            }
        }
    };
    "undefined" != typeof define && define.amd ? define([], function() {
        return t
    }) : "undefined" != typeof module && module.exports ? module.exports = t : this.Favico = t
}(),
function(t, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.NProgress = e()
}(this, function() {
    function t(t, e, n) {
        return t < e ? e : t > n ? n : t
    }
    function e(t) {
        return 100 * (-1 + t)
    }
    function n(t, n, r) {
        var i;
        return i = "translate3d" === u.positionUsing ? {
            transform: "translate3d(" + e(t) + "%,0,0)"
        } : "translate" === u.positionUsing ? {
            transform: "translate(" + e(t) + "%,0)"
        } : {
            "margin-left": e(t) + "%"
        },
        i.transition = "all " + n + "ms " + r,
        i
    }
    function r(t, e) {
        var n = "string" == typeof t ? t : a(t);
        return n.indexOf(" " + e + " ") >= 0
    }
    function i(t, e) {
        var n = a(t)
          , i = n + e;
        r(n, e) || (t.className = i.substring(1))
    }
    function o(t, e) {
        var n, i = a(t);
        r(t, e) && (n = i.replace(" " + e + " ", " "),
        t.className = n.substring(1, n.length - 1))
    }
    function a(t) {
        return (" " + (t && t.className || "") + " ").replace(/\s+/gi, " ")
    }
    function s(t) {
        t && t.parentNode && t.parentNode.removeChild(t)
    }
    var l = {};
    l.version = "0.2.0";
    var u = l.settings = {
        minimum: .08,
        easing: "linear",
        positionUsing: "",
        speed: 200,
        trickle: !0,
        trickleSpeed: 200,
        showSpinner: !0,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: "body",
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    l.configure = function(t) {
        var e, n;
        for (e in t)
            n = t[e],
            void 0 !== n && t.hasOwnProperty(e) && (u[e] = n);
        return this
    }
    ,
    l.status = null,
    l.set = function(e) {
        var r = l.isStarted();
        e = t(e, u.minimum, 1),
        l.status = 1 === e ? null : e;
        var i = l.render(!r)
          , o = i.querySelector(u.barSelector)
          , a = u.speed
          , s = u.easing;
        return i.offsetWidth,
        c(function(t) {
            "" === u.positionUsing && (u.positionUsing = l.getPositioningCSS()),
            d(o, n(e, a, s)),
            1 === e ? (d(i, {
                transition: "none",
                opacity: 1
            }),
            i.offsetWidth,
            setTimeout(function() {
                d(i, {
                    transition: "all " + a + "ms linear",
                    opacity: 0
                }),
                setTimeout(function() {
                    l.remove(),
                    t()
                }, a)
            }, a)) : setTimeout(t, a)
        }),
        this
    }
    ,
    l.isStarted = function() {
        return "number" == typeof l.status
    }
    ,
    l.start = function() {
        l.status || l.set(0);
        var t = function() {
            setTimeout(function() {
                l.status && (l.trickle(),
                t())
            }, u.trickleSpeed)
        };
        return u.trickle && t(),
        this
    }
    ,
    l.done = function(t) {
        return t || l.status ? l.inc(.3 + .5 * Math.random()).set(1) : this
    }
    ,
    l.inc = function(e) {
        var n = l.status;
        return n ? n > 1 ? void 0 : ("number" != typeof e && (e = n >= 0 && n < .2 ? .1 : n >= .2 && n < .5 ? .04 : n >= .5 && n < .8 ? .02 : n >= .8 && n < .99 ? .005 : 0),
        n = t(n + e, 0, .994),
        l.set(n)) : l.start()
    }
    ,
    l.trickle = function() {
        return l.inc()
    }
    ,
    function() {
        var t = 0
          , e = 0;
        l.promise = function(n) {
            return n && "resolved" !== n.state() ? (0 === e && l.start(),
            t++,
            e++,
            n.always(function() {
                e--,
                0 === e ? (t = 0,
                l.done()) : l.set((t - e) / t)
            }),
            this) : this
        }
    }(),
    l.render = function(t) {
        if (l.isRendered())
            return document.getElementById("nprogress");
        i(document.documentElement, "nprogress-busy");
        var n = document.createElement("div");
        n.id = "nprogress",
        n.innerHTML = u.template;
        var r, o = n.querySelector(u.barSelector), a = t ? "-100" : e(l.status || 0), c = document.querySelector(u.parent);
        return d(o, {
            transition: "all 0 linear",
            transform: "translate3d(" + a + "%,0,0)"
        }),
        u.showSpinner || (r = n.querySelector(u.spinnerSelector),
        r && s(r)),
        c != document.body && i(c, "nprogress-custom-parent"),
        c.appendChild(n),
        n
    }
    ,
    l.remove = function() {
        o(document.documentElement, "nprogress-busy"),
        o(document.querySelector(u.parent), "nprogress-custom-parent");
        var t = document.getElementById("nprogress");
        t && s(t)
    }
    ,
    l.isRendered = function() {
        return !!document.getElementById("nprogress")
    }
    ,
    l.getPositioningCSS = function() {
        var t = document.body.style
          , e = "WebkitTransform"in t ? "Webkit" : "MozTransform"in t ? "Moz" : "msTransform"in t ? "ms" : "OTransform"in t ? "O" : "";
        return e + "Perspective"in t ? "translate3d" : e + "Transform"in t ? "translate" : "margin"
    }
    ;
    var c = function() {
        function t() {
            var n = e.shift();
            n && n(t)
        }
        var e = [];
        return function(n) {
            e.push(n),
            1 == e.length && t()
        }
    }()
      , d = function() {
        function t(t) {
            return t.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(t, e) {
                return e.toUpperCase()
            })
        }
        function e(t) {
            var e = document.body.style;
            if (t in e)
                return t;
            for (var n, r = i.length, o = t.charAt(0).toUpperCase() + t.slice(1); r--; )
                if (n = i[r] + o,
                n in e)
                    return n;
            return t
        }
        function n(n) {
            return n = t(n),
            o[n] || (o[n] = e(n))
        }
        function r(t, e, r) {
            e = n(e),
            t.style[e] = r
        }
        var i = ["Webkit", "O", "Moz", "ms"]
          , o = {};
        return function(t, e) {
            var n, i, o = arguments;
            if (2 == o.length)
                for (n in e)
                    i = e[n],
                    void 0 !== i && e.hasOwnProperty(n) && r(t, n, i);
            else
                r(t, o[1], o[2])
        }
    }();
    return l
}),
/*! outline.js */
/*! outline.js | https://github.com/lindsayevans/outline.js *
 *  based on http://www.paciellogroup.com/blog/2012/04/how-to-remove-css-outlines-in-an-accessible-manner !*/
function(t) {
    var e = t.createElement("STYLE")
      , n = "addEventListener"in t
      , r = function(e, r) {
        n ? t.addEventListener(e, r) : t.attachEvent("on" + e, r)
    }
      , i = function(t) {
        e.styleSheet ? e.styleSheet.cssText = t : e.innerHTML = t
    };
    t.getElementsByTagName("HEAD")[0].appendChild(e),
    r("mousedown", function() {
        i(":focus{outline:0}::-moz-focus-inner{border:0;}")
    }),
    r("keydown", function() {
        i("")
    })
}(document),
/*! loadJS.js */
/*! loadJS: load a JS file asynchronously. [c]2014 @scottjehl, Filament Group, Inc. (Based on http://goo.gl/REQGQ by Paul Irish). Licensed MIT */
function(t) {
    var e = function(e, n) {
        "use strict";
        var r = t.document.getElementsByTagName("script")[0]
          , i = t.document.createElement("script");
        return i.src = e,
        i.async = !0,
        r.parentNode.insertBefore(i, r),
        n && "function" == typeof n && (i.onload = n),
        i
    };
    "undefined" != typeof module ? module.exports = e : t.loadJS = e
}("undefined" != typeof global ? global : this),
function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof module && module.exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    "use strict";
    function e(e) {
        return !e.nodeName || -1 !== t.inArray(e.nodeName.toLowerCase(), ["iframe", "#document", "html", "body"])
    }
    function n(e) {
        return t.isFunction(e) || t.isPlainObject(e) ? e : {
            top: e,
            left: e
        }
    }
    var r = t.scrollTo = function(e, n, r) {
        return t(window).scrollTo(e, n, r)
    }
    ;
    return r.defaults = {
        axis: "xy",
        duration: 0,
        limit: !0
    },
    t.fn.scrollTo = function(i, o, a) {
        "object" == typeof o && (a = o,
        o = 0),
        "function" == typeof a && (a = {
            onAfter: a
        }),
        "max" === i && (i = 9e9),
        a = t.extend({}, r.defaults, a),
        o = o || a.duration;
        var s = a.queue && 1 < a.axis.length;
        return s && (o /= 2),
        a.offset = n(a.offset),
        a.over = n(a.over),
        this.each(function() {
            function l(e) {
                var n = t.extend({}, a, {
                    queue: !0,
                    duration: o,
                    complete: e && function() {
                        e.call(d, f, a)
                    }
                });
                p.animate(h, n)
            }
            if (null !== i) {
                var u, c = e(this), d = c ? this.contentWindow || window : this, p = t(d), f = i, h = {};
                switch (typeof f) {
                case "number":
                case "string":
                    if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(f)) {
                        f = n(f);
                        break
                    }
                    f = c ? t(f) : t(f, d);
                case "object":
                    if (0 === f.length)
                        return;
                    (f.is || f.style) && (u = (f = t(f)).offset())
                }
                var m = t.isFunction(a.offset) && a.offset(d, f) || a.offset;
                t.each(a.axis.split(""), function(t, e) {
                    var n = "x" === e ? "Left" : "Top"
                      , i = n.toLowerCase()
                      , o = "scroll" + n
                      , g = p[o]()
                      , v = r.max(d, e);
                    u ? (h[o] = u[i] + (c ? 0 : g - p.offset()[i]),
                    a.margin && (h[o] -= parseInt(f.css("margin" + n), 10) || 0,
                    h[o] -= parseInt(f.css("border" + n + "Width"), 10) || 0),
                    h[o] += m[i] || 0,
                    a.over[i] && (h[o] += f["x" === e ? "width" : "height"]() * a.over[i])) : (n = f[i],
                    h[o] = n.slice && "%" === n.slice(-1) ? parseFloat(n) / 100 * v : n),
                    a.limit && /^\d+$/.test(h[o]) && (h[o] = 0 >= h[o] ? 0 : Math.min(h[o], v)),
                    !t && 1 < a.axis.length && (g === h[o] ? h = {} : s && (l(a.onAfterFirst),
                    h = {}))
                }),
                l(a.onAfter)
            }
        })
    }
    ,
    r.max = function(n, r) {
        var i = "x" === r ? "Width" : "Height"
          , o = "scroll" + i;
        if (!e(n))
            return n[o] - t(n)[i.toLowerCase()]();
        var i = "client" + i
          , a = n.ownerDocument || n.document
          , s = a.documentElement
          , a = a.body;
        return Math.max(s[o], a[o]) - Math.min(s[i], a[i])
    }
    ,
    t.Tween.propHooks.scrollLeft = t.Tween.propHooks.scrollTop = {
        get: function(e) {
            return t(e.elem)[e.prop]()
        },
        set: function(e) {
            var n = this.get(e);
            if (e.options.interrupt && e._last && e._last !== n)
                return t(e.elem).stop();
            var r = Math.round(e.now);
            n !== r && (t(e.elem)[e.prop](r),
            e._last = this.get(e))
        }
    },
    r
}),
/*! jquery.waypoints.min.js */
/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function() {
    "use strict";
    function t(r) {
        if (!r)
            throw new Error("No options passed to Waypoint constructor");
        if (!r.element)
            throw new Error("No element option passed to Waypoint constructor");
        if (!r.handler)
            throw new Error("No handler option passed to Waypoint constructor");
        this.key = "waypoint-" + e,
        this.options = t.Adapter.extend({}, t.defaults, r),
        this.element = this.options.element,
        this.adapter = new t.Adapter(this.element),
        this.callback = r.handler,
        this.axis = this.options.horizontal ? "horizontal" : "vertical",
        this.enabled = this.options.enabled,
        this.triggerPoint = null,
        this.group = t.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis
        }),
        this.context = t.Context.findOrCreateByElement(this.options.context),
        t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]),
        this.group.add(this),
        this.context.add(this),
        n[this.key] = this,
        e += 1
    }
    var e = 0
      , n = {};
    t.prototype.queueTrigger = function(t) {
        this.group.queueTrigger(this, t)
    }
    ,
    t.prototype.trigger = function(t) {
        this.enabled && this.callback && this.callback.apply(this, t)
    }
    ,
    t.prototype.destroy = function() {
        this.context.remove(this),
        this.group.remove(this),
        delete n[this.key]
    }
    ,
    t.prototype.disable = function() {
        return this.enabled = !1,
        this
    }
    ,
    t.prototype.enable = function() {
        return this.context.refresh(),
        this.enabled = !0,
        this
    }
    ,
    t.prototype.next = function() {
        return this.group.next(this)
    }
    ,
    t.prototype.previous = function() {
        return this.group.previous(this)
    }
    ,
    t.invokeAll = function(t) {
        var e = [];
        for (var r in n)
            e.push(n[r]);
        for (var i = 0, o = e.length; o > i; i++)
            e[i][t]()
    }
    ,
    t.destroyAll = function() {
        t.invokeAll("destroy")
    }
    ,
    t.disableAll = function() {
        t.invokeAll("disable")
    }
    ,
    t.enableAll = function() {
        t.Context.refreshAll();
        for (var e in n)
            n[e].enabled = !0;
        return this
    }
    ,
    t.refreshAll = function() {
        t.Context.refreshAll()
    }
    ,
    t.viewportHeight = function() {
        return window.innerHeight || document.documentElement.clientHeight
    }
    ,
    t.viewportWidth = function() {
        return document.documentElement.clientWidth
    }
    ,
    t.adapters = [],
    t.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0
    },
    t.offsetAliases = {
        "bottom-in-view": function() {
            return this.context.innerHeight() - this.adapter.outerHeight()
        },
        "right-in-view": function() {
            return this.context.innerWidth() - this.adapter.outerWidth()
        }
    },
    window.Waypoint = t
}(),
function() {
    "use strict";
    function t(t) {
        window.setTimeout(t, 1e3 / 60)
    }
    function e(t) {
        this.element = t,
        this.Adapter = i.Adapter,
        this.adapter = new this.Adapter(t),
        this.key = "waypoint-context-" + n,
        this.didScroll = !1,
        this.didResize = !1,
        this.oldScroll = {
            x: this.adapter.scrollLeft(),
            y: this.adapter.scrollTop()
        },
        this.waypoints = {
            vertical: {},
            horizontal: {}
        },
        t.waypointContextKey = this.key,
        r[t.waypointContextKey] = this,
        n += 1,
        i.windowContext || (i.windowContext = !0,
        i.windowContext = new e(window)),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler()
    }
    var n = 0
      , r = {}
      , i = window.Waypoint
      , o = window.onload;
    e.prototype.add = function(t) {
        var e = t.options.horizontal ? "horizontal" : "vertical";
        this.waypoints[e][t.key] = t,
        this.refresh()
    }
    ,
    e.prototype.checkEmpty = function() {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal)
          , e = this.Adapter.isEmptyObject(this.waypoints.vertical)
          , n = this.element == this.element.window;
        t && e && !n && (this.adapter.off(".waypoints"),
        delete r[this.key])
    }
    ,
    e.prototype.createThrottledResizeHandler = function() {
        function t() {
            e.handleResize(),
            e.didResize = !1
        }
        var e = this;
        this.adapter.on("resize.waypoints", function() {
            e.didResize || (e.didResize = !0,
            i.requestAnimationFrame(t))
        })
    }
    ,
    e.prototype.createThrottledScrollHandler = function() {
        function t() {
            e.handleScroll(),
            e.didScroll = !1
        }
        var e = this;
        this.adapter.on("scroll.waypoints", function() {
            (!e.didScroll || i.isTouch) && (e.didScroll = !0,
            i.requestAnimationFrame(t))
        })
    }
    ,
    e.prototype.handleResize = function() {
        i.Context.refreshAll()
    }
    ,
    e.prototype.handleScroll = function() {
        var t = {}
          , e = {
            horizontal: {
                newScroll: this.adapter.scrollLeft(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left"
            },
            vertical: {
                newScroll: this.adapter.scrollTop(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up"
            }
        };
        for (var n in e) {
            var r = e[n]
              , i = r.newScroll > r.oldScroll
              , o = i ? r.forward : r.backward;
            for (var a in this.waypoints[n]) {
                var s = this.waypoints[n][a];
                if (null !== s.triggerPoint) {
                    var l = r.oldScroll < s.triggerPoint
                      , u = r.newScroll >= s.triggerPoint
                      , c = l && u
                      , d = !l && !u;
                    (c || d) && (s.queueTrigger(o),
                    t[s.group.id] = s.group)
                }
            }
        }
        for (var p in t)
            t[p].flushTriggers();
        this.oldScroll = {
            x: e.horizontal.newScroll,
            y: e.vertical.newScroll
        }
    }
    ,
    e.prototype.innerHeight = function() {
        return this.element == this.element.window ? i.viewportHeight() : this.adapter.innerHeight()
    }
    ,
    e.prototype.remove = function(t) {
        delete this.waypoints[t.axis][t.key],
        this.checkEmpty()
    }
    ,
    e.prototype.innerWidth = function() {
        return this.element == this.element.window ? i.viewportWidth() : this.adapter.innerWidth()
    }
    ,
    e.prototype.destroy = function() {
        var t = [];
        for (var e in this.waypoints)
            for (var n in this.waypoints[e])
                t.push(this.waypoints[e][n]);
        for (var r = 0, i = t.length; i > r; r++)
            t[r].destroy()
    }
    ,
    e.prototype.refresh = function() {
        var t, e = this.element == this.element.window, n = e ? void 0 : this.adapter.offset(), r = {};
        this.handleScroll(),
        t = {
            horizontal: {
                contextOffset: e ? 0 : n.left,
                contextScroll: e ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left",
                offsetProp: "left"
            },
            vertical: {
                contextOffset: e ? 0 : n.top,
                contextScroll: e ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up",
                offsetProp: "top"
            }
        };
        for (var o in t) {
            var a = t[o];
            for (var s in this.waypoints[o]) {
                var l, u, c, d, p, f = this.waypoints[o][s], h = f.options.offset, m = f.triggerPoint, g = 0, v = null == m;
                f.element !== f.element.window && (g = f.adapter.offset()[a.offsetProp]),
                "function" == typeof h ? h = h.apply(f) : "string" == typeof h && (h = parseFloat(h),
                f.options.offset.indexOf("%") > -1 && (h = Math.ceil(a.contextDimension * h / 100))),
                l = a.contextScroll - a.contextOffset,
                f.triggerPoint = Math.floor(g + l - h),
                u = m < a.oldScroll,
                c = f.triggerPoint >= a.oldScroll,
                d = u && c,
                p = !u && !c,
                !v && d ? (f.queueTrigger(a.backward),
                r[f.group.id] = f.group) : !v && p ? (f.queueTrigger(a.forward),
                r[f.group.id] = f.group) : v && a.oldScroll >= f.triggerPoint && (f.queueTrigger(a.forward),
                r[f.group.id] = f.group)
            }
        }
        return i.requestAnimationFrame(function() {
            for (var t in r)
                r[t].flushTriggers()
        }),
        this
    }
    ,
    e.findOrCreateByElement = function(t) {
        return e.findByElement(t) || new e(t)
    }
    ,
    e.refreshAll = function() {
        for (var t in r)
            r[t].refresh()
    }
    ,
    e.findByElement = function(t) {
        return r[t.waypointContextKey]
    }
    ,
    window.onload = function() {
        o && o(),
        e.refreshAll()
    }
    ,
    i.requestAnimationFrame = function(e) {
        var n = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;
        n.call(window, e)
    }
    ,
    i.Context = e
}(),
function() {
    "use strict";
    function t(t, e) {
        return t.triggerPoint - e.triggerPoint
    }
    function e(t, e) {
        return e.triggerPoint - t.triggerPoint
    }
    function n(t) {
        this.name = t.name,
        this.axis = t.axis,
        this.id = this.name + "-" + this.axis,
        this.waypoints = [],
        this.clearTriggerQueues(),
        r[this.axis][this.name] = this
    }
    var r = {
        vertical: {},
        horizontal: {}
    }
      , i = window.Waypoint;
    n.prototype.add = function(t) {
        this.waypoints.push(t)
    }
    ,
    n.prototype.clearTriggerQueues = function() {
        this.triggerQueues = {
            up: [],
            down: [],
            left: [],
            right: []
        }
    }
    ,
    n.prototype.flushTriggers = function() {
        for (var n in this.triggerQueues) {
            var r = this.triggerQueues[n]
              , i = "up" === n || "left" === n;
            r.sort(i ? e : t);
            for (var o = 0, a = r.length; a > o; o += 1) {
                var s = r[o];
                (s.options.continuous || o === r.length - 1) && s.trigger([n])
            }
        }
        this.clearTriggerQueues()
    }
    ,
    n.prototype.next = function(e) {
        this.waypoints.sort(t);
        var n = i.Adapter.inArray(e, this.waypoints)
          , r = n === this.waypoints.length - 1;
        return r ? null : this.waypoints[n + 1]
    }
    ,
    n.prototype.previous = function(e) {
        this.waypoints.sort(t);
        var n = i.Adapter.inArray(e, this.waypoints);
        return n ? this.waypoints[n - 1] : null
    }
    ,
    n.prototype.queueTrigger = function(t, e) {
        this.triggerQueues[e].push(t)
    }
    ,
    n.prototype.remove = function(t) {
        var e = i.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1)
    }
    ,
    n.prototype.first = function() {
        return this.waypoints[0]
    }
    ,
    n.prototype.last = function() {
        return this.waypoints[this.waypoints.length - 1]
    }
    ,
    n.findOrCreate = function(t) {
        return r[t.axis][t.name] || new n(t)
    }
    ,
    i.Group = n
}(),
function() {
    "use strict";
    function t(t) {
        this.$element = e(t)
    }
    var e = window.jQuery
      , n = window.Waypoint;
    e.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function(e, n) {
        t.prototype[n] = function() {
            var t = Array.prototype.slice.call(arguments);
            return this.$element[n].apply(this.$element, t)
        }
    }),
    e.each(["extend", "inArray", "isEmptyObject"], function(n, r) {
        t[r] = e[r]
    }),
    n.adapters.push({
        name: "jquery",
        Adapter: t
    }),
    n.Adapter = t
}(),
function() {
    "use strict";
    function t(t) {
        return function() {
            var n = []
              , r = arguments[0];
            return t.isFunction(arguments[0]) && (r = t.extend({}, arguments[1]),
            r.handler = arguments[0]),
            this.each(function() {
                var i = t.extend({}, r, {
                    element: this
                });
                "string" == typeof i.context && (i.context = t(this).closest(i.context)[0]),
                n.push(new e(i))
            }),
            n
        }
    }
    var e = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
    window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto))
}(),
/*! tua-bsl.umd.min.js */
/*!
tua-body-scroll-lock
https://github.com/tuateam/tua-body-scroll-lock
*/
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = t || self).bodyScrollLock = {})
}(this, function(t) {
    "use strict";
    function e(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n,
        t
    }
    function n(t) {
        for (var n = 1; n < arguments.length; n++) {
            var r = null != arguments[n] ? arguments[n] : {}
              , i = Object.keys(r);
            "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(r).filter(function(t) {
                return Object.getOwnPropertyDescriptor(r, t).enumerable
            }))),
            i.forEach(function(n) {
                e(t, n, r[n])
            })
        }
        return t
    }
    var r, i = 0, o = 0, a = null, s = !1, l = "undefined" == typeof window, u = [], c = !l && document.querySelector.bind(document);
    if (!l) {
        var d = {
            get passive() {
                r = {
                    passive: !1
                }
            }
        };
        window.addEventListener("__TUA_BSL_TEST_PASSIVE__", null, d),
        window.removeEventListener("__TUA_BSL_TEST_PASSIVE__", null, d)
    }
    var p = function() {
        var t = navigator.userAgent
          , e = /(iPad).*OS\s([\d_]+)/.test(t)
          , n = !e && /(iPhone\sOS)\s([\d_]+)/.test(t)
          , r = /(Android);?[\s\/]+([\d.]+)?/.test(t);
        return {
            os: r ? "android" : "ios",
            ios: n || e,
            ipad: e,
            iphone: n,
            android: r
        }
    }
      , f = function(t) {
        t.cancelable && t.preventDefault()
    };
    t.lock = function(t) {
        var e, d, h, m, g;
        l || (p().ios ? (t && -1 === u.indexOf(t) && (t.ontouchstart = function(t) {
            o = t.targetTouches[0].clientY
        }
        ,
        t.ontouchmove = function(e) {
            1 === e.targetTouches.length && function(t, e) {
                var n = t.targetTouches[0].clientY - o;
                if (e) {
                    var r = e.scrollTop
                      , i = e.scrollHeight
                      , a = e.clientHeight;
                    if (n > 0 && 0 === r || n < 0 && r + a + 1 >= i)
                        return f(t)
                }
                t.stopPropagation()
            }(e, t)
        }
        ,
        u.push(t)),
        s || (document.addEventListener("touchmove", f, r),
        s = !0)) : i <= 0 && (a = p().android ? (e = c("html"),
        d = c("body"),
        h = e.scrollTop || d.scrollTop,
        m = n({}, e.style),
        g = n({}, d.style),
        e.style.height = "100%",
        e.style.overflow = "hidden",
        d.style.top = "-".concat(h, "px"),
        d.style.width = "100%",
        d.style.height = "auto",
        d.style.position = "fixed",
        d.style.overflow = "hidden",
        function() {
            e.style.height = m.height || "",
            e.style.overflow = m.overflow || "",
            ["top", "width", "height", "overflow", "position"].forEach(function(t) {
                d.style[t] = g[t] || ""
            }),
            window.scrollTo(0, h)
        }
        ) : function() {
            var t = c("body")
              , e = n({}, t.style)
              , r = window.innerWidth - document.body.clientWidth;
            return t.style.overflow = "hidden",
            t.style.boxSizing = "border-box",
            t.style.paddingRight = "".concat(r, "px"),
            function() {
                ["overflow", "boxSizing", "paddingRight"].forEach(function(n) {
                    t.style[n] = e[n] || ""
                })
            }
        }()),
        i += 1)
    }
    ,
    t.unlock = function(t) {
        if (!(l || (i -= 1) > 0))
            if (p().ios) {
                var e = u.indexOf(t);
                -1 !== e && (t.ontouchmove = null,
                t.ontouchstart = null,
                u.splice(e, 1)),
                s && (document.removeEventListener("touchmove", f, r),
                s = !1)
            } else
                i <= 0 && "function" == typeof a && a()
    }
    ,
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}),
/*! jquery.ba-throttle-debounce.min.js */
/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
function(t, e) {
    var n, r = t.jQuery || t.Cowboy || (t.Cowboy = {});
    r.throttle = n = function(t, n, i, o) {
        function a() {
            function r() {
                l = +new Date,
                i.apply(u, d)
            }
            function a() {
                s = e
            }
            var u = this
              , c = +new Date - l
              , d = arguments;
            o && !s && r(),
            s && clearTimeout(s),
            o === e && c > t ? r() : n !== !0 && (s = setTimeout(o ? a : r, o === e ? t - c : t))
        }
        var s, l = 0;
        return "boolean" != typeof n && (o = i,
        i = n,
        n = e),
        r.guid && (a.guid = i.guid = i.guid || r.guid++),
        a
    }
    ,
    r.debounce = function(t, r, i) {
        return i === e ? n(t, r, !1) : n(t, i, r !== !1)
    }
}(this),
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = "../images/m",
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = "png",
MarkerClusterer.prototype.extend = function(t, e) {
    return function(t) {
        for (var e in t.prototype)
            this.prototype[e] = t.prototype[e];
        return this
    }
    .apply(t, [e])
}
,
MarkerClusterer.prototype.onAdd = function() {
    this.setReady_(!0)
}
,
MarkerClusterer.prototype.draw = function() {}
,
MarkerClusterer.prototype.setupStyles_ = function() {
    if (!this.styles_.length)
        for (var t, e = 0; t = this.sizes[e]; e++)
            this.styles_.push({
                url: this.imagePath_ + (e + 1) + "." + this.imageExtension_,
                height: t,
                width: t
            })
}
,
MarkerClusterer.prototype.fitMapToMarkers = function() {
    for (var t, e = this.getMarkers(), n = new google.maps.LatLngBounds, r = 0; t = e[r]; r++)
        n.extend(t.getPosition());
    this.map_.fitBounds(n)
}
,
MarkerClusterer.prototype.setStyles = function(t) {
    this.styles_ = t
}
,
MarkerClusterer.prototype.getStyles = function() {
    return this.styles_
}
,
MarkerClusterer.prototype.isZoomOnClick = function() {
    return this.zoomOnClick_
}
,
MarkerClusterer.prototype.isAverageCenter = function() {
    return this.averageCenter_
}
,
MarkerClusterer.prototype.getMarkers = function() {
    return this.markers_
}
,
MarkerClusterer.prototype.getTotalMarkers = function() {
    return this.markers_.length
}
,
MarkerClusterer.prototype.setMaxZoom = function(t) {
    this.maxZoom_ = t
}
,
MarkerClusterer.prototype.getMaxZoom = function() {
    return this.maxZoom_
}
,
MarkerClusterer.prototype.calculator_ = function(t, e) {
    for (var n = 0, r = t.length, i = r; 0 !== i; )
        i = parseInt(i / 10, 10),
        n++;
    return {
        text: r,
        index: n = Math.min(n, e)
    }
}
,
MarkerClusterer.prototype.setCalculator = function(t) {
    this.calculator_ = t
}
,
MarkerClusterer.prototype.getCalculator = function() {
    return this.calculator_
}
,
MarkerClusterer.prototype.addMarkers = function(t, e) {
    if (t.length)
        for (var n = 0; r = t[n]; n++)
            this.pushMarkerTo_(r);
    else if (Object.keys(t).length)
        for (var r in t)
            this.pushMarkerTo_(t[r]);
    e || this.redraw()
}
,
MarkerClusterer.prototype.pushMarkerTo_ = function(t) {
    if (t.isAdded = !1,
    t.draggable) {
        var e = this;
        google.maps.event.addListener(t, "dragend", function() {
            t.isAdded = !1,
            e.repaint()
        })
    }
    this.markers_.push(t)
}
,
MarkerClusterer.prototype.addMarker = function(t, e) {
    this.pushMarkerTo_(t),
    e || this.redraw()
}
,
MarkerClusterer.prototype.removeMarker_ = function(t) {
    var e = -1;
    if (this.markers_.indexOf)
        e = this.markers_.indexOf(t);
    else
        for (var n, r = 0; n = this.markers_[r]; r++)
            if (n == t) {
                e = r;
                break
            }
    return -1 != e && (t.setMap(null),
    this.markers_.splice(e, 1),
    !0)
}
,
MarkerClusterer.prototype.removeMarker = function(t, e) {
    var n = this.removeMarker_(t);
    return !(e || !n || (this.resetViewport(),
    this.redraw(),
    0))
}
,
MarkerClusterer.prototype.removeMarkers = function(t, e) {
    for (var n, r = t === this.getMarkers() ? t.slice() : t, i = !1, o = 0; n = r[o]; o++) {
        var a = this.removeMarker_(n);
        i = i || a
    }
    if (!e && i)
        return this.resetViewport(),
        this.redraw(),
        !0
}
,
MarkerClusterer.prototype.setReady_ = function(t) {
    this.ready_ || (this.ready_ = t,
    this.createClusters_())
}
,
MarkerClusterer.prototype.getTotalClusters = function() {
    return this.clusters_.length
}
,
MarkerClusterer.prototype.getMap = function() {
    return this.map_
}
,
MarkerClusterer.prototype.setMap = function(t) {
    this.map_ = t
}
,
MarkerClusterer.prototype.getGridSize = function() {
    return this.gridSize_
}
,
MarkerClusterer.prototype.setGridSize = function(t) {
    this.gridSize_ = t
}
,
MarkerClusterer.prototype.getMinClusterSize = function() {
    return this.minClusterSize_
}
,
MarkerClusterer.prototype.setMinClusterSize = function(t) {
    this.minClusterSize_ = t
}
,
MarkerClusterer.prototype.getExtendedBounds = function(t) {
    var e = this.getProjection()
      , n = new google.maps.LatLng(t.getNorthEast().lat(),t.getNorthEast().lng())
      , r = new google.maps.LatLng(t.getSouthWest().lat(),t.getSouthWest().lng())
      , i = e.fromLatLngToDivPixel(n);
    i.x += this.gridSize_,
    i.y -= this.gridSize_;
    var o = e.fromLatLngToDivPixel(r);
    o.x -= this.gridSize_,
    o.y += this.gridSize_;
    var a = e.fromDivPixelToLatLng(i)
      , s = e.fromDivPixelToLatLng(o);
    return t.extend(a),
    t.extend(s),
    t
}
,
MarkerClusterer.prototype.isMarkerInBounds_ = function(t, e) {
    return e.contains(t.getPosition())
}
,
MarkerClusterer.prototype.clearMarkers = function() {
    this.resetViewport(!0),
    this.markers_ = []
}
,
MarkerClusterer.prototype.resetViewport = function(t) {
    for (var e, n = 0; e = this.clusters_[n]; n++)
        e.remove();
    var r;
    for (n = 0; r = this.markers_[n]; n++)
        r.isAdded = !1,
        t && r.setMap(null);
    this.clusters_ = []
}
,
MarkerClusterer.prototype.repaint = function() {
    var t = this.clusters_.slice();
    this.clusters_.length = 0,
    this.resetViewport(),
    this.redraw(),
    window.setTimeout(function() {
        for (var e, n = 0; e = t[n]; n++)
            e.remove()
    }, 0)
}
,
MarkerClusterer.prototype.redraw = function() {
    this.createClusters_()
}
,
MarkerClusterer.prototype.distanceBetweenPoints_ = function(t, e) {
    if (!t || !e)
        return 0;
    var n = (e.lat() - t.lat()) * Math.PI / 180
      , r = (e.lng() - t.lng()) * Math.PI / 180
      , i = Math.sin(n / 2) * Math.sin(n / 2) + Math.cos(t.lat() * Math.PI / 180) * Math.cos(e.lat() * Math.PI / 180) * Math.sin(r / 2) * Math.sin(r / 2);
    return 6371 * (2 * Math.atan2(Math.sqrt(i), Math.sqrt(1 - i)))
}
,
MarkerClusterer.prototype.addToClosestCluster_ = function(t) {
    for (var e, n = 4e4, r = null, i = (t.getPosition(),
    0); e = this.clusters_[i]; i++) {
        var o = e.getCenter();
        if (o) {
            var a = this.distanceBetweenPoints_(o, t.getPosition());
            a < n && (n = a,
            r = e)
        }
    }
    r && r.isMarkerInClusterBounds(t) ? r.addMarker(t) : ((e = new Cluster(this)).addMarker(t),
    this.clusters_.push(e))
}
,
MarkerClusterer.prototype.createClusters_ = function() {
    if (this.ready_)
        for (var t, e = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(),this.map_.getBounds().getNorthEast()), n = this.getExtendedBounds(e), r = 0; t = this.markers_[r]; r++)
            !t.isAdded && this.isMarkerInBounds_(t, n) && this.addToClosestCluster_(t)
}
,
Cluster.prototype.isMarkerAlreadyAdded = function(t) {
    if (this.markers_.indexOf)
        return -1 != this.markers_.indexOf(t);
    for (var e, n = 0; e = this.markers_[n]; n++)
        if (e == t)
            return !0;
    return !1
}
,
Cluster.prototype.addMarker = function(t) {
    if (this.isMarkerAlreadyAdded(t))
        return !1;
    if (this.center_) {
        if (this.averageCenter_) {
            var e = this.markers_.length + 1
              , n = (this.center_.lat() * (e - 1) + t.getPosition().lat()) / e
              , r = (this.center_.lng() * (e - 1) + t.getPosition().lng()) / e;
            this.center_ = new google.maps.LatLng(n,r),
            this.calculateBounds_()
        }
    } else
        this.center_ = t.getPosition(),
        this.calculateBounds_();
    t.isAdded = !0,
    this.markers_.push(t);
    var i = this.markers_.length;
    if (i < this.minClusterSize_ && t.getMap() != this.map_ && t.setMap(this.map_),
    i == this.minClusterSize_)
        for (var o = 0; o < i; o++)
            this.markers_[o].setMap(null);
    return i >= this.minClusterSize_ && t.setMap(null),
    this.updateIcon(),
    !0
}
,
Cluster.prototype.getMarkerClusterer = function() {
    return this.markerClusterer_
}
,
Cluster.prototype.getBounds = function() {
    for (var t, e = new google.maps.LatLngBounds(this.center_,this.center_), n = this.getMarkers(), r = 0; t = n[r]; r++)
        e.extend(t.getPosition());
    return e
}
,
Cluster.prototype.remove = function() {
    this.clusterIcon_.remove(),
    this.markers_.length = 0,
    delete this.markers_
}
,
Cluster.prototype.getSize = function() {
    return this.markers_.length
}
,
Cluster.prototype.getMarkers = function() {
    return this.markers_
}
,
Cluster.prototype.getCenter = function() {
    return this.center_
}
,
Cluster.prototype.calculateBounds_ = function() {
    var t = new google.maps.LatLngBounds(this.center_,this.center_);
    this.bounds_ = this.markerClusterer_.getExtendedBounds(t)
}
,
Cluster.prototype.isMarkerInClusterBounds = function(t) {
    return this.bounds_.contains(t.getPosition())
}
,
Cluster.prototype.getMap = function() {
    return this.map_
}
,
Cluster.prototype.updateIcon = function() {
    var t = this.map_.getZoom()
      , e = this.markerClusterer_.getMaxZoom();
    if (e && e < t)
        for (var n, r = 0; n = this.markers_[r]; r++)
            n.setMap(this.map_);
    else if (this.markers_.length < this.minClusterSize_)
        this.clusterIcon_.hide();
    else {
        var i = this.markerClusterer_.getStyles().length
          , o = this.markerClusterer_.getCalculator()(this.markers_, i);
        this.clusterIcon_.setCenter(this.center_),
        this.clusterIcon_.setSums(o),
        this.clusterIcon_.show()
    }
}
,
ClusterIcon.prototype.triggerClusterClick = function() {
    var t = this.cluster_.getMarkerClusterer();
    google.maps.event.trigger(t.map_, "clusterclick", this.cluster_),
    t.isZoomOnClick() && this.map_.fitBounds(this.cluster_.getBounds())
}
,
ClusterIcon.prototype.onAdd = function() {
    if (this.div_ = document.createElement("DIV"),
    this.visible_) {
        var t = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(t),
        this.div_.innerHTML = this.sums_.text
    }
    this.getPanes().overlayMouseTarget.appendChild(this.div_);
    var e = this;
    google.maps.event.addDomListener(this.div_, "click", function() {
        e.triggerClusterClick()
    })
}
,
ClusterIcon.prototype.getPosFromLatLng_ = function(t) {
    var e = this.getProjection().fromLatLngToDivPixel(t);
    return e.x -= parseInt(this.width_ / 2, 10),
    e.y -= parseInt(this.height_ / 2, 10),
    e
}
,
ClusterIcon.prototype.draw = function() {
    if (this.visible_) {
        var t = this.getPosFromLatLng_(this.center_);
        this.div_.style.top = t.y + "px",
        this.div_.style.left = t.x + "px",
        this.div_.style.zIndex = google.maps.Marker.MAX_ZINDEX + 1
    }
}
,
ClusterIcon.prototype.hide = function() {
    this.div_ && (this.div_.style.display = "none"),
    this.visible_ = !1
}
,
ClusterIcon.prototype.show = function() {
    if (this.div_) {
        var t = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(t),
        this.div_.style.display = ""
    }
    this.visible_ = !0
}
,
ClusterIcon.prototype.remove = function() {
    this.setMap(null)
}
,
ClusterIcon.prototype.onRemove = function() {
    this.div_ && this.div_.parentNode && (this.hide(),
    this.div_.parentNode.removeChild(this.div_),
    this.div_ = null)
}
,
ClusterIcon.prototype.setSums = function(t) {
    this.sums_ = t,
    this.text_ = t.text,
    this.index_ = t.index,
    this.div_ && (this.div_.innerHTML = t.text),
    this.useStyle()
}
,
ClusterIcon.prototype.useStyle = function() {
    var t = Math.max(0, this.sums_.index - 1);
    t = Math.min(this.styles_.length - 1, t);
    var e = this.styles_[t];
    this.url_ = e.url,
    this.height_ = e.height,
    this.width_ = e.width,
    this.textColor_ = e.textColor,
    this.anchor_ = e.anchor,
    this.textSize_ = e.textSize,
    this.backgroundPosition_ = e.backgroundPosition
}
,
ClusterIcon.prototype.setCenter = function(t) {
    this.center_ = t
}
,
ClusterIcon.prototype.createCss = function(t) {
    var e = [];
    e.push("background-image:url(" + this.url_ + ");");
    var n = this.backgroundPosition_ ? this.backgroundPosition_ : "0 0";
    e.push("background-position:" + n + ";"),
    "object" == typeof this.anchor_ ? ("number" == typeof this.anchor_[0] && 0 < this.anchor_[0] && this.anchor_[0] < this.height_ ? e.push("height:" + (this.height_ - this.anchor_[0]) + "px; padding-top:" + this.anchor_[0] + "px;") : e.push("height:" + this.height_ + "px; line-height:" + this.height_ + "px;"),
    "number" == typeof this.anchor_[1] && 0 < this.anchor_[1] && this.anchor_[1] < this.width_ ? e.push("width:" + (this.width_ - this.anchor_[1]) + "px; padding-left:" + this.anchor_[1] + "px;") : e.push("width:" + this.width_ + "px; text-align:center;")) : e.push("height:" + this.height_ + "px; line-height:" + this.height_ + "px; width:" + this.width_ + "px; text-align:center;");
    var r = this.textColor_ ? this.textColor_ : "black"
      , i = this.textSize_ ? this.textSize_ : 11;
    return e.push("cursor:pointer; top:" + t.y + "px; left:" + t.x + "px; color:" + r + "; position:absolute; font-size:" + i + "px; font-family:Arial,sans-serif; font-weight:bold"),
    e.join("")
}
;
var window = window || {};
(window.MarkerClusterer = MarkerClusterer).prototype.addMarker = MarkerClusterer.prototype.addMarker,
MarkerClusterer.prototype.addMarkers = MarkerClusterer.prototype.addMarkers,
MarkerClusterer.prototype.clearMarkers = MarkerClusterer.prototype.clearMarkers,
MarkerClusterer.prototype.fitMapToMarkers = MarkerClusterer.prototype.fitMapToMarkers,
MarkerClusterer.prototype.getCalculator = MarkerClusterer.prototype.getCalculator,
MarkerClusterer.prototype.getGridSize = MarkerClusterer.prototype.getGridSize,
MarkerClusterer.prototype.getExtendedBounds = MarkerClusterer.prototype.getExtendedBounds,
MarkerClusterer.prototype.getMap = MarkerClusterer.prototype.getMap,
MarkerClusterer.prototype.getMarkers = MarkerClusterer.prototype.getMarkers,
MarkerClusterer.prototype.getMaxZoom = MarkerClusterer.prototype.getMaxZoom,
MarkerClusterer.prototype.getStyles = MarkerClusterer.prototype.getStyles,
MarkerClusterer.prototype.getTotalClusters = MarkerClusterer.prototype.getTotalClusters,
MarkerClusterer.prototype.getTotalMarkers = MarkerClusterer.prototype.getTotalMarkers,
MarkerClusterer.prototype.redraw = MarkerClusterer.prototype.redraw,
MarkerClusterer.prototype.removeMarker = MarkerClusterer.prototype.removeMarker,
MarkerClusterer.prototype.removeMarkers = MarkerClusterer.prototype.removeMarkers,
MarkerClusterer.prototype.resetViewport = MarkerClusterer.prototype.resetViewport,
MarkerClusterer.prototype.repaint = MarkerClusterer.prototype.repaint,
MarkerClusterer.prototype.setCalculator = MarkerClusterer.prototype.setCalculator,
MarkerClusterer.prototype.setGridSize = MarkerClusterer.prototype.setGridSize,
MarkerClusterer.prototype.setMaxZoom = MarkerClusterer.prototype.setMaxZoom,
MarkerClusterer.prototype.onAdd = MarkerClusterer.prototype.onAdd,
MarkerClusterer.prototype.draw = MarkerClusterer.prototype.draw,
Cluster.prototype.getCenter = Cluster.prototype.getCenter,
Cluster.prototype.getSize = Cluster.prototype.getSize,
Cluster.prototype.getMarkers = Cluster.prototype.getMarkers,
ClusterIcon.prototype.onAdd = ClusterIcon.prototype.onAdd,
ClusterIcon.prototype.draw = ClusterIcon.prototype.draw,
ClusterIcon.prototype.onRemove = ClusterIcon.prototype.onRemove,
Object.keys = Object.keys || function(t) {
    var e = [];
    for (var n in t)
        t.hasOwnProperty(n) && e.push(n);
    return e
}
,
"object" == typeof module && (module.exports = MarkerClusterer),
// even if the comment does not have directives such as `@license` or `/*!`.
//
// Implemented via the [`uglify-save-license`](https://github.com/shinnn/uglify-save-license)
// module, this option preserves a comment if one of the following is true:
//
// 1. The comment is in the *first* line of a file
// 2. A regular expression matches the string of the comment.
//    For example: `MIT`, `@license`, or `Copyright`.
// 3. There is a comment at the *previous* line, and it matches 1, 2, or 3.
/*! jquery.yu2fvl */
/*! YU2FVL - jQuery Youtube Url To FullScreen Video Lightbox - v0.1.0 - 2016-02-07
* http://otakod.es/yu2fvl
* Copyright (c) 2016 darkylmnx; Licensed MIT */
!function(t, e, n) {
    function r(t) {
        var e = /(youtube\.com\/(watch\?v=|v\/|embed\/)|youtu\.be\/)([\w-]+)/.exec(t)
          , n = /[?&#]t=(\d+)/.exec(t);
        return !(!e || !e[3]) && {
            id: e[3],
            t: n && n[1]
        }
    }
    function i(t, e, n) {
        var r = JSON.stringify({
            event: "command",
            func: e,
            args: n || []
        });
        t.src.indexOf("youtube.com/embed") !== -1 && t.contentWindow.postMessage(r, "*")
    }
    function o(e, r, o, f) {
        function h() {
            var t = a.width() - e.minPaddingX
              , n = a.height() - e.minPaddingY
              , r = t / n
              , i = e.ratio;
            r > i ? (w.height(n),
            w.width(n * i)) : (w.width(t),
            w.height(t / i)),
            w.css("left", (a.width() - w.width()) / 2),
            w.css("top", (a.height() - w.height()) / 2)
        }
        function m() {
            i(k[0], "playVideo"),
            g()
        }
        function g() {
            x.stop().fadeIn("fast"),
            w.stop().fadeIn("fast")
        }
        function v() {
            x.stop().fadeOut("fast"),
            w.stop().fadeOut("fast", function() {
                null === r && e.open && (x.remove(),
                w.remove())
            })
        }
        function y(t) {
            t.on("click", function(t) {
                t.preventDefault(),
                m()
            })
        }
        function b(t) {
            t.on("click", function(t) {
                t.preventDefault(),
                i(k[0], "pauseVideo"),
                v()
            })
        }
        var w = t(n.createElement("DIV")).addClass(e.cssClass).css(c)
          , x = t(n.createElement("DIV")).addClass(e.cssClass + e.overlayCssClass).css(p)
          , C = t(n.createElement("BUTTON")).addClass(e.cssClass + e.closeCssClass).html(e.closeText)
          , k = t(n.createElement("IFRAME")).addClass(e.cssClass + e.iframeCssClass).attr({
            src: s + o + l + f + u + "&rel=0&fs=1&showinfo=0"
        }).css(d);
        w.append(k).append(C),
        t("body").append(x).append(w),
        e.open && k.on("load", function() {
            m()
        }),
        null !== r && y(r),
        b(C.add(x)),
        a.on("resize", h).trigger("resize")
    }
    var a = t(e)
      , s = "https://www.youtube.com/embed/"
      , l = "?start="
      , u = "&enablejsapi=1"
      , c = {
        display: "none",
        position: "fixed"
    }
      , d = {
        width: "100%",
        height: "100%"
    }
      , p = {
        display: "none",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%"
    }
      , f = {
        minPaddingX: 50,
        minPaddingY: 50,
        ratio: 16 / 9,
        cssClass: "yu2fvl",
        overlayCssClass: "-overlay",
        iframeCssClass: "-iframe",
        closeCssClass: "-close",
        closeText: "X",
        open: !1,
        vid: !1,
        t: 0
    };
    t.yu2fvl = function(e) {
        var n = t.extend({}, f, e);
        if (n.vid === !1)
            throw "YOU MUST SET THE 'vid' option";
        o(n, null, n.vid, n.t)
    }
    ,
    t.fn.yu2fvl = function(e) {
        function n() {
            var e = t(this)
              , n = r(e.attr("href"));
            o(i, e, n.id, n.t)
        }
        var i = t.extend({}, f, e);
        return i.vid !== !1 ? (o(i, this, i.vid, i.t),
        this) : this.each(n)
    }
}(jQuery, window, document);
/* @license
Papa Parse
v5.0.0-beta.0
https://github.com/mholt/PapaParse
License: MIT
*/
!function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : "object" == typeof module && "undefined" != typeof exports ? module.exports = t() : e.Papa = t()
}(this, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage
      , o = n && /blob:/i.test((f.location || {}).protocol)
      , a = {}
      , h = 0
      , k = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            M(r) && (t.dynamicTypingFunction = r,
            r = {});
            if (t.dynamicTyping = r,
            t.transform = !!M(t.transform) && t.transform,
            t.worker && k.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!k.WORKERS_SUPPORTED)
                        return !1;
                    var e = (r = f.URL || f.webkitURL || null,
                    i = s.toString(),
                    k.BLOB_URL || (k.BLOB_URL = r.createObjectURL(new Blob(["(", i, ")();"],{
                        type: "text/javascript"
                    }))))
                      , t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = g,
                    t.id = h++,
                    a[t.id] = t
                }();
                return i.userStep = t.step,
                i.userChunk = t.chunk,
                i.userComplete = t.complete,
                i.userError = t.error,
                t.step = M(t.step),
                t.chunk = M(t.chunk),
                t.complete = M(t.complete),
                t.error = M(t.error),
                delete t.worker,
                void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                })
            }
            var n = null;
            k.NODE_STREAM_INPUT,
            "string" == typeof e ? n = t.download ? new l(t) : new p(t) : !0 === e.readable && M(e.read) && M(e.on) ? n = new _(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e)
        },
        unparse: function(e, t) {
            var i = !1
              , g = !0
              , m = ","
              , v = "\r\n"
              , n = '"'
              , r = !1;
            !function() {
                if ("object" != typeof t)
                    return;
                "string" != typeof t.delimiter || k.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e)
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || Array.isArray(t.quotes)) && (i = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (v = t.newline);
                "string" == typeof t.quoteChar && (n = t.quoteChar);
                "boolean" == typeof t.header && (g = t.header)
            }();
            var s = new RegExp(n,"g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0]))
                    return o(null, e, r);
                if ("object" == typeof e[0])
                    return o(a(e[0]), e, r)
            } else if ("object" == typeof e)
                return "string" == typeof e.data && (e.data = JSON.parse(e.data)),
                Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields),
                e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : a(e.data[0])),
                Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [e.data])),
                o(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function a(e) {
                if ("object" != typeof e)
                    return [];
                var t = [];
                for (var r in e)
                    t.push(r);
                return t
            }
            function o(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)),
                "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length
                  , s = !Array.isArray(t[0]);
                if (n && g) {
                    for (var a = 0; a < e.length; a++)
                        0 < a && (i += m),
                        i += y(e[a], a);
                    0 < t.length && (i += v)
                }
                for (var o = 0; o < t.length; o++) {
                    var h = n ? e.length : t[o].length
                      , u = !1
                      , f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (u = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length),
                    "greedy" === r && n) {
                        for (var d = [], l = 0; l < h; l++) {
                            var c = s ? e[l] : l;
                            d.push(t[o][c])
                        }
                        u = "" === d.join("").trim()
                    }
                    if (!u) {
                        for (var p = 0; p < h; p++) {
                            0 < p && !f && (i += m);
                            var _ = n && s ? e[p] : p;
                            i += y(t[o][_], p)
                        }
                        o < t.length - 1 && (!r || 0 < h && !f) && (i += v)
                    }
                }
                return i
            }
            function y(e, t) {
                if (null == e)
                    return "";
                if (e.constructor === Date)
                    return JSON.stringify(e).slice(1, 25);
                e = e.toString().replace(s, n + n);
                var r = "boolean" == typeof i && i || Array.isArray(i) && i[t] || function(e, t) {
                    for (var r = 0; r < t.length; r++)
                        if (-1 < e.indexOf(t[r]))
                            return !0;
                    return !1
                }(e, k.BAD_DELIMITERS) || -1 < e.indexOf(m) || " " === e.charAt(0) || " " === e.charAt(e.length - 1);
                return r ? n + e + n : e
            }
        }
    };
    if (k.RECORD_SEP = String.fromCharCode(30),
    k.UNIT_SEP = String.fromCharCode(31),
    k.BYTE_ORDER_MARK = "\ufeff",
    k.BAD_DELIMITERS = ["\r", "\n", '"', k.BYTE_ORDER_MARK],
    k.WORKERS_SUPPORTED = !n && !!f.Worker,
    k.NODE_STREAM_INPUT = 1,
    k.LocalChunkSize = 10485760,
    k.RemoteChunkSize = 5242880,
    k.DefaultDelimiter = ",",
    k.Parser = b,
    k.ParserHandle = r,
    k.NetworkStreamer = l,
    k.FileStreamer = c,
    k.StringStreamer = p,
    k.ReadableStreamStreamer = _,
    f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}
              , h = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length)
                    return !0;
                for (var t = 0; t < this.files.length; t++)
                    h.push({
                        file: this.files[t],
                        inputElem: this,
                        instanceConfig: d.extend({}, r)
                    })
            }),
            e(),
            this;
            function e() {
                if (0 !== h.length) {
                    var e, t, r, i, n = h[0];
                    if (M(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action)
                                return e = "AbortError",
                                t = n.file,
                                r = n.inputElem,
                                i = s.reason,
                                void (M(o.error) && o.error({
                                    name: e
                                }, t, r, i));
                            if ("skip" === s.action)
                                return void u();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config))
                        } else if ("skip" === s)
                            return void u()
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        M(a) && a(e, n.file, n.inputElem),
                        u()
                    }
                    ,
                    k.parse(n.file, n.instanceConfig)
                } else
                    M(o.complete) && o.complete()
            }
            function u() {
                h.splice(0, 1),
                e()
            }
        }
    }
    function u(e) {
        this._handle = null,
        this._finished = !1,
        this._completed = !1,
        this._input = null,
        this._baseIndex = 0,
        this._partialLine = "",
        this._rowCount = 0,
        this._start = 0,
        this._nextChunk = null,
        this.isFirstChunk = !0,
        this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        },
        function(e) {
            var t = E(e);
            t.chunkSize = parseInt(t.chunkSize),
            e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t),
            (this._handle.streamer = this)._config = t
        }
        .call(this, e),
        this.parseChunk = function(e, t) {
            if (this.isFirstChunk && M(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r)
            }
            this.isFirstChunk = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex),
                this._baseIndex = s),
                n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o)
                    f.postMessage({
                        results: n,
                        workerId: k.WORKER_ID,
                        finished: a
                    });
                else if (M(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle),
                    this._handle.paused() || this._handle.aborted())
                        return;
                    n = void 0,
                    this._completeResults = void 0
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data),
                this._completeResults.errors = this._completeResults.errors.concat(n.errors),
                this._completeResults.meta = n.meta),
                this._completed || !a || !M(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input),
                this._completed = !0),
                a || n && n.meta.paused || this._nextChunk(),
                n
            }
        }
        ,
        this._sendError = function(e) {
            M(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: k.WORKER_ID,
                error: e,
                finished: !1
            })
        }
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = k.RemoteChunkSize),
        u.call(this, e),
        this._nextChunk = n ? function() {
            this._readChunk(),
            this._chunkLoaded()
        }
        : function() {
            this._readChunk()
        }
        ,
        this.stream = function(e) {
            this._input = e,
            this._nextChunk()
        }
        ,
        this._readChunk = function() {
            if (this._finished)
                this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest,
                this._config.withCredentials && (i.withCredentials = this._config.withCredentials),
                n || (i.onload = w(this._chunkLoaded, this),
                i.onerror = w(this._chunkError, this)),
                i.open("GET", this._input, !n),
                this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for (var t in e)
                        i.setRequestHeader(t, e[t])
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r)
                }
                try {
                    i.send()
                } catch (e) {
                    this._chunkError(e.message)
                }
                n && 0 === i.status ? this._chunkError() : this._start += this._config.chunkSize
            }
        }
        ,
        this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._finished = !this._config.chunkSize || this._start > function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t)
                    return -1;
                return parseInt(t.substr(t.lastIndexOf("/") + 1))
            }(i),
            this.parseChunk(i.responseText)))
        }
        ,
        this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t))
        }
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = k.LocalChunkSize),
        u.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e,
            n = e.slice || e.webkitSlice || e.mozSlice,
            s ? ((i = new FileReader).onload = w(this._chunkLoaded, this),
            i.onerror = w(this._chunkError, this)) : i = new FileReaderSync,
            this._nextChunk()
        }
        ,
        this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk()
        }
        ,
        this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t)
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            })
        }
        ,
        this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize,
            this._finished = !this._config.chunkSize || this._start >= this._input.size,
            this.parseChunk(e.target.result)
        }
        ,
        this._chunkError = function() {
            this._sendError(i.error)
        }
    }
    function p(e) {
        var r;
        u.call(this, e = e || {}),
        this.stream = function(e) {
            return r = e,
            this._nextChunk()
        }
        ,
        this._nextChunk = function() {
            if (!this._finished) {
                var e = this._config.chunkSize
                  , t = e ? r.substr(0, e) : r;
                return r = e ? r.substr(e) : "",
                this._finished = !r,
                this.parseChunk(t)
            }
        }
    }
    function _(e) {
        u.call(this, e = e || {});
        var t = []
          , r = !0
          , i = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments),
            this._input.pause()
        }
        ,
        this.resume = function() {
            u.prototype.resume.apply(this, arguments),
            this._input.resume()
        }
        ,
        this.stream = function(e) {
            this._input = e,
            this._input.on("data", this._streamData),
            this._input.on("end", this._streamEnd),
            this._input.on("error", this._streamError)
        }
        ,
        this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0)
        }
        ,
        this._nextChunk = function() {
            this._checkIsFinished(),
            t.length ? this.parseChunk(t.shift()) : r = !0
        }
        ,
        this._streamData = w(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)),
                r && (r = !1,
                this._checkIsFinished(),
                this.parseChunk(t.shift()))
            } catch (e) {
                this._streamError(e)
            }
        }, this),
        this._streamError = w(function(e) {
            this._streamCleanUp(),
            this._sendError(e)
        }, this),
        this._streamEnd = w(function() {
            this._streamCleanUp(),
            i = !0,
            this._streamData("")
        }, this),
        this._streamCleanUp = w(function() {
            this._input.removeListener("data", this._streamData),
            this._input.removeListener("end", this._streamEnd),
            this._input.removeListener("error", this._streamError)
        }, this)
    }
    function r(g) {
        var a, o, h, i = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i, n = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/, t = this, r = 0, s = 0, u = !1, e = !1, f = [], d = {
            data: [],
            errors: [],
            meta: {}
        };
        if (M(g.step)) {
            var l = g.step;
            g.step = function(e) {
                if (d = e,
                p())
                    c();
                else {
                    if (c(),
                    0 === d.data.length)
                        return;
                    r += e.data.length,
                    g.preview && r > g.preview ? o.abort() : l(d, t)
                }
            }
        }
        function m(e) {
            return "greedy" === g.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length
        }
        function c() {
            if (d && h && (v("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + k.DefaultDelimiter + "'"),
            h = !1),
            g.skipEmptyLines)
                for (var e = 0; e < d.data.length; e++)
                    m(d.data[e]) && d.data.splice(e--, 1);
            return p() && function() {
                if (!d)
                    return;
                for (var e = 0; p() && e < d.data.length; e++)
                    for (var t = 0; t < d.data[e].length; t++) {
                        var r = d.data[e][t];
                        M(g.transformHeader) && (r = g.transformHeader(r)),
                        f.push(r)
                    }
                d.data.splice(0, 1)
            }(),
            function() {
                if (!d || !g.header && !g.dynamicTyping && !g.transform)
                    return d;
                for (var e = 0; e < d.data.length; e++) {
                    var t, r = g.header ? {} : [];
                    for (t = 0; t < d.data[e].length; t++) {
                        var i = t
                          , n = d.data[e][t];
                        g.header && (i = t >= f.length ? "__parsed_extra" : f[t]),
                        g.transform && (n = g.transform(n, i)),
                        n = _(i, n),
                        "__parsed_extra" === i ? (r[i] = r[i] || [],
                        r[i].push(n)) : r[i] = n
                    }
                    d.data[e] = r,
                    g.header && (t > f.length ? v("FieldMismatch", "TooManyFields", "Too many fields: expected " + f.length + " fields but parsed " + t, s + e) : t < f.length && v("FieldMismatch", "TooFewFields", "Too few fields: expected " + f.length + " fields but parsed " + t, s + e))
                }
                g.header && d.meta && (d.meta.fields = f);
                return s += d.data.length,
                d
            }()
        }
        function p() {
            return g.header && 0 === f.length
        }
        function _(e, t) {
            return r = e,
            g.dynamicTypingFunction && void 0 === g.dynamicTyping[r] && (g.dynamicTyping[r] = g.dynamicTypingFunction(r)),
            !0 === (g.dynamicTyping[r] || g.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (i.test(t) ? parseFloat(t) : n.test(t) ? new Date(t) : "" === t ? null : t) : t;
            var r
        }
        function v(e, t, r, i) {
            d.errors.push({
                type: e,
                code: t,
                message: r,
                row: i
            })
        }
        this.parse = function(e, t, r) {
            var i = g.quoteChar || '"';
            if (g.newline || (g.newline = function(e, t) {
                e = e.substr(0, 1048576);
                var r = new RegExp(y(t) + "([^]*?)" + y(t),"gm")
                  , i = (e = e.replace(r, "")).split("\r")
                  , n = e.split("\n")
                  , s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s)
                    return "\n";
                for (var a = 0, o = 0; o < i.length; o++)
                    "\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r"
            }(e, i)),
            h = !1,
            g.delimiter)
                M(g.delimiter) && (g.delimiter = g.delimiter(e),
                d.meta.delimiter = g.delimiter);
            else {
                var n = function(e, t, r, i) {
                    for (var n, s, a, o = [",", "\t", "|", ";", k.RECORD_SEP, k.UNIT_SEP], h = 0; h < o.length; h++) {
                        var u = o[h]
                          , f = 0
                          , d = 0
                          , l = 0;
                        a = void 0;
                        for (var c = new b({
                            comments: i,
                            delimiter: u,
                            newline: t,
                            preview: 10
                        }).parse(e), p = 0; p < c.data.length; p++)
                            if (r && m(c.data[p]))
                                l++;
                            else {
                                var _ = c.data[p].length;
                                d += _,
                                void 0 !== a ? 1 < _ && (f += Math.abs(_ - a),
                                a = _) : a = _
                            }
                        0 < c.data.length && (d /= c.data.length - l),
                        (void 0 === s || f < s) && 1.99 < d && (s = f,
                        n = u)
                    }
                    return {
                        successful: !!(g.delimiter = n),
                        bestDelimiter: n
                    }
                }(e, g.newline, g.skipEmptyLines, g.comments);
                n.successful ? g.delimiter = n.bestDelimiter : (h = !0,
                g.delimiter = k.DefaultDelimiter),
                d.meta.delimiter = g.delimiter
            }
            var s = E(g);
            return g.preview && g.header && s.preview++,
            a = e,
            o = new b(s),
            d = o.parse(a, t, r),
            c(),
            u ? {
                meta: {
                    paused: !0
                }
            } : d || {
                meta: {
                    paused: !1
                }
            }
        }
        ,
        this.paused = function() {
            return u
        }
        ,
        this.pause = function() {
            u = !0,
            o.abort(),
            a = a.substr(o.getCharIndex())
        }
        ,
        this.resume = function() {
            u = !1,
            t.streamer.parseChunk(a, !0)
        }
        ,
        this.aborted = function() {
            return e
        }
        ,
        this.abort = function() {
            e = !0,
            o.abort(),
            d.meta.aborted = !0,
            M(g.complete) && g.complete(d),
            a = ""
        }
    }
    function y(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    }
    function b(e) {
        var S, O = (e = e || {}).delimiter, x = e.newline, I = e.comments, D = e.step, T = e.preview, L = e.fastMode, A = S = void 0 === e.quoteChar ? '"' : e.quoteChar;
        if (void 0 !== e.escapeChar && (A = e.escapeChar),
        ("string" != typeof O || -1 < k.BAD_DELIMITERS.indexOf(O)) && (O = ","),
        I === O)
            throw new Error("Comment character same as delimiter");
        !0 === I ? I = "#" : ("string" != typeof I || -1 < k.BAD_DELIMITERS.indexOf(I)) && (I = !1),
        "\n" !== x && "\r" !== x && "\r\n" !== x && (x = "\n");
        var F = 0
          , z = !1;
        this.parse = function(i, r, t) {
            if ("string" != typeof i)
                throw new Error("Input must be a string");
            var n = i.length
              , e = O.length
              , s = x.length
              , a = I.length
              , o = M(D)
              , h = []
              , u = []
              , f = []
              , d = F = 0;
            if (!i)
                return C();
            if (L || !1 !== L && -1 === i.indexOf(S)) {
                for (var l = i.split(x), c = 0; c < l.length; c++) {
                    if (f = l[c],
                    F += f.length,
                    c !== l.length - 1)
                        F += x.length;
                    else if (t)
                        return C();
                    if (!I || f.substr(0, a) !== I) {
                        if (o) {
                            if (h = [],
                            k(f.split(O)),
                            R(),
                            z)
                                return C()
                        } else
                            k(f.split(O));
                        if (T && T <= c)
                            return h = h.slice(0, T),
                            C(!0)
                    }
                }
                return C()
            }
            for (var p, _ = i.indexOf(O, F), g = i.indexOf(x, F), m = new RegExp(A.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&") + S,"g"); ; )
                if (i[F] !== S)
                    if (I && 0 === f.length && i.substr(F, a) === I) {
                        if (-1 === g)
                            return C();
                        F = g + s,
                        g = i.indexOf(x, F),
                        _ = i.indexOf(O, F)
                    } else if (-1 !== _ && (_ < g || -1 === g))
                        f.push(i.substring(F, _)),
                        F = _ + e,
                        _ = i.indexOf(O, F);
                    else {
                        if (-1 === g)
                            break;
                        if (f.push(i.substring(F, g)),
                        w(g + s),
                        o && (R(),
                        z))
                            return C();
                        if (T && h.length >= T)
                            return C(!0)
                    }
                else
                    for (p = F,
                    F++; ; ) {
                        if (-1 === (p = i.indexOf(S, p + 1)))
                            return t || u.push({
                                type: "Quotes",
                                code: "MissingQuotes",
                                message: "Quoted field unterminated",
                                row: h.length,
                                index: F
                            }),
                            E();
                        if (p === n - 1)
                            return E(i.substring(F, p).replace(m, S));
                        if (S !== A || i[p + 1] !== A) {
                            if (S === A || 0 === p || i[p - 1] !== A) {
                                var v = b(-1 === g ? _ : Math.min(_, g));
                                if (i[p + 1 + v] === O) {
                                    f.push(i.substring(F, p).replace(m, S)),
                                    F = p + 1 + v + e,
                                    _ = i.indexOf(O, F),
                                    g = i.indexOf(x, F);
                                    break
                                }
                                var y = b(g);
                                if (i.substr(p + 1 + y, s) === x) {
                                    if (f.push(i.substring(F, p).replace(m, S)),
                                    w(p + 1 + y + s),
                                    _ = i.indexOf(O, F),
                                    o && (R(),
                                    z))
                                        return C();
                                    if (T && h.length >= T)
                                        return C(!0);
                                    break
                                }
                                u.push({
                                    type: "Quotes",
                                    code: "InvalidQuotes",
                                    message: "Trailing quote on quoted field is malformed",
                                    row: h.length,
                                    index: F
                                }),
                                p++
                            }
                        } else
                            p++
                    }
            return E();
            function k(e) {
                h.push(e),
                d = F
            }
            function b(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(p + 1, e);
                    r && "" === r.trim() && (t = r.length)
                }
                return t
            }
            function E(e) {
                return t || (void 0 === e && (e = i.substr(F)),
                f.push(e),
                F = n,
                k(f),
                o && R()),
                C()
            }
            function w(e) {
                F = e,
                k(f),
                f = [],
                g = i.indexOf(x, F)
            }
            function C(e, t) {
                return {
                    data: t || !1 ? h[0] : h,
                    errors: u,
                    meta: {
                        delimiter: O,
                        linebreak: x,
                        aborted: z,
                        truncated: !!e,
                        cursor: d + (r || 0)
                    }
                }
            }
            function R() {
                D(C(void 0, !0)),
                h = [],
                u = []
            }
        }
        ,
        this.abort = function() {
            z = !0
        }
        ,
        this.getCharIndex = function() {
            return F
        }
    }
    function g(e) {
        var t = e.data
          , r = a[t.workerId]
          , i = !1;
        if (t.error)
            r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0,
                    m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    })
                },
                pause: v,
                resume: v
            };
            if (M(r.userStep)) {
                for (var s = 0; s < t.results.data.length && (r.userStep({
                    data: [t.results.data[s]],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n),
                !i); s++)
                    ;
                delete t.results
            } else
                M(r.userChunk) && (r.userChunk(t.results, n, t.file),
                delete t.results)
        }
        t.finished && !i && m(t.workerId, t.results)
    }
    function m(e, t) {
        var r = a[e];
        M(r.userComplete) && r.userComplete(t),
        r.terminate(),
        delete a[e]
    }
    function v() {
        throw new Error("Not implemented.")
    }
    function E(e) {
        if ("object" != typeof e || null === e)
            return e;
        var t = Array.isArray(e) ? [] : {};
        for (var r in e)
            t[r] = E(e[r]);
        return t
    }
    function w(e, t) {
        return function() {
            e.apply(t, arguments)
        }
    }
    function M(e) {
        return "function" == typeof e
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === k.WORKER_ID && t && (k.WORKER_ID = t.workerId);
        if ("string" == typeof t.input)
            f.postMessage({
                workerId: k.WORKER_ID,
                results: k.parse(t.input, t.config),
                finished: !0
            });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = k.parse(t.input, t.config);
            r && f.postMessage({
                workerId: k.WORKER_ID,
                results: r,
                finished: !0
            })
        }
    }
    ),
    (l.prototype = Object.create(u.prototype)).constructor = l,
    (c.prototype = Object.create(u.prototype)).constructor = c,
    (p.prototype = Object.create(p.prototype)).constructor = p,
    (_.prototype = Object.create(u.prototype)).constructor = _,
    k
});

//GLightbox
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self).GLightbox = e()
}(this, (function() {
    "use strict";
    function t(e) {
        return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        }
        : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        }
        )(e)
    }
    function e(t, e) {
        if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function")
    }
    function i(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1,
            n.configurable = !0,
            "value"in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n)
        }
    }
    function n(t, e, n) {
        return e && i(t.prototype, e),
        n && i(t, n),
        t
    }
    function s(t) {
        return function(t) {
            if (Array.isArray(t)) {
                for (var e = 0, i = new Array(t.length); e < t.length; e++)
                    i[e] = t[e];
                return i
            }
        }(t) || function(t) {
            if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))
                return Array.from(t)
        }(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance")
        }()
    }
    function o(t) {
        return Math.sqrt(t.x * t.x + t.y * t.y)
    }
    function l(t, e) {
        var i = function(t, e) {
            var i = o(t) * o(e);
            if (0 === i)
                return 0;
            var n = function(t, e) {
                return t.x * e.x + t.y * e.y
            }(t, e) / i;
            return n > 1 && (n = 1),
            Math.acos(n)
        }(t, e);
        return function(t, e) {
            return t.x * e.y - e.x * t.y
        }(t, e) > 0 && (i *= -1),
        180 * i / Math.PI
    }
    var r = function() {
        function t(i) {
            e(this, t),
            this.handlers = [],
            this.el = i
        }
        return n(t, [{
            key: "add",
            value: function(t) {
                this.handlers.push(t)
            }
        }, {
            key: "del",
            value: function(t) {
                t || (this.handlers = []);
                for (var e = this.handlers.length; e >= 0; e--)
                    this.handlers[e] === t && this.handlers.splice(e, 1)
            }
        }, {
            key: "dispatch",
            value: function() {
                for (var t = 0, e = this.handlers.length; t < e; t++) {
                    var i = this.handlers[t];
                    "function" == typeof i && i.apply(this.el, arguments)
                }
            }
        }]),
        t
    }();
    function a(t, e) {
        var i = new r(t);
        return i.add(e),
        i
    }
    var h = function() {
        function t(i, n) {
            e(this, t),
            this.element = "string" == typeof i ? document.querySelector(i) : i,
            this.start = this.start.bind(this),
            this.move = this.move.bind(this),
            this.end = this.end.bind(this),
            this.cancel = this.cancel.bind(this),
            this.element.addEventListener("touchstart", this.start, !1),
            this.element.addEventListener("touchmove", this.move, !1),
            this.element.addEventListener("touchend", this.end, !1),
            this.element.addEventListener("touchcancel", this.cancel, !1),
            this.preV = {
                x: null,
                y: null
            },
            this.pinchStartLen = null,
            this.zoom = 1,
            this.isDoubleTap = !1;
            var s = function() {};
            this.rotate = a(this.element, n.rotate || s),
            this.touchStart = a(this.element, n.touchStart || s),
            this.multipointStart = a(this.element, n.multipointStart || s),
            this.multipointEnd = a(this.element, n.multipointEnd || s),
            this.pinch = a(this.element, n.pinch || s),
            this.swipe = a(this.element, n.swipe || s),
            this.tap = a(this.element, n.tap || s),
            this.doubleTap = a(this.element, n.doubleTap || s),
            this.longTap = a(this.element, n.longTap || s),
            this.singleTap = a(this.element, n.singleTap || s),
            this.pressMove = a(this.element, n.pressMove || s),
            this.twoFingerPressMove = a(this.element, n.twoFingerPressMove || s),
            this.touchMove = a(this.element, n.touchMove || s),
            this.touchEnd = a(this.element, n.touchEnd || s),
            this.touchCancel = a(this.element, n.touchCancel || s),
            this._cancelAllHandler = this.cancelAll.bind(this),
            window.addEventListener("scroll", this._cancelAllHandler),
            this.delta = null,
            this.last = null,
            this.now = null,
            this.tapTimeout = null,
            this.singleTapTimeout = null,
            this.longTapTimeout = null,
            this.swipeTimeout = null,
            this.x1 = this.x2 = this.y1 = this.y2 = null,
            this.preTapPosition = {
                x: null,
                y: null
            }
        }
        return n(t, [{
            key: "start",
            value: function(t) {
                if (t.touches) {
                    this.now = Date.now(),
                    this.x1 = t.touches[0].pageX,
                    this.y1 = t.touches[0].pageY,
                    this.delta = this.now - (this.last || this.now),
                    this.touchStart.dispatch(t, this.element),
                    null !== this.preTapPosition.x && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30,
                    this.isDoubleTap && clearTimeout(this.singleTapTimeout)),
                    this.preTapPosition.x = this.x1,
                    this.preTapPosition.y = this.y1,
                    this.last = this.now;
                    var e = this.preV;
                    if (t.touches.length > 1) {
                        this._cancelLongTap(),
                        this._cancelSingleTap();
                        var i = {
                            x: t.touches[1].pageX - this.x1,
                            y: t.touches[1].pageY - this.y1
                        };
                        e.x = i.x,
                        e.y = i.y,
                        this.pinchStartLen = o(e),
                        this.multipointStart.dispatch(t, this.element)
                    }
                    this._preventTap = !1,
                    this.longTapTimeout = setTimeout(function() {
                        this.longTap.dispatch(t, this.element),
                        this._preventTap = !0
                    }
                    .bind(this), 750)
                }
            }
        }, {
            key: "move",
            value: function(t) {
                if (t.touches) {
                    var e = this.preV
                      , i = t.touches.length
                      , n = t.touches[0].pageX
                      , s = t.touches[0].pageY;
                    if (this.isDoubleTap = !1,
                    i > 1) {
                        var r = t.touches[1].pageX
                          , a = t.touches[1].pageY
                          , h = {
                            x: t.touches[1].pageX - n,
                            y: t.touches[1].pageY - s
                        };
                        null !== e.x && (this.pinchStartLen > 0 && (t.zoom = o(h) / this.pinchStartLen,
                        this.pinch.dispatch(t, this.element)),
                        t.angle = l(h, e),
                        this.rotate.dispatch(t, this.element)),
                        e.x = h.x,
                        e.y = h.y,
                        null !== this.x2 && null !== this.sx2 ? (t.deltaX = (n - this.x2 + r - this.sx2) / 2,
                        t.deltaY = (s - this.y2 + a - this.sy2) / 2) : (t.deltaX = 0,
                        t.deltaY = 0),
                        this.twoFingerPressMove.dispatch(t, this.element),
                        this.sx2 = r,
                        this.sy2 = a
                    } else {
                        if (null !== this.x2) {
                            t.deltaX = n - this.x2,
                            t.deltaY = s - this.y2;
                            var c = Math.abs(this.x1 - this.x2)
                              , u = Math.abs(this.y1 - this.y2);
                            (c > 10 || u > 10) && (this._preventTap = !0)
                        } else
                            t.deltaX = 0,
                            t.deltaY = 0;
                        this.pressMove.dispatch(t, this.element)
                    }
                    this.touchMove.dispatch(t, this.element),
                    this._cancelLongTap(),
                    this.x2 = n,
                    this.y2 = s,
                    i > 1 && t.preventDefault()
                }
            }
        }, {
            key: "end",
            value: function(t) {
                if (t.changedTouches) {
                    this._cancelLongTap();
                    var e = this;
                    t.touches.length < 2 && (this.multipointEnd.dispatch(t, this.element),
                    this.sx2 = this.sy2 = null),
                    this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (t.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2),
                    this.swipeTimeout = setTimeout((function() {
                        e.swipe.dispatch(t, e.element)
                    }
                    ), 0)) : (this.tapTimeout = setTimeout((function() {
                        e._preventTap || e.tap.dispatch(t, e.element),
                        e.isDoubleTap && (e.doubleTap.dispatch(t, e.element),
                        e.isDoubleTap = !1)
                    }
                    ), 0),
                    e.isDoubleTap || (e.singleTapTimeout = setTimeout((function() {
                        e.singleTap.dispatch(t, e.element)
                    }
                    ), 250))),
                    this.touchEnd.dispatch(t, this.element),
                    this.preV.x = 0,
                    this.preV.y = 0,
                    this.zoom = 1,
                    this.pinchStartLen = null,
                    this.x1 = this.x2 = this.y1 = this.y2 = null
                }
            }
        }, {
            key: "cancelAll",
            value: function() {
                this._preventTap = !0,
                clearTimeout(this.singleTapTimeout),
                clearTimeout(this.tapTimeout),
                clearTimeout(this.longTapTimeout),
                clearTimeout(this.swipeTimeout)
            }
        }, {
            key: "cancel",
            value: function(t) {
                this.cancelAll(),
                this.touchCancel.dispatch(t, this.element)
            }
        }, {
            key: "_cancelLongTap",
            value: function() {
                clearTimeout(this.longTapTimeout)
            }
        }, {
            key: "_cancelSingleTap",
            value: function() {
                clearTimeout(this.singleTapTimeout)
            }
        }, {
            key: "_swipeDirection",
            value: function(t, e, i, n) {
                return Math.abs(t - e) >= Math.abs(i - n) ? t - e > 0 ? "Left" : "Right" : i - n > 0 ? "Up" : "Down"
            }
        }, {
            key: "on",
            value: function(t, e) {
                this[t] && this[t].add(e)
            }
        }, {
            key: "off",
            value: function(t, e) {
                this[t] && this[t].del(e)
            }
        }, {
            key: "destroy",
            value: function() {
                return this.singleTapTimeout && clearTimeout(this.singleTapTimeout),
                this.tapTimeout && clearTimeout(this.tapTimeout),
                this.longTapTimeout && clearTimeout(this.longTapTimeout),
                this.swipeTimeout && clearTimeout(this.swipeTimeout),
                this.element.removeEventListener("touchstart", this.start),
                this.element.removeEventListener("touchmove", this.move),
                this.element.removeEventListener("touchend", this.end),
                this.element.removeEventListener("touchcancel", this.cancel),
                this.rotate.del(),
                this.touchStart.del(),
                this.multipointStart.del(),
                this.multipointEnd.del(),
                this.pinch.del(),
                this.swipe.del(),
                this.tap.del(),
                this.doubleTap.del(),
                this.longTap.del(),
                this.singleTap.del(),
                this.pressMove.del(),
                this.twoFingerPressMove.del(),
                this.touchMove.del(),
                this.touchEnd.del(),
                this.touchCancel.del(),
                this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null,
                window.removeEventListener("scroll", this._cancelAllHandler),
                null
            }
        }]),
        t
    }()
      , c = function() {
        function t(i, n) {
            var s = this
              , o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            if (e(this, t),
            this.img = i,
            this.slide = n,
            this.onclose = o,
            this.img.setZoomEvents)
                return !1;
            this.active = !1,
            this.zoomedIn = !1,
            this.dragging = !1,
            this.currentX = null,
            this.currentY = null,
            this.initialX = null,
            this.initialY = null,
            this.xOffset = 0,
            this.yOffset = 0,
            this.img.addEventListener("mousedown", (function(t) {
                return s.dragStart(t)
            }
            ), !1),
            this.img.addEventListener("mouseup", (function(t) {
                return s.dragEnd(t)
            }
            ), !1),
            this.img.addEventListener("mousemove", (function(t) {
                return s.drag(t)
            }
            ), !1),
            this.img.addEventListener("click", (function(t) {
                if (!s.zoomedIn)
                    return s.zoomIn();
                s.zoomedIn && !s.dragging && s.zoomOut()
            }
            ), !1),
            this.img.setZoomEvents = !0
        }
        return n(t, [{
            key: "zoomIn",
            value: function() {
                var t = this.widowWidth();
                if (!(this.zoomedIn || t <= 768)) {
                    var e = this.img;
                    if (e.setAttribute("data-style", e.getAttribute("style")),
                    e.style.maxWidth = e.naturalWidth + "px",
                    e.style.maxHeight = e.naturalHeight + "px",
                    e.naturalWidth > t) {
                        var i = t / 2 - e.naturalWidth / 2;
                        this.setTranslate(this.img.parentNode, i, 0)
                    }
                    this.slide.classList.add("zoomed"),
                    this.zoomedIn = !0
                }
            }
        }, {
            key: "zoomOut",
            value: function() {
                this.img.parentNode.setAttribute("style", ""),
                this.img.setAttribute("style", this.img.getAttribute("data-style")),
                this.slide.classList.remove("zoomed"),
                this.zoomedIn = !1,
                this.currentX = null,
                this.currentY = null,
                this.initialX = null,
                this.initialY = null,
                this.xOffset = 0,
                this.yOffset = 0,
                this.onclose && "function" == typeof this.onclose && this.onclose()
            }
        }, {
            key: "dragStart",
            value: function(t) {
                t.preventDefault(),
                this.zoomedIn ? ("touchstart" === t.type ? (this.initialX = t.touches[0].clientX - this.xOffset,
                this.initialY = t.touches[0].clientY - this.yOffset) : (this.initialX = t.clientX - this.xOffset,
                this.initialY = t.clientY - this.yOffset),
                t.target === this.img && (this.active = !0,
                this.img.classList.add("dragging"))) : this.active = !1
            }
        }, {
            key: "dragEnd",
            value: function(t) {
                var e = this;
                t.preventDefault(),
                this.initialX = this.currentX,
                this.initialY = this.currentY,
                this.active = !1,
                setTimeout((function() {
                    e.dragging = !1,
                    e.img.isDragging = !1,
                    e.img.classList.remove("dragging")
                }
                ), 100)
            }
        }, {
            key: "drag",
            value: function(t) {
                this.active && (t.preventDefault(),
                "touchmove" === t.type ? (this.currentX = t.touches[0].clientX - this.initialX,
                this.currentY = t.touches[0].clientY - this.initialY) : (this.currentX = t.clientX - this.initialX,
                this.currentY = t.clientY - this.initialY),
                this.xOffset = this.currentX,
                this.yOffset = this.currentY,
                this.img.isDragging = !0,
                this.dragging = !0,
                this.setTranslate(this.img, this.currentX, this.currentY))
            }
        }, {
            key: "onMove",
            value: function(t) {
                if (this.zoomedIn) {
                    var e = t.clientX - this.img.naturalWidth / 2
                      , i = t.clientY - this.img.naturalHeight / 2;
                    this.setTranslate(this.img, e, i)
                }
            }
        }, {
            key: "setTranslate",
            value: function(t, e, i) {
                t.style.transform = "translate3d(" + e + "px, " + i + "px, 0)"
            }
        }, {
            key: "widowWidth",
            value: function() {
                return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            }
        }]),
        t
    }()
      , u = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i)
      , d = null !== u || void 0 !== document.createTouch || "ontouchstart"in window || "onmsgesturechange"in window || navigator.msMaxTouchPoints
      , g = document.getElementsByTagName("html")[0]
      , p = function() {
        var t, e = document.createElement("fakeelement"), i = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd"
        };
        for (t in i)
            if (void 0 !== e.style[t])
                return i[t]
    }()
      , v = function() {
        var t, e = document.createElement("fakeelement"), i = {
            animation: "animationend",
            OAnimation: "oAnimationEnd",
            MozAnimation: "animationend",
            WebkitAnimation: "webkitAnimationEnd"
        };
        for (t in i)
            if (void 0 !== e.style[t])
                return i[t]
    }()
      , f = Date.now()
      , m = {}
      , y = {
        selector: "glightbox",
        elements: null,
        skin: "clean",
        closeButton: !0,
        startAt: null,
        autoplayVideos: !0,
        descPosition: "bottom",
        width: 900,
        height: 506,
        videosWidth: 960,
        beforeSlideChange: null,
        afterSlideChange: null,
        beforeSlideLoad: null,
        afterSlideLoad: null,
        onOpen: null,
        onClose: null,
        loop: !1,
        touchNavigation: !0,
        touchFollowAxis: !0,
        keyboardNavigation: !0,
        closeOnOutsideClick: !0,
        plyr: {
            css: "https://cdn.plyr.io/3.5.6/plyr.css",
            js: "https://cdn.plyr.io/3.5.6/plyr.js",
            ratio: "16:9",
            config: {
                youtube: {
                    noCookie: !0,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3
                },
                vimeo: {
                    byline: !1,
                    portrait: !1,
                    title: !1,
                    transparent: !1
                }
            }
        },
        openEffect: "zoomIn",
        closeEffect: "zoomOut",
        slideEffect: "slide",
        moreText: "See more",
        moreLength: 60,
        lightboxHtml: "",
        cssEfects: {
            fade: {
                in: "fadeIn",
                out: "fadeOut"
            },
            zoom: {
                in: "zoomIn",
                out: "zoomOut"
            },
            slide: {
                in: "slideInRight",
                out: "slideOutLeft"
            },
            slide_back: {
                in: "slideInLeft",
                out: "slideOutRight"
            }
        },
        svg: {
            close: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',
            next: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',
            prev: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>'
        }
    };
    y.slideHtml = '<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>';
    function b() {
        var t = {}
          , e = !1
          , i = 0
          , n = arguments.length;
        "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (e = arguments[0],
        i++);
        for (var s = function(i) {
            for (var n in i)
                Object.prototype.hasOwnProperty.call(i, n) && (e && "[object Object]" === Object.prototype.toString.call(i[n]) ? t[n] = b(!0, t[n], i[n]) : t[n] = i[n])
        }; i < n; i++) {
            s(arguments[i])
        }
        return t
    }
    y.lightboxHtml = '<div id="glightbox-body" class="glightbox-container">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gnext gbtn" tabindex="0">{nextSVG}</button>\n    <button class="gprev gbtn" tabindex="1">{prevSVG}</button>\n    <button class="gclose gbtn" tabindex="2">{closeSVG}</button>\n</div>\n</div>';
    var x = {
        isFunction: function(t) {
            return "function" == typeof t
        },
        isString: function(t) {
            return "string" == typeof t
        },
        isNode: function(t) {
            return !(!t || !t.nodeType || 1 != t.nodeType)
        },
        isArray: function(t) {
            return Array.isArray(t)
        },
        isArrayLike: function(t) {
            return t && t.length && isFinite(t.length)
        },
        isObject: function(e) {
            return "object" === t(e) && null != e && !x.isFunction(e) && !x.isArray(e)
        },
        isNil: function(t) {
            return null == t
        },
        has: function(t, e) {
            return null !== t && hasOwnProperty.call(t, e)
        },
        size: function(t) {
            if (x.isObject(t)) {
                if (t.keys)
                    return t.keys().length;
                var e = 0;
                for (var i in t)
                    x.has(t, i) && e++;
                return e
            }
            return t.length
        },
        isNumber: function(t) {
            return !isNaN(parseFloat(t)) && isFinite(t)
        }
    };
    function w(t, e) {
        if ((x.isNode(t) || t === window || t === document) && (t = [t]),
        x.isArrayLike(t) || x.isObject(t) || (t = [t]),
        0 != x.size(t))
            if (x.isArrayLike(t) && !x.isObject(t))
                for (var i = t.length, n = 0; n < i && !1 !== e.call(t[n], t[n], n, t); n++)
                    ;
            else if (x.isObject(t))
                for (var s in t)
                    if (x.has(t, s) && !1 === e.call(t[s], t[s], s, t))
                        break
    }
    function S(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null
          , i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null
          , n = t[f] = t[f] || []
          , s = {
            all: n,
            evt: null,
            found: null
        };
        return e && i && x.size(n) > 0 && w(n, (function(t, n) {
            if (t.eventName == e && t.fn.toString() == i.toString())
                return s.found = !0,
                s.evt = n,
                !1
        }
        )),
        s
    }
    function T(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
          , i = e.onElement
          , n = e.withCallback
          , s = e.avoidDuplicate
          , o = void 0 === s || s
          , l = e.once
          , r = void 0 !== l && l
          , a = e.useCapture
          , h = void 0 !== a && a
          , c = arguments.length > 2 ? arguments[2] : void 0
          , u = i || [];
        function d(t) {
            x.isFunction(n) && n.call(c, t, this),
            r && d.destroy()
        }
        return x.isString(u) && (u = document.querySelectorAll(u)),
        d.destroy = function() {
            w(u, (function(e) {
                var i = S(e, t, d);
                i.found && i.all.splice(i.evt, 1),
                e.removeEventListener && e.removeEventListener(t, d, h)
            }
            ))
        }
        ,
        w(u, (function(e) {
            var i = S(e, t, d);
            (e.addEventListener && o && !i.found || !o) && (e.addEventListener(t, d, h),
            i.all.push({
                eventName: t,
                fn: d
            }))
        }
        )),
        d
    }
    function k(t, e) {
        w(e.split(" "), (function(e) {
            return t.classList.add(e)
        }
        ))
    }
    function E(t, e) {
        w(e.split(" "), (function(e) {
            return t.classList.remove(e)
        }
        ))
    }
    function A(t, e) {
        return t.classList.contains(e)
    }
    function C(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
          , i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!t || "" === e)
            return !1;
        if ("none" == e)
            return x.isFunction(i) && i(),
            !1;
        var n = e.split(" ");
        w(n, (function(e) {
            k(t, "g" + e)
        }
        )),
        T(v, {
            onElement: t,
            avoidDuplicate: !1,
            once: !0,
            withCallback: function(t, e) {
                w(n, (function(t) {
                    E(e, "g" + t)
                }
                )),
                x.isFunction(i) && i()
            }
        })
    }
    function L(t) {
        var e = document.createDocumentFragment()
          , i = document.createElement("div");
        for (i.innerHTML = t; i.firstChild; )
            e.appendChild(i.firstChild);
        return e
    }
    function M(t, e) {
        for (; t !== document.body; ) {
            if ("function" == typeof (t = t.parentElement).matches ? t.matches(e) : t.msMatchesSelector(e))
                return t
        }
    }
    function O(t) {
        t.style.display = "block"
    }
    function z(t) {
        t.style.display = "none"
    }
    function q() {
        return {
            width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        }
    }
    function N(t) {
        if (A(t.target, "plyr--html5")) {
            var e = M(t.target, ".gslide-media");
            "enterfullscreen" == t.type && k(e, "fullscreen"),
            "exitfullscreen" == t.type && E(e, "fullscreen")
        }
    }
    var I = function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null
          , e = arguments.length > 1 ? arguments[1] : void 0
          , i = {
            href: "",
            title: "",
            type: "",
            description: "",
            descPosition: e.descPosition,
            effect: "",
            width: "",
            height: "",
            node: t
        };
        if (x.isObject(t) && !x.isNode(t))
            return b(i, t);
        var n = ""
          , s = t.getAttribute("data-glightbox")
          , o = t.nodeName.toLowerCase();
        if ("a" === o && (n = t.href),
        "img" === o && (n = t.src),
        i.href = n,
        w(i, (function(n, s) {
            x.has(e, s) && "width" !== s && (i[s] = e[s]);
            var o = t.dataset[s];
            x.isNil(o) || (i[s] = o)
        }
        )),
        i.type || (i.type = W(n)),
        x.isNil(s)) {
            if ("a" == o) {
                var l = t.title;
                x.isNil(l) || "" === l || (i.title = l)
            }
            if ("img" == o) {
                var r = t.alt;
                x.isNil(r) || "" === r || (i.title = r)
            }
            var a = t.getAttribute("data-description");
            x.isNil(a) || "" === a || (i.description = a)
        } else {
            var h = [];
            w(i, (function(t, e) {
                h.push(";\\s?" + e)
            }
            )),
            h = h.join("\\s?:|"),
            "" !== s.trim() && w(i, (function(t, e) {
                var n = s
                  , o = new RegExp("s?" + e + "s?:s?(.*?)(" + h + "s?:|$)")
                  , l = n.match(o);
                if (l && l.length && l[1]) {
                    var r = l[1].trim().replace(/;\s*$/, "");
                    i[e] = r
                }
            }
            ))
        }
        if (i.description && "." == i.description.substring(0, 1) && document.querySelector(i.description))
            i.description = document.querySelector(i.description).innerHTML;
        else {
            var c = t.querySelector(".glightbox-desc");
            c && (i.description = c.innerHTML)
        }
        var u = "video" == i.type ? e.videosWidth : e.width
          , d = e.height;
        return i.width = x.has(i, "width") && "" !== i.width ? i.width : u,
        i.height = x.has(i, "height") && "" !== i.height ? i.height : d,
        i
    }
      , D = function() {
        var t = this
          , e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null
          , i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
          , n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (A(e, "loaded"))
            return !1;
        x.isFunction(this.settings.beforeSlideLoad) && this.settings.beforeSlideLoad(e, i);
        var s = i.type
          , o = i.descPosition
          , l = e.querySelector(".gslide-media")
          , r = e.querySelector(".gslide-title")
          , a = e.querySelector(".gslide-desc")
          , h = e.querySelector(".gdesc-inner")
          , d = n;
        if (x.isFunction(this.settings.afterSlideLoad) && (d = function() {
            x.isFunction(n) && n(),
            t.settings.afterSlideLoad(e, i)
        }
        ),
        "" == i.title && "" == i.description ? h && h.parentNode.parentNode.removeChild(h.parentNode) : (r && "" !== i.title ? r.innerHTML = i.title : r.parentNode.removeChild(r),
        a && "" !== i.description ? u && this.settings.moreLength > 0 ? (i.smallDescription = G(i.description, this.settings.moreLength, this.settings.moreText),
        a.innerHTML = i.smallDescription,
        Z.apply(this, [a, i])) : a.innerHTML = i.description : a.parentNode.removeChild(a),
        k(l.parentNode, "desc-".concat(o)),
        k(h.parentNode, "description-".concat(o))),
        k(l, "gslide-".concat(s)),
        k(e, "loaded"),
        "video" === s)
            return k(l.parentNode, "gvideo-container"),
            l.insertBefore(L('<div class="gvideo-wrapper"></div>'), l.firstChild),
            void X.apply(this, [e, i, d]);
        if ("external" === s) {
            var g = Y({
                url: i.href,
                width: i.width,
                height: i.height,
                callback: d
            });
            return l.parentNode.style.maxWidth = "".concat(i.width, "px"),
            void l.appendChild(g)
        }
        if ("inline" !== s) {
            if ("image" === s) {
                var p = new Image;
                return p.addEventListener("load", (function() {
                    !u && p.naturalWidth > p.offsetWidth && (k(p, "zoomable"),
                    new c(p,e,(function() {
                        t.resize(e)
                    }
                    ))),
                    x.isFunction(d) && d()
                }
                ), !1),
                p.src = i.href,
                void l.insertBefore(p, l.firstChild)
            }
            x.isFunction(d) && d()
        } else
            P.apply(this, [e, i, d])
    };
    function X(t, e, i) {
        var n = this
          , s = "gvideo" + e.index
          , o = t.querySelector(".gvideo-wrapper");
        B(this.settings.plyr.css);
        var l = e.href
          , r = location.protocol.replace(":", "")
          , a = ""
          , h = ""
          , c = !1;
        "file" == r && (r = "http"),
        o.parentNode.style.maxWidth = "".concat(e.width, "px"),
        B(this.settings.plyr.js, "Plyr", (function() {
            if (l.match(/vimeo\.com\/([0-9]*)/)) {
                var t = /vimeo.*\/(\d+)/i.exec(l);
                a = "vimeo",
                h = t[1]
            }
            if (l.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || l.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || l.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)) {
                var r = function(t) {
                    var e = "";
                    e = void 0 !== (t = t.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/))[2] ? (e = t[2].split(/[^0-9a-z_\-]/i))[0] : t;
                    return e
                }(l);
                a = "youtube",
                h = r
            }
            if (null !== l.match(/\.(mp4|ogg|webm|mov)$/)) {
                a = "local";
                var u = '<video id="' + s + '" ';
                u += 'style="background:#000; max-width: '.concat(e.width, 'px;" '),
                u += 'preload="metadata" ',
                u += 'x-webkit-airplay="allow" ',
                u += 'webkit-playsinline="" ',
                u += "controls ",
                u += 'class="gvideo-local">';
                var d = l.toLowerCase().split(".").pop()
                  , g = {
                    mp4: "",
                    ogg: "",
                    webm: ""
                };
                for (var p in g[d = "mov" == d ? "mp4" : d] = l,
                g)
                    if (g.hasOwnProperty(p)) {
                        var v = g[p];
                        e.hasOwnProperty(p) && (v = e[p]),
                        "" !== v && (u += '<source src="'.concat(v, '" type="video/').concat(p, '">'))
                    }
                c = L(u += "</video>")
            }
            var f = c || L('<div id="'.concat(s, '" data-plyr-provider="').concat(a, '" data-plyr-embed-id="').concat(h, '"></div>'));
            k(o, "".concat(a, "-video gvideo")),
            o.appendChild(f),
            o.setAttribute("data-id", s);
            var y = x.has(n.settings.plyr, "config") ? n.settings.plyr.config : {}
              , b = new Plyr("#" + s,y);
            b.on("ready", (function(t) {
                var e = t.detail.plyr;
                m[s] = e,
                x.isFunction(i) && i()
            }
            )),
            b.on("enterfullscreen", N),
            b.on("exitfullscreen", N)
        }
        ))
    }
    function Y(t) {
        var e = t.url
          , i = t.width
          , n = t.height
          , s = t.allow
          , o = t.callback
          , l = t.appendTo
          , r = document.createElement("iframe")
          , a = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return r.className = "vimeo-video gvideo",
        r.src = e,
        n && (r.style.height = u && a < 767 ? "" : "".concat(n, "px")),
        i && (r.style.width = "".concat(i, "px")),
        s && r.setAttribute("allow", s),
        r.onload = function() {
            k(r, "node-ready"),
            x.isFunction(o) && o()
        }
        ,
        l && l.appendChild(r),
        r
    }
    function B(t, e, i) {
        if (x.isNil(t))
            console.error("Inject videos api error");
        else {
            var n;
            if (x.isFunction(e) && (i = e,
            e = !1),
            -1 !== t.indexOf(".css")) {
                if ((n = document.querySelectorAll('link[href="' + t + '"]')) && n.length > 0)
                    return void (x.isFunction(i) && i());
                var s = document.getElementsByTagName("head")[0]
                  , o = s.querySelectorAll('link[rel="stylesheet"]')
                  , l = document.createElement("link");
                return l.rel = "stylesheet",
                l.type = "text/css",
                l.href = t,
                l.media = "all",
                o ? s.insertBefore(l, o[0]) : s.appendChild(l),
                void (x.isFunction(i) && i())
            }
            if ((n = document.querySelectorAll('script[src="' + t + '"]')) && n.length > 0) {
                if (x.isFunction(i)) {
                    if (x.isString(e))
                        return F((function() {
                            return void 0 !== window[e]
                        }
                        ), (function() {
                            i()
                        }
                        )),
                        !1;
                    i()
                }
            } else {
                var r = document.createElement("script");
                r.type = "text/javascript",
                r.src = t,
                r.onload = function() {
                    if (x.isFunction(i)) {
                        if (x.isString(e))
                            return F((function() {
                                return void 0 !== window[e]
                            }
                            ), (function() {
                                i()
                            }
                            )),
                            !1;
                        i()
                    }
                }
                ,
                document.body.appendChild(r)
            }
        }
    }
    function F(t, e, i, n) {
        if (t())
            e();
        else {
            var s;
            i || (i = 100);
            var o = setInterval((function() {
                t() && (clearInterval(o),
                s && clearTimeout(s),
                e())
            }
            ), i);
            n && (s = setTimeout((function() {
                clearInterval(o)
            }
            ), n))
        }
    }
    function P(t, e, i) {
        var n = this
          , s = t.querySelector(".gslide-media")
          , o = e.href.split("#").pop().trim()
          , l = document.getElementById(o);
        if (!l)
            return !1;
        var r = l.cloneNode(!0);
        r.style.height = x.isNumber(e.height) ? "".concat(e.height, "px") : e.height,
        r.style.maxWidth = x.isNumber(e.width) ? "".concat(e.width, "px") : e.width,
        k(r, "ginlined-content"),
        s.appendChild(r),
        this.events["inlineclose" + o] = T("click", {
            onElement: s.querySelectorAll(".gtrigger-close"),
            withCallback: function(t) {
                t.preventDefault(),
                n.close()
            }
        }),
        x.isFunction(i) && i()
    }
    var W = function(t) {
        var e = t;
        if (null !== (t = t.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|svg)$/))
            return "image";
        if (t.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || t.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || t.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/))
            return "video";
        if (t.match(/vimeo\.com\/([0-9]*)/))
            return "video";
        if (null !== t.match(/\.(mp4|ogg|webm|mov)$/))
            return "video";
        if (t.indexOf("#") > -1 && "" !== e.split("#").pop().trim())
            return "inline";
        return t.includes("gajax=true") ? "ajax" : "external"
    };
    function _() {
        var t = this;
        if (this.events.hasOwnProperty("keyboard"))
            return !1;
        this.events.keyboard = T("keydown", {
            onElement: window,
            withCallback: function(e, i) {
                var n = (e = e || window.event).keyCode;
                if (9 == n) {
                    e.preventDefault();
                    var o = document.querySelectorAll(".gbtn");
                    if (!o || o.length <= 0)
                        return;
                    var l = s(o).filter((function(t) {
                        return A(t, "focused")
                    }
                    ));
                    if (!l.length) {
                        var r = document.querySelector('.gbtn[tabindex="0"]');
                        return void (r && (r.focus(),
                        k(r, "focused")))
                    }
                    o.forEach((function(t) {
                        return E(t, "focused")
                    }
                    ));
                    var a = l[0].getAttribute("tabindex");
                    a = a || "0";
                    var h = parseInt(a) + 1;
                    h > o.length - 1 && (h = "0");
                    var c = document.querySelector('.gbtn[tabindex="'.concat(h, '"]'));
                    c && (c.focus(),
                    k(c, "focused"))
                }
                39 == n && t.nextSlide(),
                37 == n && t.prevSlide(),
                27 == n && t.close()
            }
        })
    }
    function j() {
        var t = this;
        if (this.events.hasOwnProperty("touch"))
            return !1;
        var e, i, n, s = q(), o = s.width, l = s.height, r = !1, a = null, c = null, u = null, d = !1, g = 1, p = 1, v = !1, f = !1, m = null, y = null, b = null, x = null, w = 0, S = 0, T = !1, C = !1, L = {}, M = {}, O = 0, z = 0, N = this, I = document.getElementById("glightbox-slider"), D = document.querySelector(".goverlay"), X = (this.loop(),
        new h(I,{
            touchStart: function(t) {
                if (A(t.targetTouches[0].target, "ginner-container"))
                    return r = !1,
                    !1;
                r = !0,
                M = t.targetTouches[0],
                L.pageX = t.targetTouches[0].pageX,
                L.pageY = t.targetTouches[0].pageY,
                O = t.targetTouches[0].clientX,
                z = t.targetTouches[0].clientY,
                a = N.activeSlide,
                c = a.querySelector(".gslide-media"),
                n = a.querySelector(".gslide-inline"),
                u = null,
                A(c, "gslide-image") && (u = c.querySelector("img")),
                E(D, "greset")
            },
            touchMove: function(s) {
                if (r && (M = s.targetTouches[0],
                !v && !f)) {
                    if (n && n.offsetHeight > l) {
                        var a = L.pageX - M.pageX;
                        if (Math.abs(a) <= 13)
                            return !1
                    }
                    d = !0;
                    var h, g = s.targetTouches[0].clientX, p = s.targetTouches[0].clientY, m = O - g, y = z - p;
                    if (Math.abs(m) > Math.abs(y) ? (T = !1,
                    C = !0) : (C = !1,
                    T = !0),
                    e = M.pageX - L.pageX,
                    w = 100 * e / o,
                    i = M.pageY - L.pageY,
                    S = 100 * i / l,
                    T && u && (h = 1 - Math.abs(i) / l,
                    D.style.opacity = h,
                    t.settings.touchFollowAxis && (w = 0)),
                    C && (h = 1 - Math.abs(e) / o,
                    c.style.opacity = h,
                    t.settings.touchFollowAxis && (S = 0)),
                    !u)
                        return H(c, "translate3d(".concat(w, "%, 0, 0)"));
                    H(c, "translate3d(".concat(w, "%, ").concat(S, "%, 0)"))
                }
            },
            touchEnd: function() {
                if (r) {
                    if (d = !1,
                    f || v)
                        return b = m,
                        void (x = y);
                    var e = Math.abs(parseInt(S))
                      , i = Math.abs(parseInt(w));
                    if (!(e > 29 && u))
                        return e < 29 && i < 25 ? (k(D, "greset"),
                        D.style.opacity = 1,
                        V(c)) : void 0;
                    t.close()
                }
            },
            multipointEnd: function() {
                setTimeout((function() {
                    v = !1
                }
                ), 50)
            },
            multipointStart: function() {
                v = !0,
                g = p || 1
            },
            pinch: function(t) {
                if (!u || d)
                    return !1;
                v = !0,
                u.scaleX = u.scaleY = g * t.zoom;
                var e = g * t.zoom;
                if (f = !0,
                e <= 1)
                    return f = !1,
                    e = 1,
                    x = null,
                    b = null,
                    m = null,
                    y = null,
                    void u.setAttribute("style", "");
                e > 4.5 && (e = 4.5),
                u.style.transform = "scale3d(".concat(e, ", ").concat(e, ", 1)"),
                p = e
            },
            pressMove: function(t) {
                if (f && !v) {
                    var e = M.pageX - L.pageX
                      , i = M.pageY - L.pageY;
                    b && (e += b),
                    x && (i += x),
                    m = e,
                    y = i;
                    var n = "translate3d(".concat(e, "px, ").concat(i, "px, 0)");
                    p && (n += " scale3d(".concat(p, ", ").concat(p, ", 1)")),
                    H(u, n)
                }
            },
            swipe: function(e) {
                if (!f)
                    if (v)
                        v = !1;
                    else {
                        if ("Left" == e.direction) {
                            if (t.index == t.elements.length - 1)
                                return V(c);
                            t.nextSlide()
                        }
                        if ("Right" == e.direction) {
                            if (0 == t.index)
                                return V(c);
                            t.prevSlide()
                        }
                    }
            }
        }));
        this.events.touch = X
    }
    function H(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if ("" == e)
            return t.style.webkitTransform = "",
            t.style.MozTransform = "",
            t.style.msTransform = "",
            t.style.OTransform = "",
            t.style.transform = "",
            !1;
        t.style.webkitTransform = e,
        t.style.MozTransform = e,
        t.style.msTransform = e,
        t.style.OTransform = e,
        t.style.transform = e
    }
    function V(t) {
        var e = A(t, "gslide-media") ? t : t.querySelector(".gslide-media")
          , i = t.querySelector(".gslide-description");
        k(e, "greset"),
        H(e, "translate3d(0, 0, 0)");
        T(p, {
            onElement: e,
            once: !0,
            withCallback: function(t, i) {
                E(e, "greset")
            }
        });
        e.style.opacity = "",
        i && (i.style.opacity = "")
    }
    function G(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50
          , i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
          , n = i;
        if ((t = t.trim()).length <= e)
            return t;
        var s = t.substr(0, e - 1);
        return n ? s + '... <a href="#" class="desc-more">' + i + "</a>" : s
    }
    function Z(t, e) {
        var i = t.querySelector(".desc-more");
        if (!i)
            return !1;
        T("click", {
            onElement: i,
            withCallback: function(t, i) {
                t.preventDefault();
                var n = document.body
                  , s = M(i, ".gslide-desc");
                if (!s)
                    return !1;
                s.innerHTML = e.description,
                k(n, "gdesc-open");
                var o = T("click", {
                    onElement: [n, M(s, ".gslide-description")],
                    withCallback: function(t, i) {
                        "a" !== t.target.nodeName.toLowerCase() && (E(n, "gdesc-open"),
                        k(n, "gdesc-closed"),
                        s.innerHTML = e.smallDescription,
                        Z(s, e),
                        setTimeout((function() {
                            E(n, "gdesc-closed")
                        }
                        ), 400),
                        o.destroy())
                    }
                })
            }
        })
    }
    var R = function() {
        function t(i) {
            e(this, t),
            this.settings = b(y, i || {}),
            this.effectsClasses = this.getAnimationClasses(),
            this.slidesData = {}
        }
        return n(t, [{
            key: "init",
            value: function() {
                var t = this;
                this.baseEvents = T("click", {
                    onElement: ".".concat(this.settings.selector),
                    withCallback: function(e, i) {
                        e.preventDefault(),
                        t.open(i)
                    }
                })
            }
        }, {
            key: "open",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (this.elements = this.getElements(t),
                0 == this.elements.length)
                    return !1;
                this.activeSlide = null,
                this.prevActiveSlideIndex = null,
                this.prevActiveSlide = null;
                var e = this.settings.startAt;
                t && x.isNil(e) && (e = this.elements.indexOf(t)) < 0 && (e = 0),
                x.isNil(e) && (e = 0),
                this.build(),
                C(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.in);
                var i = document.body;
                if (i.style.width = "".concat(i.offsetWidth, "px"),
                k(i, "glightbox-open"),
                k(g, "glightbox-open"),
                u && (k(document.body, "glightbox-mobile"),
                this.settings.slideEffect = "slide"),
                this.showSlide(e, !0),
                1 == this.elements.length ? (z(this.prevButton),
                z(this.nextButton)) : (O(this.prevButton),
                O(this.nextButton)),
                this.lightboxOpen = !0,
                x.isFunction(this.settings.onOpen) && this.settings.onOpen(),
                u && d && this.settings.touchNavigation)
                    return j.apply(this),
                    !1;
                this.settings.keyboardNavigation && _.apply(this)
            }
        }, {
            key: "showSlide",
            value: function() {
                var t = this
                  , e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0
                  , i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                O(this.loader),
                this.index = parseInt(e);
                var n = this.slidesContainer.querySelector(".current");
                n && E(n, "current"),
                this.slideAnimateOut();
                var s = this.slidesContainer.querySelectorAll(".gslide")[e];
                if (A(s, "loaded"))
                    this.slideAnimateIn(s, i),
                    z(this.loader);
                else {
                    O(this.loader);
                    var o = I(this.elements[e], this.settings);
                    o.index = e,
                    this.slidesData[e] = o,
                    D.apply(this, [s, o, function() {
                        z(t.loader),
                        t.resize(),
                        t.slideAnimateIn(s, i)
                    }
                    ])
                }
                this.slideDescription = s.querySelector(".gslide-description"),
                this.slideDescriptionContained = this.slideDescription && A(this.slideDescription.parentNode, "gslide-media"),
                this.preloadSlide(e + 1),
                this.preloadSlide(e - 1);
                var l = this.loop();
                E(this.nextButton, "disabled"),
                E(this.prevButton, "disabled"),
                0 !== e || l ? e !== this.elements.length - 1 || l || k(this.nextButton, "disabled") : k(this.prevButton, "disabled"),
                this.activeSlide = s
            }
        }, {
            key: "preloadSlide",
            value: function(t) {
                var e = this;
                if (t < 0 || t > this.elements.length)
                    return !1;
                if (x.isNil(this.elements[t]))
                    return !1;
                var i = this.slidesContainer.querySelectorAll(".gslide")[t];
                if (A(i, "loaded"))
                    return !1;
                var n = I(this.elements[t], this.settings);
                n.index = t,
                this.slidesData[t] = n;
                var s = n.sourcetype;
                "video" == s || "external" == s ? setTimeout((function() {
                    D.apply(e, [i, n])
                }
                ), 200) : D.apply(this, [i, n])
            }
        }, {
            key: "prevSlide",
            value: function() {
                this.goToSlide(this.index - 1)
            }
        }, {
            key: "nextSlide",
            value: function() {
                this.goToSlide(this.index + 1)
            }
        }, {
            key: "goToSlide",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                this.prevActiveSlide = this.activeSlide,
                this.prevActiveSlideIndex = this.index;
                var e = this.loop();
                if (!e && (t < 0 || t > this.elements.length))
                    return !1;
                t < 0 ? t = this.elements.length - 1 : t >= this.elements.length && (t = 0),
                this.showSlide(t)
            }
        }, {
            key: "slideAnimateIn",
            value: function(t, e) {
                var i = this
                  , n = t.querySelector(".gslide-media")
                  , s = t.querySelector(".gslide-description")
                  , o = {
                    index: this.prevActiveSlideIndex,
                    slide: this.prevActiveSlide
                }
                  , l = {
                    index: this.index,
                    slide: this.activeSlide
                };
                if (n.offsetWidth > 0 && s && (z(s),
                s.style.display = ""),
                E(t, this.effectsClasses),
                e)
                    C(t, this.settings.openEffect, (function() {
                        !u && i.settings.autoplayVideos && i.playSlideVideo(t),
                        x.isFunction(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [o, l])
                    }
                    ));
                else {
                    var r = this.settings.slideEffect
                      , a = "none" !== r ? this.settings.cssEfects[r].in : r;
                    this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (a = this.settings.cssEfects.slide_back.in),
                    C(t, a, (function() {
                        !u && i.settings.autoplayVideos && i.playSlideVideo(t),
                        x.isFunction(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [o, l])
                    }
                    ))
                }
                setTimeout((function() {
                    i.resize(t)
                }
                ), 100),
                k(t, "current")
            }
        }, {
            key: "slideAnimateOut",
            value: function() {
                if (!this.prevActiveSlide)
                    return !1;
                var t = this.prevActiveSlide;
                E(t, this.effectsClasses),
                k(t, "prev");
                var e = this.settings.slideEffect
                  , i = "none" !== e ? this.settings.cssEfects[e].out : e;
                this.stopSlideVideo(t),
                x.isFunction(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [{
                    index: this.prevActiveSlideIndex,
                    slide: this.prevActiveSlide
                }, {
                    index: this.index,
                    slide: this.activeSlide
                }]),
                this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (i = this.settings.cssEfects.slide_back.out),
                C(t, i, (function() {
                    var e = t.querySelector(".gslide-media")
                      , i = t.querySelector(".gslide-description");
                    e.style.transform = "",
                    E(e, "greset"),
                    e.style.opacity = "",
                    i && (i.style.opacity = ""),
                    E(t, "prev")
                }
                ))
            }
        }, {
            key: "stopSlideVideo",
            value: function(t) {
                x.isNumber(t) && (t = this.slidesContainer.querySelectorAll(".gslide")[t]);
                var e = t ? t.querySelector(".gvideo") : null;
                if (!e)
                    return !1;
                var i = e.getAttribute("data-id");
                if (m && x.has(m, i)) {
                    var n = m[i];
                    n && n.play && n.pause()
                }
            }
        }, {
            key: "playSlideVideo",
            value: function(t) {
                x.isNumber(t) && (t = this.slidesContainer.querySelectorAll(".gslide")[t]);
                var e = t.querySelector(".gvideo");
                if (!e)
                    return !1;
                var i = e.getAttribute("data-id");
                if (m && x.has(m, i)) {
                    var n = m[i];
                    n && n.play && n.play()
                }
            }
        }, {
            key: "setElements",
            value: function(t) {
                this.settings.elements = t
            }
        }, {
            key: "getElements",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (this.elements = [],
                !x.isNil(this.settings.elements) && x.isArray(this.settings.elements))
                    return this.settings.elements;
                var e = !1;
                if (null !== t) {
                    var i = t.getAttribute("data-gallery");
                    i && "" !== i && (e = document.querySelectorAll('[data-gallery="'.concat(i, '"]')))
                }
                return 0 == e && (e = document.querySelectorAll(".".concat(this.settings.selector))),
                e = Array.prototype.slice.call(e)
            }
        }, {
            key: "getActiveSlide",
            value: function() {
                return this.slidesContainer.querySelectorAll(".gslide")[this.index]
            }
        }, {
            key: "getActiveSlideIndex",
            value: function() {
                return this.index
            }
        }, {
            key: "getAnimationClasses",
            value: function() {
                var t = [];
                for (var e in this.settings.cssEfects)
                    if (this.settings.cssEfects.hasOwnProperty(e)) {
                        var i = this.settings.cssEfects[e];
                        t.push("g".concat(i.in)),
                        t.push("g".concat(i.out))
                    }
                return t.join(" ")
            }
        }, {
            key: "build",
            value: function() {
                var t = this;
                if (this.built)
                    return !1;
                var e = x.has(this.settings.svg, "next") ? this.settings.svg.next : ""
                  , i = x.has(this.settings.svg, "prev") ? this.settings.svg.prev : ""
                  , n = x.has(this.settings.svg, "close") ? this.settings.svg.close : ""
                  , s = this.settings.lightboxHtml;
                s = L(s = (s = (s = s.replace(/{nextSVG}/g, e)).replace(/{prevSVG}/g, i)).replace(/{closeSVG}/g, n)),
                document.body.appendChild(s);
                var o = document.getElementById("glightbox-body");
                this.modal = o;
                var l = o.querySelector(".gclose");
                this.prevButton = o.querySelector(".gprev"),
                this.nextButton = o.querySelector(".gnext"),
                this.overlay = o.querySelector(".goverlay"),
                this.loader = o.querySelector(".gloader"),
                this.slidesContainer = document.getElementById("glightbox-slider"),
                this.events = {},
                k(this.modal, "glightbox-" + this.settings.skin),
                this.settings.closeButton && l && (this.events.close = T("click", {
                    onElement: l,
                    withCallback: function(e, i) {
                        e.preventDefault(),
                        t.close()
                    }
                })),
                l && !this.settings.closeButton && l.parentNode.removeChild(l),
                this.nextButton && (this.events.next = T("click", {
                    onElement: this.nextButton,
                    withCallback: function(e, i) {
                        e.preventDefault(),
                        t.nextSlide()
                    }
                })),
                this.prevButton && (this.events.prev = T("click", {
                    onElement: this.prevButton,
                    withCallback: function(e, i) {
                        e.preventDefault(),
                        t.prevSlide()
                    }
                })),
                this.settings.closeOnOutsideClick && (this.events.outClose = T("click", {
                    onElement: o,
                    withCallback: function(e, i) {
                        A(document.body, "glightbox-mobile") || M(e.target, ".ginner-container") || M(e.target, ".gbtn") || A(e.target, "gnext") || A(e.target, "gprev") || t.close()
                    }
                })),
                w(this.elements, (function() {
                    var e = L(t.settings.slideHtml);
                    t.slidesContainer.appendChild(e)
                }
                )),
                d && k(document.body, "glightbox-touch"),
                this.events.resize = T("resize", {
                    onElement: window,
                    withCallback: function() {
                        t.resize()
                    }
                }),
                this.built = !0
            }
        }, {
            key: "resize",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (t = t || this.activeSlide,
                document.body.style.width = "",
                document.body.style.width = "".concat(document.body.offsetWidth, "px"),
                t && !A(t, "zoomed")) {
                    var e = q()
                      , i = t.querySelector(".gvideo-wrapper")
                      , n = t.querySelector(".gslide-image")
                      , s = this.slideDescription
                      , o = e.width
                      , l = e.height;
                    if (o <= 768 ? k(document.body, "glightbox-mobile") : E(document.body, "glightbox-mobile"),
                    i || n) {
                        var r = !1;
                        if (s && (A(s, "description-bottom") || A(s, "description-top")) && !A(s, "gabsolute") && (r = !0),
                        n)
                            if (o <= 768) {
                                var a = n.querySelector("img");
                                a.setAttribute("style", "")
                            } else if (r) {
                                var h = s.offsetHeight
                                  , c = this.slidesData[this.index].width;
                                c = c <= o ? c + "px" : "100%";
                                var u = n.querySelector("img");
                                u.setAttribute("style", "max-height: calc(100vh - ".concat(h, "px)")),
                                s.setAttribute("style", "max-width: ".concat(u.offsetWidth, "px;"))
                            }
                        if (i) {
                            var d = this.settings.plyr.ratio.split(":")
                              , g = this.slidesData[this.index].width
                              , p = g / (parseInt(d[0]) / parseInt(d[1]));
                            if (p = Math.floor(p),
                            r && (l -= s.offsetHeight),
                            l < p && o > g) {
                                var v = i.offsetWidth
                                  , f = i.offsetHeight
                                  , m = l / f
                                  , y = {
                                    width: v * m,
                                    height: f * m
                                };
                                i.parentNode.setAttribute("style", "max-width: ".concat(y.width, "px")),
                                r && s.setAttribute("style", "max-width: ".concat(y.width, "px;"))
                            } else
                                i.parentNode.style.maxWidth = "".concat(g, "px"),
                                r && s.setAttribute("style", "max-width: ".concat(g, "px;"))
                        }
                    }
                }
            }
        }, {
            key: "reload",
            value: function() {
                this.init()
            }
        }, {
            key: "loop",
            value: function() {
                var t = x.has(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
                return t = x.has(this.settings, "loop") ? this.settings.loop : t,
                t
            }
        }, {
            key: "close",
            value: function() {
                var t = this;
                if (this.closing)
                    return !1;
                this.closing = !0,
                this.stopSlideVideo(this.activeSlide),
                k(this.modal, "glightbox-closing"),
                C(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.out),
                C(this.activeSlide, this.settings.closeEffect, (function() {
                    if (t.activeSlide = null,
                    t.prevActiveSlideIndex = null,
                    t.prevActiveSlide = null,
                    t.built = !1,
                    t.events) {
                        for (var e in t.events)
                            t.events.hasOwnProperty(e) && t.events[e].destroy();
                        t.events = null
                    }
                    var i = document.body;
                    E(g, "glightbox-open"),
                    E(i, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile"),
                    i.style.width = "",
                    t.modal.parentNode.removeChild(t.modal),
                    x.isFunction(t.settings.onClose) && t.settings.onClose(),
                    t.closing = null
                }
                ))
            }
        }, {
            key: "destroy",
            value: function() {
                this.close(),
                this.baseEvents.destroy()
            }
        }]),
        t
    }();
    return function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
          , e = new R(t);
        return e.init(),
        e
    }
}
));
